export const resources = {
  en: {
    translation: {
      common: {
        saving: "Saving...",
        refresh: "Refresh",
        logout: "Logout",
        deleteAccount: "Delete Account",
        viewPost: "View Post",
        unsave: "Unsave",
        unlike: "Unlike",
        members: "members",
        posts: "Posts",
        editProfile: "Edit Profile",
        unknownUser: "Unknown User",
        exploreUsers: "Explore Users",
        showAll: "Show all",
        searchMutualFollows: "Search mutual follows...",
        myPosts: "My Posts",
        likedPosts: "Liked Posts",
        savedPosts: "Saved Posts",
        organizationPosts: "Organization Posts",
      },
      navbar: {
        home: "Home",
        feed: "Feed",
        community: "Community",
        projects: "Programs",
        organizations: "Organizations",
        donateNow: "Donate Now",
        pro: "Greenwich Pro",
        buddy: "Buddy",
        greencoins: "Greencoins",
        shop: "Greenwich Shop",
        settings: "Settings",
        contactUs: "Contact Us",
        whoWeAre: "Who We Are",
        account: "Account",
        editProfile: "Edit Profile",
        howItWorks: "How It Works",
        logOut: "Log Out",
        viewDashboard: "View your dashboard",
        adminDashboard: "Admin Dashboard",
        verifiedOrganizations: "Verified Organizations",
        adminPanel: "Admin Panel",
        searchPlaceholder: "Search users, posts, communities, organizations...",
        searching: "Searching...",
        searchMinChars: "Type at least 2 characters to search",
        users: "Users",
        communities: "Communities",
        posts: "Posts",
        noResults: "No results found for",
        seeAllResults: "See all results",
        organization: "Organization",
        user: "User",
        postBy: "Post by",
        tryDifferentKeywords: "Try different keywords",
        searchMembers: "Search members",
        loginToSearch: "Please login to use search",
        sessionExpired: "Session expired. Please login again.",
        serverError: "Server error. Please try again later.",
        searchFailed: "Search failed",
        networkError: "Network error. Please check your connection and try again.",
        language: "Language",
        selectLanguage: "Select language",
        messages: "Messages",
        cancel: "Cancel",
      },
      notifications: {
        title: "Notifications",
        markAllRead: "Mark all read",
        marking: "Marking...",
        loading: "Loading...",
        allCaughtUp: "All caught up!",
        noNew: "No new notifications",
        liked: "liked your post",
        commented: "commented on your post",
        followed: "started following you",
        followRequest: "wants to follow you",
        followAccepted: "accepted your follow request",
        sentMessage: "sent you a message",
        postRemoved: "your post was removed by admin",
        genericNotification: "sent a notification",
        reason: "Reason",
        admin: "Admin",
        processing: "Processing...",
        accept: "Accept",
        decline: "Decline",
        total: "total",
        unread: "unread",
        refresh: "Refresh",
        justNow: "now",
        dismiss: "Dismiss",
        missingFollowData: "Cannot process: missing follow request data.",
        followActionFailed: "Failed to {{action}} follow request. Please try again.",
        networkError: "Network error. Please try again.",
        avatarAlt: "Avatar",
        viewProfile: "View {{name}}'s profile",
        someone: "Someone",
      },
      messageModal: {
        sendMessage: "Send Message",
        noMutualFollows: "No mutual follows yet",
        noMutualFollowsHint: "Follow people and wait for them to follow back to message them.",
        mutualFollowsCount: "{{count}} mutual follows",
        org: "Org",
        user: "User",
        mutualFollow: "Mutual follow",
        cancel: "Cancel",
        verified: "Verified",
      },
      postModal: {
        reply: "Reply",
        report: "Report",
        delete: "Delete",
        save: "Save",
        share: "Share",
        writeReply: "Write a reply...",
        writeComment: "Write a comment...",
        noCommentsYet: "No comments yet",
        deletePost: "Delete Post",
        deleteComment: "Delete Comment",
        cancel: "Cancel",
        areYouSure: "Are you sure?",
        postWillBeDeleted: "This post will be permanently deleted.",
        deleteThisComment: "Delete this comment?",
        reportPost: "Report Post",
        reasonSpam: "Spam",
        reasonInappropriate: "Inappropriate Content",
        reasonHarassment: "Harassment",
        reasonHateSpeech: "Hate Speech",
        reasonMisinformation: "Misinformation",
        reasonOther: "Other",
        linkCopied: "Link copied!",
        beFirstComment: "Be the first to comment!",
        comment: "Comment",
        comments: "Comments",
        justNow: "Just now",
        minutesAgo: "{{m}}m ago",
        hoursAgo: "{{h}}h ago",
        daysAgo: "{{day}}d ago",
        unknown: "Unknown",
        me: "Me",
        replyPosted: "Reply posted!",
        commentAdded: "Comment added!",
        postDeleted: "Post deleted.",
        commentDeleted: "Comment deleted.",
        reportSubmitted: "Report submitted.",
        failedLoadPost: "Failed to load post.",
        loadingPost: "Loading post...",
        postNotFound: "Post not found.",
        like: "Like",
        likes: "Likes",
        submit: "Submit",
        user: "User",
      },
      authPages: {
        orgReg: {
          stepProfileShort: "Profile", stepProfileLong: "Organization Profile",
          stepContactShort: "Contact", stepContactLong: "Contact & Networks", stepContactMedium: "Contact",
          stepTeamShort: "Team", stepTeamLong: "Team & Security",
          stepVerification: "Account",
          back: "Back",
          loadingOrgData: "Loading your organization data...",
          continueStep2: "Continue to Step 2",
          continueStep3: "Continue to Step 3",
          continueVerification: "Continue to Verification",
          orgNameTitle: "Organization Name",
          orgNameTooltip: "Add your organization name in different languages. Armenian version is required.",
          orgNameDesc: "Provide your organization's name in different languages",
          language: "Language",
          orgNameLabel: "Org. Name",
          orgNamePlaceholder: "Enter organization name",
          addNameInAnotherLanguage: "Add Name in Another Language",
          orgTypeTitle: "Organization Type",
          selectOrgType: "Select Organization Type",
          typesSelected: "{{count}} types selected",
          specifyOrgType: "Specify your organization type...",
          ageGroupsTitle: "Target Age Groups",
          ageGroups: {
            all: "All Age Groups",
            "0-12": "Children (0-12)",
            "13-17": "Teenagers (13-17)",
            "18-25": "Young Adults (18-25)",
            "26-35": "Adults (26-35)",
            "36-50": "Middle-aged (36-50)",
            "51-65": "Senior Adults (51-65)",
            "65+": "Elderly (65+)",
          },
          orgNameLanguages: {
            Armenian: "Armenian",
            English: "English",
            Russian: "Russian",
            French: "French",
            German: "German",
            Spanish: "Spanish",
            Other: "Other",
          },
          focusAreasTitle: "Focus Areas",
          selectFocusAreas: "Select Focus Areas",
          areasSelected: "{{count}} areas selected",
          specifyFocusArea: "Specify your focus area...",
          detailsTitle: "Organization Details",
          briefDescription: "Brief Description",
          briefDescriptionPlaceholder: "Describe your organization's purpose, activities, and impact...",
          missionStatement: "Mission Statement",
          missionPlaceholder: "What is your organization's core mission and values?",
          yearEstablished: "Year Established",
          legalForm: "Legal Form",
          selectLegalForm: "Select Legal Form",
          formsSelected: "{{count}} forms selected",
          specifyLegalForm: "Specify legal form...",
          alertName: "Please enter your organization's name",
          alertOrgType: "Please select at least one organization type",
          alertAudience: "Please select at least one target age group",
          alertFocusArea: "Please select at least one focus area",
          alertDescription: "Please fill in the brief description",
          alertMission: "Please fill in the mission statement",
          alertYear: "Please enter the year your organization was established",
          alertLegalForm: "Please select a legal form",
          step2Title: "Step 2: Contact & Networks",
          step2Subtitle: "How can people reach your organization?",
          contactInfoTitle: "Contact Information",
          orgEmail: "Organization Email",
          orgEmailPlaceholder: "your.org@example.com",
          orgEmailHint: "We'll send a confirmation code to this address to verify your account.",
          primaryPhone: "Primary Phone",
          phoneNumberPlaceholder: "Phone number",
          website: "Website",
          address: "Address",
          addressPlaceholder: "Street, City, Country",
          socialLinks: "Social Links",
          socialLinkPlaceholder: "https://example.com/profile",
          addLink: "Add Link",
          networksTitle: "International Networks",
          networksDesc: "Select the networks your organization is part of",
          customNetworkPlaceholder: "Add custom network...",
          add: "Add",
          alertRequiredFields: "Please fill required fields: email and phone",
          alertValidEmail: "Please enter a valid email address",
          alertValidPhone: "Please enter a valid phone number (at least 6 digits)",
          alertAddress: "Please enter your organization's address",
          step3Title: "Step 3: Team & Security",
          step3Subtitle: "Manage your team members and set up security policies",
          brandingTitle: "Organization Branding",
          logoOptional: "Logo (optional)",
          addLogo: "Add Logo",
          upTo8mb: "Up to 8MB",
          change: "Change",
          orgPresentationOptional: "Organization Presentation (optional)",
          uploadPresentation: "Upload Presentation",
          presentationHint: "PDF, slides or image, up to 8MB",
          fileAttached: "File attached",
          clickToChange: "Click to change",
          teamTitle: "Authorized Team Members",
          teamDesc: "Add team members authorized to publish content on behalf of your organization. Each person will receive an email invitation and only joins your team's confirmed list once they accept it.",
          member: "Member #{{n}}",
          fullNamePlaceholder: "Full Name",
          rolePlaceholder: "Role / Responsibility",
          teamEmailPlaceholder: "team@org.com",
          addTeamMember: "Add Team Member",
          alertFileSize: "Files must be smaller than 8MB.",
          alertMember: "Please fill in at least one authorized team member's full name, role and email",
          step4Title: "Step 4: Account & Contact Person",
          step4Subtitle: "Finish registration with login credentials. Legal verification is done later, from your dashboard",
          missingInfoTitle: "Missing Information",
          missingInfoDesc: "Please complete Step 1: Organization Profile first.",
          goToStep1: "Go to Step 1",
          submittingRegistration: "Submitting your registration...",
          loginCredentialsTitle: "Login Credentials",
          orDivider: "or finish with email and password",
          username: "Username",
          usernamePlaceholder: "e.g., greenpeace_official",
          usernameValid: "✓ Username valid",
          usernameInvalid: "Must be at least 3 characters, using lowercase letters, numbers, _ and . only",
          suggestions: "Suggestions:",
          email: "Email",
          emailHintPrefix: "Set in Step 2. We'll send your confirmation code here,",
          changeIt: "change it",
          password: "Password",
          passwordPlaceholder: "At least 8 chars",
          confirmPassword: "Confirm Password",
          confirmPasswordPlaceholder: "Re-enter password",
          passwordsMatch: "✓ Passwords match",
          passwordsDontMatch: "✗ Passwords don't match",
          strengthWeak: "Weak", strengthMedium: "Medium", strengthStrong: "Strong",
          easyPasswordsTitle: "💡 Easy passwords to remember (click to use):",
          refresh: "Refresh",
          passwordFormatHint: "Format: Word + Word + Numbers (easy to remember, hard to guess)",
          legalRepTitle: "Who's registering?",
          legalRepDesc: "The person creating this account and legally authorized to act on behalf of the organization",
          registrantRoleQuestion: "Are you registering as the organization itself, or as its representative?",
          registrantRoleOrg: "The organization",
          registrantRoleRep: "I'm a representative",
          name: "Name", firstNamePlaceholder: "First name",
          surname: "Surname", lastNamePlaceholder: "Last name",
          position: "Position / Title", positionPlaceholder: "e.g., Executive Director",
          phone: "Phone",
          optional: "(optional)",
          optionalPlaceholder: "Optional",
          verificationTitle: "Legal Registration & Verification",
          verificationDesc: "This information lets our team verify your organization is legitimate before it goes live on the platform",
          isInformalQuestion: "Is your organization an informal / unregistered group?",
          formallyRegistered: "No, we are formally registered",
          informal: "Yes, we are informal",
          informalHint: "No registration details needed. Informal groups can skip straight to documents below.",
          legalFormFromStep1: "Legal form (from step 1):",
          stateRegNumber: "State Registration Number", stateRegNumberPlaceholder: "Certificate / registry number",
          countryOfReg: "Country of Registration", countryOfRegPlaceholder: "e.g., Armenia",
          dateOfReg: "Date of Registration",
          taxId: "Tax ID / Legal ID", taxIdPlaceholder: "Taxpayer identification number",
          vatNumber: "VAT Number", vatNumberPlaceholder: "e.g., AM12345678",
          registeredAddress: "Registered Legal Address", registeredAddressPlaceholder: "Address on file with the registry",
          documentsTitle: "Documents",
          optionalParen: "(Optional)",
          registrationDoc: "Registration Doc",
          vatCertificate: "VAT Certificate",
          stateSeal: "State Seal",
          passportScan: "Passport Scan",
          uploadShort: "+ Upload",
          docHint: "PDF or image, max 8MB",
          completeRegistration: "Complete Registration",
          submittingBtn: "Submitting...",
          alertUsernameRequired: "Username is required",
          alertUsernameFormat: "Username must be 3-20 characters and contain only lowercase letters, numbers, underscores and periods",
          alertMissingEmail: "Missing organization email. Please go back to Step 2",
          alertPasswordRequired: "Password is required",
          alertPasswordsMismatch: "Passwords do not match",
          alertPasswordLength: "Password must be at least 8 characters",
          alertRegistrantRole: "Please specify whether you're registering as the organization or as its representative",
          alertRepName: "Legal representative name is required",
          alertRepSurname: "Legal representative surname is required",
          alertRepPosition: "Legal representative position/title is required",
          alertStateRegId: "State registration number is required for a formally registered organization",
          alertCountry: "Country of registration is required",
          alertRegDate: "Date of registration is required",
          alertLegalId: "Tax ID / Legal ID is required",
          alertRegAddress: "Registered legal address is required",
          alertVat: "VAT number is required",
          alertCaptcha: "Please complete the CAPTCHA",
          alertFileTooLarge: "File too large (max 8MB)",
          successEmailVerify: "✅ Registration submitted! Check your email for a confirmation code.",
          successRegistered: "✅ Registration successful!",
          successSocial: "Social registration successful!",
          errorRegistrationFailed: "Registration failed. Please try again.",
          errorSocialFailed: "Social registration failed. Please try again.",
        },
        backToLogin: "Back to login",
        enterEmail: "Please enter your email.",
        somethingWrong: "Something went wrong. Please try again.",
        checkYourEmail: "Check your email",
        resetEmailSent: "If an account exists for {{email}}, we've sent a link to reset your password. It expires in 1 hour.",
        forgotTitle: "Forgot your password?",
        forgotSubtitle: "Enter your email and we'll send you a reset link.",
        email: "Email",
        sending: "Sending…",
        sendResetLink: "Send reset link",
        confirmEmailTitle: "Confirm your email",
        confirmEmailSubtitle: "We sent a 6-digit code to {{email}}. Enter it below to activate your account.",
        yourEmail: "your email",
        confirmationCode: "Confirmation code",
        confirmBtn: "Confirm",
        verifying: "Confirming…",
        resendCode: "Resend code",
        resendCodeIn: "Resend code in {{seconds}}s",
        codeResent: "A new code has been sent to your email.",
        missingResetInfo: "This reset link is missing information. Please request a new one.",
        passwordTooShort: "Password must be at least 8 characters.",
        passwordsDontMatch: "Passwords do not match.",
        failedResetPassword: "Failed to reset password.",
        passwordUpdated: "Password updated",
        redirecting: "Redirecting you to login…",
        chooseNewPassword: "Choose a new password",
        forAccount: "for {{email}}",
        yourAccount: "your account",
        newPassword: "New password",
        confirmNewPassword: "Confirm new password",
        atLeast8Chars: "At least 8 characters",
        reenterPassword: "Re-enter new password",
        updating: "Updating…",
        updatePassword: "Update password",
        resendLink: "Resend link",
        resendLinkIn: "Resend link in {{seconds}}s",
        linkResent: "A new reset link is on its way.",
        checkSpamHint: "Didn't get it? Check your spam folder, it can take a minute to arrive.",
        oauthNoticeTitle: "You signed in with {{provider}}",
        oauthNoticeDesc: "That account doesn't have a password, so there's nothing to reset, just continue with {{provider}} from the login page.",
        socialAccountGeneric: "a social account",
        goToLogin: "Go to login",
        passwordReqLength: "At least 8 characters",
        passwordReqMatch: "Passwords match",
        login: "Login",
        password: "Password",
        forgotPassword: "Forgot password?",
        loading: "Loading...",
        continueBtn: "Continue",
        or: "or",
        dontHaveAccount: "Don't have an account?",
        register: "Register",
        socialLoginFailed: "Social login failed.",
        chooseAccountType: "Choose Account Type",
        selectHowToUse: "Select how you want to use our platform",
        player: "Player",
        playerDescLong: "Discover scholarships, grants and exchange programs, and build your profile",
        playerDescShort: "Discover & apply",
        organizer: "Organizer",
        organizerDescLong: "Publish your programs and connect with Armenian youth",
        organizerDescShort: "Post & manage programs",
        pendingApproval: "Your account is pending approval. Please wait for administrator approval.",
        loginFailed: "Login failed. Please try again.",
        invalidCredentials: "Invalid email or password.",
        socialRegisterFailed: "Social registration failed. Please try again.",
        loggingIn: "Logging in...",
        showPassword: "Show password",
        hidePassword: "Hide password",
        registrationVisual: "Registration visual",
        togglePasswordVisibility: "Toggle password visibility",
        registerAsOrg: "Register as Organization",
        registerAsUser: "Register as User",
        fillRequired: "Please fill in all required fields",
        nameLength: "Name must be 2-20 characters",
        surnameLength: "Surname must be 2-20 characters",
        invalidEmail: "Please enter a valid email address",
        useRealEmail: "Please use a real email address",
        invalidPhone: "Please enter a valid phone number (+374XXXXXXXX or 0XXXXXXXX)",
        passwordLength: "Password must be 6-20 characters",
        passwordLetterNumber: "Password must contain at least one letter and one number",
        passwordTooWeak: "Please choose a more secure password",
        passwordsNoMatch: "Passwords do not match",
        mustAgreeTerms: "You must agree to the Terms & Conditions",
        completeCaptcha: "Please complete the CAPTCHA verification",
        registrationFailed: "Registration failed",
        registrationError: "An error occurred during registration",
        registrationTimeout: "Registration is taking longer than expected. Please check your connection and try again.",
        socialRegFailed: "Social registration failed",
        createAccount: "Create an Account",
        orRegisterEmail: "or register with email",
        name: "Name",
        surname: "Surname",
        phoneOptional: "Phone",
        phoneExample: "Example: +374 98 123 456",
        confirmPassword: "Confirm Password",
        confirmYourPassword: "Confirm your password",
        passwordPlaceholderHint: "At least 6 characters, include a letter and a number",
        charsMin: "6+ chars",
        letter: "letter",
        number: "number",
        passwordsMatch: "Passwords match",
        passwordsDontMatchShort: "Passwords don't match",
        agreeToTerms: "I agree to the",
        termsConditions: "Terms & Conditions",
        and: "and",
        privacyPolicy: "Privacy Policy",
        registering: "Registering...",
        registerBtn: "Register",
      },
      followButton: {
        pleaseLogin: "Please log in to follow users",
        userIdMissing: "Cannot follow: User ID is missing",
        requestSent: "Follow request sent!",
        failedSendRequest: "Failed to send follow request",
        noRequestId: "No request ID found",
        requestAccepted: "Follow request accepted!",
        failedAccept: "Failed to accept follow request",
        requestRejected: "Follow request rejected",
        failedReject: "Failed to reject follow request",
        unfollowedSuccess: "Unfollowed successfully",
        unfollowIdMissing: "Cannot unfollow: User ID is missing",
        failedUnfollow: "Failed to unfollow user",
        noRequestIdCancel: "No request ID found to cancel",
        requestCancelled: "Follow request cancelled",
        failedCancel: "Failed to cancel follow request",
        userUnavailable: "User Unavailable",
        loading: "Loading...",
        acceptRequest: "Accept Request",
        reject: "Reject",
        mutualFollow: "Mutual Follow",
        following: "Following",
        unfollow: "Unfollow",
        requestSentBtn: "Request Sent",
        follow: "Follow",
      },
      followSettings: {
        pleaseLogin: "Please log in to view settings",
        failedLoad: "Failed to load settings",
        settingsSaved: "Settings saved successfully!",
        failedSave: "Failed to save settings",
        loadingSettings: "Loading settings...",
        title: "Follow Settings",
        subtitle: "Control how others can follow you",
        followRequests: "Follow Requests",
        followRequestsDesc: "Control whether people need your approval to follow you",
        requireApproval: "Require approval for followers",
        approvalOnDesc: "People must send a request to follow you",
        approvalOffDesc: "Anyone can follow you without approval",
        whenOn: "When ON:",
        onPoint1: "Users must send a follow request",
        onPoint2: "You can approve or reject requests",
        onPoint3: "You have full control over who follows you",
        onPoint4: "Perfect for private accounts",
        whenOff: "When OFF:",
        offPoint1: "Anyone can follow you instantly",
        offPoint2: "No approval required",
        offPoint3: "Great for public figures and organizations",
        offPoint4: "Maximizes your reach",
        notifications: "Notifications",
        notificationsDesc: "Manage how you're notified about follow requests",
        emailNotifications: "Email notifications",
        emailNotifDesc: "Receive email alerts for new follow requests",
        pushNotifications: "Push notifications",
        pushNotifDesc: "Get browser notifications for follow requests",
        inAppNotifications: "In-app notifications",
        inAppNotifDesc: "See notifications within the app",
        followers: "Followers",
        following: "Following",
        pendingRequests: "Pending Requests",
        resetDefaults: "Reset to Defaults",
        saving: "Saving...",
        saveSettings: "Save Settings",
      },
      followRequestsPage: {
        failedLoad: "Failed to load follow requests",
        serverError: "Server error: {{status}}",
        acceptedRequest: "You accepted {{name}}'s request!",
        failedAccept: "Failed to accept follow request. Please try again.",
        rejectedRequest: "Request from {{name}} rejected",
        failedReject: "Failed to reject follow request. Please try again.",
        needMutualToMessage: "You need to follow each other to message {{name}}",
        failedStartConversation: "Failed to start conversation",
        justNow: "Just now",
        minAgo: "{{n}}m ago",
        hourAgo: "{{n}}h ago",
        dayAgo: "{{n}}d ago",
        loadingRequests: "Loading follow requests...",
        title: "Follow Requests",
        pending: "{{count}} pending",
        requestCount: "{{count}} request",
        requestCountPlural: "{{count}} requests",
        refreshing: "Refreshing...",
        refresh: "Refresh",
        organization: "Organization",
        wantsToFollow: "Wants to follow you",
        accept: "Accept",
        decline: "Decline",
        sendMessage: "Send message",
        noRequests: "No pending follow requests",
        noRequestsDesc: "When someone wants to follow you, their request will appear here.",
        checkNewRequests: "Check for new requests",
      },
      messagesWidget: {
        messages: "Messages",
        newMessage: "New message",
        fullScreen: "Full screen",
        close: "Close",
        members: "members",
        online: "Online",
        delete: "Delete",
        sharedPost: "Shared post",
        sharedPostMessage: "📤 Shared a post from {{name}}",
        unknown: "Unknown",
        post: "Post",
        tapToView: "Tap to view post →",
        sharingPost: "Sharing a post",
        from: "From: {{name}}",
        typeMessage: "Type a message...",
        direct: "Direct",
        groups: "Groups",
        noConversations: "No conversations yet",
        startNewChat: "Start New Chat",
        noMessages: "No messages",
        noGroups: "No groups yet",
        browseGroups: "Browse Groups",
        someone: "Someone",
        newMessageTitle: "New Message",
        searchFollowed: "Search followed users...",
        organization: "Organization",
        user: "User",
        notFollowingAnyone: "You're not following anyone yet",
        followToMessage: "Follow people to start messaging them",
        confirmDeleteMessage: "Delete this message?",
        emojis: "Emojis",
        recent: "Recent",
        smileys: "Smileys",
        hearts: "Hearts",
        hands: "Hands",
        animals: "Animals",
        food: "Food",
        travel: "Travel",
        symbols: "Symbols",
        weather: "Weather",
      },
      searchModal: {
        placeholder: "Search users, organizations, posts, communities...",
        postThumbnail: "Post thumbnail",
        all: "All",
        organizations: "Organizations",
        players: "Players",
        posts: "Posts",
        communities: "Communities",
        searching: "Searching...",
        users: "Users",
        noResultsFor: 'No results found for "{{query}}"',
        tryDifferentKeywords: "Try different keywords",
        seeAllResultsFor: 'See all results for "{{query}}"',
        recentSearches: "Recent Searches",
        clearAll: "Clear all",
        searchPlatform: "Search Greenwich Platform",
        findPeopleEtc: "Find people, organizations, posts and communities",
        organization: "Organization",
        administrator: "Administrator",
        communityMember: "Community Member",
        verifiedOrganization: "Verified Organization",
        followers: "followers",
        postsCount: "posts",
        following: "Following",
        follow: "Follow",
        hAgo: "{{n}}h ago",
        dAgo: "{{n}}d ago",
        user: "User",
        noContent: "No content",
        likes: "likes",
        comments: "comments",
        community: "Community",
        members: "members",
        privateCommunity: "Private community",
        searchFailed: "Search failed. Please try again later.",
        serverError: "Server error. Please try again later.",
        cannotConnect: "Cannot connect to server. Please check your connection and try again.",
        networkError: "Network error. Please try again later.",
      },
      onboarding: {
        skip: "Skip",
        skipTour: "Skip tour",
        back: "Back",
        next: "Next",
        start: "Start",
        getStarted: "Get Started",
        steps: {
          welcome:       { title: "Welcome to Greenwich!", subtitle: "Your new home for connection", content: "We're so happy to see you here! Hi, I'm Erika AI, and I'll guide you as you explore and discover everything our platform has to offer.", expression: "Happy to meet you! " },
          navigation:    { title: "Navigation Menu", subtitle: "Your compass around Greenwich", content: "This is your navigation menu! From here you can jump to Home, Profile, Messages, and Notifications.", expression: "Navigate with Greenwich!" },
          "create-post": { title: "Create a Post", subtitle: "Share your voice", content: "Write your thoughts, upload photos, share videos, and tell the world your story. Your voice matters, let everyone hear it!", expression: "Create something! " },
          "feed-posts":  { title: "Your Feed", subtitle: "All the action in one place", content: "Here you'll see posts from people and organizations you follow. Like, comment, save, and share!", expression: "Feed of amazing content!" },
          greencoins:    { title: "Greencoin Market", subtitle: "Spend what you earn", content: "Earn Greencoins by being active, then spend them here on real rewards and perks in the marketplace.", expression: "Shop time! " },
          buddy:         { title: "Greenwich Buddy", subtitle: "Find a mentor, or become one", content: "Buddy connects you with a mentor who's been where you want to go, or lets you become one yourself and guide someone else.", expression: "Let's connect! " },
          search:        { title: "Search", subtitle: "Discover everything", content: "Find new friends, organizations, posts, and topics you care about.", expression: "Searching? " },
          programs:      { title: "Programs & Projects", subtitle: "Opportunities waiting for you", content: "Discover ongoing projects and programs. Track progress, see updates, and participate in initiatives that create real impact.", expression: "Building the future! " },
          messages:      { title: "Messages", subtitle: "Where the magic happens", content: "Send direct messages, create group conversations, share photos, and see when messages are read.", expression: "Chat with friends! " },
          notifications: { title: "Notifications", subtitle: "Stay in the loop", content: "See likes, new comments, follow requests, and messages. Never miss an important update!", expression: "You have notifications!" },
          organization:  { title: "Organizations", subtitle: "Trusted. Recognized. Impactful.", content: "Your organization is officially verified. Share updates, publish reports, engage with your members, and showcase your real-world impact.", expression: "Professional! " },
          settings:      { title: "Settings", subtitle: "Customize everything", content: "Manage privacy, theme, notification preferences, and account info.", expression: "In control! " },
          communities:   { title: "Communities", subtitle: "Build your community", content: "Join groups with shared interests, participate in discussions, collaborate on projects, and make lasting friendships.", expression: "Welcoming! " },
          final:         { title: "You're All Set!", subtitle: "Welcome to the Greenwich!", content: "You now know all the main features of Greenwich. Be kind, share amazing content, connect with wonderful people, and have fun!", expression: "Welcome! " },
        },
      },
      accountProfile: {
        successSaved: "✅ Profile saved successfully! Redirecting...",
        debugImages: "Debug Images",
        editCover: "Edit Cover",
        verifiedOrg: "Verified Organization",
        placeholderFullName: "Your Full Name",
        placeholderHeadline: "Professional Headline",
        placeholderLocation: "📍 Location",
        placeholderEmail: "Email",
        placeholderPhone: "Phone",
        aboutMe: "About Me",
        aboutPlaceholder: "Share your story, passions, and what drives you...",
        quickActions: "Quick Actions",
        myPosts: "My Posts",
        likedPosts: "Liked Posts",
        savedPosts: "Saved Posts",
        areasOfInterest: "Areas of Interest",
        edit: "Edit",
        save: "Save",
        selectInterestsGuide: "Select your areas of interest:",
        noInterestsYet: "No interests selected yet",
        profileInformation: "Profile Information",
        profileInfoNote: "Your profile information will be updated after saving.",
        tipsTitle: "Tips for best results:",
        tip1: "Use high-quality images (JPEG or PNG)",
        tip2: "Profile image should be square (1:1 ratio)",
        tip3: "Cover image should be wide (16:9 ratio)",
        tip4: "Changes are automatically saved to your dashboard",
        cancel: "Cancel",
        saving: "Saving...",
        saveProfile: "Save Profile",
        alertImageTooLarge: "Image size should be less than 5MB",
        alertInvalidImageType: "Only JPEG, PNG and GIF images are allowed",
        alertErrorPrefix: "❌ Error: ",
        errorUpdateFailed: "Update failed. Please try again.",
        errorUnexpected: "An unexpected error occurred. Please try again.",
      },
      adminProgramsReview: {
        deleteTitle: "Delete program?",
        deleteSub: "This action cannot be undone.",
        cancel: "Cancel",
        delete: "Delete",
        needsEditSendTitle: "Needs edit, send feedback",
        sendMessageTitle: "Send message to organization",
        needsEditSendSub: "Status changes to «needs edit». Organization will receive your message.",
        sendMessageSub: "Send a message without changing program status.",
        program: "Program",
        quickTemplates: "Quick templates",
        template1Label: "Missing information",
        template1Text: "Your program submission is missing some required information. Please update the following fields and resubmit:\n\n• [Specify missing fields]\n\nOnce updated, your program will be reviewed again.",
        template2Label: "Does not meet requirements",
        template2Text: "Unfortunately, your program does not meet our platform requirements at this time. Specifically:\n\n• [Explain the issue]\n\nPlease review our submission guidelines and consider resubmitting with the necessary changes.",
        template3Label: "Update and resubmit",
        template3Text: "Thank you for submitting your program. We were unable to approve it as submitted, but we encourage you to make the following changes and resubmit:\n\n• [List changes needed]\n\nWe look forward to reviewing your updated submission.",
        template4Label: "Duplicate submission",
        template4Text: "It appears that a similar program already exists on our platform. Please check existing listings before resubmitting, or contact us if you believe this is an error.",
        messagePlaceholder: "Write your message here…",
        feedbackHint: "Organization will see this and can edit & resubmit.",
        needsEditAndSend: "Needs edit & send",
        sendMessage: "Send message",
        pageTitle: "Programs Review",
        pageSubtitle: "Organization submissions. Approved ones appear in /programs",
        pendingChip: "{{count}} pending",
        refresh: "Refresh",
        tabPending: "Pending",
        tabApproved: "Approved",
        tabNeedsEdit: "Needs Edit",
        tabRejected: "Rejected",
        tabAll: "All",
        loadingPrograms: "Loading programs…",
        noProgramsAll: "No programs",
        noProgramsFiltered: "No {{status}} programs",
        statusWordPending: "pending",
        statusWordApproved: "approved",
        statusWordNeedsEdit: "needs edit",
        statusWordRejected: "rejected",
        nothingToShow: "Nothing to show here yet.",
        saving: "Saving…",
        titlePlaceholder: "Title",
        categoryPlaceholder: "Category",
        descriptionPlaceholder: "Description",
        uploadImage: "Upload image",
        remove: "Remove",
        pasteImageUrl: "Or paste image URL…",
        save: "Save",
        statusPending: "Pending",
        statusApproved: "Approved",
        statusNeedsEdit: "Needs edit",
        statusRejected: "Rejected",
        defaultOrgName: "Organization",
        feedbackSent: "Feedback sent",
        sendMessageTooltip: "Send message",
        editTooltip: "Edit",
        deleteTooltip: "Delete",
        lastFeedback: "Last feedback",
        approve: "Approve",
        needsEdit: "Needs edit",
        reject: "Reject",
        waitingForEdits: "Waiting for organization edits",
        visibleInPrograms: "Visible in /programs",
        revoke: "Revoke",
        reApprove: "Re-approve",
        sendFeedback: "Send feedback",
        deadline: "Deadline",
        location: "Location",
        education: "Education",
        organization: "Organization",
        description: "Description",
        openProgram: "Open program",
        view: "View",
        toastApproved: "Program approved",
        toastNeedsEdit: "Marked as needs edit",
        toastRejected: "Program rejected",
        toastDone: "Done",
        toastFeedbackSent: "Feedback sent to organization",
        toastDeleted: "Program deleted",
        toastUpdated: "Program updated",
        toastImageTooLarge: "Image must be under 5 MB",
      },
      orgSettings: {
        pageTitle: "Organization Settings",
        pageSubtitle: "Manage your organization's registration data and information",
        tabProfile: "Organization Profile",
        tabContact: "Contact & Networks",
        tabTeam: "Team & Security",
        tabVerification: "Verification",
        edit: "Edit",
        save: "Save",
        saving: "Saving...",
        notSet: "Not set",
        step1Title: "Step 1: Organization Profile",
        orgNames: "Organization Names",
        langArmenian: "Armenian",
        langEnglish: "English",
        langRussian: "Russian",
        orgNamePlaceholder: "Organization name",
        addName: "Add Name",
        orgType: "Organization Type",
        addCustomTypePlaceholder: "Add custom type",
        description: "Description",
        mission: "Mission",
        focusAreas: "Focus Areas",
        establishedYear: "Established Year",
        legalForm: "Legal Form",
        step2Title: "Step 2: Contact & Networks",
        contactEmail: "Contact Email",
        primaryPhone: "Primary Phone",
        secondaryPhone: "Secondary Phone",
        address: "Address",
        website: "Website",
        socialLinks: "Social Links",
        socialLinkPlaceholder: "https://...",
        addLink: "Add Link",
        noSocialLinks: "No social links",
        networks: "Networks",
        step3Title: "Step 3: Team & Security",
        secureSealText: "Secure Seal Text",
        authorizedMembers: "Authorized Team Members",
        memberNum: "Member #{{n}}",
        fullNamePlaceholder: "Full Name",
        rolePlaceholder: "Role",
        emailPlaceholder: "Email",
        addMember: "Add Member",
        noMembers: "No members added",
        step4Title: "Step 4: Verification & Login",
        username: "Username",
        email: "Email",
        representativeName: "Representative Name",
        representativeEmail: "Representative Email",
        stateRegistrationId: "State Registration ID",
        vatNumber: "VAT Number",
        alertSavedSuccess: "Settings saved successfully!",
        alertErrorSaving: "Error saving: ",
        alertErrorSavingSettings: "Error saving settings: ",
      },
      orgAccountProfile: {
        editCover: "Edit Cover",
        followers: "Followers",
        following: "Following",
        placeholderOrgName: "Organization Name",
        placeholderOrgType: "Organization Type / Headline",
        placeholderLocation: "📍 Location",
        placeholderEmail: "Email",
        placeholderPhone: "Phone",
        quickActions: "Quick Actions",
        myPosts: "My Posts",
        likedPosts: "Liked Posts",
        savedPosts: "Saved Posts",
        aboutOrg: "About Organization",
        aboutPlaceholder: "Share your organization's story, mission, and what drives you...",
        areasOfInterest: "Areas of Interest",
        edit: "Edit",
        save: "Save",
        selectInterestsGuide: "Select your areas of interest:",
        noInterestsYet: "No interests selected yet",
        createPost: "Create Post",
        postPlaceholder: "Share what's on your mind...",
        addPhoto: "Add Photo",
        post: "Post",
        orgPosts: "Organization Posts",
        noPostsYet: "No posts yet. Share your first post above!",
        orgActivities: "Organization Activities",
        activityNamePlaceholder: "Activity or Project Name",
        partnerOrgPlaceholder: "Partner Organization",
        activityDescPlaceholder: "Describe your organization's activities and achievements...",
        addActivity: "Add Activity",
        previewProfile: "Preview Profile",
        saveContinue: "Save & Continue to Dashboard",
        defaultOrgFallback: "Organization",
        coverAlt: "Cover",
        profileAlt: "Profile",
        verifiedOrgTitle: "Verified Organization",
        uploadAlt: "Upload",
        postPreviewAlt: "Post preview",
        postAlt: "Post",
        alertPleaseLogin: "Please log in again",
        alertInvalidResponse: "Server returned invalid response. Check console for details.",
        alertErrorCreating: "Error creating post: ",
        alertNetworkError: "Network error: ",
        alertEnterContent: "Please enter some content or add an image",
        alertPostSuccess: "Post created successfully!",
        interests: {
          environment: "Environment", education: "Education", technology: "Technology", health: "Health",
          artsCulture: "Arts & Culture", communityDevelopment: "Community Development", humanRights: "Human Rights",
          socialInclusion: "Social Inclusion", internationalExchanges: "International Exchanges", entrepreneurship: "Entrepreneurship",
        },
      },
      orgProgramSubmit: {
        greencoinToggle: "Reward participants with greencoins",
        greencoinPitch: "Programs that reward greencoins attract more applicants. Participants who complete this program will receive the amount below, redeemable in our rewards shop. Cost is deducted from your organization's greencoin balance the moment each participant is confirmed.",
        greencoinAmountLabel: "Greencoins per participant",
        greencoinBalance: "Your balance: {{balance}}",
        greencoinLowBalance: "This is more than your current balance. Top up before participants start completing the program, or some may not get paid.",
        successTitle: "Program Submitted!",
        successBodyPre: "Your program is now ",
        successBodyBold: "pending admin review",
        successBodyPost: ". It will appear in /programs once approved.",
        viewMySubmissions: "View My Submissions",
        submitAnother: "Submit Another",
        title: "Submit a Program",
        subtitle: "Same fields as the admin program form, reviewed before publishing",
        defaultOrgName: "Organization",
        uploadCoverImage: "Upload cover image",
        coverImageHint: "Recommended: 1200×630px",
        coverImageAlt: "Cover",
        programTitle: "Program title",
        programTitlePlaceholder: "e.g. Erasmus+ Youth Exchange 2026",
        description: "Description",
        descriptionPlaceholder: "What the program offers, who it is for…",
        categories: "Categories",
        categoriesHint: " (multi-select, same as admin)",
        sectors: "Sectors",
        sectorsHint: " (multi-select, same as admin)",
        programUrl: "Program / application URL",
        source: "Source",
        location: "Location",
        locationPlaceholder: "e.g. Yerevan, Armenia",
        format: "Format",
        formatPlaceholder: "e.g. Online, Hybrid, On-site",
        educationLevel: "Education level",
        eduAny: "Any / Not specified",
        eduHighSchool: "High school",
        eduStudent: "Student",
        eduUndergrad: "Undergraduate",
        eduGrad: "Graduate",
        eduDoctoral: "Doctoral",
        eduProfessional: "Professional",
        startDate: "Start date",
        endDate: "End date",
        deadline: "Application deadline",
        fundingType: "Funding type",
        fundingTypePlaceholder: "e.g. Fully funded, Partial…",
        targetGroup: "Target group",
        targetGroupPlaceholder: "e.g. Youth 18-30, researchers…",
        requirements: "Requirements / eligibility",
        requirementsPlaceholder: "Age, nationality, language level, etc. (appended to description for reviewers)",
        reviewNotice: "Admin review required. Categories and sectors match the public Programs filters once approved.",
        submitting: "Submitting…",
        submitForReview: "Submit for review ✓",
        errorTitleDesc: "Title and description are required.",
        errorCategory: "Select at least one category (same as admin form).",
        errorSector: "Select at least one sector (same as admin form).",
        errorSubmitFailed: "Submission failed. Please try again.",
        errorNetwork: "Network error. Please try again.",
        sectorLabels: {
          ecology: "Ecology", international: "International", technology: "Technology", medical: "Medical",
          education: "Education", business: "Business", arts: "Arts & Culture", science: "Science",
          sports: "Sports", agriculture: "Agriculture", local: "Local", media: "Media",
        },
        categoryLabels: {
          education: "Education", scholarship: "Scholarship", fellowship: "Fellowship", erasmusplus: "Erasmus Plus",
          training: "Training", grant: "Grant", internship: "Internship", conference: "Conference",
          online: "Online", volunteering: "Volunteering", event: "Event", award: "Award",
        },
      },
      organizationGreencoins: {
        back: "Back",
        title: "Greencoin Wallet",
        subtitle: "Buy greencoins and spend them rewarding participants who complete your programs.",
        balanceLabel: "Current balance",
        buyTitle: "Buy greencoins",
        buyNote: "Payment is confirmed manually for now. File a request below and our team will follow up to confirm payment and top up your balance right away.",
        selfServiceLocked: "Buying greencoins directly isn't open yet. Reach out to our team and we'll set you up.",
        buyButton: "Buy now",
        sending: "Sending...",
        requestSent: "Request sent. We'll be in touch to confirm payment.",
        requestError: "Couldn't send the request. Please try again.",
        pendingTitle: "Pending requests",
        pendingStatus: "Awaiting confirmation",
        historyTitle: "History",
        historyEmpty: "No transactions yet.",
        txTopup: "Balance top-up",
        txSpend: "Reward paid to a participant",
        perksTitle: "What greencoins let you do",
        perks: {
          reward: { title: "Reward participants", desc: "Attach a greencoin reward to your programs so participants who complete them get paid automatically." },
          completion: { title: "Higher completion", desc: "Programs with a reward attached see stronger signup-to-completion rates." },
          flexible: { title: "Flexible amounts", desc: "Set any reward per program, and buy exactly as many greencoins as you need." },
        },
        greencoinsLabel: "greencoins",
        amdPerCoin: "AMD / coin",
        payTitle: "Pay by bank transfer",
        payBank: "Bank",
        payAccount: "Account number",
        payRecipient: "Recipient",
        payReferenceHint: "Include your organization name as the payment reference so we can match your transfer.",
        interestTitle: "Not quite live yet",
        interestBody: "Buying greencoins isn't available on the site yet. Leave your email and we'll let you know the moment it's ready.",
        interestEmailPlaceholder: "you@organization.org",
        interestSubmit: "Notify me",
        interestError: "Couldn't send that. Please try again.",
        interestDoneTitle: "Thanks!",
        interestDoneBody: "We've noted your interest and will email you as soon as buying greencoins is live.",
        interestClose: "Close",
        payWithCard: "Pay by card",
        redirectingToBank: "Redirecting to the bank...",
        cardPaymentSuccess: "Payment successful, your balance has been topped up!",
        cardPaymentFailed: "Payment failed. You can try again.",
        cardPaymentError: "Something went wrong with the payment. Please try again.",
      },
      organizationPanel: {
        back: "Back",
        title: "Organization Panel",
        subtitle: "Your organization's activity, published projects, and greencoin rewards, all in one place.",
        loading: "Loading...",
        tabOverview: "Overview",
        tabPrograms: "Projects",
        tabGreencoins: "Greencoins",
        statsTitle: "At a glance",
        statProfileViews: "Profile views",
        statFollowers: "Followers",
        statPrograms: "Projects",
        statProgramViews: "Project views",
        statApplyClicks: "Apply clicks",
        statApplicants: "Applicants",
        statusApproved: "approved",
        statusPending: "in review",
        programsTitle: "Your projects",
        publishNew: "Publish a project",
        noPrograms: "You haven't published any projects yet.",
        viewsLabel: "views",
        clicksLabel: "apply clicks",
        manageAll: "Manage all submissions",
        status: {
          approved: "Approved",
          pending: "Pending",
          needs_edit: "Needs edit",
          rejected: "Rejected",
        },
        greencoinsTitle: "Greencoin rewards",
        buyGreencoins: "Buy greencoins",
        balanceLabel: "Wallet balance",
        rewardsNote: "Set how many greencoins a participant earns for completing each project. You can adjust the amount at any time, even after the project is live.",
        noApprovedPrograms: "No approved projects yet.",
        rewardLabel: "Greencoin reward",
        rewardSaveError: "Couldn't save the reward. Please try again.",
        lowBalanceWarning: "Your wallet balance is lower than this reward. Top it up so participants get paid.",
        tabUsers: "Users",
        users: {
          title: "Create a user account",
          subtitle: "Create a login and password for someone who won't register themselves, a regular account not tied to your organization. They sign in with it and can customize their own public profile (photo, cover, bio, accent color) from Settings.",
          namePlaceholder: "First name",
          surnamePlaceholder: "Last name (optional)",
          emailPlaceholder: "Email",
          passwordPlaceholder: "Password",
          createBtn: "Create account",
          creating: "Creating...",
          created: "Account created for {{email}}",
          createError: "Couldn't create the account. Please try again.",
          listTitle: "Accounts you've created",
          empty: "You haven't created any user accounts yet.",
        },
      },
      greencoinsPage: {
        back: "Back",
        title: "Greencoins",
        subtitle: "Earn greencoins across the platform and spend them in the Greenwich Shop.",
        balanceLabel: "Your balance",
        goToShop: "Go to shop",
        tabEarned: "Earned",
        tabSpent: "Spent",
        tabWays: "Ways to earn",
        earnedEmpty: "No greencoins earned yet. Get started by completing your profile or joining a program.",
        spentEmpty: "No purchases yet.",
        waysIntro: "Everyday ways to earn greencoins on Greenwich:",
        aboutTitle: "What are greencoins?",
        aboutBody: "Greencoins aren't money. They're Greenwich's internal recognition system, earned by being active and engaged on the platform. You can't cash them out today, but that option is planned for the future.",
        aboutPerks: {
          redeem: { title: "Real rewards", desc: "Redeem what you earn for real perks and prizes in the Greenwich Shop." },
          motivation: { title: "Recognition, not cash", desc: "A way to measure and reward real contribution, not a currency." },
          future: { title: "Cash-out coming later", desc: "Converting greencoins to real money isn't possible yet, but it's on the roadmap." },
        },
        stat5x: "Posts and projects with a greencoin reward attached see about 5x more interest from members.",
        actions: {
          account_verified: "Verifying your account",
          profile_complete: "Completing your profile",
          onboarding_complete: "Finishing onboarding",
          program_apply: "Applying to a program",
          program_apply_milestone_10: "Applying to 10 programs (one-time)",
          program_accepted: "Being accepted into a program",
          event_attended: "Completing/attending a program",
          project_joined: "Joining a project/community",
          review_written: "Writing a review",
          daily_login: "Logging in each day",
          login_streak_7: "7-day login streak",
          buddy_mentee_completed: "Completing a Buddy mentorship as mentee",
          buddy_mentor_completed: "Completing a Buddy mentorship as mentor",
          buddy_mentor_certificate: "Earning a Buddy mentor certificate",
          referral_signup: "Each friend you refer who signs up",
          social_event_participation: "Taking part in an important social/community event",
        },
      },
      orgMySubmissions: {
        title: "My Submissions",
        subtitle: "Track and manage your submitted programs",
        refresh: "Refresh",
        greencoinWallet: "Greencoin Wallet",
        submitNew: "Submit New",
        statTotal: "Total",
        statPending: "Pending",
        statApproved: "Approved",
        statNeedsEdit: "Needs Edit",
        loading: "Loading your submissions…",
        emptyTitleAll: "No submissions yet",
        emptyTitleFiltered: "No {{filter}} programs",
        emptyBodyAll: "Submit your first program to get started.",
        emptyBodyFiltered: "You have no {{filter}} programs at this time.",
        submitProgram: "Submit a Program",
        filterNames: { pending: "pending", approved: "approved", rejected: "rejected" },
        statusPending: "Pending Review",
        statusApproved: "Approved",
        statusRejected: "Not Approved",
        submitted: "Submitted {{date}}",
        editResubmitHeading: "Edit & Resubmit",
        fieldTitle: "Program Title *",
        fieldTitlePlaceholder: "Title",
        fieldWebsite: "Website / Application Link",
        fieldUrlPlaceholder: "https://…",
        fieldLocation: "Location",
        fieldLocationPlaceholder: "City, Country or Online",
        fieldDeadline: "Deadline",
        fieldDescription: "Description *",
        fieldDescriptionPlaceholder: "Describe your program…",
        fieldRequirements: "Requirements",
        fieldRequirementsPlaceholder: "Eligibility requirements…",
        fieldBenefits: "Benefits",
        fieldBenefitsPlaceholder: "What participants receive…",
        fieldCoverImage: "Cover Image URL",
        cancel: "Cancel",
        resubmitForReview: "Resubmit for Review",
        viewProgram: "View Program",
        messageFromAdmin: "Message from Admin",
        feedbackCta: "Please review the feedback above and resubmit your program with the required changes.",
        pendingNotice: "Your program is under review. We'll notify you once a decision is made.",
        approvedNotice: "Your program is live and visible on the Programs page.",
        viewArrow: "View →",
        editAndResubmit: "Edit & Resubmit",
        updateAndResubmit: "Update & Resubmit",
        resubmittedToast: "🔄 Resubmitted for review!",
        savedLocallyToast: "🔄 Saved locally, will sync when online.",
        statusNeedsEdit: "Needs Edit",
        applications: "Applications",
        withdraw: "Withdraw",
        confirmWithdraw: "Withdraw this submission? This cannot be undone.",
        withdrawnToast: "Submission withdrawn",
        withdrawFailedToast: "Failed to withdraw submission",
      },
      shareMenu: {
        sharePost: "Share Post",
        copyLink: "Copy Link",
        defaultShareText: "Check out this post",
      },
      userPublicProfile: {
        loginRequired: "You need to log in to view profiles.",
        loadingProfile: "Loading profile...",
        userNotFound: "User not found",
        goBack: "Go Back",
        failedLoadProfile: "Failed to load profile.",
        failedLoadPosts: "Failed to load posts.",
        justNow: "Just now",
        minutesAgo: "{{n}}m ago",
        hoursAgo: "{{n}}h ago",
        daysAgo: "{{n}}d ago",
        confirmBlock: "Block {{name}}? They won't be able to follow or message you.",
        userMuted: "User muted, their posts are hidden from your feed",
        userUnmuted: "User unmuted",
        userBlocked: "User blocked",
        userUnblocked: "User unblocked",
        failedToMuteUser: "Failed to mute user",
        failedToUnmuteUser: "Failed to unmute user",
        failedToBlockUser: "Failed to block user",
        failedToUnblockUser: "Failed to unblock user",
        reportSubmitted: "Report submitted. Thanks for helping keep the community safe.",
        failedSubmitReport: "Failed to submit report",
        needMutualFollowMessage: "You need to follow each other to send messages",
        messageSent: "Message sent!",
        failedSendMessage: "Failed to send message",
        failedStartConversation: "Failed to start conversation",
        profileLinkCopied: "Profile link copied!",
        failedShareProfile: "Failed to share profile",
        back: "Back",
        coverAlt: "Cover",
        verified: "Verified",
        verifiedOrg: "Verified Org",
        organization: "Organization",
        communityMember: "Community Member",
        approved: "Approved",
        message: "Message",
        copied: "Copied!",
        copyLink: "Copy link",
        shareOnFacebook: "Share on Facebook",
        moreOptions: "More options",
        pleaseWait: "Please wait…",
        unmute: "Unmute",
        mutePosts: "Mute posts",
        unblock: "Unblock",
        blockUser: "Block user",
        reportUser: "Report user",
        postsLabel: "Posts",
        aboutLabel: "About",
        reportsTabLabel: "Reports",
        portfolioLabel: "Portfolio",
        certificatesLabel: "Certificates",
        followersLabel: "Followers",
        followingLabel: "Following",
        joined: "Joined {{date}}",
        quickMessagePlaceholder: "Send a quick message…",
        noPostsYet: "No posts yet",
        postImageAlt: "Post image {{n}}",
        postAlt: "Post",
        nameLabel: "Name",
        emailLabel: "Email",
        phoneLabel: "Phone",
        locationLabel: "Location",
        interestsLabel: "Interests",
        missionLabel: "Mission",
        reportsTitle: "Reports & Licenses",
        noReportsYet: "No reports uploaded yet.",
        view: "View",
        download: "Download",
        noPortfolioYet: "No portfolio items yet.",
        noCertificatesYet: "No certificates added yet.",
        viewPdf: "View PDF",
        noFollowersYet: "No followers yet",
        orgBadge: "Org",
        followsYou: "Follows you",
        friends: "Friends",
        notFollowingAnyone: "Not following anyone yet",
        mutual: "Mutual",
        previewNotAvailable: "Preview not available for this file type.",
        reportModalTitle: "Report {{name}}",
        reportModalSubtitle: "Select a reason. This is anonymous to the person reported.",
        reportReasons: {
          spam: "Spam",
          inappropriate: "Inappropriate Content",
          harassment: "Harassment",
          hateSpeech: "Hate Speech",
          misinformation: "Misinformation",
          other: "Other",
        },
        detailsPlaceholder: "Additional details (optional)",
        cancel: "Cancel",
        submitting: "Submitting…",
        submitReport: "Submit Report",
        comments: "Comments",
        noCommentsYet: "No comments yet. Be first!",
        addCommentPlaceholder: "Add a comment…",
        interests: {
          environment: "Environment", education: "Education", technology: "Technology", health: "Health",
          artsCulture: "Arts & Culture", communityDevelopment: "Community Development", humanRights: "Human Rights",
          socialInclusion: "Social Inclusion", internationalExchanges: "International Exchanges", entrepreneurship: "Entrepreneurship",
        },
      },
      blockedMuted: {
        pleaseLogin: "Please log in to view this page",
        backToSettings: "Back to Settings",
        blockedTitle: "Blocked Accounts",
        blockedSubtitle: "People you've blocked can't follow you, message you, or see your profile.",
        failedLoadBlocked: "Failed to load blocked accounts",
        userUnblocked: "User unblocked",
        failedUnblock: "Failed to unblock user",
        noBlocked: "No blocked accounts",
        blockedEmptyHint: "Accounts you block will show up here.",
        unblocking: "Unblocking…",
        unblock: "Unblock",
        mutedTitle: "Muted Accounts",
        mutedSubtitle: "Their posts are hidden from your feed. You still follow each other and can still message normally. They aren't notified.",
        failedLoadMuted: "Failed to load muted accounts",
        userUnmuted: "User unmuted",
        failedUnmute: "Failed to unmute user",
        noMuted: "No muted accounts",
        mutedEmptyHint: "Accounts you mute will show up here.",
        unmuting: "Unmuting…",
        unmute: "Unmute",
        loading: "Loading...",
      },
      orgDashboard: {
        organization: "Organization",
        noLocation: "No location set",
        noEmail: "No email",
        aboutOrg: "About Organization",
        noDescription: "No description yet",
        areasOfInterest: "Areas of Interest",
        noInterests: "No interests selected yet",
        welcomeTitle: "Welcome to Your Organization Dashboard",
        welcomeMessage: "Welcome back, {{name}}! This is your organization dashboard where you can manage your profile and activities.",
        quickActions: "Quick Actions",
        panel: "Organization Panel",
        editProfile: "Edit Profile",
        viewActivities: "View Activities",
        settings: "Settings",
        recentActivity: "Recent Activity",
        profileCompleted: "Organization profile completed successfully",
        interestsUpdated: "Interests updated",
        today: "Today",
      },
      orgVerification: {
        sectionTitle: "Verification",
        pitch: "Get a verified badge and become eligible for the organizations ranking. Submit your legal documents for a quick review.",
        benefitBadge: "A verified badge on your profile and posts",
        benefitRanking: "Eligible for the organizations ranking and featured placement",
        startBtn: "Get Verified",
        resubmitBtn: "Resubmit for Verification",
        statusPending: "Verification request submitted",
        statusApproved: "Organization verified",
        statusRejected: "Verification request rejected",
        etaHint: "This usually takes up to a week to review.",
        modalTitle: "Request Verification",
        modalSubtitle: "Submit your legal details and documents for review",
        registrantRoleQuestion: "Are you the organization itself, or its representative?",
        registrantRoleOrg: "The organization",
        registrantRoleRep: "I'm a representative",
        name: "Name",
        surname: "Surname",
        position: "Position / Title",
        phone: "Phone",
        email: "Email",
        isInformalQuestion: "Is your organization an informal / unregistered group?",
        formallyRegistered: "No, formally registered",
        informal: "Yes, informal",
        stateRegNumber: "State Registration Number",
        countryOfReg: "Country of Registration",
        dateOfReg: "Date of Registration",
        taxId: "Tax ID / Legal ID",
        vatNumber: "VAT Number",
        registeredAddress: "Registered Legal Address",
        documentsTitle: "Documents",
        registrationDoc: "Registration Document",
        vatCertificate: "VAT Certificate",
        stateSeal: "State Seal",
        passportScan: "Representative's Passport Scan",
        uploadShort: "Upload",
        alreadyUploaded: "already uploaded",
        errorRole: "Please specify whether you're the organization or its representative",
        errorRep: "Representative name, surname and position are required",
        errorLegal: "All legal registration fields are required unless you're an informal group",
        errorSubmit: "Failed to submit verification request. Please try again.",
        fileTooLarge: "Files must be smaller than 8MB.",
        submitting: "Submitting...",
        submit: "Submit for Review",
      },
      supportChat: {
        title: "Greenwich Support",
        welcome: "Hi! Ask me anything about how Greenwich works: programs, applications, organizations, Pro, greencoins, and more.",
        placeholder: "Type your question...",
        error: "Something went wrong. Please try again.",
        leaveContact: "Talk to a human, leave your contact",
        contactIntro: "Leave your name and a way to reach you, and an admin will contact you directly.",
        contactNamePlaceholder: "Your name",
        contactInfoPlaceholder: "Email or phone number",
        contactNotePlaceholder: "What's this about? (optional)",
        contactSubmit: "Send",
        contactSending: "Sending...",
        contactSent: "Thanks! An admin will reach out to you soon.",
        backToChat: "← Back to chat",
      },
      activeSessions: {
        pleaseLogin: "Please log in to view this page",
        backToSettings: "Back to Settings",
        title: "Active Sessions",
        subtitle: "Devices currently signed in to your account. Log out anything you don't recognize.",
        failedLoad: "Failed to load sessions",
        deviceLoggedOut: "Device logged out",
        failedLogout: "Failed to log out device",
        confirmRevokeAll: "Log out of all other devices?",
        loggedOutAll: "Logged out of all other devices",
        failedLogoutAll: "Failed to log out other devices",
        loading: "Loading...",
        noSessions: "No tracked sessions yet. This shows up for logins made after this feature shipped.",
        thisDevice: "This device",
        loggingOut: "Logging out…",
        logout: "Log out",
        logoutOtherDevices: "Log out other devices ({{count}})",
        activeJustNow: "Active just now",
        activeMinAgo: "Active {{n}}m ago",
        activeHourAgo: "Active {{n}}h ago",
        activeDayAgo: "Active {{n}}d ago",
        unknownBrowser: "Unknown browser",
        unknownDevice: "Unknown device",
        onDevice: "{{browser}} on {{os}}",
      },
      socialAuth: {
        googleLoadFailed: "Google sign-in could not be loaded.",
        facebookLoadFailed: "Facebook sign-in could not be loaded.",
        googleCancelled: "Google sign-in was cancelled.",
        googleFailed: "Google sign-in failed.",
        facebookCancelled: "Facebook sign-in was cancelled.",
        facebookFailed: "Facebook sign-in failed.",
        signUpWith: "Sign up with",
        continueWith: "Continue with",
        connectingGoogle: "Connecting Google...",
        connectingFacebook: "Connecting Facebook...",
        configHint: "Social sign-in is currently unavailable.",
      },
      playerInterest: {
        loading: "Loading...",
        maxInterests: "You can select up to 5 interests",
        selectAtLeastOne: "Please select at least one interest",
        failedSave: "Failed to save interests",
        errorSaving: "An error occurred while saving your interests",
        detailsTitle: "Complete your profile",
        detailsSubtitle: "A few quick details so people can find and recognize you.",
        usernameLabel: "Username",
        usernamePlaceholder: "e.g. john_doe",
        nameLabel: "First name",
        surnameLabel: "Last name",
        dobLabel: "Date of birth",
        invalidUsername: "Username must be 3-20 characters: lowercase letters, numbers, underscores or periods",
        usernameChecking: "Checking availability...",
        usernameAvailable: "Username is available",
        usernameTaken: "This username is already taken",
        nameRequired: "Please enter your first name",
        title: "What are you into?",
        subtitle: "Pick up to 5. This is exactly what our AI matching uses to find programs worth your time.",
        selected: "Selected",
        skipForNow: "Skip for Now",
        saving: "Saving...",
        continueBtn: "Continue",
        interestEnvironment: "Environment",
        interestEducation: "Education",
        interestTechnology: "Technology",
        interestHealth: "Health",
        interestArts: "Arts & Culture",
        interestCommunityDev: "Community Dev",
        interestHumanRights: "Human Rights",
        interestSocialInclusion: "Social Inclusion",
        interestIntlExchanges: "Intl Exchanges",
        interestEntrepreneurship: "Entrepreneurship",
      },
      orgActivities: {
        noToken: "No authentication token found.",
        confirmDeletePost: "Delete this post?",
        deleteError: "Delete error: {{message}}",
        noPostsYet: "No posts yet",
        organization: "Organization",
        loadingTab: "Loading {{tab}}...",
        error: "Error: {{message}}",
        orgCreatedPost: "Your organization created a post",
        noActivityYet: "No activity yet",
        title: "Organization Activities",
        subtitle: "Track posts and interactions",
        all: "All",
        posts: "Posts",
        liked: "Liked",
        saved: "Saved",
        profileAlt: "Profile",
        postAlt: "Post",
        deleteFailed: "Delete failed",
      },
      activities: {
        noToken: "No authentication token found. Please log in again.",
        unknownApiError: "Unknown API error",
        confirmDeletePost: "Are you sure you want to delete this post? It will be moved to trash for 30 days before permanent deletion.",
        errorDeletingPost: "Error deleting post: {{message}}",
        justNow: "Just now",
        hoursAgo: "{{n}}h ago",
        daysAgo: "{{n}}d ago",
        errorLoadingTitle: "Error Loading Data",
        tryAgain: "Try Again",
        loadingYour: "Loading your {{tab}}...",
        noActivitiesYet: "No activities yet. Start by creating your first post!",
        noPostsYetCreate: "No posts yet. Create your first post from your profile!",
        noLikedYet: "No liked posts yet. Start exploring and liking posts!",
        noSavedYet: "No saved posts yet. Save posts to find them later!",
        you: "You",
        unknown: "Unknown",
        deletePost: "Delete post",
        activityPost: "You created a new post",
        activityLike: "You liked a post",
        activitySave: "You saved a post",
        activityComment: "You commented on a post",
        newActivity: "New activity",
        title: "Your Activities",
        subtitle: "Track your engagement and content",
        allActivities: "All Activities",
        myPosts: "My Posts",
        likedPosts: "Liked Posts",
        savedPosts: "Saved Posts",
        profileAlt: "Profile",
        postAlt: "Post",
        deleteAlt: "Delete",
        likesAlt: "Likes",
        commentsAlt: "Comments",
        savesAlt: "Saves",
      },
      pages: {
        welcome: {
          skip: "Skip",
          next: "Next",
          slide1Title: "Find real opportunities",
          slide1Desc: "Browse verified scholarships, grants, fellowships, internships and exchange programs, all matched to you by AI, all in one place.",
          slide2Title: "Apply in a few clicks",
          slide2Desc: "Fill out your profile once, then apply to programs directly through Greenwich and track every application's status as it moves.",
          slide3Title: "You're not doing this alone",
          slide3Desc: "Get paired with a Greenwich Buddy mentor, join a community of applicants like you, and earn greencoins along the way.",
          consentTitle: "Before you start",
          consentDesc: "We use essential cookies and data to make Greenwich work properly and to improve your experience. By continuing, you agree to our use of cookies as described in our Privacy Policy.",
          consentAgree: "Agree & start using Greenwich",
          alreadyHaveAccount: "Already have an account?",
          logIn: "Log in",
        },
        seo: {
          home: {
            title: "Greenwich: Scholarships, Grants & Exchange Programs for Armenian Youth",
            description: "Greenwich is Armenia's platform for scholarships, grants, fellowships, internships and exchange programs. Get AI-matched to verified opportunities and find a Greenwich Buddy mentor, free and in one place.",
            keywords: "scholarships Armenia, grants for Armenian youth, fellowships Armenia, internships Armenia, Erasmus+ Armenia, exchange programs Armenia, study abroad Armenia, volunteer programs Armenia, AI matching scholarships, Greenwich Buddy mentor, free scholarships for Armenian students, study in Europe from Armenia, study in USA from Armenia, master's scholarships Armenia, PhD scholarships Armenia, undergraduate scholarships Armenia, summer school Armenia, paid internships abroad Armenia, remote internships Armenia, youth exchange programs, mentorship program Armenia, education opportunities Yerevan, scholarship search engine Armenia, funded study abroad programs, international exchange for students, Armenian students abroad, Erasmus Armenia application",
          },
          whoweare: {
            title: "Who We Are: Greenwich Armenia",
            description: "Learn about Greenwich's mission to connect Armenian youth with verified scholarships, grants and exchange programs, and to support them through the Greenwich Buddy mentorship community.",
            keywords: "Greenwich Armenia, about Greenwich, Armenian youth NGO, education nonprofit Armenia, mentorship Armenia",
          },
          programs: {
            title: "Scholarships, Grants & Exchange Programs: Greenwich",
            description: "Browse verified scholarships, grants, fellowships, internships and exchange programs open to Armenian youth. Filter by country, deadline and category, or get AI-matched instantly.",
            keywords: "scholarships list Armenia, open grants Armenia, exchange programs list, internship opportunities Armenia, fellowship deadlines, study abroad opportunities, scholarships in Europe, scholarships in USA, scholarships in Germany, scholarships in France, scholarships in UK, Erasmus+ programs list, summer internships abroad, volunteer abroad programs, grants for university students Armenia, fully funded scholarships, scholarship deadlines 2026, exchange semester abroad, gap year programs Armenia, research fellowships, youth mobility programs",
          },
          contact: {
            title: "Contact Us: Greenwich Armenia",
            description: "Get in touch with the Greenwich Armenia team: questions about scholarships, partnerships, or the platform.",
            keywords: "contact Greenwich Armenia, Greenwich support",
          },
          donate: {
            title: "Support Armenian Youth: Donate to Greenwich",
            description: "Support Greenwich's mission to connect Armenian youth with life-changing scholarships, grants and exchange opportunities. Every contribution helps more young people find their path.",
            keywords: "donate Armenia education, support Armenian youth, Greenwich donation",
          },
          terms: {
            title: "Terms of Service: Greenwich",
            description: "Read the Terms of Service governing the use of the Greenwich platform, including accounts, acceptable use, the Greenwich Buddy program and donations.",
            keywords: "Greenwich terms of service, Greenwich terms and conditions",
          },
          privacy: {
            title: "Privacy Policy: Greenwich",
            description: "Learn how Greenwich collects, uses, and protects your personal data, including information about cookies, third-party services, and your privacy rights.",
            keywords: "Greenwich privacy policy, data protection Armenia",
          },
          registration: {
            title: "Sign Up: Greenwich",
            description: "Create your free Greenwich account to get AI-matched with scholarships, grants and exchange programs, and connect with a Greenwich Buddy mentor.",
            keywords: "sign up Greenwich, register Greenwich Armenia, create account scholarships",
          },
        },
        footer: {
          contactUs: "Contact Us",
          whoWeAre: "Who we are",
          feed: "Feed",
          community: "Community",
          account: "Account",
          organizations: "Organizations",
          contact: "Contact us",
          projects: "Projects",
          donate: "Donate",
          terms: "Terms",
          privacy: "Privacy",
          copyright: "© 2026 Greenwich Armenia",
          copyrightLong: "© 2026 Greenwich Armenia. All rights reserved.",
        },
        home: {
          hero1: "Youth",
          hero2: "Connect",
          tagline: "Your map of global opportunities",
          explorePrograms: "Explore Programs",
          roleCardPlayer: "I am\na player",
          roleCardPlayerSub: "Discover programs and apply in a few clicks",
          roleCardOrganizer: "I am an\norganizer",
          roleCardOrganizerSub: "Publish your programs and find participants",
          searchOpportunities: "Search Opportunities",
          searchCtaText: "Every year, more than 10,000,000 young people worldwide take part in exchange programs, scholarships, and internships abroad, completely free of charge.",
          searchCtaHint: "Drag a bubble around, or tap it to see what it offers ↓",
          filterScholarship: "Scholarships",
          filterExchange: "Exchange",
          filterVolunteering: "Volunteering",
          filterInternship: "Internships",
          filterGrant: "Grants",
          filterEducation: "Education",
          filterFellowship: "Fellowships",
          filterTraining: "Training",
          benefitScholarship: "Cover part or all of your tuition. Many scholarships also include a monthly stipend, housing, and health insurance, so you can focus entirely on studying abroad.",
          benefitExchange: "Spend a semester or a full year at a partner university abroad, earn credits that count back home, and build friendships across dozens of countries.",
          benefitVolunteering: "Live, work, and travel abroad for free. Most volunteering programs already cover accommodation, meals, and even a monthly allowance.",
          benefitInternship: "Get real, hands-on work experience at an international company or organization. Many placements are paid and open doors to future job offers.",
          benefitGrant: "Get funding for your own idea, research, or project. Travel, research, and project grants almost never need to be paid back.",
          benefitEducation: "Study abroad at every level, from a semester exchange to a full bachelor's, master's, or PhD program at a foreign university.",
          benefitFellowship: "Join a research or professional fellowship abroad, work alongside experts in your field, and grow a network that lasts well beyond the program.",
          benefitTraining: "Build practical, job-ready skills through short courses and workshops abroad: professional, technical, or soft skills, online or in person.",
          hotNow: "Deadline Soon",
          noDeadlinesSoon: "No programs with a deadline today or tomorrow right now",
          programFallback: "Program",
          untitledProgram: "Untitled Program",
          countriesHeading: "Find opportunities from all over the world",
          deadlineBadge: "Deadline",
          daysShort: "d ",
          seeMore: "See more",
          viewArrow: "View →",
          topOrgs: "Top Organizations of the Month",
          topOrgsDesc: "The ranking is based on the impact of our programs, the number of participants, feedback, visibility, and other key indicators. It highlights organizations that actively contribute to community growth, foster meaningful engagement, and create sustainable positive change.",
          topOrgsDescMobile: "Rankings based on impact, participants & community feedback.",
          orgLabel: "Organization",
          unknown: "Unknown",
          seeTopList: "See Top List",
          partners: "Partners",
          feedbackTitle: "Feedback from Greenwich members",
          supportedBy: "Supported by",
          thankYou: "Thank you!",
          feedbackSent: "Your feedback has been sent successfully.",
          betaVersion: "Beta Version",
          shareFeedback: "Share Your Feedback",
          shareFeedbackSub: "Help us improve YouthConnect, your opinion matters!",
          ratingOptional: "Rating (optional)",
          inProgress: "In Progress",
          comingSoonLabel: "Coming Soon",
          craftingSpecial: "We're crafting something special.",
          checkBack: "Check back very soon.",
          heroSubDesktop: "Scholarships, grants, fellowships and exchange programs from around the world, matched to Armenian youth and organizations, all in one place.",
          heroSubMobile: "Scholarships, grants & exchange programs for Armenian youth, all in one place.",
          memberFeedbackSoon: "Member Feedback",
          supportedBySoon: "Supported By",
          aiKicker: "AI Matching",
          aiTitle: "AI Matching is here",
          aiDesc: "We figure out which programs actually fit your interests and match you to them automatically.",
          aiPoint1: "Ranked by fit",
          aiPoint2: "New picks daily",
          aiPoint3: "Set up in under a minute",
          aiCta: "Try it now",
          buddyKicker: "Greenwich Buddy",
          buddyTitle: "Want to learn something new? Or teach it?",
          buddyDesc: "Join Buddy as a mentor or a mentee and start building new friendships and connections.",
          buddyPoint1: "Matched by shared interests",
          buddyPoint2: "One focused month",
          buddyPoint3: "Certificate after 6 mentees",
          buddyCta: "Join Buddy",
          faqKicker: "Frequently asked questions",
          faqTitle: "Everything you need to know about Greenwich",
          faqQ1: "What is Greenwich?",
          faqA1: "Greenwich is a free platform that connects Armenian youth (roughly ages 14-35) with scholarships, grants, fellowships, internships and exchange programs from Armenia and around the world, including opportunities like Erasmus+. We collect verified opportunities in one place so you don't have to search dozens of sites.",
          faqQ2: "Is it free to use Greenwich and apply for scholarships or grants?",
          faqA2: "Yes. Creating an account, browsing programs, using AI Matching and joining Greenwich Buddy are completely free for students. Greenwich never charges a fee to apply to a scholarship, grant or exchange program listed on the platform.",
          faqQ3: "How does AI Matching work?",
          faqA3: "AI Matching looks at your profile, interests and goals and automatically recommends scholarships, grants, internships and exchange programs that fit you, instead of making you scroll through every listing manually.",
          faqQ4: "What is Greenwich Buddy?",
          faqA4: "Greenwich Buddy is our peer-mentorship program. You can join as a mentee to get guidance from someone with relevant experience, or become a mentor yourself after completing the program, make new connections, and earn a certificate.",
          faqQ5: "What kind of opportunities can I find: scholarships, grants, internships, exchange programs?",
          faqA5: "Greenwich lists scholarships, university grants, fellowships, paid and unpaid internships, volunteer programs and exchange programs (including Erasmus+) for study, work and volunteering both in Armenia and abroad.",
          faqQ6: "Who can use Greenwich?",
          faqA6: "Greenwich is built for Armenian youth roughly between 14 and 35 years old: high school and university students, recent graduates and young professionals looking for their next scholarship, grant, internship or exchange opportunity.",
          statsKicker: "Our achievements",
          trustLabelUsers: "users on the platform",
          trustLabelOpportunities: "opportunities published",
          trustLabelSatisfaction: "find a project they love",
          trustLabelCountries: "countries with active programs",
        },
        programs: {
          allPrograms: "All Programs",
          greencoinReward: "+{{amount}} greencoins on completion",
          greencoinsFilter: "Greencoin rewards",
          programsFound: "{{count}} program(s) found",
          viewDetails: "View Details",
          noPrograms: "No programs found",
          adjustFilters: "Try adjusting your filters.",
          resetFilters: "Reset Filters",
          clear: "Clear",
          anyAge: "Any Age",
          anyTime: "Any Time",
          educationAny: "Any level",
          educationLevelLabel: "Education",
          educationLevelShort: "Education",
          educationUndergraduate: "Undergraduate",
          educationGraduate: "Graduate (Master's)",
          educationDoctoral: "Doctoral / PhD",
          educationStudent: "Student (general)",
          educationProfessional: "Professional",
          educationHighSchool: "High school",
          filtersLabel: "Filters",
          ageLabel: "Age",
          age18_25: "18-25 years",
          age25_35: "25-35 years",
          age35plus: "35+ years",
          deadlinePassed: "Deadline Passed",
          deadlineLabel: "Deadline",
          applyDeadlineLabel: "Application deadline",
          eventDateLabel: "Event date",
          eventDatePassed: "Event Passed",
          funding: "Funding",
          location: "Location",
          pending: "Pending",
          rejected: "Rejected",
          approve: "Approve",
          reapprove: "Re-approve",
          reject: "Reject",
          revoke: "Revoke",
          edit: "Edit",
          delete: "Delete",
          save: "Save",
          cancel: "Cancel",
          title: "Title",
          description: "Description",
          saveProgram: "Save",
          unsaveProgram: "Saved",
          savePromptLogin: "Log in to save programs",
          recommendedTitle: "Recommended for you",
          popularTitle: "Popular right now",
          recommendedLoading: "Finding programs for you…",
          recommendedEmpty: "Nothing to recommend yet. Explore programs to get personalized picks.",
          heroTitle: "Explore Programs",
          heroSubtitle: "Scholarships, fellowships, internships, awards and more",
          sourceLabel: "Source:",
          sourceByAi: "By AI",
          sourceByAdmin: "By Admin",
          sourceByOrganization: "By Organization",
          sourceAllOption: "Source: All",
          allSectorsOption: "All Sectors",
          sector_ecology: "Ecology",
          sector_international: "International",
          sector_technology: "Technology",
          sector_medical: "Medical",
          sector_education: "Education",
          sector_business: "Business",
          sector_arts: "Arts & Culture",
          sector_science: "Science",
          sector_sports: "Sports",
          sector_agriculture: "Agriculture",
          sector_local: "Local",
          sector_media: "Media",
          cat_education: "Education",
          cat_scholarship: "Scholarship",
          cat_fellowship: "Fellowship",
          cat_erasmusplus: "Erasmus Plus",
          cat_training: "Training",
          cat_grant: "Grant",
          cat_internship: "Internship",
          cat_conference: "Conference",
          cat_online: "Online",
          cat_volunteering: "Volunteering",
          cat_event: "Event",
          cat_award: "Award",
          sub_all_education: "All Education",
          sub_abroad: "Study Abroad",
          sub_bachelor: "Bachelor",
          sub_master: "Master",
          sub_phd: "PhD",
          sub_online: "Online",
          sub_all_scholarship: "All Scholarships",
          sub_full: "Full",
          sub_partial: "Partial",
          sub_government: "Government",
          sub_private: "Private",
          sub_all_fellowship: "All Fellowships",
          sub_research: "Research",
          sub_postdoc: "Postdoctoral",
          sub_visiting: "Visiting",
          sub_all_erasmusplus: "All Erasmus+",
          sub_ka1: "KA1 - Mobility",
          sub_ka2: "KA2 - Cooperation",
          sub_ka3: "KA3 - Policy",
          sub_all_training: "All Training",
          sub_professional: "Professional",
          sub_technical: "Technical",
          sub_soft_skills: "Soft Skills",
          sub_online_training: "Online",
          sub_all_grant: "All Grants",
          sub_research_grant: "Research",
          sub_project_grant: "Project",
          sub_travel_grant: "Travel",
          sub_all_internship: "All Internships",
          sub_summer: "Summer",
          sub_paid: "Paid",
          sub_unpaid: "Unpaid",
          sub_virtual: "Virtual",
          sub_all_conference: "All Conferences",
          sub_international_conf: "International",
          sub_funded_conf: "Funded",
          sub_virtual_conf: "Virtual",
          sub_all_online: "All Online",
          sub_online_course: "Course",
          sub_webinar: "Webinar",
          sub_mooc: "MOOC",
          sub_all_volunteering: "All Volunteering",
          sub_local_vol: "Local",
          sub_international_vol: "International",
          sub_evs: "EVS / ESC",
          sub_all_event: "All Events",
          sub_festival: "Festival",
          sub_competition: "Competition",
          sub_summit: "Summit",
          sub_all_award: "All Awards",
          sub_international_award: "International",
          sub_national_award: "National",
          sub_regional_award: "Regional",
          sub_special_award: "Special Recognition",
          deadlineAny: "Any deadline",
          deadlineLast24h: "Last 24 hours",
          deadlineIn3Days: "In 3 days",
          deadlineIn7Days: "In 7 days",
          deadlineIn30Days: "In 30 days",
          archiveLabel: "Archive",
          archiveShowActive: "Show active programs",
          archiveShowArchive: "Show archive",
          archiveEmpty: "No archive",
          aiMatchingTag: "AI Matching",
          aiThinkingButton: "AI is thinking…",
          aiMatchedToday: "Matched today ✓",
          aiShowAllPrograms: "Show all programs",
          aiNextMatchIn: "Next AI match in {{time}}",
          aiNewMatchesIn: "New matches available in {{time}}",
          aiShowProgramsMatchedTooltip: "Show programs matched to you by AI",
          aiOverlaySub: "Matching your interests against every open program…",
          aiCouldNotLoad: "Couldn't load recommendations",
          tryAgain: "Try again",
          aiNoStrongMatches: "No strong matches yet",
          aiBrowseAndSave: "Browse and save a few programs so we can learn what you like.",
          programsMatchedCount: "{{count}} programs matched to you",
          aiPhaseReading: "Reading your interests…",
          aiPhaseScanning: "Scanning open programs…",
          aiPhaseComparing: "Comparing categories & sectors…",
          aiPhaseScoring: "Scoring the best matches…",
          aiPhaseAlmost: "Almost there…",
          nowLabel: "now",
          unlockPreviewText: "You're seeing {{previewLimit}} of {{count}} programs. Create a free account to unlock the rest, save favorites, and get deadline reminders.",
          unlockMoreWaiting: "{{count}} more programs are waiting for you",
          unlockFullListText: "Create a free account to unlock the full list, save programs you like, and get reminders before deadlines close.",
          unlockFullListCta: "Unlock Full List, It's Free",
          orgBarQuestion: "Want to list your program?",
          mySubmissions: "My Submissions",
          submitNew: "Submit New",
          categoriesLabel: "Categories",
          sidebarClose: "Close",
          sidebarFilter: "Filter",
          deleteConfirmTitle: "Delete this program?",
          deleteConfirmBody: "This action cannot be undone.",
          loadingPrograms: "Loading programs…",
          durationLabel: "Duration",
          datesLabel: "Dates",
          targetGroupLabel: "Target Group",
          formatLabel: "Format",
          organizerLabel: "Organizer",
          mediaLabel: "Media",
          additionalDetailsLabel: "Additional Details",
          requirementsLabel: "Requirements",
          benefitsLabel: "Benefits",
          openMediaLabel: "Open media",
          applyNowLabel: "Apply Now",
          applyLabel: "Apply",
          copyLinkLabel: "Copy Link",
          copyLinkTooltip: "Copy shareable link",
          yourApplicationLabel: "Your Application",
          acceptedStatus: "Accepted",
          notAcceptedStatus: "Not accepted",
          attendedStatus: "Attended",
          appStatusPendingMsg: "Application submitted, awaiting response.",
          appAcceptedMsg: "Accepted!",
          appNotAcceptedMsg: "Not accepted.",
          appAttendedMsg: "Attendance confirmed.",
          appCertificateMayFollow: "A certificate may follow.",
          rateOrgTitle: "Rate this organization",
          optionalCommentPlaceholder: "Optional comment",
          submitReviewLabel: "Submit Review",
          submittingLabel: "Submitting...",
          thanksForFeedback: "Thanks for your feedback!",
          starAriaLabel: "{{n}} star",
          linkCopiedToast: "🔗 Link copied!",
          applicationSubmittedToast: "✅ Application submitted!",
          submitReviewFailedToast: "Failed to submit review",
          submitReviewNetworkErrorToast: "Network error submitting review",
          loadRecommendationsFailedError: "Failed to load recommendations",
        },
        cookie: {
          title: "Cookies & privacy",
          accept: "Accept",
          reject: "Reject",
          learnMore: "Learn more",
          bannerTitle: "We value your privacy",
          bannerDesc: "By continuing to use Greenwich, you agree to our use of cookies. We collect only the essential data necessary to improve your experience and ensure the platform functions properly.",
          decline: "Decline",
          acceptContinueFull: "Accept & Continue",
          requiredTitle: "Cookies Required",
          requiredBody: "To continue using Greenwich, you must accept the use of essential cookies. These are necessary for the platform to function properly and to ensure a smooth experience.",
          acceptCookiesContinue: "Accept Cookies & Continue",
        },
        community: {
          title: "Community",
          loading: "Loading communities...",
          retry: "Retry",
          createGroup: "Create Group",
          createShort: "Create",
          myCommunities: "My Communities",
          myGroupsShort: "My Groups",
          searchPlaceholder: "Search communities...",
          filterAll: "All",
          filterOpen: "Open",
          filterClosed: "Closed",
          noGroupsSearch: "No groups found for \"{{term}}\".",
          noGroupsYet: "No groups yet. Be the first to create one!",
          createFirstGroup: "Create First Group",
          fetchError: "Failed to fetch groups",
          loadError: "Failed to load communities. Please try again.",
          joinSuccess: "Successfully joined the group!",
          joinRequestSent: "Join request sent. The group owner will review it.",
          joinFailed: "Failed to join group",
          joinError: "Error joining group. Please try again.",
          membersCount: "{{count}} members",
          public: "Public",
          private: "Private",
          admin: "Admin",
          closed: "Closed",
          manageGroup: "Manage Group",
          viewGroup: "View Group",
          joining: "Joining...",
          registrationClosed: "Registration Closed",
          join: "Join",
          noDescriptionAvailable: "No description available",
        },
        organizations: {
          topTitle: "Top Organizations",
          topSubtitle: "Most popular organizations this month",
          secondPlace: "Second Place",
          secondDesc: "Excellent organization with great achievements",
          firstPlace: "First Place",
          firstDesc: "Leading organization with outstanding performance",
          thirdPlace: "Third Place",
          thirdDesc: "Remarkable organization making a difference",
          allVerified: "All Verified Organizations",
          loading: "Loading organizations...",
          tryAgain: "Try Again",
          noneTitle: "No Organizations Found",
          noneDesc: "There are currently no organizations to display.",
          refresh: "Refresh",
          loadError: "Failed to load organizations. Please try again.",
          noDescription: "No description available",
          unknownOrg: "Unknown Organization",
        },
        adminPanel: {
          signOutTitle: "Sign out?",
          signOutBody: "Are you sure you want to log out of the admin panel?",
          cancel: "Cancel",
          yesLogOut: "Yes, log out",
          viewArrow: "View →",
          dashboardTitle: "Admin Dashboard",
          welcomeBack: "Welcome back,",
          navOrganizerApprovals: "Organizer Approvals",
          navPrograms: "Programs",
          navAnalytics: "Analytics",
          logoutBtn: "Logout",
          statTotalOrganizers: "Total Organizers",
          statPendingOrganizers: "Pending Organizers",
          statVerifiedOrganizers: "Verified Organizers",
          statRejectedUsers: "Rejected Users",
          statTotalUsers: "Total Users",
          statRecentRegistrations: "Recent Registrations",
          statBetaFeedbacks: "Beta Feedbacks",
          statTotalPosts: "Total Posts",
          statTotalPrograms: "Total Programs",
          statPendingPrograms: "Pending Programs",
          statTotalCommunities: "Total Communities",
          statPendingReports: "Pending Reports",
          reviewLink: "Review →",
          recentRegistrations: "Recent Registrations",
          noRecentRegistrations: "No recent registrations",
          colLogo: "Logo",
          colName: "Name",
          colEmail: "Email",
          colOrganization: "Organization",
          colType: "Type",
          colStatus: "Status",
          colDate: "Date",
          colActions: "Actions",
        },
        buddy: {
          title: "Buddy",
          subtitle: "A personal mentor-matching system: get connected with someone experienced in what you care about, or become that person for someone starting out.",
          backHome: "Back to home",
          loading: "Loading...",
          roleMentorTitle: "Become a Mentor",
          roleMentorDesc: "Share your experience with someone starting out in youth projects, volunteering, Erasmus+, ESC and similar opportunities.",
          roleMenteeTitle: "Become a Mentee",
          roleMenteeDesc: "Get matched with a mentor experienced in the areas you're interested in.",
          mentorInfoTitle: "The mentor's role 🌟",
          mentorInfoBody: "A mentor is an experienced participant who helps newcomers understand the world of youth projects, volunteering, Erasmus+, ESC and other opportunities.\n\nResponsibilities:\n• Stay in touch with your mentee for the full month\n• Guide with advice and real experience\n• Be respectful, responsible and supportive\n• Don't promise things you can't deliver\n\nA mentor can have up to 3 active mentees at once. After 6 successfully completed mentees, you earn a Greenwich Mentor certificate.",
          menteeInfoTitle: "The mentee's role 🚀",
          menteeInfoBody: "A mentee is someone just starting their path in youth projects, volunteering or international programs.\n\nYou can choose a mentor experienced in the areas you care about.\nYou can only have one active mentor at a time.\nA mentorship lasts 1 month.",
          agreeContinue: "I agree, continue",
          cancel: "Cancel",
          back: "Back",
          step: "Step {{current}} of {{total}}",
          formCategoriesMentor: "Pick up to 3 areas where you have experience",
          formCategoriesMentee: "Pick up to 3 areas you're interested in",
          categoriesHint: "{{count}}/3 selected",
          formExperience: "Rate your experience in this area from 1 to 10",
          formExperienceMentee: "How much experience do you already have in this area? This helps us match you with the right mentor level.",
          formExperiencePlaceholder: "1 = no experience, 10 = expert",
          experiencePrompt: "Pick a star rating",
          experienceLevels: { novice: "Novice", amateur: "Amateur", pro: "Pro", guru: "Guru" },
          menteeExperienceLabel: "{{level}} in this area",
          formProjectsCount: "How many projects have you taken part in, across your chosen areas?",
          formProjectsCountPlaceholder: "e.g. 5",
          formHours: "How many hours a week can you give to mentoring?",
          formBio: "A short bio your mentees will see (max 200 characters)",
          formBioMenteeLabel: "What do you want to achieve with a mentor? (max 200 characters)",
          formBioPlaceholder: "Tell a little about yourself...",
          formContact: "How can a matched mentee/mentor reach you?",
          contactHint: "Only shared once a request is accepted. Everything here is optional",
          contactHintMentor: "Only shared once a request is accepted. Pick at least 2 ways to be reached",
          contactInvalidHint: "One of these doesn't look right. Check the phone, email or Telegram format",
          contactMinHint: "Please fill in at least 2 contact methods",
          phonePlaceholder: "Phone number",
          emailPlaceholder: "Email",
          telegramPlaceholder: "Telegram username",
          instagramPlaceholder: "Instagram",
          facebookPlaceholder: "Facebook",
          formGender: "Your gender",
          genders: { male: "Male", female: "Female", other: "Other" },
          formPreferredMenteeGender: "What gender should your mentee be?",
          formPreferredMentorGender: "What gender should your mentor be?",
          genderPrefs: { any: "No preference", male: "Male", female: "Female", same: "Same as mine" },
          previewLabel: "Your profile preview",
          previewHint: "This is exactly what mentees will see when browsing mentors",
          noRatingsYet: "No ratings yet",
          contactLabels: { phone: "Phone", email: "Email", telegram: "Telegram", instagram: "Instagram", facebook: "Facebook" },
          continueBtn: "Continue",
          submitMentor: "Submit mentor application",
          submitMentee: "Save and see matching mentors",
          errPickCategory: "Pick at least 1 category",
          errExperience: "Enter a number from 1 to 10",
          errBioLength: "Bio must be under 100 words",
          errGeneric: "Something went wrong. Please try again.",
          mentorPendingTitle: "Application under review",
          mentorPendingBody: "Your mentor application was sent to the Greenwich admins. We'll notify you as soon as it's approved.",
          mentorRejectedTitle: "Application not approved",
          mentorRejectedBody: "Your mentor application wasn't approved this time.",
          mentorApprovedBadge: "Approved mentor",
          availabilityOn: "Available for new mentees",
          availabilityOff: "Not available right now",
          toggleAvailability: "Toggle availability",
          activeMenteesTitle: "Your active mentees",
          noActiveMentees: "No active mentees right now.",
          pendingRequestsTitle: "New mentee requests",
          noPendingRequests: "No pending requests.",
          accept: "Accept",
          decline: "Decline",
          completedLabel: "Completed mentorships",
          mentorsChatBtn: "Mentors Chat",
          certificateEarned: "🎓 You've earned the Greenwich Buddy Mentor certificate!",
          asMentorTab: "As Mentor",
          asMenteeTab: "As Mentee",
          matchingMentorsTitle: "Mentors that match you",
          allMentorsTitle: "Available mentors",
          noMatchingMentors: "No matching mentor is free right now. Try again later.",
          overlapLabel: "{{count}} matching area(s)",
          experienceLabel: "Experience",
          projectsLabel: "Projects",
          activeLabel: "Active mentees",
          chooseMentor: "Choose this mentor",
          requestSentTitle: "Request sent ✅",
          requestSentBody: "We let the mentor know. You'll be notified as soon as they respond.",
          withdrawRequest: "Withdraw request",
          youHaveMentorTitle: "Your mentor",
          youHaveMenteeOf: "Mentee",
          daysLeft: "{{count}} days left",
          endsOn: "Ends on {{date}}",
          messageBtn: "Message",
          viewProfile: "View profile",
          endMentorship: "End mentorship",
          endMentorshipConfirmTitle: "End this mentorship?",
          endMentorshipConfirmBody: "This can't be undone. You'll both be asked for a private rating afterward.",
          endMentorshipConfirmYes: "Yes, end it",
          reviewTitle: "Rate your mentorship",
          reviewBody: "This stays private and is never shown to the other side.",
          reviewCommentPlaceholder: "A short comment (optional)",
          submitReview: "Submit rating",
          reviewThanks: "Thanks for your feedback ✅",
          skipReview: "Skip",
          pendingReviewTitle: "Waiting for your rating",
          pendingReviewBody: "These mentorships have ended. Leave a private rating. The other side will never see it.",
          leaveReview: "Leave a rating",
          reportBtn: "Report",
          reportTitle: "Report {{name}}",
          reportBody: "Tell us what happened in this Buddy mentorship. Our team will review it. This isn't shared with {{name}}.",
          reportDetailsPlaceholder: "What happened? (optional, helps us review faster)",
          reportSubmittedTitle: "Report sent",
          reportSubmittedBody: "Thanks. Our team will review it. If you're ever concerned for your safety, please also reach out directly.",
          close: "Close",
          cancel: "Cancel",
          submitting: "Submitting…",
          submitReport: "Submit report",
          categories: {
            volunteering: "Volunteering", intlPractice: "International practice", erasmusPlus: "Erasmus+",
            erasmusMundus: "Erasmus Mundus", esc: "ESC", leadership: "Leadership", networking: "Networking",
            webinar: "Webinar", workshop: "Workshop", business: "Business", startup: "Startup",
            hiking: "Hiking", training: "Training", eco: "Eco", communitySupport: "Community support",
            organizational: "Organizational skills", marketing: "Marketing", communication: "Communication",
            regionalDev: "Regional development", art: "Art", painting: "Painting", dance: "Dance",
            singing: "Singing", other: "Other",
          },
        },
        levels: {
          title: "Levels & XP",
          subtitle: "Every account grows through levels as you take part in the platform. This page explains the general idea, not exact numbers.",
          nextLevel: "Working toward Level {{level}}",
          maxLevelReached: "You've reached the highest level 🏆",
          howTitle: "How you earn XP",
          howSub: "Roughly everything you do on the platform that helps others or moves you forward counts toward your level.",
          categories: {
            apply: { title: "Apply & get accepted", desc: "Applying to programs through the platform, and being accepted into one." },
            attend: { title: "Attend & show up", desc: "Actually taking part in the programs and events you signed up for." },
            community: { title: "Communities", desc: "Starting a community, or joining one someone else built." },
            voice: { title: "Share your voice", desc: "Posting updates and getting real engagement from others." },
            mentorship: { title: "Mentorship", desc: "Being a Buddy mentor or mentee, and seeing it through to the end." },
            trust: { title: "Trust & profile", desc: "Verifying your account, completing your profile, adding your CV." },
            reviews: { title: "Reviews", desc: "Leaving honest feedback after a program wraps up." },
            streak: { title: "Consistency", desc: "Coming back regularly: being active day after day matters." },
            tasks: { title: "Challenges", desc: "Completing tasks the team puts up from time to time." },
            referrals: { title: "Referrals", desc: "Bringing friends onto the platform." },
          },
          certTitle: "Certificates & XP",
          certSub: "Programs that award greencoins also earn you XP and a certificate once you actually attend and complete them.",
          certSteps: {
            participate: { title: "Attend the event", desc: "Sign up and actually show up. Organizers mark attendance once the program is done." },
            certificate: { title: "Earn XP + a certificate", desc: "Completed programs add XP toward your level, and eligible ones issue a certificate to your account." },
            bio: { title: "Show it on your profile", desc: "Your certificates live on your profile, ordered by how important they are and when you earned them." },
          },
          tiersTitle: "Tiers",
          tiersSub: "As your level climbs, your badge moves through five tiers.",
          tierNames: { bronze: "Bronze", silver: "Silver", gold: "Gold", diamond: "Diamond", legend: "Legend" },
          tierDescs: {
            bronze: "Everyone starts here.",
            silver: "Steady, active members.",
            gold: "Seriously engaged users.",
            diamond: "Long-term contributors.",
            legend: "The platform's most dedicated.",
          },
          youAreHere: "You are here",
          greencoins: "greencoins",
          tasksLink: "Tasks",
          back: "Back",
        },
        tasks: {
          title: "Tasks",
          subtitle: "Quick things you can do for extra XP and greencoins. Some repeat daily or monthly.",
          loading: "Loading tasks...",
          empty: "No tasks right now — check back later.",
          frequencyOnce: "One-time",
          frequencyDaily: "Daily",
          frequencyMonthly: "Monthly",
          xpAmount: "{{amount}} XP",
          completeBtn: "Complete",
          doneBtn: "Done",
          savingEllipsis: "Saving...",
          completed: "+{{xp}} XP!",
          completedWithCoins: "+{{xp}} XP, +{{coins}} greencoins!",
          completeFailed: "Couldn't complete this task. Try again.",
          back: "Back",
        },
        pro: {
          title: "Greenwich Pro",
          subtitle: "A paid plan for members who want more control over their profile and how they find their next opportunity.",
          plans: { "1m": "1 month", "3m": "3 months", "6m": "6 months" },
          bestValue: "Best value",
          perMonth: "{{price}} AMD / month",
          totalBilled: "{{total}} AMD total for {{months}} months",
          perksTitle: "What Pro gives you",
          perks: {
            design: { title: "Custom profile design", desc: "Personalize your profile with your own look." },
            frame: { title: "Custom avatar frame", desc: "Stand out with an exclusive frame around your photo." },
            views: { title: "See who viewed your profile", desc: "Both individual users and organizations, with dates, for the duration of your subscription." },
            matches: { title: "Best-matching projects, delivered", desc: "Get your top project matches by email, Telegram bot, or right inside the platform. You choose the channel." },
            shop: { title: "Exclusive greencoin rewards", desc: "Spend your greencoins on exclusive items, not just everyday ones." },
            early: { title: "Early access", desc: "See newly published opportunities 6 hours before everyone else." },
          },
          statusActive: "Your Pro is active until {{date}}",
          statusNone: "You don't have Pro yet",
          paymentComingSoon: "Online payment is being set up right now. Purchasing Pro isn't available on the site yet.",
          choosePlan: "Choose a plan, then pay by bank transfer",
          payTitle: "Pay by bank transfer",
          payBank: "Bank",
          payAccount: "Account number",
          payRecipient: "Recipient",
          payReference: "Payment reference",
          payReferenceHint: "Include this exactly so we can match your transfer to your account.",
          submitPayment: "Pay now",
          signInToPay: "Sign in to purchase",
          submitting: "Submitting...",
          submitSuccess: "Thanks! We'll confirm your transfer and activate Pro within 24 hours.",
          pendingNote: "Your {{plan}} request is pending. We're confirming your transfer and will activate Pro shortly.",
          interestTitle: "One moment",
          interestBody: "We're finishing up online payment for Pro. Tap below and we'll email your account the moment it's ready.",
          interestSubmit: "Notify me",
          interestDoneTitle: "Thanks!",
          interestDoneBody: "We've noted your interest and will email you as soon as Pro purchase is live.",
          interestClose: "Close",
          payWithCard: "Pay by card",
          redirectingToBank: "Redirecting to the bank...",
          cardPaymentSuccess: "Payment successful, Pro is now active!",
          cardPaymentFailed: "Payment failed. You can try again.",
          cardPaymentError: "Something went wrong with the payment. Please try again.",
          extendPrompt: "Already have Pro.",
          extendLink: "Want another plan? Buy again",
          historyTitle: "Purchase history",
          historyEmpty: "No purchases yet.",
          historyReceipt: "Receipt",
          receiptTitle: "Payment receipt",
          receiptOrder: "Order",
          receiptDate: "Date",
          receiptPlan: "Plan",
          receiptAmount: "Amount",
          receiptCard: "Card",
          receiptApproval: "Approval code",
          receiptClose: "Close",
          receiptPrint: "Print / Save as PDF",
          back: "Back",
        },
        paymentConfirmation: {
          titleSuccess: "Payment successful",
          titleFailed: "Payment failed",
          titlePending: "Checking your payment...",
          subtitleSuccess: "Your purchase is confirmed and active on your account.",
          subtitleFailed: "The bank couldn't complete this payment. No money was taken.",
          subtitlePending: "Hang tight, this takes a few seconds.",
          viewReceipt: "View receipt details",
          hideReceipt: "Hide receipt details",
          downloadReceipt: "Download receipt",
          continuePro: "Go to Pro",
          backToFeed: "Back to feed",
          tryAgain: "Try again",
          refundNote: "Changed your mind? You can request a refund within 7 days from",
          refundNoteLink: "Settings → Pro → Billing",
          notFound: "We couldn't find this payment.",
        },
        shop: {
          title: "Greencoin Shop",
          subtitle: "Spend the greencoins you've earned on the platform for real rewards.",
          greencoins: "greencoins",
          loading: "Loading...",
          empty: "Nothing here yet, check back soon.",
          everydayTitle: "Everyday rewards",
          exclusiveTitle: "Exclusive rewards",
          exclusiveSub: "Only available to Pro members.",
          exclusive: "Pro",
          proOnly: "Pro only",
          redeem: "Redeem",
          confirmRedeem: "Redeem \"{{name}}\" for {{cost}} greencoins?",
          redeemSuccess: "\"{{name}}\" redeemed! Our team will follow up on delivery.",
          redeemError: "Couldn't redeem this item. Please try again.",
          cancel: "Cancel",
          redeeming: "Redeeming...",
          redeemSuccessTitle: "Redeemed!",
          qrHint: "Show this QR code at pickup.",
          codeHint: "Show or enter this code at pickup.",
          done: "Done",
          myPurchases: "My purchases",
          myPurchasesSub: "Everything you've redeemed, with your pickup codes.",
          noPurchases: "You haven't redeemed anything yet.",
          showCode: "Show code",
          hideCode: "Hide code",
          back: "Back",
        },
        donate: {
          heroTitle: "Support Armenian Youth",
          heroSub: "Join our community of supporters and help create opportunities for the next generation of Armenian leaders.",
          missionTitle: "Our Mission",
          missionSub: "Empowering Armenian youth through education",
          quote: "\"By supporting our mission, you are investing in the future of Armenian youth.\"",
          quoteBody: "Your contribution helps us create educational programs, provide mentorship, and open new opportunities for growth. Every donation brings us one step closer to achieving this vision.",
          statYouth: "Youth Impacted",
          statSuccess: "Program Success",
          statPrograms: "Programs Created",
          chooseTier: "Choose Your Support Tier",
          chooseTierSub: "Select a monthly support level or enter a custom amount",
          popular: "Popular",
          perMonth: "per month",
          customAmount: "Or Enter Custom Amount",
          minUsd: "Minimum ${{amount}} ({{amd}} AMD)",
          thankYou: "Thank You! 🎉",
          thankBody: "Your ${{amount}} monthly support is now active. Confirmation sent to {{email}}.",
          whatNext: "What happens next:",
          next1: "Welcome email within 24 hours",
          next2: "Monthly receipt to your email",
          next3: "Supporter benefits start immediately",
          makeAnother: "Make Another Donation",
          supportLevel: "Support Level:",
          custom: "Custom",
          quickAmount: "Quick amount:",
          monthly: "Monthly:",
          recurringNote: "Recurring monthly donation",
          cancelAnytime: "Cancel or change anytime",
          yourInfo: "Your Information",
          fullName: "Full Name",
          emailReq: "Email Address *",
          paymentMethod: "Payment Method",
          bmcTitle: "Buy Me a Coffee",
          bmcSub: "Simple, one-time or monthly support",
          processing: "Processing...",
          continueBmc: "Continue to Buy Me a Coffee",
          redirectTitle: "Opening secure payment page...",
          redirectBody: "We opened Buy Me a Coffee in a new tab to complete your ${{amount}} donation. Please finish the payment there. This page has no way of knowing when it's done.",
          reopenPayment: "Reopen payment page",
          backToForm: "Back to form",
          secureNote: "Secure & encrypted payment",
          termsAgree: "By continuing, you agree to our",
          terms: "Terms",
          and: "and",
          privacyPolicy: "Privacy Policy",
          whyMonthly: "Why Support Monthly?",
          whyItems: [
            ["Sustainable impact", "Enables long-term program planning"],
            ["Predictable funding", "Helps us serve more youth consistently"],
            ["Flexible", "Change or cancel your support anytime"],
            ["Tax benefits", "Monthly receipts for easy tax reporting"],
          ],
          alertMin: "Please enter at least ${{min}}",
          alertEmail: "Please enter your email address.",
          alertPayment: "Please select a payment method.",
          alertCardLogin: "Please log in to donate by card.",
          alertCardError: "Something went wrong with the payment. Please try again.",
          bmcToast: "☕ Buy Me a Coffee selected",
          cardTitle: "Pay by card",
          cardSub: "Instant one-time donation in AMD",
          continueCard: "Donate by card",
          redirectingToBank: "Redirecting to the bank...",
          cardPaymentSuccess: "Thank you, your donation went through!",
          cardPaymentFailed: "Payment failed. You can try again.",
          cardPaymentError: "Something went wrong with the payment. Please try again.",
          tier1n: "Supporter", tier1d: "Basic support for our mission", tier1p0: "Thank you email", tier1p1: "Monthly newsletter",
          tier2n: "Friend", tier2d: "Help fund educational materials", tier2p0: "All previous perks", tier2p1: "Digital certificate", tier2p2: "Name in supporters list",
          tier3n: "Champion", tier3d: "Sponsor a youth program", tier3p0: "All previous perks", tier3p1: "Exclusive updates", tier3p2: "Digital badge",
          tier4n: "Leader", tier4d: "Make a significant impact", tier4p0: "All previous perks", tier4p1: "Video thank you", tier4p2: "Recognition on website",
        },
        contact: {
          badge: "We're here to help",
          title: "Get in Touch",
          subtitle: "Connect with our team to learn more about opportunities, partnerships, or how you can get involved.",
          email: "Email",
          phone: "Phone",
          followJourney: "Follow Our Journey",
          quickAskTitle: "Need a fast answer?",
          quickAskSubtitle: "Ask our AI assistant instead of waiting for a reply to the form below.",
          faqTitle: "Frequently Asked Questions",
          tabGeneral: "General",
          tabPrograms: "Programs",
          tabPartnerships: "Partnerships",
          sendMessage: "Send us a Message",
          replyWithin: "We'll get back to you within 24 hours",
          sentTitle: "Message Sent! 🎉",
          sentBody: "Thank you for contacting Greenwich. Our team will respond shortly.",
          sendError: "Something went wrong sending your message. Please try again in a moment.",
          yourName: "Your Name",
          emailPlaceholder: "Email Address",
          messagePlaceholder: "Your message...",
          sending: "Sending...",
          sendBtn: "Send Message",
          responseTime: "Response Time: within 24 hours",
          ctaTitle: "Ready to Start Your Journey?",
          ctaSub: "Join thousands of Armenian youth who have found their path through Greenwich.",
          browseOpps: "Browse Opportunities",
          learnMore: "Learn More About Us",
          faqG1q: "What is Greenwich?", faqG1a: "Greenwich is a digital platform connecting Armenian youth with global opportunities in education, exchange programs, and career development.",
          faqG2q: "Who can use Greenwich?", faqG2a: "Armenian youth aged 14-35, students, professionals, and anyone seeking international opportunities.",
          faqP1q: "What types of programs do you offer?", faqP1a: "We offer exchange programs, scholarships, internships, volunteer opportunities, and cultural exchanges.",
          faqP2q: "How do I apply for programs?", faqP2a: "Create an account, browse opportunities, and submit applications through our system.",
          faqPr1q: "Can my organization partner with Greenwich?", faqPr1a: "Yes! We welcome partnerships with educational institutions, NGOs, and companies.",
          faqPr2q: "What are partnership benefits?", faqPr2a: "Partners gain access to our talent pool, co-host events, and receive visibility in our network.",
        },
        whoWeAre: {
          heroLabel: "Est. 2025 · Armenia",
          heroTitle1: "Connecting Youth",
          heroTitle2: "with the World",
          heroBody: "Greenwich connects Armenian youth (14-35) with global and local opportunities, from scholarships and exchanges to volunteering and cultural programs.",
          seeMore: "See more →",
          sectionLabel: "Who We Are",
          overviewTitle1: "A platform built",
          overviewTitle2: "for young people",
          overviewP1: "Greenwich.am is a digital platform that connects young people with educational, social, and professional opportunities worldwide. Founded in Armenia in early 2025, it started as a Telegram channel and quickly evolved into an innovative web platform that unites youth and organisations in one trusted ecosystem.",
          overviewP2: "Greenwich helps users discover verified projects, build a digital portfolio, and access global opportunities in one place.",
          statAge: "Target age group",
          statYear: "Year founded",
          statOpp: "Opportunities listed",
          whyLabel: "Why Greenwich?",
          whyTitle1: "All opportunities,",
          whyTitle2: "one trusted place",
          whyBody: "Finding opportunities can be hard: they are scattered across websites, social media, and word of mouth. Many young people miss them simply because information isn't accessible in one place. Greenwich brings it all together.",
          regionAmerica: "America", regionAsia: "Asia", regionEurope: "Europe",
          quote: "\"We strive to build a trusted digital ecosystem that connects youth and organisations, makes participation visible and measurable.\"",
          visionLabel: "Vision",
          visionTitle1: "Our",
          visionTitle2: "vision",
          visionTitle3: "for",
          visionTitle4: "global youth",
          visionBody: "Our vision is to create a unified global platform where every young person has equal access to opportunities regardless of location or background. We strive to build a trusted digital ecosystem that connects youth and organisations, makes participation visible and measurable, and transforms engagement into real impact and long-term growth.",
          missionLabel: "Mission",
          missionTitle1: "Empowering youth",
          missionTitle2: "through technology",
          missionBody1: "Our mission is to make global opportunities accessible, structured, and transparent for young people everywhere. We aim to connect motivated individuals with organisations, support meaningful participation, and provide a trusted digital space where achievements are recognised and growth is encouraged.",
          missionBody2: "Through technology and community, we empower youth to discover their potential and turn opportunities into real impact.",
          sdgLabel: "Sustainability",
          sdgTitle1: "Promoting the",
          sdgTitle2: "SDG Agenda",
          sdgBody: "Greenwich.am is committed to promoting the United Nations Sustainable Development Goals by empowering young people to actively participate in social, educational, and community-driven initiatives.",
          sdgChip1: "Quality Education", sdgChip2: "Decent Work", sdgChip3: "Reduced Inequalities", sdgChip4: "Climate Action", sdgChip5: "Strong Institutions",
          ctaTitle1: "Ready to discover",
          ctaTitle2: "your opportunity?",
          ctaSub: "Join thousands of young Armenians already growing with Greenwich.",
          getStarted: "Get Started →",
        },
        notifications: {
          title: "Notifications",
          newBadge: "{{count}} new",
          markAllRead: "Mark all as read",
          total: "Total",
          unread: "Unread",
          likes: "Likes",
          follows: "Follows",
          filter: "Filter:",
          all: "All",
          unreadTab: "Unread",
          readTab: "Read",
          allTypes: "All types",
          comments: "Comments",
          noneTitle: "No notifications found",
          noneUnread: "You don't have any unread notifications.",
          noneDefault: "When you get notifications, they'll appear here.",
          showAll: "Show all notifications",
          today: "Today",
          yesterday: "Yesterday",
          markRead: "Mark read",
          deleteTitle: "Delete notification",
          deleting: "Deleting...",
          footer: "Showing {{shown}} of {{total}} notifications",
          someone: "Someone",
          msgLike: "{{name}} liked your post",
          msgComment: "{{name}} commented on your post",
          msgFollow: "{{name}} started following you",
          msgFollowReq: "{{name}} wants to follow you",
          msgMessage: "{{name}} sent you a message",
          msgVerify: "Your organization has been verified!",
          msgMention: "{{name}} mentioned you in a post",
          msgNew: "New notification",
          justNow: "Just now",
          timeAgo: "{{n}}m ago",
          hourAgo: "{{n}}h ago",
          dayAgo: "{{n}}d ago",
        },
        search: {
          likes: "Likes",
          comments: "Comments",
          tabAll: "All",
          tabUsers: "Users",
          tabOrganizations: "Organizations",
          tabProjects: "Projects",
          tabHashtags: "Hashtags",
          tabCommunities: "Communities",
          tabPosts: "Posts",
          heroTitle: "Search Greenwich",
          heroSubtitle: "Discover people, organizations, communities, and content across the platform",
          searchPlaceholder: "Search for users, organizations, communities, posts...",
          filtersBtn: "Filters",
          sortBy: "Sort by:",
          sortRelevance: "Relevance",
          sortNewest: "Newest",
          sortPopular: "Most Popular",
          sortName: "Name A-Z",
          dateRange: "Date range:",
          dateAll: "All time",
          dateToday: "Today",
          dateWeek: "This week",
          dateMonth: "This month",
          locationLabel: "Location:",
          locationPlaceholder: "Enter location",
          verifiedOnly: "Verified only",
          clearFilters: "Clear filters",
          searchingFor: "Searching for \"{{term}}\"...",
          emptyTitle: "Search Greenwich Platform",
          emptyDescription: "Find people, organizations, posts, and communities across the platform",
          browseCategory: "Browse {{category}}",
          trendingHeading: "Trending Searches",
          trendingTerms: [
            "Education", "Erasmus", "Work", "International", "youthprograms",
            "summerjobs", "scholarshipsearch", "gapyear", "Community", "Organization",
            "Event", "Study Abroad", "Full Scholarships", "Fellowship", "Grants",
          ],
          resultsHeading: "Results",
          pageOf: "Page {{current}} of {{total}}",
          noResultsFor: "No results found for \"{{term}}\"",
          noResultsHint: "Try adjusting your search terms or filters",
          previous: "Previous",
          next: "Next",
          pillUser: "User",
          pillOrg: "Org",
          pillProgram: "Project",
          pillOrganizationFull: "Organization",
          pillCommunity: "Community",
          pillPost: "Post",
          metaFollowers: "followers",
          metaPosts: "posts",
          metaMembers: "members",
          btnFollowing: "Following",
          btnRequested: "Requested",
          btnFollow: "Follow",
          viewCommunity: "View Community",
          viewPost: "View Post",
          viewOrg: "View Org",
          viewProgram: "View Project",
          untitledProgram: "Untitled project",
          viewProfile: "View Profile",
          viewShort: "View",
          statFollowers: "Followers",
          statPosts: "Posts",
          statMembers: "Members",
          unknown: "Unknown",
          unknownUser: "Unknown User",
          today: "Today",
          yesterday: "Yesterday",
        },
        dashboard: {
          pleaseLoginSave: "Please log in to save changes",
          saveFailed: "Failed to save changes",
          saveError: "Error saving changes.",
          imageTooBig: "Image size should be less than 5MB",
          imageTypes: "Only JPEG, PNG and GIF images are allowed",
          coverFailed: "Failed to update cover photo",
          coverError: "Error updating cover photo",
          avatarFailed: "Failed to update profile photo",
          avatarError: "Error updating profile photo",
          loginUpload: "Please log in to upload files",
          uploadFailed: "Failed to upload files",
          uploadError: "Error uploading file",
          deleteFileFailed: "Failed to delete file",
          deleteFileError: "Error deleting file",
          navAbout: "About",
          navPosts: "Posts",
          navReports: "Reports",
          navPortfolio: "Portfolio",
          navCertificates: "Certificates",
          navApplications: "My Applications",
          editProfileBtn: "Edit Profile",
          tabAbout: "About",
          tabPosts: "Posts",
          tabReports: "Reports & Licenses",
          tabPortfolio: "Portfolio",
          tabCertificates: "Certificates",
          tabApplications: "My Applications",
          firstName: "First Name *",
          firstNamePh: "First Name",
          lastName: "Last Name",
          titlePosition: "Title / Position",
          titlePh: "Senior Product Manager",
          emailLabel: "Email *",
          emailPh: "example@email.com",
          invalidEmail: "Please enter a valid email address",
          phoneLabel: "Phone",
          phonePh: "+1234567890",
          locationLabel: "Location",
          locationPh: "Enter location",
          websiteLabel: "Website",
          websitePh: "https://example.com",
          bioLabel: "Bio",
          bioPh: "Tell us about yourself...",
          interestsLabel: "Interests",
          addInterestPh: "Add interest (Enter)",
          addBtn: "Add",
          maxInterests: "{{count}}/5 selected — used to recommend programs to you",
          saveChanges: "Save Changes",
          saving: "Saving...",
          cancel: "Cancel",
          noBio: "No bio yet.",
          nameLabel: "Name",
          emailInfoLabel: "Email",
          phoneInfoLabel: "Phone",
          locationInfoLabel: "Location",
          websiteInfoLabel: "Website",
          interestsHeader: "Interests",
          whatsOnMind: "What's on your mind?",
          photosBtn: "Photos",
          postBtn: "Post",
          loadingPosts: "Loading posts...",
          noPostsYet: "No posts yet",
          noCommentsYet: "No comments yet",
          writeReplyPh: "Write a reply...",
          writeCommentPh: "Write a comment...",
          postFeedbackEmpty: "Please add some content or image.",
          postFeedbackLoginRequired: "Please log in to post.",
          postCreateFailed: "Failed to create post",
          postCreateError: "Error creating post.",
          postCreated: "Post created successfully.",
          linkCopied: "Link copied",
          maxImages: "You can upload maximum 10 images",
          imageTooLarge: "Image {{name}} too large",
          notAnImage: "{{name}} is not an image",
          uploadedDocuments: "Uploaded Documents",
          portfolioItems: "Portfolio Items",
          uploadFileBtn: "Upload File",
          addItemBtn: "Add Item",
          previewBtn: "Preview",
          downloadBtn: "Download",
          openBtn: "Open",
          deleteBtn: "Delete",
          confirmDeleteFile: "Are you sure you want to delete this file?",
          myCertificates: "My Certificates",
          addCertificateBtn: "Add Certificate",
          certTitlePh: "Certificate title *",
          certIssuerPh: "Issuing organization",
          certDatePh: "Issue date (e.g. 2026-01-15)",
          certLocationPh: "Location (city, country)",
          certRolePh: "Your role / activity",
          certDescPh: "Description (optional)",
          cvHeader: "CV / Resume",
          cvUploadBtn: "Upload CV",
          cvReplaceBtn: "Replace CV",
          cvUploadedNote: "Visible to organizers when you apply to a program.",
          cvEmptyNote: "Add your CV as a PDF so organizers can see it when you apply.",
          saveCertificate: "Save Certificate",
          savingEllipsis: "Saving…",
          noCertificatesYet: "No certificates added yet.",
          issuedByOrganizerFor: "Issued by {{org}} for {{program}}",
          issuedByOrganizer: "Issued by {{org}}",
          theOrganizer: "the organizer",
          viewPdf: "View PDF",
          confirmDeleteCertificate: "Delete this certificate?",
          certTitleRequired: "Title is required.",
          certFileRequired: "Please attach the certificate as a PDF.",
          certFilePdfOnly: "Certificates must be uploaded as a PDF file.",
          certAddFailed: "Failed to add certificate.",
          certDeleteFailed: "Failed to delete certificate.",
          programsAppliedTo: "Programs I've Applied To",
          loadingApplications: "Loading applications…",
          noApplicationsYet: "You haven't applied to any programs yet.",
          browsePrograms: "Browse programs",
          appliedOn: "Applied {{date}}",
          statusPending: "⏳ Awaiting response",
          statusAccepted: "✅ Accepted",
          statusRejected: "❌ Not accepted",
          statusAttended: "🎓 Attendance confirmed",
          certIssuedSeeTab: "Certificate issued, see your Certificates tab",
          certPending: "Certificate pending",
          viewSubmission: "View my submission",
          programFallback: "Program",
          statsPosts: "Posts",
          statsFollowers: "Followers",
          statsFollowing: "Following",
          totalPostsLabel: "Total posts:",
          openPosts: "Open Posts",
          noUsersYet: "No users to show yet.",
          unsavedTitle: "Unsaved Changes",
          unsavedMessage: "You have unsaved changes. Do you want to save them?",
          dontSave: "Don't Save",
          changeCoverPhoto: "Change cover photo",
          coverLabel: "Cover",
          changeProfilePhoto: "Change profile photo",
          reportAction: "Report",
          saveBtn: "Save",
        },
        messages: {
          justNow: "Just now",
          errNoContent: "Please enter a message or select an image",
          errNoConversation: "No active conversation",
          confirmDeleteMessage: "Delete this message?",
          errDeleteMessage: "Failed to delete message",
          errNoGroup: "No active group",
          confirmDeleteConversation: "Delete this conversation?",
          conversationDeleted: "Conversation deleted",
          errDeleteConversation: "Failed to delete conversation",
          confirmLeaveGroup: "Leave this group?",
          leftGroupSuccess: "Left group successfully",
          errLeaveGroup: "Failed to leave group",
          joinedGroupSuccess: "Successfully joined the group!",
          errJoinGroup: "Failed to join group",
          errFileTooLarge: "File size must be less than 10MB",
          errSelectImage: "Please select an image file",
          errSendMessage: "Failed to send message",
          errCreateConversation: "Failed to create conversation",
          errStartConversation: "Failed to start conversation",
          emojiRecent: "Recent",
          emojiSmileys: "Smileys",
          emojiHearts: "Hearts",
          emojiHands: "Hands",
          emojiAnimals: "Animals",
          emojiFood: "Food",
          emojiTravel: "Travel",
          emojiSymbols: "Symbols",
          emojiWeather: "Weather",
          signInTitle: "Sign in to continue",
          signInSubtitle: "View and send messages",
          logIn: "Log In",
          title: "Messages",
          newTooltip: "New",
          tabDirect: "Direct",
          tabGroups: "Groups",
          searchPlaceholder: "Search...",
          loading: "Loading...",
          noConversations: "No conversations yet",
          startChat: "Start a chat",
          unknown: "Unknown",
          sharedAPost: "📤 Shared a post",
          noMessagesYet: "No messages yet",
          noGroups: "No groups yet",
          browseGroups: "Browse groups",
          tagPrivate: "Private",
          tagAdmin: "Admin",
          membersCount: "{{count}} members",
          someoneTyping: "{{name}} typing...",
          online: "Online",
          offline: "Offline",
          typing: "Typing...",
          viewProfileTooltip: "View Profile",
          infoTooltip: "Info",
          leaveGroupTooltip: "Leave group",
          loadingMessages: "Loading messages...",
          beFirstToSayHello: "Be the first to say hello!",
          joinGroupToChat: "Join Group to Chat",
          sharedPost: "Shared post",
          tapToView: "Tap to view →",
          deleteMessageTooltip: "Delete message",
          joinToSend: "Join this group to send messages",
          join: "Join",
          attachTooltip: "Attach",
          emojisTooltip: "Emojis",
          messagePlaceholder: "Message {{name}}...",
          yourMessages: "Your Messages",
          yourGroups: "Your Groups",
          selectConversation: "Select a conversation or start a new one",
          selectGroup: "Select a group to start chatting",
          newConversation: "New Conversation",
          newMessageTitle: "New Message",
          noUsersAvailable: "No users available",
          mutualFollowersOnly: "You can only message mutual followers",
          conversationInfoTitle: "Conversation Info",
          deleteConversation: "Delete Conversation",
          groupInfoTitle: "Group Info",
          membersCountDot: "{{count}} members ·",
          public: "Public",
          leaveGroup: "Leave Group",
          joinGroup: "Join Group",
        },
        feed: {
          seeMore: "See more",
          seeLess: "See less",
          noPostsYet: "No posts available yet. Be the first to post!",
          loadFailed: "Failed to load feed. Please try again later.",
          justNow: "Just now",
          minAgo: "{{n}}m ago",
          hourAgo: "{{n}}h ago",
          dayAgo: "{{n}}d ago",
          loginToLike: "Please log in to like posts",
          followRequestSent: "Follow request sent!",
          failedFollowReq: "Failed to send follow request",
          replyPosted: "Reply posted!",
          commentAdded: "Comment added!",
          failedComment: "Failed to add comment.",
          failedLike: "Failed to like post.",
          failedSave: "Failed to save post.",
        },
      },
      settings: {
        title: "Settings",
        subtitle: "Manage your account preferences and content",
        sidebar: {
          account: "Account",
          accountSettings: "Account Settings",
          savedLiked: "Saved & Liked",
          preferences: "Preferences",
          privacySecurity: "Privacy & Security",
          notifications: "Notifications",
          pro: "Pro",
          archive: "Archive",
          yourActivity: "Your activity",
          howOthersInteract: "How others interact with you",
          interactionsLabel: "Messages, comments & restrictions",
          accessibility: "Accessibility",
          dataPermissions: "Archiving, download & permissions",
          support: "Support",
        },
        interactions: {
          title: "How others can interact with you",
          subtitle: "Control who can message you, who can comment on your posts, and who's restricted.",
          messagesHeading: "Messages",
          messagesSubtitle: "Who can start a new conversation with you.",
          everyone: "Everyone",
          followersBack: "People who follow you back",
          noOne: "No one",
          commentsHeading: "Comments",
          commentsSubtitle: "Who can comment on your posts.",
          yourFollowers: "Your followers",
          turnOffComments: "Turn off comments",
          restrictedHeading: "Restricted accounts",
          restrictedSubtitle: "Restricted people can't comment on your posts. They can still see your public profile and follow you. This is lighter than blocking.",
          searchPlaceholder: "Search by name or username…",
          searching: "Searching…",
          noUsersFound: "No users found.",
          restrictBtn: "Restrict",
          noneRestricted: "You haven't restricted anyone.",
          unrestrictBtn: "Unrestrict",
        },
        archive: {
          title: "Archive",
          subtitle: "Posts you've archived are hidden from your profile. Only you can see this list.",
          emptyTitle: "Nothing archived",
          emptyBody: "Archive a post from its options menu and it'll show up here.",
          unarchiveBtn: "Unarchive",
        },
        activity: {
          title: "Your activity",
          subtitle: "A quick look at what you've been up to recently.",
          filterLiked: "Liked",
          filterSaved: "Saved",
          filterCommented: "Commented",
          filterSearches: "Searches",
          empty: "Nothing here yet.",
        },
        accessibility: {
          title: "Accessibility",
          subtitle: "Adjust how the site behaves to suit you.",
          reduceMotion: "Reduce motion",
          reduceMotionDesc: "Turns off animations and transitions across the site.",
        },
        dataExport: {
          title: "Archiving & downloading",
          subtitle: "Download a copy of your data.",
          downloadHeading: "Download your data",
          downloadDesc: "Get a JSON file with your profile, posts, and applications.",
          preparing: "Preparing…",
          downloadBtn: "Download",
          scopeHint: "Choose everything, or just one part of your data.",
          scopeAll: "Everything",
          scopeProfile: "Profile only",
          scopePrograms: "Program applications",
          scopeBuddy: "Buddy mentorship",
          scopeMessages: "Messages",
          permissionsTitle: "🔐 Site permissions",
          permissionsSubtitle: "What your browser lets Greenwich do, and how to change it.",
          permissionsPara1: "Greenwich only asks your browser for one permission: notifications, to alert you about likes, comments, follows and messages even when the tab isn't open. It doesn't request your camera, microphone, or location.",
          permissionsPara2: "You can review or revoke this any time from your browser's site settings. Click the padlock icon next to the address bar while on greenwich.am.",
        },
        toasts: {
          failedToSave: "Failed to save.",
          userRestricted: "User restricted.",
          failedToRestrict: "Failed to restrict user.",
          userUnrestricted: "User unrestricted.",
          failedToUnrestrict: "Failed to unrestrict user.",
          postUnarchived: "Post unarchived, it's back on your profile.",
          failedToUnarchive: "Failed to unarchive post.",
          failedToExport: "Failed to export your data.",
        },
        account: {
          title: "Account Information",
          subtitle: "Manage your personal information and preferences",
          firstName: "First Name",
          lastName: "Last Name",
          email: "Email",
          phone: "Phone",
          location: "Location",
          bio: "Bio",
          bioPlaceholder: "Tell us about yourself...",
          profileColor: "Profile accent color",
          profileColorHint: "Shown on your public profile. Pick your own or keep the default.",
          saveChanges: "Save Changes",
          profileUpdated: "Profile updated successfully!",
          profileUpdateError: "Error updating profile",
          accountDeleted: "Account deleted successfully.",
          changePasswordTitle: "Change Password",
          changePasswordSubtitle: "Update the password you use to log in.",
          currentPassword: "Current password",
          newPassword: "New password",
          confirmNewPassword: "Confirm new password",
          newPasswordPlaceholder: "At least 8 characters",
          confirmNewPasswordPlaceholder: "Re-enter new password",
          updatePassword: "Update Password",
          passwordFieldsRequired: "Please fill in all password fields.",
          passwordTooShort: "New password must be at least 8 characters.",
          passwordMismatch: "New password and confirmation do not match.",
          passwordUpdated: "Password updated successfully.",
          passwordUpdateFailed: "Failed to update password.",
          activeSessionsTitle: "Active Sessions",
          activeSessionsSubtitle: "See where you're logged in and sign out of other devices.",
          manage: "Manage →",
        },
        savedLiked: {
          title: "Saved & Liked Posts",
          subtitle: "Posts you've saved or liked",
          emptyTitle: "No Saved or Liked Posts",
          emptySubtitle: "Posts you save or like will appear here for quick access.",
          savedCount: "Saved",
          likedCount: "Liked",
          badgeSaved: "Saved",
          badgeLiked: "Liked",
          loadingPosts: "Loading posts...",
          unknownAuthor: "Unknown",
        },
        privacy: {
          title: "Privacy & Security",
          subtitle: "Control your privacy and security settings",
          accountPrivacy: "Account Privacy",
          accountPrivacySubtitle: "Control who can see your profile and posts",
          visibility: {
            public: "Public",
            private: "Private",
            friends: "Friends Only",
          },
          language: "Language",
          languageSubtitle: "Choose your preferred language",
          contentLanguage: "Content Language",
          contentLanguageSubtitle: "Which language programs and opportunities are shown in, independent of your interface language",
          market: "Country",
          marketSubtitle: "Switch between the Armenia and France versions of Greenwich",
          twoFactor: "Two-Factor Authentication",
          twoFactorSubtitle: "Add an extra layer of security to your account",
          privateAccount: "Private Account & Follow Requests",
          privateAccountSubtitle: "Require approval before people can follow you",
          notificationsRow: "Notifications",
          notificationsRowSubtitle: "Choose which alerts you get by email, push, and in-app, and set quiet hours",
          security: "Security",
          securitySubtitle: "Two-factor authentication, change email, connected accounts",
          blockedAccounts: "Blocked Accounts",
          blockedAccountsSubtitle: "People you've blocked can't view your profile or contact you",
          mutedAccounts: "Muted Accounts",
          mutedAccountsSubtitle: "Their posts are hidden from your feed, silently",
          manage: "Manage →",
          dangerZone: "Danger Zone",
        },
        deleteModal: {
          heading: "Why do you want to delete your account?",
          selectReason: "Select reason",
          reasonPrivacy: "Privacy concerns",
          reasonNotUseful: "Not useful",
          reasonTooManyEmails: "Too many notifications",
          reasonOther: "Other",
          writeReason: "Write your reason...",
          pleaseSelectReason: "Please select reason",
          areYouSure: "Are you sure?",
          cannotBeUndone: "This action cannot be undone. All your data will be permanently deleted.",
          yesDelete: "Yes, Delete",
          error: "Error deleting account. Please try again.",
        },
        notifications: {
          title: "Notifications",
          subtitle: "Manage how and when you receive notifications",
          pushTitle: "Push Notifications",
          pushSubtitle: "Get browser notifications",
        },
        languages: {
          en: "English",
          hy: "Armenian",
          ru: "Russian",
          de: "German",
          es: "Spanish",
          fr: "French",
        },
        pro: {
          title: "Greenwich Pro",
          subtitle: "Manage your Pro perks: custom design, avatar frame, and profile-view history.",
          statusActive: "Your Pro is active until {{date}}",
          statusNone: "You don't have Pro yet.",
          learnMore: "Learn more about Pro",
          frameTitle: "Avatar frame",
          frameNone: "None", frameGold: "Gold", frameEmerald: "Emerald", frameRoyal: "Royal",
          designTitle: "Profile design",
          designNone: "None", designSunset: "Sunset", designOcean: "Ocean", designForest: "Forest", designMidnight: "Midnight",
          save: "Save", saving: "Saving...",
          customizationSaved: "Customization saved!",
          customizationError: "Failed to save customization.",
          channelTitle: "Project match delivery",
          channelSubtitle: "Choose where you'd like to get your best-matching project picks.",
          channelPlatform: "In the platform", channelEmail: "Email", channelTelegram: "Telegram bot",
          comingSoon: "coming soon",
          linkTelegram: "link your account",
          sendTest: "Send my matches now",
          testSent: "Sent! Check your chosen channel.",
          timingTitle: "Timing & content",
          timingSubtitle: "Control when picks arrive, whether you get reminders, and how much detail each one carries.",
          deliveryHour: "Delivery time",
          remindersLabel: "Keep sending even when the picks haven't changed (reminder mode)",
          detailLevel: "Message detail",
          detail_brief: "Brief", detail_detailed: "Detailed",
          sourceTitle: "How picks are chosen",
          sourceAi: "AI matching (recommended)", sourceCategories: "I'll choose my categories",
          sourceAiHint: "Recommended for accuracy. Picks are ranked against your activity on the platform.",
          category_education: "Education", category_scholarship: "Scholarship", category_fellowship: "Fellowship",
          category_erasmusplus: "Erasmus+", category_training: "Training", category_grant: "Grant",
          category_internship: "Internship", category_conference: "Conference", category_online: "Online",
          category_volunteering: "Volunteering", category_event: "Event", category_award: "Award",
          viewsTitle: "Who viewed your profile",
          viewsSubtitle: "Visible only for as long as your Pro subscription stays active.",
          viewsLocked: "Get Pro to see who's been viewing your profile.",
          viewsCountToday: "{{count}} people viewed your profile today.",
          viewsEmpty: "No profile views yet during this Pro period.",
          loading: "Loading...",
          billingTitle: "Billing & refunds",
          billingSubtitle: "Your past purchases, with the option to request a refund within 7 days.",
          billingEmpty: "No purchases yet.",
          requestRefund: "Request a refund",
          refundWindowExpired: "Refund window has passed",
          refundStatusRequested: "Refund requested, under review",
          refundStatusApproved: "Refund approved",
          refundStatusRejected: "Refund request declined",
          refundStatusRefunded: "Refunded",
          refundModalTitle: "Request a refund",
          refundModalSubtitle: "Tell us what happened. This helps us improve, and it's needed to process your refund.",
          refundReasonLabel: "Reason",
          selectReason: "Select a reason",
          reason_not_what_expected: "Not what I expected",
          reason_found_cheaper_elsewhere: "Found a cheaper option elsewhere",
          reason_technical_issues: "Ran into technical issues",
          reason_accidental_purchase: "Accidental purchase",
          reason_no_longer_needed: "No longer needed",
          reason_bought_wrong_plan: "Bought the wrong plan",
          reason_unsatisfied_with_features: "Not satisfied with the features",
          reason_other: "Other",
          ratingLabel: "How would you rate your experience?",
          commentLabel: "Anything else you'd like to add? (optional)",
          commentPlaceholder: "Tell us more...",
          talkToSupport: "Prefer to talk to someone first?",
          talkToSupportLink: "Chat with support",
          submitRefund: "Submit refund request",
          submittingRefund: "Submitting...",
          refundSubmitted: "Refund request submitted, we'll review it shortly.",
          refundError: "Couldn't submit the refund request. Please try again.",
        },
        confirmLogout: "Are you sure you want to logout?",
      },
      feed: {
        sidebarExplore: "Explore",
        photos: "Photos",
        postBtn: "Post",
        whatsOnMind: "What's on your mind?",
        recommendedForYou: "Recommended For You",
        programsForYou: "Programs For You",
        programsForYouFallback: "Program",
        programsForYouPopularHint: "Popular right now. Save or apply to programs to personalize these.",
        seeAll: "See All",
        followPeopleHint: "Follow people to see them here",
        loading: "Loading...",
        close: "Close",
        noFollowersYet: "No followers yet",
        noFollowingYet: "Not following anyone yet",
        unknown: "Unknown",
        viewAllFollowing: "View all {{count}} following",
        noRecommendationsYet: "No recommendations yet",
        recommendationsHint: "Follow people or explore to get recommendations",
        alreadyFollowing: "Already following",
        reasonViolent: "Violent Content",
        reasonDescSpam: "This is spam",
        reasonDescInappropriate: "Contains 18+ or explicit content",
        reasonDescViolent: "Contains violent, gore, or disturbing content",
        reasonDescHarassment: "Harassing or bullying",
        reasonDescHateSpeech: "Promotes hate or violence",
        reasonDescMisinformation: "False or misleading information",
        reasonDescOther: "Other reason",
        reportComment: "Report Comment",
        reportSelectReasonHint: "Please select a reason for reporting this {{type}}. This action is anonymous.",
        additionalDetails: "Additional details (optional)",
        reportDetailsPlaceholder: "Provide more details about your report...",
        submitReport: "Submit Report",
        editPost: "Edit Post",
        archivePost: "Archive Post",
        archiving: "Archiving…",
        commentWillBeDeleted: "This comment will be permanently deleted. This action cannot be undone.",
        sendAndShare: "Send & Share",
        imagePost: "Image post",
        sendToMutualFollows: "Send to mutual follows",
        loadingMutualFollows: "Loading mutual follows...",
        showLess: "Show less",
        showAllUsers: "Show all {{count}} users",
        shareOnSocialMedia: "Share on social media",
        failedToCopyLink: "Failed to copy link",
        failedToLikeComment: "Failed to like comment.",
        commentDeletedToast: "Comment deleted!",
        failedToDeleteComment: "Failed to delete comment",
        postArchivedToast: "Post archived. You can find it in Settings → Archive.",
        reportSubmittedToast: "Report submitted successfully",
        failedToSubmitReport: "Failed to submit report",
        maxImagesError: "You can upload maximum 10 images",
        postContentEmptyError: "Post content cannot be empty",
        pleaseLogInToEdit: "Please log in to edit posts",
        postUpdatedToast: "Post updated successfully!",
        cannotSendPostError: "Cannot send post: missing information",
        postNotFoundError: "Post not found",
        pleaseAddContentError: "Please add some content or image",
        pleaseLogInToPost: "Please log in to post",
        postCreatedToast: "Post created successfully!",
        cannotConnectError: "Cannot connect to server. Please check your internet connection",
        cannotCopyProfileLinkError: "Cannot copy profile link: User not loaded",
        postDeletedByAdmin: "Post deleted by admin.",
        failedToDeletePost: "Failed to delete post",
        failedToArchivePost: "Failed to archive post",
        failedToUpdatePost: "Failed to update post.",
        failedToCreatePost: "Failed to create post.",
        replaceImages: "Replace images",
        addImages: "Add images",
      },
    },
  },
  hy: {
    translation: {
      common: {
        saving: "Պահպանվում է...",
        refresh: "Թարմացնել",
        logout: "Դուրս գալ",
        deleteAccount: "Ջնջել հաշիվը",
        viewPost: "Դիտել գրառումը",
        unsave: "Չպահպանել",
        unlike: "Չհավանել",
        members: "անդամներ",
        posts: "Գրառումներ",
        editProfile: "Խմբագրել պրոֆիլը",
        unknownUser: "Անհայտ օգտատեր",
        exploreUsers: "Ուսումնասիրել օգտատերեր",
        showAll: "Ցույց տալ բոլորը",
        searchMutualFollows: "Որոնել փոխադարձ հետևորդներ...",
        myPosts: "Իմ գրառումները",
        likedPosts: "Հավանած գրառումներ",
        savedPosts: "Պահպանված գրառումներ",
        organizationPosts: "Կազմակերպության գրառումներ",
      },
      navbar: {
        home: "Գլխավոր",
        feed: "Ժապավեն",
        community: "Համայնք",
        projects: "Ծրագրեր",
        organizations: "Կազմակերպություններ",
        donateNow: "Նվիրաբերել",
        pro: "Greenwich Pro",
        buddy: "Buddy",
        greencoins: "Greencoin-ներ",
        shop: "Greenwich խանութ",
        settings: "Կարգավորումներ",
        contactUs: "Կապ մեզ հետ",
        whoWeAre: "Մեր մասին",
        account: "Հաշիվ",
        editProfile: "Խմբագրել պրոֆիլը",
        howItWorks: "Ինչպես է աշխատում",
        logOut: "Դուրս գալ",
        viewDashboard: "Դիտել ձեր վահանակը",
        adminDashboard: "Ադմինի վահանակ",
        verifiedOrganizations: "Հաստատված կազմակերպություններ",
        adminPanel: "Ադմինի վահանակ",
        searchPlaceholder: "Որոնել օգտատերեր, գրառումներ, համայնքներ, կազմակերպություններ...",
        searching: "Որոնվում է...",
        searchMinChars: "Մուտքագրեք առնվազն 2 նիշ որոնման համար",
        users: "Օգտատերեր",
        communities: "Համայնքներ",
        posts: "Գրառումներ",
        noResults: "Արդյունքներ չգտնվեց",
        seeAllResults: "Տեսնել բոլոր արդյունքները",
        organization: "Կազմակերպություն",
        user: "Օգտատեր",
        postBy: "Գրառումը",
        tryDifferentKeywords: "Փորձեք այլ հիմնաբառեր",
        searchMembers: "Որոնել անդամներ",
        loginToSearch: "Խնդրում ենք մուտք գործել որոնման համար",
        sessionExpired: "Նիստը լրացել է: Խնդրում ենք նորից մուտք գործել:",
        serverError: "Սերվերի սխալ: Խնդրում ենք փորձել ավելի ուշ:",
        searchFailed: "Որոնումը ձախողվեց",
        networkError: "Ցանցի սխալ: Խնդրում ենք ստուգել ձեր կապը և նորից փորձել:",
        language: "Լեզու",
        selectLanguage: "Ընտրել լեզուն",
        messages: "Հաղորդագրություններ",
        cancel: "Չեղարկել",
      },
      notifications: {
        title: "Ծանուցումներ",
        markAllRead: "Նշել բոլորը որպես կարդացված",
        marking: "Նշվում է...",
        loading: "Բեռնվում է...",
        allCaughtUp: "Ամեն ինչ կարդացված է!",
        noNew: "Նոր ծանուցումներ չկան",
        liked: "հավանել է ձեր գրառումը",
        commented: "մեկնաբանել է ձեր գրառումը",
        followed: "սկսել է հետևել ձեզ",
        followRequest: "ցանկանում է հետևել ձեզ",
        followAccepted: "ընդունել է ձեր հետևելու հարցումը",
        sentMessage: "ուղարկել է ձեզ հաղորդագրություն",
        postRemoved: "ձեր գրառումը հեռացվել է ադմինիստրատորի կողմից",
        genericNotification: "ուղարկել է ծանուցում",
        reason: "Պատճառ",
        admin: "Ադմին",
        processing: "Մշակվում է...",
        accept: "Ընդունել",
        decline: "Մերժել",
        total: "ընդամենը",
        unread: "չկարդացված",
        refresh: "Թարմացնել",
        justNow: "հիմա",
        dismiss: "Փակել",
        missingFollowData: "Հնարավոր չէ մշակել՝ բացակայում են հետևելու հարցման տվյալները:",
        followActionFailed: "Չհաջողվեց {{action}} հետևելու հարցումը: Խնդրում ենք փորձել կրկին:",
        networkError: "Ցանցի սխալ: Խնդրում ենք փորձել կրկին:",
        avatarAlt: "Ավատար",
        viewProfile: "Դիտել {{name}}-ի պրոֆիլը",
        someone: "Ինչ-որ մեկը",
      },
      messageModal: {
        sendMessage: "Ուղարկել հաղորդագրություն",
        noMutualFollows: "Փոխադարձ հետևորդներ դեռ չկան",
        noMutualFollowsHint: "Հետևեք մարդկանց և սպասեք, որ նրանք էլ հետևեն ձեզ՝ գրելու համար:",
        mutualFollowsCount: "{{count}} փոխադարձ հետևորդ",
        org: "Կազմ.",
        user: "Օգտատեր",
        mutualFollow: "Փոխադարձ հետևում",
        cancel: "Չեղարկել",
        verified: "Հաստատված",
      },
      postModal: {
        reply: "Պատասխանել",
        report: "Բողոքել",
        delete: "Ջնջել",
        save: "Պահպանել",
        share: "Կիսվել",
        writeReply: "Գրեք պատասխան...",
        writeComment: "Գրեք մեկնաբանություն...",
        noCommentsYet: "Մեկնաբանություններ դեռ չկան",
        deletePost: "Ջնջել գրառումը",
        deleteComment: "Ջնջել մեկնաբանությունը",
        cancel: "Չեղարկել",
        areYouSure: "Վստա՞հ եք",
        postWillBeDeleted: "Այս գրառումը կջնջվի ընդմիշտ:",
        deleteThisComment: "Ջնջե՞լ այս մեկնաբանությունը:",
        reportPost: "Բողոքել գրառումից",
        reasonSpam: "Սպամ",
        reasonInappropriate: "Անհարմար բովանդակություն",
        reasonHarassment: "Ոտնձգություն",
        reasonHateSpeech: "Ատելության խոսք",
        reasonMisinformation: "Ապատեղեկատվություն",
        reasonOther: "Այլ",
        linkCopied: "Հղումը պատճենվեց!",
        beFirstComment: "Եղեք առաջինը, ով կմեկնաբանի!",
        comment: "Մեկնաբանություն",
        comments: "Մեկնաբանություններ",
        justNow: "Հենց նոր",
        minutesAgo: "{{m}} րոպե առաջ",
        hoursAgo: "{{h}} ժամ առաջ",
        daysAgo: "{{day}} օր առաջ",
        unknown: "Անհայտ",
        me: "Ես",
        replyPosted: "Պատասխանը հրապարակվեց!",
        commentAdded: "Մեկնաբանությունը ավելացվեց!",
        postDeleted: "Գրառումը ջնջվեց:",
        commentDeleted: "Մեկնաբանությունը ջնջվեց:",
        reportSubmitted: "Բողոքն ուղարկվեց:",
        failedLoadPost: "Չհաջողվեց բեռնել գրառումը:",
        loadingPost: "Գրառումը բեռնվում է...",
        postNotFound: "Գրառումը չի գտնվել:",
        like: "Հավանել",
        likes: "Հավանումներ",
        submit: "Ուղարկել",
        user: "Օգտատեր",
      },
      authPages: {
        orgReg: {
          stepProfileShort: "Պրոֆիլ", stepProfileLong: "Կազմակերպության պրոֆիլ",
          stepContactShort: "Կապ", stepContactLong: "Կապ և ցանցեր", stepContactMedium: "Կապ",
          stepTeamShort: "Թիմ", stepTeamLong: "Թիմ և անվտանգություն",
          stepVerification: "Հաշիվ",
          back: "Հետ",
          loadingOrgData: "Բեռնվում են ձեր կազմակերպության տվյալները...",
          continueStep2: "Շարունակել դեպի 2-րդ քայլ",
          continueStep3: "Շարունակել դեպի 3-րդ քայլ",
          continueVerification: "Շարունակել դեպի հաստատում",
          orgNameTitle: "Կազմակերպության անվանում",
          orgNameTooltip: "Ավելացրեք ձեր կազմակերպության անվանումը տարբեր լեզուներով: Հայերեն տարբերակը պարտադիր է:",
          orgNameDesc: "Նշեք ձեր կազմակերպության անվանումը տարբեր լեզուներով",
          language: "Լեզու",
          orgNameLabel: "Կազմ. անվանում",
          orgNamePlaceholder: "Մուտքագրեք կազմակերպության անվանումը",
          addNameInAnotherLanguage: "Ավելացնել անվանում այլ լեզվով",
          orgTypeTitle: "Կազմակերպության տեսակ",
          selectOrgType: "Ընտրեք կազմակերպության տեսակը",
          typesSelected: "ընտրված է {{count}} տեսակ",
          specifyOrgType: "Նշեք ձեր կազմակերպության տեսակը...",
          ageGroupsTitle: "Թիրախային տարիքային խմբեր",
          ageGroups: {
            all: "Բոլոր տարիքային խմբերը",
            "0-12": "Երեխաներ (0-12)",
            "13-17": "Դեռահասներ (13-17)",
            "18-25": "Երիտասարդներ (18-25)",
            "26-35": "Հասուն (26-35)",
            "36-50": "Միջին տարիք (36-50)",
            "51-65": "Ավագ սերունդ (51-65)",
            "65+": "Տարեց (65+)",
          },
          orgNameLanguages: {
            Armenian: "Հայերեն",
            English: "Անգլերեն",
            Russian: "Ռուսերեն",
            French: "Ֆրանսերեն",
            German: "Գերմաներեն",
            Spanish: "Իսպաներեն",
            Other: "Այլ",
          },
          focusAreasTitle: "Գործունեության ոլորտներ",
          selectFocusAreas: "Ընտրեք գործունեության ոլորտները",
          areasSelected: "ընտրված է {{count}} ոլորտ",
          specifyFocusArea: "Նշեք ձեր գործունեության ոլորտը...",
          detailsTitle: "Կազմակերպության մանրամասներ",
          briefDescription: "Համառոտ նկարագրություն",
          briefDescriptionPlaceholder: "Նկարագրեք ձեր կազմակերպության նպատակը, գործունեությունը և ազդեցությունը...",
          missionStatement: "Առաքելություն",
          missionPlaceholder: "Որն է ձեր կազմակերպության հիմնական առաքելությունը և արժեքները:",
          yearEstablished: "Հիմնադրման տարեթիվ",
          legalForm: "Իրավական ձև",
          selectLegalForm: "Ընտրեք իրավական ձևը",
          formsSelected: "ընտրված է {{count}} ձև",
          specifyLegalForm: "Նշեք իրավական ձևը...",
          alertName: "Խնդրում ենք մուտքագրել ձեր կազմակերպության անվանումը",
          alertOrgType: "Խնդրում ենք ընտրել առնվազն մեկ կազմակերպության տեսակ",
          alertAudience: "Խնդրում ենք ընտրել առնվազն մեկ թիրախային տարիքային խումբ",
          alertFocusArea: "Խնդրում ենք ընտրել առնվազն մեկ գործունեության ոլորտ",
          alertDescription: "Խնդրում ենք լրացնել համառոտ նկարագրությունը",
          alertMission: "Խնդրում ենք լրացնել առաքելությունը",
          alertYear: "Խնդրում ենք նշել ձեր կազմակերպության հիմնադրման տարեթիվը",
          alertLegalForm: "Խնդրում ենք ընտրել իրավական ձև",
          step2Title: "Քայլ 2. Կապ և ցանցեր",
          step2Subtitle: "Ինչպե՞ս կարող են մարդիկ կապվել ձեր կազմակերպության հետ:",
          contactInfoTitle: "Կոնտակտային տվյալներ",
          orgEmail: "Կազմակերպության էլ. փոստ",
          orgEmailPlaceholder: "your.org@example.com",
          orgEmailHint: "Այս հասցեին կուղարկենք հաստատման կոդ՝ ձեր հաշիվը ստուգելու համար:",
          primaryPhone: "Հիմնական հեռախոսահամար",
          phoneNumberPlaceholder: "Հեռախոսահամար",
          website: "Կայք",
          address: "Հասցե",
          addressPlaceholder: "Փողոց, քաղաք, երկիր",
          socialLinks: "Սոցիալական ցանցեր",
          socialLinkPlaceholder: "https://example.com/profile",
          addLink: "Ավելացնել հղում",
          networksTitle: "Միջազգային ցանցեր",
          networksDesc: "Ընտրեք ցանցերը, որոնց մաս է կազմում ձեր կազմակերպությունը",
          customNetworkPlaceholder: "Ավելացնել ցանց...",
          add: "Ավելացնել",
          alertRequiredFields: "Խնդրում ենք լրացնել պարտադիր դաշտերը՝ էլ. փոստ և հեռախոսահամար",
          alertValidEmail: "Խնդրում ենք մուտքագրել վավեր էլ. փոստի հասցե",
          alertValidPhone: "Խնդրում ենք մուտքագրել վավեր հեռախոսահամար (առնվազն 6 նիշ)",
          alertAddress: "Խնդրում ենք նշել ձեր կազմակերպության հասցեն",
          step3Title: "Քայլ 3. Թիմ և անվտանգություն",
          step3Subtitle: "Կառավարեք ձեր թիմի անդամներին և անվտանգության կարգավորումները",
          brandingTitle: "Կազմակերպության բրենդինգ",
          logoOptional: "Լոգո (ընտրովի)",
          addLogo: "Ավելացնել լոգո",
          upTo8mb: "Մինչև 8ՄԲ",
          change: "Փոխել",
          orgPresentationOptional: "Կազմակերպության պրեզենտացիա (ընտրովի)",
          uploadPresentation: "Վերբեռնել պրեզենտացիա",
          presentationHint: "PDF, սլայդներ կամ նկար, մինչև 8ՄԲ",
          fileAttached: "Ֆայլը կցված է",
          clickToChange: "Սեղմեք՝ փոխելու համար",
          teamTitle: "Լիազորված թիմի անդամներ",
          teamDesc: "Ավելացրեք թիմի անդամներին, ովքեր լիազորված են բովանդակություն հրապարակել կազմակերպության անունից: Յուրաքանչյուրը կստանա հրավեր էլ. փոստով և կմիանա հաստատված ցուցակին միայն այն ընդունելուց հետո:",
          member: "Անդամ #{{n}}",
          fullNamePlaceholder: "Անուն Ազգանուն",
          rolePlaceholder: "Դեր / պարտականություն",
          teamEmailPlaceholder: "team@org.com",
          addTeamMember: "Ավելացնել թիմի անդամ",
          alertFileSize: "Ֆայլերը պետք է լինեն փոքր, քան 8ՄԲ:",
          alertMember: "Խնդրում ենք լրացնել գոնե մեկ լիազորված թիմի անդամի անուն-ազգանունը, դերը և էլ. փոստը",
          step4Title: "Քայլ 4. Հաշիվ և կոնտակտային անձ",
          step4Subtitle: "Ավարտեք գրանցումը՝ ստեղծելով մուտքի տվյալներ։ Իրավական հաստատումը կատարվում է ավելի ուշ՝ ձեր վահանակից",
          missingInfoTitle: "Բացակայող տեղեկություն",
          missingInfoDesc: "Նախ ավարտեք Քայլ 1-ը՝ Կազմակերպության պրոֆիլը:",
          goToStep1: "Անցնել Քայլ 1",
          submittingRegistration: "Ուղարկվում է ձեր գրանցումը...",
          loginCredentialsTitle: "Մուտքի տվյալներ",
          orDivider: "կամ ավարտեք էլ. փոստով և գաղտնաբառով",
          username: "Օգտանուն",
          usernamePlaceholder: "օր.՝ greenpeace_official",
          usernameValid: "✓ Օգտանունը վավեր է",
          usernameInvalid: "Պետք է լինի առնվազն 3 նիշ՝ միայն փոքրատառ լատինատառեր, թվեր, _ և .",
          suggestions: "Առաջարկներ.",
          email: "Էլ. փոստ",
          emailHintPrefix: "Նշված է Քայլ 2-ում: Հաստատման կոդը կուղարկենք այստեղ,",
          changeIt: "փոխել",
          password: "Գաղտնաբառ",
          passwordPlaceholder: "Առնվազն 8 նիշ",
          confirmPassword: "Հաստատեք գաղտնաբառը",
          confirmPasswordPlaceholder: "Կրկնեք գաղտնաբառը",
          passwordsMatch: "✓ Գաղտնաբառերը համընկնում են",
          passwordsDontMatch: "✗ Գաղտնաբառերը չեն համընկնում",
          strengthWeak: "Թույլ", strengthMedium: "Միջին", strengthStrong: "Ուժեղ",
          easyPasswordsTitle: "💡 Հեշտ հիշվող գաղտնաբառեր (սեղմեք՝ օգտագործելու համար).",
          refresh: "Թարմացնել",
          passwordFormatHint: "Ձևաչափ՝ Բառ + Բառ + Թվեր (հեշտ հիշվող, դժվար գուշակվող)",
          legalRepTitle: "Ո՞վ է գրանցվում",
          legalRepDesc: "Հաշիվը ստեղծող և կազմակերպության անունից գործելու իրավասություն ունեցող անձը",
          registrantRoleQuestion: "Դուք գրանցվում եք որպես բուն կազմակերպությո՞ւնը, թե՞ որպես նրա ներկայացուցիչ",
          registrantRoleOrg: "Կազմակերպությունը",
          registrantRoleRep: "Ես ներկայացուցիչ եմ",
          name: "Անուն", firstNamePlaceholder: "Անուն",
          surname: "Ազգանուն", lastNamePlaceholder: "Ազգանուն",
          position: "Պաշտոն", positionPlaceholder: "օր.՝ գործադիր տնօրեն",
          phone: "Հեռախոս",
          optional: "(ընտրովի)",
          optionalPlaceholder: "Ընտրովի",
          verificationTitle: "Իրավական գրանցում և հաստատում",
          verificationDesc: "Այս տեղեկությունը մեր թիմին թույլ է տալիս հաստատել կազմակերպության իրավաչափությունը մինչև հարթակում հրապարակվելը",
          isInformalQuestion: "Ձեր կազմակերպությունն ոչ պաշտոնական / չգրանցված խու՞մբ է:",
          formallyRegistered: "Ոչ, մենք պաշտոնապես գրանցված ենք",
          informal: "Այո, մենք ոչ պաշտոնական խումբ ենք",
          informalHint: "Գրանցման տվյալներ պետք չեն։ Ոչ պաշտոնական խմբերը կարող են անցնել ուղիղ ներքևի փաստաթղթերին:",
          legalFormFromStep1: "Իրավական ձև (1-ին քայլից).",
          stateRegNumber: "Պետական գրանցման համար", stateRegNumberPlaceholder: "Վկայագրի / գրանցամատյանի համար",
          countryOfReg: "Գրանցման երկիր", countryOfRegPlaceholder: "օր.՝ Հայաստան",
          dateOfReg: "Գրանցման ամսաթիվ",
          taxId: "ՀՎՀՀ / իրավական ID", taxIdPlaceholder: "Հարկ վճարողի հաշվառման համար",
          vatNumber: "ԱԱՀ համար", vatNumberPlaceholder: "օր.՝ AM12345678",
          registeredAddress: "Գրանցված իրավաբանական հասցե", registeredAddressPlaceholder: "Գրանցամատյանում նշված հասցեն",
          documentsTitle: "Փաստաթղթեր",
          optionalParen: "(Ընտրովի)",
          registrationDoc: "Գրանցման փաստաթուղթ",
          vatCertificate: "ԱԱՀ վկայական",
          stateSeal: "Պետական կնիք",
          passportScan: "Անձնագրի սկան",
          uploadShort: "+ Վերբեռնել",
          docHint: "PDF կամ նկար, մինչև 8ՄԲ",
          completeRegistration: "Ավարտել գրանցումը",
          submittingBtn: "Ուղարկվում է...",
          alertUsernameRequired: "Օգտանունը պարտադիր է",
          alertUsernameFormat: "Օգտանունը պետք է լինի 3-20 նիշ և պարունակի միայն փոքրատառ լատինատառեր, թվեր, ընդգծումներ և կետեր",
          alertMissingEmail: "Կազմակերպության էլ. փոստը բացակայում է։ Խնդրում ենք վերադառնալ Քայլ 2",
          alertPasswordRequired: "Գաղտնաբառը պարտադիր է",
          alertPasswordsMismatch: "Գաղտնաբառերը չեն համընկնում",
          alertPasswordLength: "Գաղտնաբառը պետք է լինի առնվազն 8 նիշ",
          alertRegistrantRole: "Խնդրում ենք նշել՝ գրանցվում եք որպես կազմակերպությո՞ւն, թե՞ ներկայացուցիչ",
          alertRepName: "Օրինական ներկայացուցչի անունը պարտադիր է",
          alertRepSurname: "Օրինական ներկայացուցչի ազգանունը պարտադիր է",
          alertRepPosition: "Օրինական ներկայացուցչի պաշտոնը պարտադիր է",
          alertStateRegId: "Պաշտոնապես գրանցված կազմակերպության համար պետական գրանցման համարը պարտադիր է",
          alertCountry: "Գրանցման երկիրը պարտադիր է",
          alertRegDate: "Գրանցման ամսաթիվը պարտադիր է",
          alertLegalId: "ՀՎՀՀ / իրավական ID-ն պարտադիր է",
          alertRegAddress: "Գրանցված իրավաբանական հասցեն պարտադիր է",
          alertVat: "ԱԱՀ համարը պարտադիր է",
          alertCaptcha: "Խնդրում ենք լրացնել CAPTCHA-ն",
          alertFileTooLarge: "Ֆայլը չափազանց մեծ է (առավելագույնը 8ՄԲ)",
          successEmailVerify: "✅ Գրանցումն ուղարկվել է: Ստուգեք ձեր էլ. փոստը հաստատման կոդի համար:",
          successRegistered: "✅ Գրանցումը հաջողվեց:",
          successSocial: "Սոցիալական ցանցով գրանցումը հաջողվեց:",
          errorRegistrationFailed: "Գրանցումը ձախողվեց: Խնդրում ենք փորձել կրկին:",
          errorSocialFailed: "Սոցիալական ցանցով գրանցումը ձախողվեց: Խնդրում ենք փորձել կրկին:",
        },
        backToLogin: "Վերադառնալ մուտք",
        enterEmail: "Խնդրում ենք մուտքագրել ձեր էլ. փոստը:",
        somethingWrong: "Ինչ-որ բան սխալ գնաց: Խնդրում ենք փորձել կրկին:",
        checkYourEmail: "Ստուգեք ձեր էլ. փոստը",
        resetEmailSent: "Եթե {{email}} հասցեով հաշիվ գոյություն ունի, մենք ուղարկել ենք հղում գաղտնաբառը վերականգնելու համար: Այն ուժի մեջ է 1 ժամ:",
        forgotTitle: "Մոռացե՞լ եք գաղտնաբառը",
        forgotSubtitle: "Մուտքագրեք ձեր էլ. փոստը, և մենք կուղարկենք վերականգնման հղում:",
        email: "Էլ. փոստ",
        sending: "Ուղարկվում է…",
        sendResetLink: "Ուղարկել հղումը",
        confirmEmailTitle: "Հաստատեք ձեր էլ. փոստը",
        confirmEmailSubtitle: "Մենք ուղարկել ենք 6-նիշանոց կոդ {{email}} հասցեին: Մուտքագրեք այն ստորև՝ հաշիվն ակտիվացնելու համար:",
        yourEmail: "ձեր էլ. փոստը",
        confirmationCode: "Հաստատման կոդ",
        confirmBtn: "Հաստատել",
        verifying: "Հաստատվում է…",
        resendCode: "Կրկին ուղարկել կոդը",
        resendCodeIn: "Կրկին ուղարկել {{seconds}} վրկ հետո",
        codeResent: "Նոր կոդն ուղարկվել է ձեր էլ. փոստին:",
        missingResetInfo: "Այս հղումին բացակայում է անհրաժեշտ տեղեկատվությունը: Խնդրում ենք հայցել նոր հղում:",
        passwordTooShort: "Գաղտնաբառը պետք է լինի առնվազն 8 նիշ:",
        passwordsDontMatch: "Գաղտնաբառերը չեն համընկնում:",
        failedResetPassword: "Չհաջողվեց վերականգնել գաղտնաբառը:",
        passwordUpdated: "Գաղտնաբառը թարմացվեց",
        redirecting: "Ուղղորդում ենք դեպի մուտք…",
        chooseNewPassword: "Ընտրեք նոր գաղտնաբառ",
        forAccount: "{{email}} հաշվի համար",
        yourAccount: "ձեր հաշիվը",
        newPassword: "Նոր գաղտնաբառ",
        confirmNewPassword: "Հաստատեք նոր գաղտնաբառը",
        atLeast8Chars: "Առնվազն 8 նիշ",
        reenterPassword: "Կրկին մուտքագրեք գաղտնաբառը",
        updating: "Թարմացվում է…",
        updatePassword: "Թարմացնել գաղտնաբառը",
        resendLink: "Կրկին ուղարկել հղումը",
        resendLinkIn: "Կրկին ուղարկել {{seconds}} վրկ հետո",
        linkResent: "Նոր հղումն արդեն ճանապարհին է:",
        checkSpamHint: "Չե՞ք գտնում: Ստուգեք սպամի պանակը, կարող է մեկ րոպե տևել հասնելը:",
        oauthNoticeTitle: "Դուք մուտք եք գործել {{provider}}-ով",
        oauthNoticeDesc: "Այդ հաշիվը գաղտնաբառ չունի, ուստի վերականգնելու բան չկա. պարզապես շարունակեք {{provider}}-ով մուտքի էջից:",
        socialAccountGeneric: "սոցիալական հաշվով",
        goToLogin: "Անցնել մուտք",
        passwordReqLength: "Առնվազն 8 նիշ",
        passwordReqMatch: "Գաղտնաբառերը համընկնում են",
        login: "Մուտք",
        password: "Գաղտնաբառ",
        forgotPassword: "Մոռացե՞լ եք գաղտնաբառը",
        loading: "Բեռնվում է...",
        continueBtn: "Շարունակել",
        or: "կամ",
        dontHaveAccount: "Հաշիվ չունե՞ք",
        register: "Գրանցվել",
        socialLoginFailed: "Սոցիալական մուտքը ձախողվեց:",
        chooseAccountType: "Ընտրեք հաշվի տեսակը",
        selectHowToUse: "Ընտրեք, թե ինչպես եք ցանկանում օգտագործել մեր հարթակը",
        player: "Խաղացող",
        playerDescLong: "Մասնակցեք մրցաշարերի և մրցեք այլ խաղացողների հետ",
        playerDescShort: "Միացեք և մրցեք",
        organizer: "Կազմակերպիչ",
        organizerDescLong: "Ստեղծեք և կառավարեք մրցաշարեր",
        organizerDescShort: "Ստեղծեք և կառավարեք",
        pendingApproval: "Ձեր հաշիվը սպասում է հաստատման: Խնդրում ենք սպասել ադմինիստրատորի հաստատմանը:",
        loginFailed: "Մուտքը ձախողվեց: Խնդրում ենք փորձել կրկին:",
        invalidCredentials: "Սխալ էլ. փոստ կամ գաղտնաբառ:",
        socialRegisterFailed: "Սոցիալական գրանցումը ձախողվեց: Խնդրում ենք փորձել կրկին:",
        loggingIn: "Մուտք է գործում...",
        showPassword: "Ցուցադրել գաղտնաբառը",
        hidePassword: "Թաքցնել գաղտնաբառը",
        registrationVisual: "Գրանցման պատկեր",
        togglePasswordVisibility: "Փոխել գաղտնաբառի տեսանելիությունը",
        registerAsOrg: "Գրանցվել որպես կազմակերպություն",
        registerAsUser: "Գրանցվել որպես օգտատեր",
        fillRequired: "Խնդրում ենք լրացնել բոլոր պարտադիր դաշտերը",
        nameLength: "Անունը պետք է լինի 2-20 նիշ",
        surnameLength: "Ազգանունը պետք է լինի 2-20 նիշ",
        invalidEmail: "Խնդրում ենք մուտքագրել վավեր էլ. փոստ",
        useRealEmail: "Խնդրում ենք օգտագործել իրական էլ. փոստ",
        invalidPhone: "Խնդրում ենք մուտքագրել վավեր հեռախոսահամար (+374XXXXXXXX կամ 0XXXXXXXX)",
        passwordLength: "Գաղտնաբառը պետք է լինի 6-20 նիշ",
        passwordLetterNumber: "Գաղտնաբառը պետք է պարունակի առնվազն մեկ տառ և մեկ թիվ",
        passwordTooWeak: "Խնդրում ենք ընտրել ավելի անվտանգ գաղտնաբառ",
        passwordsNoMatch: "Գաղտնաբառերը չեն համընկնում",
        mustAgreeTerms: "Դուք պետք է համաձայնվեք Պայմաններին",
        completeCaptcha: "Խնդրում ենք լրացնել CAPTCHA հաստատումը",
        registrationFailed: "Գրանցումը ձախողվեց",
        registrationError: "Գրանցման ընթացքում սխալ տեղի ունեցավ",
        registrationTimeout: "Գրանցումը սպասվածից ավելի երկար է տևում։ Խնդրում ենք ստուգել ձեր կապը և փորձել կրկին։",
        socialRegFailed: "Սոցիալական գրանցումը ձախողվեց",
        createAccount: "Ստեղծել հաշիվ",
        orRegisterEmail: "կամ գրանցվեք էլ. փոստով",
        name: "Անուն",
        surname: "Ազգանուն",
        phoneOptional: "Հեռախոս",
        phoneExample: "Օրինակ՝ +374 98 123 456",
        confirmPassword: "Հաստատեք գաղտնաբառը",
        confirmYourPassword: "Հաստատեք ձեր գաղտնաբառը",
        passwordPlaceholderHint: "Առնվազն 6 նիշ, ներառեք տառ և թիվ",
        charsMin: "6+ նիշ",
        letter: "տառ",
        number: "թիվ",
        passwordsMatch: "Գաղտնաբառերը համընկնում են",
        passwordsDontMatchShort: "Գաղտնաբառերը չեն համընկնում",
        agreeToTerms: "Ես համաձայն եմ",
        termsConditions: "Պայմաններին",
        and: "և",
        privacyPolicy: "Գաղտնիության քաղաքականությանը",
        registering: "Գրանցվում է...",
        registerBtn: "Գրանցվել",
      },
      followButton: {
        pleaseLogin: "Խնդրում ենք մուտք գործել՝ օգտատերերին հետևելու համար",
        userIdMissing: "Հնարավոր չէ հետևել՝ օգտատիրոջ ID-ն բացակայում է",
        requestSent: "Հետևելու հարցումն ուղարկվեց!",
        failedSendRequest: "Չհաջողվեց ուղարկել հետևելու հարցումը",
        noRequestId: "Հարցման ID չի գտնվել",
        requestAccepted: "Հետևելու հարցումն ընդունվեց!",
        failedAccept: "Չհաջողվեց ընդունել հետևելու հարցումը",
        requestRejected: "Հետևելու հարցումը մերժվեց",
        failedReject: "Չհաջողվեց մերժել հետևելու հարցումը",
        unfollowedSuccess: "Հետևումը հաջողությամբ չեղարկվեց",
        unfollowIdMissing: "Հնարավոր չէ չեղարկել հետևումը՝ օգտատիրոջ ID-ն բացակայում է",
        failedUnfollow: "Չհաջողվեց չեղարկել հետևումը",
        noRequestIdCancel: "Հարցման ID չի գտնվել չեղարկելու համար",
        requestCancelled: "Հետևելու հարցումը չեղարկվեց",
        failedCancel: "Չհաջողվեց չեղարկել հետևելու հարցումը",
        userUnavailable: "Օգտատերն անհասանելի է",
        loading: "Բեռնվում է...",
        acceptRequest: "Ընդունել հարցումը",
        reject: "Մերժել",
        mutualFollow: "Փոխադարձ հետևում",
        following: "Հետևում եք",
        unfollow: "Չեղարկել հետևումը",
        requestSentBtn: "Հարցումն ուղարկված է",
        follow: "Հետևել",
      },
      followSettings: {
        pleaseLogin: "Խնդրում ենք մուտք գործել կարգավորումները դիտելու համար",
        failedLoad: "Չհաջողվեց բեռնել կարգավորումները",
        settingsSaved: "Կարգավորումները հաջողությամբ պահպանվեցին!",
        failedSave: "Չհաջողվեց պահպանել կարգավորումները",
        loadingSettings: "Կարգավորումները բեռնվում են...",
        title: "Հետևման կարգավորումներ",
        subtitle: "Վերահսկեք, թե ինչպես կարող են ուրիշները հետևել ձեզ",
        followRequests: "Հետևելու հարցումներ",
        followRequestsDesc: "Վերահսկեք՝ արդյոք մարդկանց անհրաժեշտ է ձեր հաստատումը ձեզ հետևելու համար",
        requireApproval: "Պահանջել հաստատում հետևորդների համար",
        approvalOnDesc: "Մարդիկ պետք է հարցում ուղարկեն ձեզ հետևելու համար",
        approvalOffDesc: "Ցանկացած ոք կարող է հետևել ձեզ առանց հաստատման",
        whenOn: "Երբ ՄԻԱՑՎԱԾ Է.",
        onPoint1: "Օգտատերերը պետք է ուղարկեն հետևելու հարցում",
        onPoint2: "Դուք կարող եք հաստատել կամ մերժել հարցումները",
        onPoint3: "Դուք ունեք լիարժեք վերահսկողություն, թե ով է հետևում ձեզ",
        onPoint4: "Իդեալական է անձնական հաշիվների համար",
        whenOff: "Երբ ԱՆՋԱՏՎԱԾ Է.",
        offPoint1: "Ցանկացած ոք կարող է անմիջապես հետևել ձեզ",
        offPoint2: "Հաստատում չի պահանջվում",
        offPoint3: "Հիանալի է հանրային անձանց և կազմակերպությունների համար",
        offPoint4: "Առավելագույնի է հասցնում ձեր հասանելիությունը",
        notifications: "Ծանուցումներ",
        notificationsDesc: "Կառավարեք, թե ինչպես եք ծանուցվում հետևելու հարցումների մասին",
        emailNotifications: "Էլ. փոստի ծանուցումներ",
        emailNotifDesc: "Ստացեք էլ. փոստի ծանուցումներ նոր հետևելու հարցումների համար",
        pushNotifications: "Push ծանուցումներ",
        pushNotifDesc: "Ստացեք բրաուզերի ծանուցումներ հետևելու հարցումների համար",
        inAppNotifications: "Հավելվածի ներսի ծանուցումներ",
        inAppNotifDesc: "Տեսեք ծանուցումները հավելվածի ներսում",
        followers: "Հետևորդներ",
        following: "Հետևում եմ",
        pendingRequests: "Սպասող հարցումներ",
        resetDefaults: "Վերականգնել կանխադրվածները",
        saving: "Պահպանվում է...",
        saveSettings: "Պահպանել կարգավորումները",
      },
      followRequestsPage: {
        failedLoad: "Չհաջողվեց բեռնել հետևելու հարցումները",
        serverError: "Սերվերի սխալ. {{status}}",
        acceptedRequest: "Դուք ընդունեցիք {{name}}-ի հարցումը!",
        failedAccept: "Չհաջողվեց ընդունել հետևելու հարցումը: Խնդրում ենք փորձել կրկին:",
        rejectedRequest: "{{name}}-ի հարցումը մերժվեց",
        failedReject: "Չհաջողվեց մերժել հետևելու հարցումը: Խնդրում ենք փորձել կրկին:",
        needMutualToMessage: "Ձեզ անհրաժեշտ է փոխադարձ հետևում {{name}}-ին գրելու համար",
        failedStartConversation: "Չհաջողվեց սկսել խոսակցությունը",
        justNow: "Հենց նոր",
        minAgo: "{{n}} րոպե առաջ",
        hourAgo: "{{n}} ժամ առաջ",
        dayAgo: "{{n}} օր առաջ",
        loadingRequests: "Հետևելու հարցումները բեռնվում են...",
        title: "Հետևելու հարցումներ",
        pending: "{{count}} սպասող",
        requestCount: "{{count}} հարցում",
        requestCountPlural: "{{count}} հարցումներ",
        refreshing: "Թարմացվում է...",
        refresh: "Թարմացնել",
        organization: "Կազմակերպություն",
        wantsToFollow: "Ցանկանում է հետևել ձեզ",
        accept: "Ընդունել",
        decline: "Մերժել",
        sendMessage: "Ուղարկել հաղորդագրություն",
        noRequests: "Սպասող հետևելու հարցումներ չկան",
        noRequestsDesc: "Երբ ինչ-որ մեկը ցանկանա հետևել ձեզ, նրա հարցումն այստեղ կհայտնվի:",
        checkNewRequests: "Ստուգել նոր հարցումները",
      },
      messagesWidget: {
        messages: "Հաղորդագրություններ",
        newMessage: "Նոր հաղորդագրություն",
        fullScreen: "Լիաէկրան",
        close: "Փակել",
        members: "անդամ",
        online: "Առցանց",
        delete: "Ջնջել",
        sharedPost: "Կիսված գրառում",
        sharedPostMessage: "📤 Կիսվեց գրառումով {{name}}-ից",
        unknown: "Անհայտ",
        post: "Գրառում",
        tapToView: "Հպեք՝ գրառումը դիտելու համար →",
        sharingPost: "Կիսվում է գրառումով",
        from: "Ումից՝ {{name}}",
        typeMessage: "Գրեք հաղորդագրություն...",
        direct: "Ուղիղ",
        groups: "Խմբեր",
        noConversations: "Խոսակցություններ դեռ չկան",
        startNewChat: "Սկսել նոր զրույց",
        noMessages: "Հաղորդագրություններ չկան",
        noGroups: "Խմբեր դեռ չկան",
        browseGroups: "Դիտել խմբերը",
        someone: "Ինչ-որ մեկը",
        newMessageTitle: "Նոր հաղորդագրություն",
        searchFollowed: "Որոնել հետևվող օգտատերերին...",
        organization: "Կազմակերպություն",
        user: "Օգտատեր",
        notFollowingAnyone: "Դուք դեռ ոչ ոքի չեք հետևում",
        followToMessage: "Հետևեք մարդկանց՝ հաղորդագրություններ գրելու համար",
        confirmDeleteMessage: "Ջնջե՞լ այս հաղորդագրությունը:",
        emojis: "Էմոջիներ",
        recent: "Վերջին",
        smileys: "Ժպիտներ",
        hearts: "Սրտեր",
        hands: "Ձեռքեր",
        animals: "Կենդանիներ",
        food: "Սնունդ",
        travel: "Ճամփորդություն",
        symbols: "Նշաններ",
        weather: "Եղանակ",
      },
      searchModal: {
        placeholder: "Որոնել օգտատերերի, կազմակերպությունների, գրառումների, համայնքների...",
        postThumbnail: "Գրառման մանրապատկեր",
        all: "Բոլորը",
        organizations: "Կազմակերպություններ",
        players: "Խաղացողներ",
        posts: "Գրառումներ",
        communities: "Համայնքներ",
        searching: "Որոնում...",
        users: "Օգտատերեր",
        noResultsFor: 'Արդյունքներ չեն գտնվել "{{query}}"-ի համար',
        tryDifferentKeywords: "Փորձեք այլ բանալի բառեր",
        seeAllResultsFor: 'Տեսնել բոլոր արդյունքները "{{query}}"-ի համար',
        recentSearches: "Վերջին որոնումները",
        clearAll: "Մաքրել բոլորը",
        searchPlatform: "Որոնել Greenwich հարթակում",
        findPeopleEtc: "Գտեք մարդկանց, կազմակերպություններին, գրառումներն ու համայնքները",
        organization: "Կազմակերպություն",
        administrator: "Ադմինիստրատոր",
        communityMember: "Համայնքի անդամ",
        verifiedOrganization: "Հաստատված կազմակերպություն",
        followers: "հետևորդներ",
        postsCount: "գրառումներ",
        following: "Հետևում եք",
        follow: "Հետևել",
        hAgo: "{{n}} ժամ առաջ",
        dAgo: "{{n}} օր առաջ",
        user: "Օգտատեր",
        noContent: "Բովանդակություն չկա",
        likes: "հավանումներ",
        comments: "մեկնաբանություններ",
        community: "Համայնք",
        members: "անդամներ",
        privateCommunity: "Անձնական համայնք",
        searchFailed: "Որոնումը ձախողվեց: Խնդրում ենք փորձել ավելի ուշ:",
        serverError: "Սերվերի սխալ: Խնդրում ենք փորձել ավելի ուշ:",
        cannotConnect: "Հնարավոր չէ միանալ սերվերին: Ստուգեք ձեր կապը և փորձեք կրկին:",
        networkError: "Ցանցի սխալ: Խնդրում ենք փորձել ավելի ուշ:",
      },
      onboarding: {
        skip: "Բաց թողնել",
        skipTour: "Բաց թողնել շրջայցը",
        back: "Հետ",
        next: "Հաջորդը",
        start: "Սկսել",
        getStarted: "Սկսել աշխատանքը",
        steps: {
          welcome:       { title: "Բարի գալուստ Greenwich!", subtitle: "Ձեր նոր տունը կապի համար", content: "Այնքան ուրախ ենք տեսնել ձեզ այստեղ! Ողջույն, ես Էրիկա AI-ն եմ, և ես կուղեկցեմ ձեզ մեր հարթակի ամեն ինչ ուսումնասիրելիս:", expression: "Ուրախ եմ ձեզ հանդիպել! " },
          navigation:    { title: "Նավիգացիայի ընտրացանկ", subtitle: "Ձեր կողմնացույցը Greenwich-ում", content: "Սա ձեր նավիգացիայի ընտրացանկն է: Այստեղից կարող եք անցնել Գլխավոր, Պրոֆիլ, Հաղորդագրություններ և Ծանուցումներ:", expression: "Նավարկեք Greenwich-ով!" },
          "create-post": { title: "Ստեղծել գրառում", subtitle: "Կիսվեք ձեր ձայնով", content: "Գրեք ձեր մտքերը, վերբեռնեք լուսանկարներ, կիսվեք տեսանյութերով. պատմեք աշխարհին ձեր պատմությունը: Ձեր ձայնը կարևոր է, թող բոլորը լսեն այն!", expression: "Ստեղծեք ինչ-որ բան! " },
          "feed-posts":  { title: "Ձեր հոսքը", subtitle: "Ամբողջ գործողությունը մեկ տեղում", content: "Այստեղ դուք կտեսնեք ձեր հետևած մարդկանց և կազմակերպությունների գրառումները: Հավանեք, մեկնաբանեք, պահպանեք և կիսվեք!", expression: "Հրաշալի բովանդակության հոսք!" },
          greencoins:    { title: "Greencoin շուկա", subtitle: "Ծախսեք այն, ինչ վաստակում եք", content: "Վաստակեք Greencoin-ներ ակտիվ լինելով, ապա ծախսեք դրանք այստեղ՝ շուկայում իրական մրցանակների և արտոնությունների վրա:", expression: "Գնումների ժամանակ! " },
          buddy:         { title: "Greenwich Buddy", subtitle: "Գտեք մենթոր կամ դարձեք մեկը", content: "Buddy-ն ձեզ կապում է մենթորի հետ, ով արդեն անցել է ձեր ուզած ճանապարհը, կամ թույլ է տալիս ձեզ դառնալ մենթոր և ուղղորդել մեկ ուրիշին:", expression: "Եկեք կապվենք! " },
          search:        { title: "Որոնում", subtitle: "Բացահայտեք ամեն ինչ", content: "Գտեք նոր ընկերներ, կազմակերպություններ, գրառումներ և թեմաներ, որոնք ձեզ հետաքրքրում են:", expression: "Փնտրու՞մ եք: " },
          programs:      { title: "Ծրագրեր և նախագծեր", subtitle: "Հնարավորություններ, որոնք սպասում են ձեզ", content: "Բացահայտեք ընթացիկ նախագծերն ու ծրագրերը: Հետևեք առաջընթացին, տեսեք թարմացումները և մասնակցեք նախաձեռնություններին, որոնք իրական ազդեցություն են ստեղծում:", expression: "Կառուցում ենք ապագան! " },
          messages:      { title: "Հաղորդագրություններ", subtitle: "Որտեղ կախարդանքը տեղի է ունենում", content: "Ուղարկեք ուղիղ հաղորդագրություններ, ստեղծեք խմբային զրույցներ, կիսվեք լուսանկարներով և տեսեք, երբ հաղորդագրություններն են կարդացվում:", expression: "Զրուցեք ընկերների հետ! " },
          notifications: { title: "Ծանուցումներ", subtitle: "Եղեք թարմացումների մեջ", content: "Տեսեք հավանումները, նոր մեկնաբանությունները, հետևելու հարցումները և հաղորդագրությունները: Երբեք մի բաց թողեք կարևոր թարմացումը!", expression: "Դուք ունեք ծանուցումներ!" },
          organization:  { title: "Կազմակերպություններ", subtitle: "Վստահելի: Ճանաչված: Ազդեցիկ:", content: "Ձեր կազմակերպությունը պաշտոնապես հաստատված է: Կիսվեք թարմացումներով, հրապարակեք հաշվետվություններ, փոխազդեք ձեր անդամների հետ և ցուցադրեք ձեր իրական ազդեցությունը:", expression: "Պրոֆեսիոնալ! " },
          settings:      { title: "Կարգավորումներ", subtitle: "Հարմարեցրեք ամեն ինչ", content: "Կառավարեք գաղտնիությունը, թեման, ծանուցումների նախապատվությունները և հաշվի տեղեկությունները:", expression: "Վերահսկողության տակ! " },
          communities:   { title: "Համայնքներ", subtitle: "Կառուցեք ձեր համայնքը", content: "Միացեք ընդհանուր հետաքրքրություններ ունեցող խմբերին, մասնակցեք քննարկումներին, համագործակցեք նախագծերում և ստեղծեք երկարատև ընկերություններ:", expression: "Ողջունելի! " },
          final:         { title: "Ամեն ինչ պատրաստ է!", subtitle: "Բարի գալուստ Greenwich!", content: "Այժմ դուք գիտեք Greenwich-ի բոլոր հիմնական հնարավորությունները: Եղեք բարի, կիսվեք հրաշալի բովանդակությամբ, կապվեք հրաշալի մարդկանց հետ և զվարճացեք!", expression: "Բարի գալուստ! " },
        },
      },
      accountProfile: {
        successSaved: "✅ Պրոֆիլը հաջողությամբ պահպանվեց! Վերահղում...",
        debugImages: "Debug Images",
        editCover: "Խմբագրել շապիկը",
        verifiedOrg: "Հաստատված կազմակերպություն",
        placeholderFullName: "Ձեր ամբողջական անունը",
        placeholderHeadline: "Մասնագիտական վերնագիր",
        placeholderLocation: "📍 Վայրը",
        placeholderEmail: "Էլ. փոստ",
        placeholderPhone: "Հեռախոս",
        aboutMe: "Իմ մասին",
        aboutPlaceholder: "Կիսվեք ձեր պատմությամբ, կրքերով և ինչն է ձեզ մղում...",
        quickActions: "Արագ գործողություններ",
        myPosts: "Իմ գրառումները",
        likedPosts: "Հավանած գրառումներ",
        savedPosts: "Պահպանված գրառումներ",
        areasOfInterest: "Հետաքրքրությունների ոլորտներ",
        edit: "Խմբագրել",
        save: "Պահպանել",
        selectInterestsGuide: "Ընտրեք ձեր հետաքրքրությունների ոլորտները.",
        noInterestsYet: "Հետաքրքրություններ դեռ ընտրված չեն",
        profileInformation: "Պրոֆիլի տեղեկություններ",
        profileInfoNote: "Ձեր պրոֆիլի տեղեկությունները կթարմացվեն պահպանելուց հետո:",
        tipsTitle: "Խորհուրդներ լավագույն արդյունքի համար.",
        tip1: "Օգտագործեք բարձրորակ նկարներ (JPEG կամ PNG)",
        tip2: "Պրոֆիլի նկարը պետք է լինի քառակուսի (1:1 հարաբերակցություն)",
        tip3: "Շապիկի նկարը պետք է լինի լայն (16:9 հարաբերակցություն)",
        tip4: "Փոփոխությունները ավտոմատ պահպանվում են ձեր վահանակում",
        cancel: "Չեղարկել",
        saving: "Պահպանվում է...",
        saveProfile: "Պահպանել պրոֆիլը",
        alertImageTooLarge: "Նկարի չափը պետք է լինի 5ՄԲ-ից պակաս",
        alertInvalidImageType: "Թույլատրվում են միայն JPEG, PNG և GIF նկարներ",
        alertErrorPrefix: "❌ Սխալ: ",
        errorUpdateFailed: "Թարմացումը ձախողվեց: Խնդրում ենք փորձել կրկին:",
        errorUnexpected: "Տեղի ունեցավ անսպասելի սխալ: Խնդրում ենք փորձել կրկին:",
      },
      adminProgramsReview: {
        deleteTitle: "Ջնջե՞լ ծրագիրը",
        deleteSub: "Այս գործողությունը հնարավոր չէ հետարկել:",
        cancel: "Չեղարկել",
        delete: "Ջնջել",
        needsEditSendTitle: "Պահանջում է խմբագրում, ուղարկել կարծիք",
        sendMessageTitle: "Ուղարկել հաղորդագրություն կազմակերպությանը",
        needsEditSendSub: "Կարգավիճակը կփոխվի «պահանջում է խմբագրում»: Կազմակերպությունը կստանա ձեր հաղորդագրությունը:",
        sendMessageSub: "Ուղարկեք հաղորդագրություն՝ առանց ծրագրի կարգավիճակը փոխելու:",
        program: "Ծրագիր",
        quickTemplates: "Արագ ձևանմուշներ",
        template1Label: "Բացակայող տեղեկություն",
        template1Text: "Ձեր ծրագրի հայտում բացակայում է որոշ պարտադիր տեղեկություն: Խնդրում ենք թարմացնել հետևյալ դաշտերը և կրկին ուղարկել.\n\n• [Նշեք բացակայող դաշտերը]\n\nԹարմացնելուց հետո ձեր ծրագիրը կրկին կվերանայվի:",
        template2Label: "Չի բավարարում պահանջները",
        template2Text: "Ցավոք, ձեր ծրագիրն այս պահին չի բավարարում մեր հարթակի պահանջները: Մասնավորապես.\n\n• [Բացատրեք խնդիրը]\n\nԽնդրում ենք վերանայել մեր հայտերի ուղեցույցը և կրկին ուղարկել անհրաժեշտ փոփոխություններով:",
        template3Label: "Թարմացնել և կրկին ուղարկել",
        template3Text: "Շնորհակալություն ձեր ծրագիրը ուղարկելու համար: Մենք չկարողացանք հաստատել այն ներկայացված տեսքով, սակայն խրախուսում ենք կատարել հետևյալ փոփոխությունները և կրկին ուղարկել.\n\n• [Նշեք անհրաժեշտ փոփոխությունները]\n\nՄենք սպասում ենք ձեր թարմացված հայտին:",
        template4Label: "Կրկնվող հայտ",
        template4Text: "Կարծես մեր հարթակում արդեն կա նմանատիպ ծրագիր: Խնդրում ենք ստուգել առկա ցանկերը կրկին ուղարկելուց առաջ, կամ կապվեք մեզ հետ, եթե կարծում եք, որ սա սխալ է:",
        messagePlaceholder: "Գրեք ձեր հաղորդագրությունը այստեղ…",
        feedbackHint: "Կազմակերպությունը կտեսնի սա և կարող է խմբագրել ու կրկին ուղարկել:",
        needsEditAndSend: "Պահանջում է խմբագրում և ուղարկել",
        sendMessage: "Ուղարկել հաղորդագրություն",
        pageTitle: "Ծրագրերի վերանայում",
        pageSubtitle: "Կազմակերպությունների հայտեր։ Հաստատվածները հայտնվում են /programs-ում",
        pendingChip: "{{count}} սպասման մեջ",
        refresh: "Թարմացնել",
        tabPending: "Սպասման մեջ",
        tabApproved: "Հաստատված",
        tabNeedsEdit: "Պահանջում է խմբագրում",
        tabRejected: "Մերժված",
        tabAll: "Բոլորը",
        loadingPrograms: "Ծրագրերը բեռնվում են…",
        noProgramsAll: "Ծրագրեր չկան",
        noProgramsFiltered: "{{status}} ծրագրեր չկան",
        statusWordPending: "սպասման մեջ",
        statusWordApproved: "հաստատված",
        statusWordNeedsEdit: "խմբագրում պահանջող",
        statusWordRejected: "մերժված",
        nothingToShow: "Այստեղ դեռ ցուցադրելու ոչինչ չկա:",
        saving: "Պահպանվում է…",
        titlePlaceholder: "Վերնագիր",
        categoryPlaceholder: "Կատեգորիա",
        descriptionPlaceholder: "Նկարագրություն",
        uploadImage: "Վերբեռնել նկար",
        remove: "Հեռացնել",
        pasteImageUrl: "Կամ տեղադրեք նկարի հղումը…",
        save: "Պահպանել",
        statusPending: "Սպասման մեջ",
        statusApproved: "Հաստատված",
        statusNeedsEdit: "Պահանջում է խմբագրում",
        statusRejected: "Մերժված",
        defaultOrgName: "Կազմակերպություն",
        feedbackSent: "Կարծիքն ուղարկված է",
        sendMessageTooltip: "Ուղարկել հաղորդագրություն",
        editTooltip: "Խմբագրել",
        deleteTooltip: "Ջնջել",
        lastFeedback: "Վերջին կարծիքը",
        approve: "Հաստատել",
        needsEdit: "Պահանջում է խմբագրում",
        reject: "Մերժել",
        waitingForEdits: "Սպասվում է կազմակերպության խմբագրումներին",
        visibleInPrograms: "Տեսանելի է /programs-ում",
        revoke: "Չեղարկել հաստատումը",
        reApprove: "Կրկին հաստատել",
        sendFeedback: "Ուղարկել կարծիք",
        deadline: "Վերջնաժամկետ",
        location: "Վայր",
        education: "Կրթություն",
        organization: "Կազմակերպություն",
        description: "Նկարագրություն",
        openProgram: "Բացել ծրագիրը",
        view: "Դիտել",
        toastApproved: "Ծրագիրը հաստատվեց",
        toastNeedsEdit: "Նշվեց որպես խմբագրում պահանջող",
        toastRejected: "Ծրագիրը մերժվեց",
        toastDone: "Կատարված է",
        toastFeedbackSent: "Կարծիքն ուղարկվեց կազմակերպությանը",
        toastDeleted: "Ծրագիրը ջնջվեց",
        toastUpdated: "Ծրագիրը թարմացվեց",
        toastImageTooLarge: "Նկարը պետք է լինի 5 ՄԲ-ից փոքր",
      },
      orgSettings: {
        pageTitle: "Կազմակերպության կարգավորումներ",
        pageSubtitle: "Կառավարեք ձեր կազմակերպության գրանցման տվյալները և տեղեկությունները",
        tabProfile: "Կազմակերպության պրոֆիլ",
        tabContact: "Կապ և ցանցեր",
        tabTeam: "Թիմ և անվտանգություն",
        tabVerification: "Հաստատում",
        edit: "Խմբագրել",
        save: "Պահպանել",
        saving: "Պահպանվում է...",
        notSet: "Նշված չէ",
        step1Title: "Քայլ 1. Կազմակերպության պրոֆիլ",
        orgNames: "Կազմակերպության անվանումներ",
        langArmenian: "Հայերեն",
        langEnglish: "Անգլերեն",
        langRussian: "Ռուսերեն",
        orgNamePlaceholder: "Կազմակերպության անվանում",
        addName: "Ավելացնել անվանում",
        orgType: "Կազմակերպության տեսակ",
        addCustomTypePlaceholder: "Ավելացնել այլ տեսակ",
        description: "Նկարագրություն",
        mission: "Առաքելություն",
        focusAreas: "Ուշադրության ոլորտներ",
        establishedYear: "Հիմնադրման տարեթիվ",
        legalForm: "Իրավական ձև",
        step2Title: "Քայլ 2. Կապ և ցանցեր",
        contactEmail: "Կապի էլ. փոստ",
        primaryPhone: "Հիմնական հեռախոս",
        secondaryPhone: "Երկրորդական հեռախոս",
        address: "Հասցե",
        website: "Կայք",
        socialLinks: "Սոց. ցանցերի հղումներ",
        socialLinkPlaceholder: "https://...",
        addLink: "Ավելացնել հղում",
        noSocialLinks: "Սոց. ցանցերի հղումներ չկան",
        networks: "Ցանցեր",
        step3Title: "Քայլ 3. Թիմ և անվտանգություն",
        secureSealText: "Անվտանգության կնիքի տեքստ",
        authorizedMembers: "Լիազորված թիմի անդամներ",
        memberNum: "Անդամ #{{n}}",
        fullNamePlaceholder: "Անուն ազգանուն",
        rolePlaceholder: "Դերը",
        emailPlaceholder: "Էլ. փոստ",
        addMember: "Ավելացնել անդամ",
        noMembers: "Անդամներ ավելացված չեն",
        step4Title: "Քայլ 4. Հաստատում և մուտք",
        username: "Օգտանուն",
        email: "Էլ. փոստ",
        representativeName: "Ներկայացուցչի անուն",
        representativeEmail: "Ներկայացուցչի էլ. փոստ",
        stateRegistrationId: "Պետական գրանցման համար",
        vatNumber: "ԱԱՀ համար",
        alertSavedSuccess: "Կարգավորումները հաջողությամբ պահպանվեցին!",
        alertErrorSaving: "Պահպանման սխալ: ",
        alertErrorSavingSettings: "Կարգավորումների պահպանման սխալ: ",
      },
      orgAccountProfile: {
        editCover: "Խմբագրել շապիկը",
        followers: "Հետևորդներ",
        following: "Հետևում է",
        placeholderOrgName: "Կազմակերպության անվանում",
        placeholderOrgType: "Կազմակերպության տեսակ / Վերնագիր",
        placeholderLocation: "📍 Վայրը",
        placeholderEmail: "Էլ. փոստ",
        placeholderPhone: "Հեռախոս",
        quickActions: "Արագ գործողություններ",
        myPosts: "Իմ գրառումները",
        likedPosts: "Հավանած գրառումներ",
        savedPosts: "Պահպանված գրառումներ",
        aboutOrg: "Կազմակերպության մասին",
        aboutPlaceholder: "Կիսվեք ձեր կազմակերպության պատմությամբ, առաքելությամբ և նպատակներով...",
        areasOfInterest: "Հետաքրքրությունների ոլորտներ",
        edit: "Խմբագրել",
        save: "Պահպանել",
        selectInterestsGuide: "Ընտրեք ձեր հետաքրքրությունների ոլորտները.",
        noInterestsYet: "Հետաքրքրություններ դեռ ընտրված չեն",
        createPost: "Ստեղծել գրառում",
        postPlaceholder: "Կիսվեք ձեր մտքերով...",
        addPhoto: "Ավելացնել լուսանկար",
        post: "Հրապարակել",
        orgPosts: "Կազմակերպության գրառումներ",
        noPostsYet: "Գրառումներ դեռ չկան: Կիսվեք ձեր առաջին գրառումով վերևում!",
        orgActivities: "Կազմակերպության գործունեություն",
        activityNamePlaceholder: "Գործունեության կամ նախագծի անվանում",
        partnerOrgPlaceholder: "Գործընկեր կազմակերպություն",
        activityDescPlaceholder: "Նկարագրեք ձեր կազմակերպության գործունեությունն ու նվաճումները...",
        addActivity: "Ավելացնել գործունեություն",
        previewProfile: "Դիտել պրոֆիլը",
        saveContinue: "Պահպանել և անցնել վահանակ",
        defaultOrgFallback: "Կազմակերպություն",
        coverAlt: "Շապիկ",
        profileAlt: "Պրոֆիլ",
        verifiedOrgTitle: "Հաստատված կազմակերպություն",
        uploadAlt: "Վերբեռնել",
        postPreviewAlt: "Գրառման նախադիտում",
        postAlt: "Գրառում",
        alertPleaseLogin: "Խնդրում ենք կրկին մուտք գործել",
        alertInvalidResponse: "Սերվերը վերադարձրեց սխալ պատասխան: Մանրամասների համար ստուգեք console-ը:",
        alertErrorCreating: "Գրառումը ստեղծելու սխալ: ",
        alertNetworkError: "Ցանցի սխալ: ",
        alertEnterContent: "Խնդրում ենք մուտքագրել բովանդակություն կամ ավելացնել նկար",
        alertPostSuccess: "Գրառումը հաջողությամբ ստեղծվեց!",
        interests: {
          environment: "Շրջակա միջավայր", education: "Կրթություն", technology: "Տեխնոլոգիա", health: "Առողջություն",
          artsCulture: "Արվեստ և մշակույթ", communityDevelopment: "Համայնքի զարգացում", humanRights: "Մարդու իրավունքներ",
          socialInclusion: "Սոցիալական ներառում", internationalExchanges: "Միջազգային փոխանակումներ", entrepreneurship: "Ձեռնարկատիրություն",
        },
      },
      orgProgramSubmit: {
        greencoinToggle: "Պարգևատրիր մասնակիցներին greencoin-ներով",
        greencoinPitch: "Greencoin-ներ առաջարկող ծրագրերն ավելի շատ դիմորդների են ներգրավում։ Ովքեր կավարտեն այս ծրագիրը, կստանան ստորև նշված քանակը, որը կարող են ծախսել մեր պարգևների խանութում։ Արժեքը հանվում է ձեր կազմակերպության greencoin հաշվեկշռից՝ յուրաքանչյուր մասնակցի հաստատման պահին։",
        greencoinAmountLabel: "Greencoin մեկ մասնակցի համար",
        greencoinBalance: "Ձեր հաշվեկշիռը՝ {{balance}}",
        greencoinLowBalance: "Սա ավելի շատ է, քան ձեր ընթացիկ հաշվեկշիռը։ Համալրիր, մինչև մասնակիցները սկսեն ավարտել ծրագիրը, հակառակ դեպքում ոմանք կարող են վարձատրություն չստանալ։",
        successTitle: "Ծրագիրն ուղարկված է!",
        successBodyPre: "Ձեր ծրագիրը այժմ ",
        successBodyBold: "սպասում է ադմինիստրատորի վերանայմանը",
        successBodyPost: ": Այն կհայտնվի /programs-ում հաստատվելուց հետո:",
        viewMySubmissions: "Դիտել իմ հայտերը",
        submitAnother: "Ուղարկել ևս մեկը",
        title: "Ուղարկել ծրագիր",
        subtitle: "Նույն դաշտերը, ինչ ադմինի ձևը, վերանայվում է հրապարակումից առաջ",
        defaultOrgName: "Կազմակերպություն",
        uploadCoverImage: "Վերբեռնել շապիկի նկար",
        coverImageHint: "Խորհուրդ է տրվում՝ 1200×630px",
        coverImageAlt: "Շապիկ",
        programTitle: "Ծրագրի վերնագիր",
        programTitlePlaceholder: "օր.՝ Erasmus+ Youth Exchange 2026",
        description: "Նկարագրություն",
        descriptionPlaceholder: "Ինչ է առաջարկում ծրագիրը, ում համար է…",
        categories: "Կատեգորիաներ",
        categoriesHint: " (բազմակի ընտրություն, ինչպես ադմինում)",
        sectors: "Ոլորտներ",
        sectorsHint: " (բազմակի ընտրություն, ինչպես ադմինում)",
        programUrl: "Ծրագրի / դիմումի հղում",
        source: "Աղբյուր",
        location: "Վայր",
        locationPlaceholder: "օր.՝ Երևան, Հայաստան",
        format: "Ձևաչափ",
        formatPlaceholder: "օր.՝ Online, Hybrid, On-site",
        educationLevel: "Կրթական մակարդակ",
        eduAny: "Ցանկացած / Չնշված",
        eduHighSchool: "Դպրոց",
        eduStudent: "Ուսանող",
        eduUndergrad: "Բակալավրիատ",
        eduGrad: "Մագիստրատուրա",
        eduDoctoral: "Դոկտորանտուրա",
        eduProfessional: "Մասնագիտական",
        startDate: "Սկսման ամսաթիվ",
        endDate: "Ավարտի ամսաթիվ",
        deadline: "Դիմումների վերջնաժամկետ",
        fundingType: "Ֆինանսավորման տեսակ",
        fundingTypePlaceholder: "օր.՝ Ամբողջական ֆինանսավորում, Մասնակի…",
        targetGroup: "Թիրախային խումբ",
        targetGroupPlaceholder: "օր.՝ Երիտասարդներ 18-30, հետազոտողներ…",
        requirements: "Պահանջներ / իրավասություն",
        requirementsPlaceholder: "Տարիք, քաղաքացիություն, լեզվի մակարդակ և այլն (կավելացվի նկարագրությանը՝ գնահատողների համար)",
        reviewNotice: "Անհրաժեշտ է ադմինի վերանայում: Կատեգորիաներն ու ոլորտները համապատասխանում են Ծրագրեր էջի հանրային զտիչներին հաստատվելուց հետո:",
        submitting: "Ուղարկվում է…",
        submitForReview: "Ուղարկել վերանայման ✓",
        errorTitleDesc: "Վերնագիրը և նկարագրությունը պարտադիր են:",
        errorCategory: "Ընտրեք առնվազն մեկ կատեգորիա (ինչպես ադմինի ձևում):",
        errorSector: "Ընտրեք առնվազն մեկ ոլորտ (ինչպես ադմինի ձևում):",
        errorSubmitFailed: "Ուղարկումը ձախողվեց: Խնդրում ենք փորձել կրկին:",
        errorNetwork: "Ցանցի սխալ: Խնդրում ենք փորձել կրկին:",
        sectorLabels: {
          ecology: "Էկոլոգիա", international: "Միջազգային", technology: "Տեխնոլոգիա", medical: "Բժշկական",
          education: "Կրթություն", business: "Բիզնես", arts: "Արվեստ և մշակույթ", science: "Գիտություն",
          sports: "Սպորտ", agriculture: "Գյուղատնտեսություն", local: "Տեղական", media: "Մեդիա",
        },
        categoryLabels: {
          education: "Կրթություն", scholarship: "Կրթաթոշակ", fellowship: "Ֆելլոուշիփ", erasmusplus: "Erasmus Plus",
          training: "Դասընթաց", grant: "Դրամաշնորհ", internship: "Պրակտիկա", conference: "Կոնֆերանս",
          online: "Առցանց", volunteering: "Կամավորություն", event: "Միջոցառում", award: "Մրցանակ",
        },
      },
      organizationGreencoins: {
        back: "Հետ",
        title: "Greencoin դրամապանակ",
        subtitle: "Գնիր greencoin-ներ և ծախսիր դրանք՝ պարգևատրելով մասնակիցներին, ովքեր ավարտում են քո ծրագրերը։",
        balanceLabel: "Ընթացիկ հաշվեկշիռ",
        buyTitle: "Գնել greencoin-ներ",
        buyNote: "Վճարումը հիմա հաստատվում է ձեռքով։ Ուղարկիր հայտը ներքևում, և մեր թիմը կապ կհաստատի՝ հաստատելու վճարումը և անմիջապես համալրելու հաշվեկշիռդ։",
        selfServiceLocked: "Greencoin-ների ուղղակի գնումը դեռ հասանելի չէ։ Կապվիր մեր թիմի հետ, և մենք կկարգավորենք։",
        buyButton: "Գնել հիմա",
        sending: "Ուղարկվում է...",
        requestSent: "Հայտն ուղարկվեց։ Մենք կկապվենք վճարումը հաստատելու համար։",
        requestError: "Հայտն ուղարկել չհաջողվեց։ Փորձիր կրկին։",
        pendingTitle: "Սպասող հայտեր",
        pendingStatus: "Սպասում է հաստատման",
        historyTitle: "Պատմություն",
        historyEmpty: "Գործարքներ դեռ չկան։",
        txTopup: "Հաշվեկշռի համալրում",
        txSpend: "Պարգև՝ վճարված մասնակցին",
        perksTitle: "Ինչ են տալիս greencoin-ները",
        perks: {
          reward: { title: "Պարգևատրիր մասնակիցներին", desc: "Կցիր greencoin պարգև քո ծրագրերին, որպեսզի ավարտողները ավտոմատ ստանան այն։" },
          completion: { title: "Ավելի բարձր ավարտում", desc: "Պարգևով ծրագրերն ունեն ավելի բարձր գրանցում-ավարտ հարաբերակցություն։" },
          flexible: { title: "Ճկուն չափաքանակներ", desc: "Սահմանիր ցանկացած պարգև ամեն ծրագրի համար և գնիր ուղիղ այնքան greencoin, որքան պետք է։" },
        },
        greencoinsLabel: "greencoin",
        amdPerCoin: "դրամ / coin",
        payTitle: "Վճարում բանկային փոխանցումով",
        payBank: "Բանկ",
        payAccount: "Հաշվեհամար",
        payRecipient: "Ստացող",
        payReferenceHint: "Նշիր կազմակերպության անունը որպես վճարման նպատակ, որպեսզի կարողանանք կապել փոխանցումը։",
        interestTitle: "Դեռ հասանելի չէ",
        interestBody: "Greencoin-ների գնումը դեռ հասանելի չէ կայքում։ Թող քո էլ. փոստը, և կիմացնենք, հենց պատրաստ լինի։",
        interestEmailPlaceholder: "you@organization.org",
        interestSubmit: "Ինձ իմացնել",
        interestError: "Չհաջողվեց ուղարկել։ Փորձիր կրկին։",
        interestDoneTitle: "Շնորհակալություն!",
        interestDoneBody: "Գրանցեցինք քո հետաքրքրությունը և կգրենք էլ. փոստով, հենց greencoin-ների գնումը հասանելի դառնա։",
        interestClose: "Փակել",
        payWithCard: "Վճարել քարտով",
        redirectingToBank: "Վերահասցեավորում ենք բանկ...",
        cardPaymentSuccess: "Վճարումը հաջողվեց, հաշվեկշիռդ համալրվեց։",
        cardPaymentFailed: "Վճարումը չհաջողվեց։ Կարող ես փորձել կրկին։",
        cardPaymentError: "Վճարման ժամանակ խնդիր առաջացավ։ Փորձիր կրկին։",
      },
      organizationPanel: {
        back: "Հետ",
        title: "Կազմակերպության վահանակ",
        subtitle: "Ձեր կազմակերպության ակտիվությունը, հրապարակված նախագծերը և greencoin պարգևները՝ մեկ տեղում։",
        loading: "Բեռնվում է...",
        tabOverview: "Ընդհանուր",
        tabPrograms: "Նախագծեր",
        tabGreencoins: "Greencoins",
        statsTitle: "Ընդհանուր պատկեր",
        statProfileViews: "Պրոֆիլի դիտումներ",
        statFollowers: "Հետևորդներ",
        statPrograms: "Նախագծեր",
        statProgramViews: "Նախագծի դիտումներ",
        statApplyClicks: "Դիմելու սեղմումներ",
        statApplicants: "Դիմորդներ",
        statusApproved: "հաստատված",
        statusPending: "ստուգման մեջ",
        programsTitle: "Ձեր նախագծերը",
        publishNew: "Հրապարակել նախագիծ",
        noPrograms: "Դուք դեռ նախագիծ չեք հրապարակել։",
        viewsLabel: "դիտում",
        clicksLabel: "դիմելու սեղմում",
        manageAll: "Կառավարել բոլոր հայտերը",
        status: {
          approved: "Հաստատված",
          pending: "Սպասման մեջ",
          needs_edit: "Պահանջում է խմբագրում",
          rejected: "Մերժված",
        },
        greencoinsTitle: "Greencoin պարգևներ",
        buyGreencoins: "Գնել greencoins",
        balanceLabel: "Դրամապանակի հաշվեկշիռ",
        rewardsNote: "Սահմանիր, թե քանի greencoin է ստանում մասնակիցը յուրաքանչյուր նախագիծն ավարտելու համար։ Չափը կարող ես փոխել ցանկացած պահի, նույնիսկ նախագիծն արդեն ընթացքի մեջ լինելիս։",
        noApprovedPrograms: "Հաստատված նախագծեր դեռ չկան։",
        rewardLabel: "Greencoin պարգև",
        rewardSaveError: "Չհաջողվեց պահպանել պարգևը։ Փորձիր կրկին։",
        lowBalanceWarning: "Դրամապանակի հաշվեկշիռը այս պարգևից ցածր է։ Համալրիր, որպեսզի մասնակիցները ստանան վճարումը։",
        tabUsers: "Օգտատերեր",
        users: {
          title: "Ստեղծել օգտատիրոջ հաշիվ",
          subtitle: "Ստեղծիր մուտք և գաղտնաբառ մեկի համար, ով ինքը չի գրանցվի, սովորական հաշիվ, որը կապված չէ քո կազմակերպության հետ։ Նա մուտք է գործում դրանով և կարող է ինքնուրույն կարգավորել իր հանրային պրոֆիլը (նկար, շապիկ, նկարագրություն, հիմնական գույն) Կարգավորումներից։",
          namePlaceholder: "Անուն",
          surnamePlaceholder: "Ազգանուն (ոչ պարտադիր)",
          emailPlaceholder: "Էլ. փոստ",
          passwordPlaceholder: "Գաղտնաբառ",
          createBtn: "Ստեղծել հաշիվ",
          creating: "Ստեղծվում է...",
          created: "Հաշիվը ստեղծվեց {{email}}-ի համար",
          createError: "Չհաջողվեց ստեղծել հաշիվը։ Փորձիր կրկին։",
          listTitle: "Քո ստեղծած հաշիվները",
          empty: "Դուք դեռ օգտատիրոջ հաշիվ չեք ստեղծել։",
        },
      },
      greencoinsPage: {
        back: "Հետ",
        title: "Greencoin-ներ",
        subtitle: "Վաստակիր greencoin-ներ հարթակում և ծախսիր դրանք Greenwich խանութում։",
        balanceLabel: "Քո հաշվեկշիռը",
        goToShop: "Անցնել խանութ",
        tabEarned: "Վաստակված",
        tabSpent: "Ծախսված",
        tabWays: "Ինչպես վաստակել",
        earnedEmpty: "Դեռ վաստակած greencoin-ներ չկան։ Սկսիր՝ լրացնելով պրոֆիլդ կամ միանալով ծրագրի։",
        spentEmpty: "Գնումներ դեռ չկան։",
        waysIntro: "Առօրյա եղանակներ Greenwich-ում greencoin վաստակելու համար.",
        aboutTitle: "Ի՞նչ են greencoin-ները",
        aboutBody: "Greencoin-ները փող չեն։ Դրանք Greenwich-ի ներքին խրախուսման համակարգն են, որը վաստակում ես՝ լինելով ակտիվ և ներգրավված հարթակում։ Դրանք հիմա հնարավոր չէ փոխանակել իրական փողի, բայց այս հնարավորությունը նախատեսված է ապագայի համար։",
        aboutPerks: {
          redeem: { title: "Իրական պարգևներ", desc: "Փոխանակիր վաստակածդ իրական պարգևների ու մրցանակների Greenwich Shop-ում։" },
          motivation: { title: "Ճանաչում, ոչ թե փող", desc: "Իրական ներդրումը չափելու և պարգևատրելու միջոց՝ ոչ թե արժույթ։" },
          future: { title: "Դրամի փոխանակումը՝ ապագայում", desc: "Greencoin-ները իրական փողի փոխարկելը դեռ հնարավոր չէ, բայց դա մեր ծրագրերում է։" },
        },
        stat5x: "Greencoin պարգևով գրառումներն ու նախագծերը ստանում են մոտավորապես 5 անգամ ավելի հետաքրքրություն օգտատերերից։",
        actions: {
          account_verified: "Հաշվի հաստատում",
          profile_complete: "Պրոֆիլի լրացում",
          onboarding_complete: "Ծանոթացման ավարտ",
          program_apply: "Ծրագրին դիմում",
          program_apply_milestone_10: "10 ծրագրի դիմում (միանվագ)",
          program_accepted: "Ծրագրում ընդունվել",
          event_attended: "Ծրագրի մասնակցություն/ավարտ",
          project_joined: "Նախագծի/համայնքի միանալ",
          review_written: "Կարծիք գրել",
          daily_login: "Ամենօրյա մուտք",
          login_streak_7: "7-օրյա մուտքի շարք",
          buddy_mentee_completed: "Buddy մենթորության ավարտ որպես mentee",
          buddy_mentor_completed: "Buddy մենթորության ավարտ որպես mentor",
          buddy_mentor_certificate: "Buddy mentor վկայական ստանալը",
          referral_signup: "Յուրաքանչյուր հրավիրված ընկեր, ով գրանցվել է",
          social_event_participation: "Կարևոր սոցիալական/համայնքային միջոցառմանը մասնակցություն",
        },
      },
      orgMySubmissions: {
        title: "Իմ հայտերը",
        subtitle: "Հետևեք և կառավարեք ձեր ուղարկած ծրագրերը",
        refresh: "Թարմացնել",
        greencoinWallet: "Greencoin դրամապանակ",
        submitNew: "Ուղարկել նոր",
        statTotal: "Ընդամենը",
        statPending: "Սպասման մեջ",
        statApproved: "Հաստատված",
        statNeedsEdit: "Պահանջում է խմբագրում",
        loading: "Ձեր հայտերը բեռնվում են…",
        emptyTitleAll: "Հայտեր դեռ չկան",
        emptyTitleFiltered: "{{filter}} ծրագրեր չկան",
        emptyBodyAll: "Ուղարկեք ձեր առաջին ծրագիրը՝ սկսելու համար:",
        emptyBodyFiltered: "Այս պահին {{filter}} ծրագրեր չունեք:",
        submitProgram: "Ուղարկել ծրագիր",
        filterNames: { pending: "սպասման մեջ գտնվող", approved: "հաստատված", rejected: "մերժված" },
        statusPending: "Սպասում է վերանայման",
        statusApproved: "Հաստատված",
        statusRejected: "Չհաստատված",
        submitted: "Ուղարկվել է {{date}}",
        editResubmitHeading: "Խմբագրել և կրկին ուղարկել",
        fieldTitle: "Ծրագրի վերնագիր *",
        fieldTitlePlaceholder: "Վերնագիր",
        fieldWebsite: "Կայք / Դիմումի հղում",
        fieldUrlPlaceholder: "https://…",
        fieldLocation: "Վայր",
        fieldLocationPlaceholder: "Քաղաք, երկիր կամ Online",
        fieldDeadline: "Վերջնաժամկետ",
        fieldDescription: "Նկարագրություն *",
        fieldDescriptionPlaceholder: "Նկարագրեք ձեր ծրագիրը…",
        fieldRequirements: "Պահանջներ",
        fieldRequirementsPlaceholder: "Իրավասության պահանջներ…",
        fieldBenefits: "Առավելություններ",
        fieldBenefitsPlaceholder: "Ինչ են ստանում մասնակիցները…",
        fieldCoverImage: "Շապիկի նկարի հղում",
        cancel: "Չեղարկել",
        resubmitForReview: "Կրկին ուղարկել վերանայման",
        viewProgram: "Դիտել ծրագիրը",
        messageFromAdmin: "Հաղորդագրություն ադմինից",
        feedbackCta: "Խնդրում ենք վերանայել վերոնշյալ մեկնաբանությունը և կրկին ուղարկել ձեր ծրագիրը անհրաժեշտ փոփոխություններով:",
        pendingNotice: "Ձեր ծրագիրը վերանայման փուլում է: Մենք կտեղեկացնենք ձեզ, երբ որոշում կայացվի:",
        approvedNotice: "Ձեր ծրագիրը հրապարակված է և տեսանելի է Ծրագրեր էջում:",
        viewArrow: "Դիտել →",
        editAndResubmit: "Խմբագրել և կրկին ուղարկել",
        updateAndResubmit: "Թարմացնել և կրկին ուղարկել",
        resubmittedToast: "🔄 Կրկին ուղարկվեց վերանայման!",
        savedLocallyToast: "🔄 Պահպանվեց տեղում, կսինխրոնացվի առցանց լինելուն պես:",
        statusNeedsEdit: "Պահանջում է խմբագրում",
        applications: "Հայտեր",
        withdraw: "Հետ կանչել",
        confirmWithdraw: "Հետ կանչե՞լ այս հայտը: Այս գործողությունը հնարավոր չէ հետարկել:",
        withdrawnToast: "Հայտը հետ կանչվեց",
        withdrawFailedToast: "Հայտը հետ կանչել չհաջողվեց",
      },
      shareMenu: {
        sharePost: "Կիսվել գրառումով",
        copyLink: "Պատճենել հղումը",
        defaultShareText: "Դիտեք այս գրառումը",
      },
      userPublicProfile: {
        loginRequired: "Պրոֆիլները դիտելու համար անհրաժեշտ է մուտք գործել:",
        loadingProfile: "Պրոֆիլը բեռնվում է...",
        userNotFound: "Օգտատերը չի գտնվել",
        goBack: "Վերադառնալ",
        failedLoadProfile: "Չհաջողվեց բեռնել պրոֆիլը:",
        failedLoadPosts: "Չհաջողվեց բեռնել գրառումները:",
        justNow: "Հենց նոր",
        minutesAgo: "{{n}} րոպե առաջ",
        hoursAgo: "{{n}} ժամ առաջ",
        daysAgo: "{{n}} օր առաջ",
        confirmBlock: "Արգելափակե՞լ {{name}}-ին: Նրանք չեն կարողանա հետևել կամ գրել ձեզ:",
        userMuted: "Օգտատերը խլացվեց, նրանց գրառումները թաքցված են ձեր հոսքից",
        userUnmuted: "Օգտատերն ապախլացվեց",
        userBlocked: "Օգտատերն արգելափակվեց",
        userUnblocked: "Օգտատերն ապարգելափակվեց",
        failedToMuteUser: "Չհաջողվեց խլացնել օգտատիրոջը",
        failedToUnmuteUser: "Չհաջողվեց ապախլացնել օգտատիրոջը",
        failedToBlockUser: "Չհաջողվեց արգելափակել օգտատիրոջը",
        failedToUnblockUser: "Չհաջողվեց ապարգելափակել օգտատիրոջը",
        reportSubmitted: "Բողոքն ուղարկվեց: Շնորհակալություն համայնքն անվտանգ պահելուն օգնելու համար:",
        failedSubmitReport: "Չհաջողվեց ուղարկել բողոքը",
        needMutualFollowMessage: "Հաղորդագրություններ ուղարկելու համար պետք է փոխադարձաբար հետևեք միմյանց",
        messageSent: "Հաղորդագրությունն ուղարկվեց!",
        failedSendMessage: "Չհաջողվեց ուղարկել հաղորդագրությունը",
        failedStartConversation: "Չհաջողվեց սկսել զրույցը",
        profileLinkCopied: "Պրոֆիլի հղումը պատճենվեց!",
        failedShareProfile: "Չհաջողվեց կիսվել պրոֆիլով",
        back: "Հետ",
        coverAlt: "Շապիկ",
        verified: "Հաստատված",
        verifiedOrg: "Հաստատված կազմակերպություն",
        organization: "Կազմակերպություն",
        communityMember: "Համայնքի անդամ",
        approved: "Հաստատված",
        message: "Հաղորդագրություն",
        copied: "Պատճենվեց!",
        copyLink: "Պատճենել հղումը",
        shareOnFacebook: "Կիսվել Facebook-ում",
        moreOptions: "Լրացուցիչ ընտրանքներ",
        pleaseWait: "Խնդրում ենք սպասել…",
        unmute: "Ապախլացնել",
        mutePosts: "Խլացնել գրառումները",
        unblock: "Ապարգելափակել",
        blockUser: "Արգելափակել օգտատիրոջը",
        reportUser: "Բողոքել օգտատիրոջից",
        postsLabel: "Գրառումներ",
        aboutLabel: "Մասին",
        reportsTabLabel: "Հաշվետվություններ",
        portfolioLabel: "Պորտֆոլիո",
        certificatesLabel: "Սերտիֆիկատներ",
        followersLabel: "Հետևորդներ",
        followingLabel: "Հետևում է",
        joined: "Միացել է {{date}}",
        quickMessagePlaceholder: "Ուղարկեք արագ հաղորդագրություն…",
        noPostsYet: "Դեռ գրառումներ չկան",
        postImageAlt: "Գրառման նկար {{n}}",
        postAlt: "Գրառում",
        nameLabel: "Անուն",
        emailLabel: "Էլ. փոստ",
        phoneLabel: "Հեռախոս",
        locationLabel: "Գտնվելու վայր",
        interestsLabel: "Հետաքրքրություններ",
        missionLabel: "Առաքելություն",
        reportsTitle: "Հաշվետվություններ և լիցենզիաներ",
        noReportsYet: "Հաշվետվություններ դեռ չեն վերբեռնվել:",
        view: "Դիտել",
        download: "Ներբեռնել",
        noPortfolioYet: "Պորտֆոլիոյում դեռ ոչինչ չկա:",
        noCertificatesYet: "Սերտիֆիկատներ դեռ ավելացված չեն:",
        viewPdf: "Դիտել PDF-ը",
        noFollowersYet: "Հետևորդներ դեռ չկան",
        orgBadge: "Կազմ.",
        followsYou: "Հետևում է ձեզ",
        friends: "Ընկերներ",
        notFollowingAnyone: "Դեռ ոչ ոքի չի հետևում",
        mutual: "Փոխադարձ",
        previewNotAvailable: "Այս ֆայլի տեսակի համար նախադիտումը հասանելի չէ:",
        reportModalTitle: "Բողոքել {{name}}-ից",
        reportModalSubtitle: "Ընտրեք պատճառը: Սա անանուն է հաղորդված անձի համար:",
        reportReasons: {
          spam: "Սպամ",
          inappropriate: "Անպատշաճ բովանդակություն",
          harassment: "Ոտնձգություն",
          hateSpeech: "Ատելության խոսք",
          misinformation: "Ապատեղեկատվություն",
          other: "Այլ",
        },
        detailsPlaceholder: "Լրացուցիչ մանրամասներ (ըստ ցանկության)",
        cancel: "Չեղարկել",
        submitting: "Ուղարկվում է…",
        submitReport: "Ուղարկել բողոքը",
        comments: "Մեկնաբանություններ",
        noCommentsYet: "Մեկնաբանություններ դեռ չկան: Եղեք առաջինը!",
        addCommentPlaceholder: "Ավելացնել մեկնաբանություն…",
        interests: {
          environment: "Շրջակա միջավայր", education: "Կրթություն", technology: "Տեխնոլոգիա", health: "Առողջություն",
          artsCulture: "Արվեստ և մշակույթ", communityDevelopment: "Համայնքի զարգացում", humanRights: "Մարդու իրավունքներ",
          socialInclusion: "Սոցիալական ներառում", internationalExchanges: "Միջազգային փոխանակումներ", entrepreneurship: "Ձեռնարկատիրություն",
        },
      },
      blockedMuted: {
        pleaseLogin: "Խնդրում ենք մուտք գործել այս էջը դիտելու համար",
        backToSettings: "Վերադառնալ կարգավորումներին",
        blockedTitle: "Արգելափակված հաշիվներ",
        blockedSubtitle: "Ձեր արգելափակած մարդիկ չեն կարող հետևել ձեզ, գրել ձեզ կամ տեսնել ձեր պրոֆիլը:",
        failedLoadBlocked: "Չհաջողվեց բեռնել արգելափակված հաշիվները",
        userUnblocked: "Օգտատերն ապարգելափակվեց",
        failedUnblock: "Չհաջողվեց ապարգելափակել օգտատիրոջը",
        noBlocked: "Արգելափակված հաշիվներ չկան",
        blockedEmptyHint: "Ձեր արգելափակած հաշիվները կհայտնվեն այստեղ:",
        unblocking: "Ապարգելափակվում է…",
        unblock: "Ապարգելափակել",
        mutedTitle: "Խլացված հաշիվներ",
        mutedSubtitle: "Նրանց գրառումները թաքցված են ձեր հոսքից: Դուք դեռ հետևում եք միմյանց և կարող եք գրել բնականոն կերպով, նրանք չեն ստանում ծանուցում:",
        failedLoadMuted: "Չհաջողվեց բեռնել խլացված հաշիվները",
        userUnmuted: "Օգտատերն ապախլացվեց",
        failedUnmute: "Չհաջողվեց ապախլացնել օգտատիրոջը",
        noMuted: "Խլացված հաշիվներ չկան",
        mutedEmptyHint: "Ձեր խլացրած հաշիվները կհայտնվեն այստեղ:",
        unmuting: "Ապախլացվում է…",
        unmute: "Ապախլացնել",
        loading: "Բեռնվում է...",
      },
      orgDashboard: {
        organization: "Կազմակերպություն",
        noLocation: "Տեղադրություն նշված չէ",
        noEmail: "Էլ. փոստ չկա",
        aboutOrg: "Կազմակերպության մասին",
        noDescription: "Նկարագրություն դեռ չկա",
        areasOfInterest: "Հետաքրքրության ոլորտներ",
        noInterests: "Հետաքրքրություններ դեռ ընտրված չեն",
        welcomeTitle: "Բարի գալուստ ձեր կազմակերպության վահանակ",
        welcomeMessage: "Բարի վերադարձ, {{name}}: Սա ձեր կազմակերպության վահանակն է, որտեղ կարող եք կառավարել ձեր պրոֆիլը և գործունեությունը:",
        quickActions: "Արագ գործողություններ",
        panel: "Կազմակերպության վահանակ",
        editProfile: "Խմբագրել պրոֆիլը",
        viewActivities: "Դիտել գործունեությունը",
        settings: "Կարգավորումներ",
        recentActivity: "Վերջին ակտիվությունը",
        profileCompleted: "Կազմակերպության պրոֆիլը հաջողությամբ ամբողջացվեց",
        interestsUpdated: "Հետաքրքրությունները թարմացվեցին",
        today: "Այսօր",
      },
      orgVerification: {
        sectionTitle: "Հաստատում",
        pitch: "Ստացեք հաստատված կարգավիճակի կրծքանշան և իրավունք մասնակցելու կազմակերպությունների վարկանիշին: Ներկայացրեք ձեր իրավական փաստաթղթերը արագ ստուգման համար:",
        benefitBadge: "Հաստատման կրծքանշան ձեր էջում և հրապարակումներում",
        benefitRanking: "Իրավունք մասնակցելու կազմակերպությունների վարկանիշին և առաջ մղվել",
        startBtn: "Անցնել հաստատում",
        resubmitBtn: "Կրկին ուղարկել հաստատման",
        statusPending: "Հաստատման հայտը ուղարկված է",
        statusApproved: "Կազմակերպությունը հաստատված է",
        statusRejected: "Հաստատման հայտը մերժվել է",
        etaHint: "Սովորաբար ստուգումը տևում է մինչև մեկ շաբաթ:",
        modalTitle: "Հաստատման հայտ",
        modalSubtitle: "Ներկայացրեք ձեր իրավական տվյալները և փաստաթղթերը ստուգման համար",
        registrantRoleQuestion: "Դուք բուն կազմակերպությո՞ւնն եք, թե՞ նրա ներկայացուցիչը",
        registrantRoleOrg: "Կազմակերպությունը",
        registrantRoleRep: "Ես ներկայացուցիչ եմ",
        name: "Անուն",
        surname: "Ազգանուն",
        position: "Պաշտոն",
        phone: "Հեռախոս",
        email: "Էլ. փոստ",
        isInformalQuestion: "Ձեր կազմակերպությունն ոչ պաշտոնական / չգրանցված խու՞մբ է",
        formallyRegistered: "Ոչ, պաշտոնապես գրանցված է",
        informal: "Այո, ոչ պաշտոնական է",
        stateRegNumber: "Պետական գրանցման համար",
        countryOfReg: "Գրանցման երկիր",
        dateOfReg: "Գրանցման ամսաթիվ",
        taxId: "ՀՎՀՀ / Իրավական ID",
        vatNumber: "ԱԱՀ համար",
        registeredAddress: "Գրանցված իրավաբանական հասցե",
        documentsTitle: "Փաստաթղթեր",
        registrationDoc: "Գրանցման փաստաթուղթ",
        vatCertificate: "ԱԱՀ վկայական",
        stateSeal: "Պետական կնիք",
        passportScan: "Ներկայացուցչի անձնագրի սկան",
        uploadShort: "Վերբեռնել",
        alreadyUploaded: "արդեն վերբեռնված է",
        errorRole: "Խնդրում ենք նշել՝ դուք կազմակերպությո՞ւնն եք, թե՞ ներկայացուցիչը",
        errorRep: "Ներկայացուցչի անունը, ազգանունը և պաշտոնը պարտադիր են",
        errorLegal: "Բոլոր իրավական գրանցման դաշտերը պարտադիր են, եթե դուք ոչ պաշտոնական խումբ չեք",
        errorSubmit: "Հայտը ուղարկել չհաջողվեց: Փորձեք կրկին:",
        fileTooLarge: "Ֆայլերը պետք է լինեն փոքր, քան 8ՄԲ:",
        submitting: "Ուղարկվում է...",
        submit: "Ուղարկել ստուգման",
      },
      supportChat: {
        title: "Greenwich Աջակցություն",
        welcome: "Բարև! Հարցրու ինձ Greenwich-ի աշխատանքի մասին՝ ծրագրեր, հայտեր, կազմակերպություններ, Pro, greencoins-ներ և այլն։",
        placeholder: "Գրիր հարցդ...",
        error: "Ինչ-որ բան սխալ գնաց։ Փորձիր կրկին։",
        leaveContact: "Խոսել մարդու հետ․ թող կապ",
        contactIntro: "Թող քո անունը և կապի եղանակը, և ադմինը կկապվի քեզ հետ ուղղակիորեն։",
        contactNamePlaceholder: "Անունդ",
        contactInfoPlaceholder: "Էլ. հասցե կամ հեռախոսահամար",
        contactNotePlaceholder: "Ինչի՞ մասին է (ոչ պարտադիր)",
        contactSubmit: "Ուղարկել",
        contactSending: "Ուղարկվում է...",
        contactSent: "Շնորհակալություն! Ադմինը շուտով կկապվի քեզ հետ։",
        backToChat: "← Վերադառնալ չաթին",
      },
      activeSessions: {
        pleaseLogin: "Խնդրում ենք մուտք գործել այս էջը դիտելու համար",
        backToSettings: "Վերադառնալ կարգավորումներին",
        title: "Ակտիվ սեսիաներ",
        subtitle: "Սարքեր, որոնք ներկայումս մուտք են գործել ձեր հաշիվ: Դուրս գրվեք այն սարքերից, որոնք չեք ճանաչում:",
        failedLoad: "Չհաջողվեց բեռնել սեսիաները",
        deviceLoggedOut: "Սարքից դուրս եք եկել",
        failedLogout: "Չհաջողվեց դուրս գալ սարքից",
        confirmRevokeAll: "Դուրս գա՞լ բոլոր մյուս սարքերից:",
        loggedOutAll: "Դուրս եք եկել բոլոր մյուս սարքերից",
        failedLogoutAll: "Չհաջողվեց դուրս գալ մյուս սարքերից",
        loading: "Բեռնվում է...",
        noSessions: "Հետագծված սեսիաներ դեռ չկան։ Սա կհայտնվի այս գործառույթի թողարկումից հետո կատարված մուտքերի համար:",
        thisDevice: "Այս սարքը",
        loggingOut: "Դուրս է գալիս…",
        logout: "Դուրս գալ",
        logoutOtherDevices: "Դուրս գալ մյուս սարքերից ({{count}})",
        activeJustNow: "Ակտիվ հենց հիմա",
        activeMinAgo: "Ակտիվ {{n}} րոպե առաջ",
        activeHourAgo: "Ակտիվ {{n}} ժամ առաջ",
        activeDayAgo: "Ակտիվ {{n}} օր առաջ",
        unknownBrowser: "Անհայտ բրաուզեր",
        unknownDevice: "Անհայտ սարք",
        onDevice: "{{browser}} - {{os}}",
      },
      socialAuth: {
        googleLoadFailed: "Google-ով մուտքը հնարավոր չէ բեռնել:",
        facebookLoadFailed: "Facebook-ով մուտքը հնարավոր չէ բեռնել:",
        googleCancelled: "Google-ով մուտքը չեղարկվեց:",
        googleFailed: "Google-ով մուտքը ձախողվեց:",
        facebookCancelled: "Facebook-ով մուտքը չեղարկվեց:",
        facebookFailed: "Facebook-ով մուտքը ձախողվեց:",
        signUpWith: "Գրանցվել",
        continueWith: "Շարունակել",
        connectingGoogle: "Կապակցում ենք Google-ին...",
        connectingFacebook: "Կապակցում ենք Facebook-ին...",
        configHint: "Սոցիալական ցանցերով մուտքը ժամանակավորապես անհասանելի է:",
      },
      playerInterest: {
        loading: "Բեռնվում է...",
        maxInterests: "Կարող եք ընտրել առավելագույնը 5 հետաքրքրություն",
        selectAtLeastOne: "Խնդրում ենք ընտրել առնվազն մեկ հետաքրքրություն",
        failedSave: "Չհաջողվեց պահպանել հետաքրքրությունները",
        errorSaving: "Սխալ տեղի ունեցավ ձեր հետաքրքրությունները պահպանելիս",
        detailsTitle: "Լրացրու քո պրոֆիլը",
        detailsSubtitle: "Մի քանի արագ մանրամասն, որպեսզի մարդիկ կարողանան գտնել ու ճանաչել քեզ։",
        usernameLabel: "Օգտանուն",
        usernamePlaceholder: "օր.՝ john_doe",
        nameLabel: "Անուն",
        surnameLabel: "Ազգանուն",
        dobLabel: "Ծննդյան ամսաթիվ",
        invalidUsername: "Օգտանունը պետք է լինի 3-20 նիշ՝ փոքրատառ տառեր, թվեր, ընդգծումներ կամ կետեր",
        usernameChecking: "Ստուգվում է հասանելիությունը...",
        usernameAvailable: "Օգտանունը հասանելի է",
        usernameTaken: "Այս օգտանունն արդեն զբաղված է",
        nameRequired: "Խնդրում ենք մուտքագրել ձեր անունը",
        title: "Ի՞նչն է քեզ հետաքրքրում",
        subtitle: "Ընտրիր մինչև 5։ Հենց սա է օգտագործում մեր AI-համապատասխանեցումը՝ քեզ հարմար ծրագրեր գտնելու համար։",
        selected: "Ընտրված է",
        skipForNow: "Բաց թողնել առայժմ",
        saving: "Պահպանվում է...",
        continueBtn: "Շարունակել",
        interestEnvironment: "Շրջակա միջավայր",
        interestEducation: "Կրթություն",
        interestTechnology: "Տեխնոլոգիա",
        interestHealth: "Առողջություն",
        interestArts: "Արվեստ և մշակույթ",
        interestCommunityDev: "Համայնքի զարգացում",
        interestHumanRights: "Մարդու իրավունքներ",
        interestSocialInclusion: "Սոցիալական ներառում",
        interestIntlExchanges: "Միջազգային փոխանակումներ",
        interestEntrepreneurship: "Ձեռնարկատիրություն",
      },
      orgActivities: {
        noToken: "Նույնականացման տոկեն չի գտնվել:",
        confirmDeletePost: "Ջնջե՞լ այս գրառումը:",
        deleteError: "Ջնջման սխալ. {{message}}",
        noPostsYet: "Գրառումներ դեռ չկան",
        organization: "Կազմակերպություն",
        loadingTab: "Բեռնվում է {{tab}}...",
        error: "Սխալ. {{message}}",
        orgCreatedPost: "Ձեր կազմակերպությունը ստեղծել է գրառում",
        noActivityYet: "Ակտիվություն դեռ չկա",
        title: "Կազմակերպության գործունեություն",
        subtitle: "Հետևեք գրառումներին և փոխազդեցություններին",
        all: "Բոլորը",
        posts: "Գրառումներ",
        liked: "Հավանված",
        saved: "Պահպանված",
        profileAlt: "Պրոֆիլ",
        postAlt: "Գրառում",
        deleteFailed: "Ջնջումը ձախողվեց",
      },
      activities: {
        noToken: "Նույնականացման տոկեն չի գտնվել: Խնդրում ենք նորից մուտք գործել:",
        unknownApiError: "Անհայտ API սխալ",
        confirmDeletePost: "Վստա՞հ եք, որ ցանկանում եք ջնջել այս գրառումը: Այն կտեղափոխվի աղբարկղ 30 օրով, նախքան վերջնական ջնջումը:",
        errorDeletingPost: "Գրառումը ջնջելու սխալ. {{message}}",
        justNow: "Հենց նոր",
        hoursAgo: "{{n}} ժամ առաջ",
        daysAgo: "{{n}} օր առաջ",
        errorLoadingTitle: "Տվյալների բեռնման սխալ",
        tryAgain: "Փորձել կրկին",
        loadingYour: "Բեռնվում է ձեր {{tab}}...",
        noActivitiesYet: "Ակտիվություն դեռ չկա: Սկսեք ձեր առաջին գրառումով:",
        noPostsYetCreate: "Գրառումներ դեռ չկան: Ստեղծեք ձեր առաջին գրառումը ձեր պրոֆիլից:",
        noLikedYet: "Հավանված գրառումներ դեռ չկան: Սկսեք ուսումնասիրել և հավանել գրառումներ:",
        noSavedYet: "Պահպանված գրառումներ դեռ չկան: Պահպանեք գրառումներ՝ հետո գտնելու համար:",
        you: "Դուք",
        unknown: "Անհայտ",
        deletePost: "Ջնջել գրառումը",
        activityPost: "Դուք ստեղծել եք նոր գրառում",
        activityLike: "Դուք հավանել եք գրառում",
        activitySave: "Դուք պահպանել եք գրառում",
        activityComment: "Դուք մեկնաբանել եք գրառում",
        newActivity: "Նոր ակտիվություն",
        title: "Ձեր ակտիվությունը",
        subtitle: "Հետևեք ձեր ներգրավվածությանն ու բովանդակությանը",
        allActivities: "Բոլոր ակտիվությունները",
        myPosts: "Իմ գրառումները",
        likedPosts: "Հավանված գրառումներ",
        savedPosts: "Պահպանված գրառումներ",
        profileAlt: "Պրոֆիլ",
        postAlt: "Գրառում",
        deleteAlt: "Ջնջել",
        likesAlt: "Հավանումներ",
        commentsAlt: "Մեկնաբանություններ",
        savesAlt: "Պահպանումներ",
      },
      pages: {
        welcome: {
          skip: "Բաց թողնել",
          next: "Հաջորդը",
          slide1Title: "Գտեք իրական հնարավորություններ",
          slide1Desc: "Դիտեք ստուգված կրթաթոշակներ, դրամաշնորհներ, ֆելոուշիփներ, պրակտիկաներ և փոխանակման ծրագրեր՝ բոլորը AI-ով ընտրված ձեզ համար, մեկ տեղում։",
          slide2Title: "Դիմեք մի քանի կտտոցով",
          slide2Desc: "Լրացրեք ձեր պրոֆիլը մեկ անգամ, ապա դիմեք ծրագրերին ուղիղ Greenwich-ից և հետևեք ամեն դիմումի կարգավիճակին։",
          slide3Title: "Դուք մենակ չեք այս ճանապարհին",
          slide3Desc: "Ստացեք Greenwich Buddy մենթոր, միացեք ձեզ նման դիմորդների համայնքին և վաստակեք greencoins-ներ ճանապարհին։",
          consentTitle: "Նախքան սկսելը",
          consentDesc: "Մենք օգտագործում ենք անհրաժեշտ թխուկներ և տվյալներ՝ Greenwich-ը ճիշտ աշխատացնելու և ձեր փորձը բարելավելու համար։ Շարունակելով՝ դուք համաձայնում եք թխուկների օգտագործմանը՝ մեր Գաղտնիության քաղաքականության համաձայն։",
          consentAgree: "Համաձայն եմ և սկսում եմ",
          alreadyHaveAccount: "Արդեն ունե՞ք հաշիվ",
          logIn: "Մուտք գործել",
        },
        seo: {
          home: {
            title: "Գրինվիչ. Կրթաթոշակներ, դրամաշնորհներ և փոխանակման ծրագրեր հայ երիտասարդության համար",
            description: "Գրինվիչը Հայաստանի հարթակն է կրթաթոշակների, դրամաշնորհների, ֆելոուշիփների, պրակտիկաների և փոխանակման ծրագրերի համար։ Ստացեք AI-հարմատեցված առաջարկներ և գտեք Greenwich Buddy մենթոր՝ անվճար, մեկ տեղում։",
            keywords: "կրթաթոշակներ Հայաստան, դրամաշնորհներ երիտասարդության համար, փոխանակման ծրագրեր, պրակտիկա արտերկրում, ուսումը արտասահմանում, կամավորական ծրագրեր Հայաստան, AI համապատասխանեցում կրթաթոշակների, անվճար կրթաթոշակներ հայ ուսանողների համար, ուսումն Եվրոպայում, ուսումն ԱՄՆ-ում, մագիստրոսական կրթաթոշակներ, դոկտորական կրթաթոշակներ, բակալավրի կրթաթոշակներ, ամառային դպրոց, վճարովի պրակտիկա արտերկրում, երիտասարդական փոխանակման ծրագրեր, մենթորական ծրագիր Հայաստան, կրթական հնարավորություններ Երևան, Էրազմուս Հայաստան դիմում, դրամաշնորհների որոնում",
          },
          whoweare: {
            title: "Մեր մասին. Գրինվիչ Հայաստան",
            description: "Իմացեք Գրինվիչի առաքելության մասին՝ կապել հայ երիտասարդությանը ստուգված կրթաթոշակների, դրամաշնորհների և փոխանակման ծրագրերի հետ, և աջակցել նրանց Greenwich Buddy մենթորական համայնքի միջոցով։",
            keywords: "Գրինվիչ Հայաստան, Գրինվիչի մասին, հայ երիտասարդության կազմակերպություն, կրթական ՀԿ Հայաստան, մենթորություն Հայաստան",
          },
          programs: {
            title: "Կրթաթոշակներ, դրամաշնորհներ և փոխանակման ծրագրեր. Գրինվիչ",
            description: "Դիտեք ստուգված կրթաթոշակներ, դրամաշնորհներ, ֆելոուշիփներ, պրակտիկաներ և փոխանակման ծրագրեր հայ երիտասարդության համար։ Զտեք ըստ երկրի, ժամկետի և կատեգորիայի, կամ ստացեք AI-հարմատեցում ակնթարթորեն։",
            keywords: "կրթաթոշակների ցանկ Հայաստան, բաց դրամաշնորհներ, փոխանակման ծրագրերի ցանկ, պրակտիկայի հնարավորություններ, ֆելոուշիփի ժամկետներ, կրթաթոշակներ Եվրոպայում, կրթաթոշակներ ԱՄՆ-ում, կրթաթոշակներ Գերմանիայում, կրթաթոշակներ Ֆրանսիայում, Էրազմուս+ ծրագրերի ցանկ, ամառային պրակտիկա արտերկրում, կամավորական ծրագրեր արտերկրում, դրամաշնորհներ ուսանողների համար, ամբողջությամբ ֆինանսավորվող կրթաթոշակներ, կրթաթոշակների ժամկետներ 2026, փոխանակման կիսամյակ արտերկրում, հետազոտական ֆելոուշիփներ",
          },
          contact: {
            title: "Կապ մեզ հետ. Գրինվիչ Հայաստան",
            description: "Կապվեք Գրինվիչ Հայաստանի թիմի հետ՝ կրթաթոշակների, համագործակցության կամ հարթակի վերաբերյալ հարցերով։",
            keywords: "կապ Գրինվիչ Հայաստան, Գրինվիչի աջակցություն",
          },
          donate: {
            title: "Աջակցեք հայ երիտասարդությանը. Նվիրաբերեք Գրինվիչին",
            description: "Աջակցեք Գրինվիչի առաքելությանը՝ կապելու հայ երիտասարդությանը կյանք փոխող կրթաթոշակների, դրամաշնորհների և փոխանակման հնարավորությունների հետ։ Յուրաքանչյուր նվիրաբերում օգնում է ավելի շատ երիտասարդների գտնել իրենց ուղին։",
            keywords: "նվիրաբերել կրթության համար Հայաստան, աջակցել հայ երիտասարդությանը, Գրինվիչ նվիրաբերում",
          },
          terms: {
            title: "Օգտագործման պայմաններ. Գրինվիչ",
            description: "Կարդացեք Գրինվիչ հարթակի օգտագործման պայմանները՝ ներառյալ հաշիվները, թույլատրելի օգտագործումը, Greenwich Buddy ծրագիրը և նվիրաբերությունները։",
            keywords: "Գրինվիչ օգտագործման պայմաններ, Գրինվիչ կանոններ",
          },
          privacy: {
            title: "Գաղտնիության քաղաքականություն. Գրինվիչ",
            description: "Իմացեք, թե ինչպես է Գրինվիչը հավաքում, օգտագործում և պաշտպանում ձեր անձնական տվյալները, ներառյալ քուքիների, երրորդ կողմի ծառայությունների և ձեր գաղտնիության իրավունքների մասին տեղեկատվությունը։",
            keywords: "Գրինվիչ գաղտնիության քաղաքականություն, տվյալների պաշտպանություն Հայաստան",
          },
          registration: {
            title: "Գրանցվել. Գրինվիչ",
            description: "Ստեղծեք ձեր անվճար Գրինվիչ հաշիվը՝ AI-հարմատեցված կրթաթոշակների, դրամաշնորհների և փոխանակման ծրագրերի համար, և կապվեք Greenwich Buddy մենթորի հետ։",
            keywords: "գրանցվել Գրինվիչ, Գրինվիչ Հայաստան հաշիվ ստեղծել, կրթաթոշակների գրանցում",
          },
        },
        footer: {
          contactUs: "Կապ մեզ հետ",
          whoWeAre: "Մեր մասին",
          feed: "Ժապավեն",
          community: "Համայնք",
          account: "Հաշիվ",
          organizations: "Կազմակերպություններ",
          contact: "Կապ",
          projects: "Նախագծեր",
          donate: "Նվիրաբերել",
          terms: "Պայմաններ",
          privacy: "Գաղտնիություն",
          copyright: "© 2026 Գրինվիչ Հայաստան",
          copyrightLong: "© 2026 Գրինվիչ Հայաստան։ Բոլոր իրավունքները պաշտպանված են։",
        },
        home: {
          hero1: "Երիտասարդական",
          hero2: "Կապ",
          tagline: "Ձեր քարտեզը համաշխարհային հնարավորությունների",
          explorePrograms: "Ուսումնասիրել ծրագրերը",
          roleCardPlayer: "Ես\nմասնակից եմ",
          roleCardPlayerSub: "Բացահայտիր ծրագրերը և դիմիր մի քանի կտտոցով",
          roleCardOrganizer: "Ես\nկազմակերպիչ եմ",
          roleCardOrganizerSub: "Հրապարակիր քո ծրագրերը և գտիր մասնակիցներ",
          searchOpportunities: "Փնտրել հնարավորություններ",
          searchCtaText: "Ամեն տարի ավելի քան 10,000,000 երիտասարդ ամբողջ աշխարհում մասնակցում է փոխանակման ծրագրերի, կրթաթոշակների և պրակտիկաների արտերկրում՝ լիովին անվճար։",
          searchCtaHint: "Տեղափոխիր փուչիկը կամ սեղմիր դրա վրա՝ իմանալու համար ինչ է առաջարկում ↓",
          filterScholarship: "Կրթաթոշակներ",
          filterExchange: "Փոխանակում",
          filterVolunteering: "Կամավորություն",
          filterInternship: "Պրակտիկա",
          filterGrant: "Դրամաշնորհներ",
          filterEducation: "Կրթություն",
          filterFellowship: "Ֆելոուշիփեր",
          filterTraining: "Վերապատրաստում",
          benefitScholarship: "Ծածկում է ուսման ամբողջ կամ մասնակի արժեքը․ շատ կրթաթոշակներում արդեն ներառված են ամսական վճար, կացարան և առողջության ապահովագրություն։",
          benefitExchange: "Անցկացրու կիսամյակ կամ ամբողջ տարի գործընկեր համալսարանում արտերկրում, ստացիր կրեդիտներ, որոնք հաշվարկվում են տանը, և ընկերացիր տասնյակ երկրների ուսանողների հետ։",
          benefitVolunteering: "Ապրիր, աշխատիր և ճամփորդիր արտերկրում անվճար․ կամավորական ծրագրերի մեծ մասն արդեն ներառում է կացարան, սնունդ և նույնիսկ ամսական դրամաշնորհ։",
          benefitInternship: "Ստացիր իրական աշխատանքային փորձ միջազգային ընկերությունում կամ կազմակերպությունում․ շատ պրակտիկաներ վճարովի են և բացում են դռներ ապագա աշխատանքի համար։",
          benefitGrant: "Ստացիր ֆինանսավորում քո սեփական գաղափարի, հետազոտության կամ նախագծի համար․ դրամաշնորհները սովորաբար հետ վերադարձնել պետք չէ։",
          benefitEducation: "Սովորիր արտերկրում ցանկացած մակարդակում՝ կիսամյակային փոխանակումից մինչև ամբողջական բակալավրիատ, մագիստրատուրա կամ ասպիրանտուրա։",
          benefitFellowship: "Միացիր հետազոտական կամ մասնագիտական ֆելոուշիփի արտերկրում, աշխատիր փորձագետների հետ և ստեղծիր կապեր, որոնք կմնան ծրագրից հետո։",
          benefitTraining: "Ձեռք բեր գործնական հմտություններ կարճաժամկետ դասընթացների միջոցով արտերկրում՝ մասնագիտական, տեխնիկական կամ soft skills, առցանց կամ դեմ առ դեմ։",
          hotNow: "Ժամկետը մոտ է",
          noDeadlinesSoon: "Այսօր կամ վաղը վերջացող ժամկետով ծրագրեր այս պահին չկան",
          programFallback: "Ծրագիր",
          untitledProgram: "Անանուն ծրագիր",
          countriesHeading: "Գտիր հնարավորություններ ամբողջ աշխարհից",
          deadlineBadge: "Վերջնաժամկետ",
          daysShort: "օր ",
          seeMore: "Տեսնել ավելին",
          viewArrow: "Դիտել →",
          topOrgs: "Ամսվա լավագույն կազմակերպությունները",
          topOrgsDesc: "Դասավորությունը հիմնված է մեր ծրագրերի ազդեցության, մասնակիցների թվի, արձագանքների, տեսանելիության և այլ ցուցանիշների վրա:",
          topOrgsDescMobile: "Դասավորություն՝ ըստ ազդեցության, մասնակիցների և արձագանքների:",
          orgLabel: "Կազմակերպություն",
          unknown: "Անհայտ",
          seeTopList: "Տեսնել ցանկը",
          partners: "Գործընկերներ",
          feedbackTitle: "Արձագանքներ Գրինվիչի անդամներից",
          supportedBy: "Աջակցում են",
          thankYou: "Շնորհակալություն։",
          feedbackSent: "Ձեր արձագանքը հաջողությամբ ուղարկվեց։",
          betaVersion: "Բետա տարբերակ",
          shareFeedback: "Կիսվեք արձագանքով",
          shareFeedbackSub: "Օգնեք բարելավել YouthConnect, ձեր կարծիքը կարևոր է։",
          ratingOptional: "Գնահատում (ըստ ցանկության)",
          inProgress: "Ընթացքում է",
          comingSoonLabel: "Շուտով",
          craftingSpecial: "Մենք պատրաստում ենք մի բան հատուկ։",
          checkBack: "Շուտով եկեք նորից։",
          heroSubDesktop: "Միացեք հազարավոր մարդկանց, ովքեր աշխարհում փոփոխություն են բերում նշանակալի ծրագրերի և միջազգային գործընկերությունների միջոցով։",
          heroSubMobile: "Բացահայտեք համաշխարհային հնարավորություններ և ավելացրեք ձեր ներդրումը։",
          memberFeedbackSoon: "Անդամների արձագանք",
          supportedBySoon: "Աջակցում են",
          aiKicker: "AI Matching",
          aiTitle: "Այժմ ունենք AI Matching",
          aiDesc: "Մենք ինքներս գտնում ենք քեզ հետաքրքրող ծրագրերը և կատարում ենք ավտոմատ համընկնում։",
          aiPoint1: "Դասավորված ըստ հարմարության",
          aiPoint2: "Նոր ընտրանի ամեն օր",
          aiPoint3: "Կարգավորումը՝ րոպեից պակաս",
          aiCta: "Փորձիր հիմա",
          buddyKicker: "Greenwich Buddy",
          buddyTitle: "Ուզում ես նոր բան սովորել։ Կամ սովորեցնել ուրիշներին։",
          buddyDesc: "Միացիր Buddy համակարգին որպես մենթոր կամ մենթի և սկսիր գտնել նոր ընկերներ ու կապեր։",
          buddyPoint1: "Ընդհանուր հետաքրքրություններով",
          buddyPoint2: "Մեկ կենտրոնացված ամիս",
          buddyPoint3: "Վկայական՝ 6 mentee-ից հետո",
          buddyCta: "Միանալ Buddy-ին",
          faqKicker: "Հաճախ տրվող հարցեր",
          faqTitle: "Այն ամենը, ինչ պետք է իմանալ Գրինվիչի մասին",
          faqQ1: "Ի՞նչ է Գրինվիչը։",
          faqA1: "Գրինվիչը անվճար հարթակ է, որը կապում է հայ երիտասարդությանը (մոտավորապես 14-35 տարեկան) Հայաստանից և ամբողջ աշխարհից կրթաթոշակների, դրամաշնորհների, ֆելոուշիփների, պրակտիկաների և փոխանակման ծրագրերի հետ, այդ թվում՝ Erasmus+-ի նման հնարավորությունների։ Մենք հավաքում ենք ստուգված հնարավորությունները մեկ տեղում, որպեսզի Ձեզ ստիպված չլինեք որոնել տասնյակ կայքերում։",
          faqQ2: "Անվճա՞ր է Գրինվիչի օգտագործումը և կրթաթոշակների ու դրամաշնորհների համար դիմելը։",
          faqA2: "Այո։ Հաշվի ստեղծումը, ծրագրերի դիտումը, AI Matching-ի օգտագործումը և Greenwich Buddy-ին միանալը լիովին անվճար են ուսանողների համար։ Գրինվիչը երբեք վճար չի գանձում հարթակում տեղադրված կրթաթոշակի, դրամաշնորհի կամ փոխանակման ծրագրի համար դիմելու համար։",
          faqQ3: "Ինչպե՞ս է աշխատում AI Matching-ը։",
          faqA3: "AI Matching-ը վերլուծում է Ձեր պրոֆիլը, հետաքրքրություններն ու նպատակները և ավտոմատ կերպով առաջարկում է Ձեզ հարմար կրթաթոշակներ, դրամաշնորհներ, պրակտիկաներ և փոխանակման ծրագրեր՝ փոխարենը որ ստիպված լինեք ձեռքով զննել բոլոր ցանկերը։",
          faqQ4: "Ի՞նչ է Greenwich Buddy-ն։",
          faqA4: "Greenwich Buddy-ը մեր փոխադարձ մենթորության ծրագիրն է։ Կարող եք միանալ որպես մենթի՝ ստանալու ուղղորդում համապատասխան փորձառություն ունեցող մեկից, կամ դառնալ մենթոր՝ ծրագիրն ավարտելուց հետո, ձեռք բերել նոր կապեր և ստանալ վկայական։",
          faqQ5: "Ի՞նչ տեսակի հնարավորություններ կարող եմ գտնել՝ կրթաթոշակներ, դրամաշնորհներ, պրակտիկաներ, փոխանակման ծրագրեր։",
          faqA5: "Գրինվիչում տեղադրված են կրթաթոշակներ, համալսարանական դրամաշնորհներ, ֆելոուշիփներ, վճարովի և անվճար պրակտիկաներ, կամավորական ծրագրեր և փոխանակման ծրագրեր (այդ թվում՝ Erasmus+) ուսման, աշխատանքի և կամավորության համար՝ ինչպես Հայաստանում, այնպես էլ արտերկրում։",
          faqQ6: "Ո՞վ կարող է օգտագործել Գրինվիչը։",
          faqA6: "Գրինվիչը ստեղծված է հայ երիտասարդության համար՝ մոտավորապես 14-ից 35 տարեկան՝ դպրոցականներ, ուսանողներ, վերջերս շրջանավարտներ և երիտասարդ մասնագետներ, ովքեր փնտրում են իրենց հաջորդ կրթաթոշակը, դրամաշնորհը, պրակտիկան կամ փոխանակման հնարավորությունը։",
          statsKicker: "Մեր նվաճումները",
          trustLabelUsers: "օգտատեր հարթակում",
          trustLabelOpportunities: "հրապարակված հնարավորություն",
          trustLabelSatisfaction: "իրենց հետաքրքրող ծրագիր են գտնում",
          trustLabelCountries: "երկրներում ակտիվ ծրագրեր",
        },
        programs: {
          allPrograms: "Բոլոր ծրագրերը",
          greencoinReward: "+{{amount}} greencoin ավարտելուց հետո",
          greencoinsFilter: "Greencoin պարգևներ",
          programsFound: "Գտնվել է {{count}} ծրագիր(ներ)",
          viewDetails: "Մանրամասներ",
          noPrograms: "Ծրագրեր չեն գտնվել",
          adjustFilters: "Փորձեք փոխել ֆիլտրերը։",
          resetFilters: "Վերակայել ֆիլտրերը",
          clear: "Մաքրել",
          anyAge: "Ցանկացած տարիք",
          anyTime: "Ցանկացած ժամանակ",
          educationAny: "Ցանկացած մակարդակ",
          educationLevelLabel: "Կրթություն",
          educationLevelShort: "Կրթություն",
          educationUndergraduate: "Բակալավրիատ",
          educationGraduate: "Մագիստրատուրա",
          educationDoctoral: "Ասպիրանտուրա / PhD",
          educationStudent: "Ուսանող (ընդհանուր)",
          educationProfessional: "Մասնագիտական",
          educationHighSchool: "Ավագ դպրոց",
          filtersLabel: "Ֆիլտրեր",
          ageLabel: "Տարիք",
          age18_25: "18-25 տարեկան",
          age25_35: "25-35 տարեկան",
          age35plus: "35+ տարեկան",
          deadlinePassed: "Ժամկետը լրացել է",
          deadlineLabel: "Վերջնաժամկետ",
          applyDeadlineLabel: "Դիմելու վերջնաժամկետ",
          eventDateLabel: "Միջոցառման օրը",
          eventDatePassed: "Միջոցառումն ավարտվել է",
          funding: "Ֆինանսավորում",
          location: "Վայր",
          pending: "Սպասման մեջ",
          rejected: "Մերժված",
          approve: "Հաստատել",
          reapprove: "Կրկին հաստատել",
          reject: "Մերժել",
          revoke: "Հանել",
          edit: "Խմբագրել",
          delete: "Ջնջել",
          save: "Պահպանել",
          cancel: "Չեղարկել",
          title: "Վերնագիր",
          description: "Նկարագրություն",
          saveProgram: "Պահպանել",
          unsaveProgram: "Պահպանված է",
          savePromptLogin: "Մուտք գործեք՝ ծրագրերը պահպանելու համար",
          recommendedTitle: "Առաջարկվում է ձեզ",
          popularTitle: "Ժողովրդական հենց հիմա",
          recommendedLoading: "Փնտրում ենք ծրագրեր ձեզ համար…",
          recommendedEmpty: "Առաջարկելու բան դեռ չկա․ ուսումնասիրեք ծրագրերը՝ անհատականացված առաջարկներ ստանալու համար։",
          heroTitle: "Բացահայտեք ծրագրերը",
          heroSubtitle: "Կրթաթոշակներ, ֆելոուշիփներ, պրակտիկաներ, մրցանակներ և ավելին",
          sourceLabel: "Աղբյուր՝",
          sourceByAi: "AI-ի կողմից",
          sourceByAdmin: "Ադմինի կողմից",
          sourceByOrganization: "Կազմակերպության կողմից",
          sourceAllOption: "Աղբյուր՝ Բոլորը",
          allSectorsOption: "Բոլոր ոլորտները",
          sector_ecology: "Էկոլոգիա",
          sector_international: "Միջազգային",
          sector_technology: "Տեխնոլոգիա",
          sector_medical: "Բժշկական",
          sector_education: "Կրթություն",
          sector_business: "Բիզնես",
          sector_arts: "Արվեստ և մշակույթ",
          sector_science: "Գիտություն",
          sector_sports: "Սպորտ",
          sector_agriculture: "Գյուղատնտեսություն",
          sector_local: "Տեղական",
          sector_media: "Մեդիա",
          cat_education: "Կրթություն",
          cat_scholarship: "Կրթաթոշակ",
          cat_fellowship: "Ֆելոուշիփ",
          cat_erasmusplus: "Էրազմուս Պլյուս",
          cat_training: "Վերապատրաստում",
          cat_grant: "Դրամաշնորհ",
          cat_internship: "Պրակտիկա",
          cat_conference: "Կոնֆերանս",
          cat_online: "Առցանց",
          cat_volunteering: "Կամավորություն",
          cat_event: "Միջոցառում",
          cat_award: "Մրցանակ",
          sub_all_education: "Բոլոր կրթական ծրագրերը",
          sub_abroad: "Ուսումն արտերկրում",
          sub_bachelor: "Բակալավրիատ",
          sub_master: "Մագիստրատուրա",
          sub_phd: "Ասպիրանտուրա",
          sub_online: "Առցանց",
          sub_all_scholarship: "Բոլոր կրթաթոշակները",
          sub_full: "Ամբողջական",
          sub_partial: "Մասնակի",
          sub_government: "Պետական",
          sub_private: "Մասնավոր",
          sub_all_fellowship: "Բոլոր ֆելոուշիփները",
          sub_research: "Հետազոտական",
          sub_postdoc: "Հետդոկտորական",
          sub_visiting: "Հյուրախաղ",
          sub_all_erasmusplus: "Բոլոր Էրազմուս+ ծրագրերը",
          sub_ka1: "KA1 - Շարժունակություն",
          sub_ka2: "KA2 - Համագործակցություն",
          sub_ka3: "KA3 - Քաղաքականություն",
          sub_all_training: "Բոլոր վերապատրաստումները",
          sub_professional: "Մասնագիտական",
          sub_technical: "Տեխնիկական",
          sub_soft_skills: "Փափուկ հմտություններ",
          sub_online_training: "Առցանց",
          sub_all_grant: "Բոլոր դրամաշնորհները",
          sub_research_grant: "Հետազոտական",
          sub_project_grant: "Ծրագրային",
          sub_travel_grant: "Ուղևորության",
          sub_all_internship: "Բոլոր պրակտիկաները",
          sub_summer: "Ամառային",
          sub_paid: "Վճարովի",
          sub_unpaid: "Անվճար",
          sub_virtual: "Վիրտուալ",
          sub_all_conference: "Բոլոր կոնֆերանսները",
          sub_international_conf: "Միջազգային",
          sub_funded_conf: "Ֆինանսավորվող",
          sub_virtual_conf: "Վիրտուալ",
          sub_all_online: "Բոլոր առցանց ծրագրերը",
          sub_online_course: "Դասընթաց",
          sub_webinar: "Վեբինար",
          sub_mooc: "MOOC",
          sub_all_volunteering: "Բոլոր կամավորական ծրագրերը",
          sub_local_vol: "Տեղական",
          sub_international_vol: "Միջազգային",
          sub_evs: "EVS / ESC",
          sub_all_event: "Բոլոր միջոցառումները",
          sub_festival: "Փառատոն",
          sub_competition: "Մրցույթ",
          sub_summit: "Գագաթնաժողով",
          sub_all_award: "Բոլոր մրցանակները",
          sub_international_award: "Միջազգային",
          sub_national_award: "Ազգային",
          sub_regional_award: "Տարածաշրջանային",
          sub_special_award: "Հատուկ ճանաչում",
          deadlineAny: "Ցանկացած վերջնաժամկետ",
          deadlineLast24h: "Վերջին 24 ժամում",
          deadlineIn3Days: "3 օրվա ընթացքում",
          deadlineIn7Days: "7 օրվա ընթացքում",
          deadlineIn30Days: "30 օրվա ընթացքում",
          archiveLabel: "Արխիվ",
          archiveShowActive: "Ցուցադրել ակտիվ ծրագրերը",
          archiveShowArchive: "Ցուցադրել արխիվը",
          archiveEmpty: "Արխիվը դատարկ է",
          aiMatchingTag: "AI Matching",
          aiThinkingButton: "AI-ն մտածում է…",
          aiMatchedToday: "Համընկնումը կատարված է այսօր ✓",
          aiShowAllPrograms: "Ցուցադրել բոլոր ծրագրերը",
          aiNextMatchIn: "Հաջորդ AI համընկնումը՝ {{time}} հետո",
          aiNewMatchesIn: "Նոր համընկնումները հասանելի կլինեն {{time}} հետո",
          aiShowProgramsMatchedTooltip: "Ցուցադրել AI-ի կողմից ձեզ համապատասխանեցված ծրագրերը",
          aiOverlaySub: "Ձեր հետաքրքրությունները համեմատվում են բոլոր բաց ծրագրերի հետ…",
          aiCouldNotLoad: "Չհաջողվեց բեռնել առաջարկությունները",
          tryAgain: "Կրկին փորձել",
          aiNoStrongMatches: "Դեռ ուժեղ համընկնումներ չկան",
          aiBrowseAndSave: "Դիտեք և պահպանեք մի քանի ծրագիր, որպեսզի մենք հասկանանք՝ ինչ է ձեզ դուր գալիս։",
          programsMatchedCount: "{{count}} ծրագիր համապատասխանեցվել է ձեզ",
          aiPhaseReading: "Ուսումնասիրում ենք ձեր հետաքրքրությունները…",
          aiPhaseScanning: "Սկանավորում ենք բաց ծրագրերը…",
          aiPhaseComparing: "Համեմատում ենք կատեգորիաներն ու ոլորտները…",
          aiPhaseScoring: "Գնահատում ենք լավագույն համընկնումները…",
          aiPhaseAlmost: "Գրեթե պատրաստ է…",
          nowLabel: "հիմա",
          unlockPreviewText: "Դուք տեսնում եք {{previewLimit}}-ը {{count}} ծրագրից․ ստեղծեք անվճար հաշիվ՝ մնացածը բացելու, ընտրյալները պահպանելու և վերջնաժամկետների հիշեցումներ ստանալու համար։",
          unlockMoreWaiting: "Եւս {{count}} ծրագիր սպասում է ձեզ",
          unlockFullListText: "Ստեղծեք անվճար հաշիվ՝ ամբողջական ցանկը բացելու, ձեզ դուր եկած ծրագրերը պահպանելու և վերջնաժամկետների մասին հիշեցումներ ստանալու համար։",
          unlockFullListCta: "Բացել ամբողջական ցանկը, անվճար է",
          orgBarQuestion: "Ցանկանո՞ւմ եք տեղադրել ձեր ծրագիրը",
          mySubmissions: "Իմ հայտերը",
          submitNew: "Ավելացնել նոր",
          categoriesLabel: "Կատեգորիաներ",
          sidebarClose: "Փակել",
          sidebarFilter: "Ֆիլտր",
          deleteConfirmTitle: "Ջնջե՞լ այս ծրագիրը",
          deleteConfirmBody: "Այս գործողությունը հնարավոր չէ հետարկել։",
          loadingPrograms: "Ծրագրերը բեռնվում են…",
          durationLabel: "Տևողություն",
          datesLabel: "Ամսաթվեր",
          targetGroupLabel: "Թիրախ խումբ",
          formatLabel: "Ձևաչափ",
          organizerLabel: "Կազմակերպիչ",
          mediaLabel: "Մեդիա",
          additionalDetailsLabel: "Լրացուցիչ մանրամասներ",
          requirementsLabel: "Պահանջներ",
          benefitsLabel: "Առավելություններ",
          openMediaLabel: "Բացել մեդիան",
          applyNowLabel: "Դիմել հիմա",
          applyLabel: "Դիմել",
          copyLinkLabel: "Պատճենել հղումը",
          copyLinkTooltip: "Պատճենել կիսվելու հղումը",
          yourApplicationLabel: "Ձեր հայտը",
          acceptedStatus: "Ընդունված",
          notAcceptedStatus: "Չի ընդունվել",
          attendedStatus: "Մասնակցել է",
          appStatusPendingMsg: "Հայտը ներկայացված է, սպասվում է պատասխան։",
          appAcceptedMsg: "Ընդունված է!",
          appNotAcceptedMsg: "Չի ընդունվել։",
          appAttendedMsg: "Մասնակցությունը հաստատված է։",
          appCertificateMayFollow: "Հավաստագիրը կարող է հետագայում տրվել։",
          rateOrgTitle: "Գնահատեք այս կազմակերպությանը",
          optionalCommentPlaceholder: "Ընտրովի մեկնաբանություն",
          submitReviewLabel: "Ուղարկել կարծիքը",
          submittingLabel: "Ուղարկվում է...",
          thanksForFeedback: "Շնորհակալություն ձեր կարծիքի համար!",
          starAriaLabel: "{{n}} աստղ",
          linkCopiedToast: "🔗 Հղումը պատճենվել է!",
          applicationSubmittedToast: "✅ Հայտն ուղարկվել է!",
          submitReviewFailedToast: "Չհաջողվեց ուղարկել կարծիքը",
          submitReviewNetworkErrorToast: "Ցանցի սխալ՝ կարծիքն ուղարկելիս",
          loadRecommendationsFailedError: "Չհաջողվեց բեռնել առաջարկությունները",
        },
        cookie: {
          title: "Թխուկներ և գաղտնիություն",
          accept: "Ընդունել",
          reject: "Մերժել",
          learnMore: "Իմանալ ավելին",
          bannerTitle: "Մենք գնահատում ենք ձեր գաղտնիությունը",
          bannerDesc: "Շարունակելով օգտագործել Greenwich-ը, դուք համաձայնում եք թխուկների օգտագործմանը։ Մենք հավաքում ենք միայն անհրաժեշտ տվյալները՝ ձեր փորձը բարելավելու և հարթակի աշխատանքը ապահովելու համար։",
          decline: "Մերժել",
          acceptContinueFull: "Ընդունել և շարունակել",
          requiredTitle: "Անհրաժեշտ են թխուկներ",
          requiredBody: "Greenwich-ը շարունակելու համար պետք է ընդունեք անհրաժեշտ թխուկները։ Դրանք անհրաժեշտ են հարթակի նորմալ աշխատանքի համար։",
          acceptCookiesContinue: "Ընդունել թխուկները և շարունակել",
        },
        community: {
          title: "Համայնք",
          loading: "Համայնքները բեռնվում են...",
          retry: "Կրկին փորձել",
          createGroup: "Ստեղծել խումբ",
          createShort: "Ստեղծել",
          myCommunities: "Իմ համայնքները",
          myGroupsShort: "Իմ խմբերը",
          searchPlaceholder: "Որոնել համայնքներ...",
          filterAll: "Բոլորը",
          filterOpen: "Բաց",
          filterClosed: "Փակ",
          noGroupsSearch: "«{{term}}» որոնման համար խումբ չի գտնվել։",
          noGroupsYet: "Դեռ խումբ չկա։ Եղեք առաջինը՝ ստեղծելու։",
          createFirstGroup: "Ստեղծել առաջին խումբը",
          fetchError: "Խմբերը բեռնել չհաջողվեց",
          loadError: "Համայնքները բեռնել չհաջողվեց։ Փորձեք նորից։",
          joinSuccess: "Դուք հաջողությամբ միացաք խմբին։",
          joinRequestSent: "Հայտն ուղարկվեց։ Խմբի սեփականատերը կվերանայի այն։",
          joinFailed: "Խմբին միանալ չհաջողվեց",
          joinError: "Սխալ՝ խմբին միանալիս։ Փորձեք նորից։",
          membersCount: "{{count}} անդամ",
          public: "Հանրային",
          private: "Մասնավոր",
          admin: "Ադմին",
          closed: "Փակ",
          manageGroup: "Կառավարել խումբը",
          viewGroup: "Դիտել խումբը",
          joining: "Միանում է...",
          registrationClosed: "Գրանցումը փակ է",
          join: "Միանալ",
          noDescriptionAvailable: "Նկարագրություն չկա",
        },
        organizations: {
          topTitle: "Լավագույն կազմակերպություններ",
          topSubtitle: "Ամսվա ամենահայտնի կազմակերպությունները",
          secondPlace: "Երկրորդ տեղ",
          secondDesc: "Գերազանց կազմակերպություն՝ մեծ նվաճումներով",
          firstPlace: "Առաջին տեղ",
          firstDesc: "Առաջատար կազմակերպություն՝ ակնառու արդյունքներով",
          thirdPlace: "Երրորդ տեղ",
          thirdDesc: "Նշանավոր կազմակերպություն՝ իրական ազդեցությամբ",
          allVerified: "Բոլոր հաստատված կազմակերպությունները",
          loading: "Կազմակերպությունները բեռնվում են...",
          tryAgain: "Կրկին փորձել",
          noneTitle: "Կազմակերպություններ չեն գտնվել",
          noneDesc: "Այս պահին ցուցադրելու կազմակերպություններ չկան։",
          refresh: "Թարմացնել",
          loadError: "Կազմակերպությունները բեռնել չհաջողվեց։ Փորձեք նորից։",
          noDescription: "Նկարագրություն չկա",
          unknownOrg: "Անհայտ կազմակերպություն",
        },
        adminPanel: {
          signOutTitle: "Դուրս գա՞լ",
          signOutBody: "Վստա՞հ եք, որ ուզում եք դուրս գալ ադմինիստրատորի վահանակից։",
          cancel: "Չեղարկել",
          yesLogOut: "Այո, դուրս գալ",
          viewArrow: "Դիտել →",
          dashboardTitle: "Ադմինիստրատորի վահանակ",
          welcomeBack: "Բարի վերադարձ,",
          navOrganizerApprovals: "Կազմակերպիչների հաստատում",
          navPrograms: "Ծրագրեր",
          navAnalytics: "Վերլուծություն",
          logoutBtn: "Դուրս գալ",
          statTotalOrganizers: "Ընդամենը կազմակերպիչներ",
          statPendingOrganizers: "Սպասման մեջ",
          statTotalUsers: "Total Users",
          statRecentRegistrations: "Recent Registrations",
          statVerifiedOrganizers: "Հաստատված կազմակերպիչներ",
          statRejectedUsers: "Մերժված օգտատերեր",
          statBetaFeedbacks: "Բետա արձագանքներ",
          statTotalPosts: "Ընդամենը գրառումներ",
          statTotalPrograms: "Ընդամենը ծրագրեր",
          statPendingPrograms: "Սպասման մեջ ծրագրեր",
          statTotalCommunities: "Ընդամենը համայնքներ",
          statPendingReports: "Սպասման մեջ բողոքներ",
          reviewLink: "Դիտել →",
          recentRegistrations: "Վերջին գրանցումներ",
          noRecentRegistrations: "Վերջին գրանցումներ չկան",
          colLogo: "Լոգո",
          colName: "Անուն",
          colEmail: "Էլ․ փոստ",
          colOrganization: "Կազմակերպություն",
          colType: "Տեսակ",
          colStatus: "Կարգավիճակ",
          colDate: "Ամսաթիվ",
          colActions: "Գործողություններ",
        },
        buddy: {
          title: "Buddy",
          subtitle: "Անհատական մենթորական համապատասխանեցման համակարգ՝ կապվիր փորձառու մեկի հետ քեզ հետաքրքրող ոլորտում, կամ եղիր այդ մարդը մեկ ուրիշի համար, ով նոր է սկսում։",
          backHome: "Վերադառնալ գլխավոր էջ",
          loading: "Բեռնվում է...",
          roleMentorTitle: "Դառնալ Mentor",
          roleMentorDesc: "Կիսվիր քո փորձով նրանց հետ, ովքեր նոր են սկսում իրենց ճանապարհը երիտասարդական նախագծերում, կամավորությունում, Erasmus+, ESC և նմանատիպ հնարավորություններում։",
          roleMenteeTitle: "Դառնալ Mentee",
          roleMenteeDesc: "Ստացիր մենթոր, ով փորձառու է քեզ հետաքրքրող ոլորտներում։",
          mentorInfoTitle: "Mentor-ի դերը 🌟",
          mentorInfoBody: "Mentor-ը փորձառու մասնակից է, ով օգնում է սկսնակներին հասկանալ երիտասարդական նախագծերի, կամավորության, Erasmus+, ESC և այլ հնարավորությունների աշխարհը։\n\nՊարտականություններ՝\n• 1 ամսվա ընթացքում կապ պահպանել mentee-ի հետ\n• օգնել ուղղորդմամբ և փորձով\n• լինել հարգալից, պատասխանատու և աջակցող\n• չխոստանալ անհնար բաներ\n\nՄեկ mentor-ը միաժամանակ կարող է ունենալ առավելագույնը 3 mentee։ 6 հաջող ավարտված mentorship-ից հետո mentor-ը ստանում է Greenwich Mentor սերտիֆիկատ։",
          menteeInfoTitle: "Mentee-ի դերը 🚀",
          menteeInfoBody: "Mentee-ն այն մարդն է, ով նոր է սկսում իր ճանապարհը երիտասարդական նախագծերում, կամավորությունում կամ միջազգային ծրագրերում։\n\nԴու կարող ես ընտրել mentor, ով ունի փորձ քո հետաքրքրությունների ոլորտում։\nՄեկ mentee կարող է ունենալ միայն մեկ active mentor։\nMentorship-ը տևում է 1 ամիս։",
          agreeContinue: "Համաձայն եմ, շարունակել",
          cancel: "Չեղարկել",
          back: "Հետ",
          step: "Քայլ {{current}} / {{total}}",
          formCategoriesMentor: "Ընտրիր մինչև 3 ուղղություն, որտեղ փորձ ունես",
          formCategoriesMentee: "Ընտրիր մինչև 3 ուղղություն, որոնք քեզ հետաքրքրում են",
          categoriesHint: "{{count}}/3 ընտրված",
          formExperience: "1-ից 10 ինչպե՞ս ես գնահատում քո փորձը այս ոլորտում",
          formExperienceMentee: "Ի՞նչ փորձ ունես արդեն այս ոլորտում։ Սա մեզ կօգնի ընտրել քեզ համապատասխան մենթոր",
          formExperiencePlaceholder: "1 = փորձ չունեմ, 10 = guru",
          experiencePrompt: "Ընտրիր աստղերի քանակը",
          experienceLevels: { novice: "Սկսնակ", amateur: "Սիրողական", pro: "Պրոֆեսիոնալ", guru: "Guru" },
          menteeExperienceLabel: "{{level}} այս ոլորտում",
          formProjectsCount: "Քանի՞ նախագծի ես մասնակցել ընտրված ուղղություններում միասին վերցրած",
          formProjectsCountPlaceholder: "օրինակ՝ 5",
          formHours: "Շաբաթական քանի՞ ժամ կարող ես տրամադրել mentorությանը",
          formBio: "Կարճ bio, որը կտեսնեն mentee-ները (առավելագույնը 200 նիշ)",
          formBioMenteeLabel: "Ի՞նչ ես ուզում ստանալ մենթորից (առավելագույնը 200 նիշ)",
          formBioPlaceholder: "Գրիր մի քանի բառ քո մասին...",
          formContact: "Ինչպե՞ս կարող է քեզ հետ կապվել համապատասխանեցված mentee/mentor-ը",
          contactHint: "Կիսվում է միայն հայտը ընդունելուց հետո՝ ամեն ինչ այստեղ ընտրովի է",
          contactHintMentor: "Կիսվում է միայն հայտը ընդունելուց հետո՝ ընտրիր առնվազն 2 եղանակ, որով կապ հաստատեն քեզ հետ",
          contactInvalidHint: "Այս դաշտերից մեկը սխալ է լրացված՝ ստուգիր հեռախոսի, email-ի կամ Telegram-ի ձևաչափը",
          contactMinHint: "Խնդրում ենք լրացնել առնվազն 2 կապի եղանակ",
          phonePlaceholder: "Հեռախոսահամար",
          emailPlaceholder: "Email",
          telegramPlaceholder: "Telegram username",
          instagramPlaceholder: "Instagram",
          facebookPlaceholder: "Facebook",
          formGender: "Քո սեռը",
          genders: { male: "Արական", female: "Իգական", other: "Այլ" },
          formPreferredMenteeGender: "Ի՞նչ սեռի պետք է լինի քո mentee-ն",
          formPreferredMentorGender: "Ի՞նչ սեռի պետք է լինի քո mentor-ը",
          genderPrefs: { any: "Կարևոր չէ", male: "Արական", female: "Իգական", same: "Իմ սեռի նման" },
          previewLabel: "Քո պրոֆիլի նախադիտում",
          previewHint: "Ուղիղ սա են տեսնելու mentee-ները mentor-ներին դիտելիս",
          noRatingsYet: "Դեռ գնահատականներ չկան",
          contactLabels: { phone: "Հեռախոս", email: "Email", telegram: "Telegram", instagram: "Instagram", facebook: "Facebook" },
          continueBtn: "Շարունակել",
          submitMentor: "Ուղարկել mentor հայտը",
          submitMentee: "Պահպանել և տեսնել համապատասխան mentor-ներ",
          errPickCategory: "Ընտրիր գոնե 1 ուղղություն",
          errExperience: "Գրիր թիվ 1-ից 10",
          errBioLength: "Bio-ն պետք է լինի առավելագույնը 100 բառ",
          errGeneric: "Ինչ-որ բան այն չէր։ Փորձիր կրկին։",
          mentorPendingTitle: "Հայտը ուսումնասիրվում է",
          mentorPendingBody: "Քո mentor հայտը ուղարկվեց Greenwich-ի ադմիններին։ Կիմանանք քեզ, հենց հաստատվի։",
          mentorRejectedTitle: "Հայտը չի հաստատվել",
          mentorRejectedBody: "Քո mentor հայտը այս պահին չի հաստատվել։",
          mentorApprovedBadge: "Հաստատված mentor",
          availabilityOn: "Հասանելի եմ նոր mentee-ների համար",
          availabilityOff: "Այս պահին հասանելի չեմ",
          toggleAvailability: "Փոխել հասանելիությունը",
          activeMenteesTitle: "Քո ակտիվ mentee-ները",
          noActiveMentees: "Այս պահին ակտիվ mentee չկա։",
          pendingRequestsTitle: "Նոր mentee հայտեր",
          noPendingRequests: "Սպասող հայտ չկա։",
          accept: "Ընդունել",
          decline: "Մերժել",
          completedLabel: "Ավարտված mentorship-ներ",
          mentorsChatBtn: "Մենթորների չաթ",
          certificateEarned: "🎓 Դու ստացար Greenwich Buddy Mentor սերտիֆիկատը։",
          asMentorTab: "Որպես Mentor",
          asMenteeTab: "Որպես Mentee",
          matchingMentorsTitle: "Քեզ համապատասխան mentor-ները",
          allMentorsTitle: "Հասանելի mentor-ներ",
          noMatchingMentors: "Այս պահին ազատ համապատասխան mentor չկա։ Փորձիր ավելի ուշ։",
          overlapLabel: "{{count}} համընկնող ուղղություն",
          experienceLabel: "Փորձ",
          projectsLabel: "Նախագծեր",
          activeLabel: "Ակտիվ mentee",
          chooseMentor: "Ընտրել այս mentor-ին",
          requestSentTitle: "Հայտն ուղարկվեց ✅",
          requestSentBody: "Mentor-ը տեղեկացվեց։ Կիմանանք քեզ, հենց նա պատասխանի։",
          withdrawRequest: "Հետ վերցնել հայտը",
          youHaveMentorTitle: "Քո mentor-ը",
          youHaveMenteeOf: "Mentee",
          daysLeft: "{{count}} օր մնացել է",
          endsOn: "Ավարտ՝ {{date}}",
          messageBtn: "Գրել",
          viewProfile: "Տեսնել պրոֆիլը",
          endMentorship: "Ավարտել mentorship-ը",
          endMentorshipConfirmTitle: "Ավարտե՞լ այս mentorship-ը",
          endMentorshipConfirmBody: "Այն հետ շրջելի չէ։ Երկուսիդ էլ կխնդրվի թողնել գաղտնի գնահատական։",
          endMentorshipConfirmYes: "Այո, ավարտել",
          reviewTitle: "Գնահատիր mentorship-ը",
          reviewBody: "Սա մնում է գաղտնի և չի ցուցադրվում մյուս կողմին։",
          reviewCommentPlaceholder: "Կարճ comment (ցանկության դեպքում)",
          submitReview: "Ուղարկել գնահատականը",
          reviewThanks: "Շնորհակալություն feedback-ի համար ✅",
          skipReview: "Բաց թողնել",
          pendingReviewTitle: "Սպասում է քո գնահատականին",
          pendingReviewBody: "Այս mentorship-երն ավարտվել են։ Թող գաղտնի գնահատական, որը մյուս կողմը երբեք չի տեսնի։",
          leaveReview: "Թողնել գնահատական",
          reportBtn: "Գանգատ",
          reportTitle: "Գանգատել {{name}}-ից",
          reportBody: "Պատմիր, թե ինչ է եղել այս Buddy mentorship-ում՝ մեր թիմը կդիտարկի այն։ Սա չի տեսնում {{name}}-ը։",
          reportDetailsPlaceholder: "Ի՞նչ է եղել (ցանկության դեպքում, օգնում է ավելի արագ դիտարկել)",
          reportSubmittedTitle: "Գանգատն ուղարկվեց",
          reportSubmittedBody: "Շնորհակալություն, մեր թիմը կդիտարկի այն։ Եթե անհանգստանում ես քո անվտանգության համար, դիմիր նաև անմիջապես։",
          close: "Փակել",
          cancel: "Չեղարկել",
          submitting: "Ուղարկվում է…",
          submitReport: "Ուղարկել գանգատը",
          categories: {
            volunteering: "Կամավորություն", intlPractice: "Միջազգային պրակտիկա", erasmusPlus: "Erasmus+",
            erasmusMundus: "Erasmus Mundus", esc: "ESC", leadership: "Leadership", networking: "Networking",
            webinar: "Webinar", workshop: "Workshop", business: "Բիզնես", startup: "Startup",
            hiking: "Hiking", training: "Training", eco: "Eco", communitySupport: "Համայնքային աջակցություն",
            organizational: "Կազմակերպչական", marketing: "Marketing", communication: "Communication",
            regionalDev: "Տարածաշրջանների զարգացում", art: "Արվեստ", painting: "Նկարչություն", dance: "Պար",
            singing: "Երգ", other: "Այլ",
          },
        },
        levels: {
          title: "Լևելներ և XP",
          subtitle: "Ամեն հաշիվ բարձրանում է լևելներով՝ կախված հարթակին մասնակցությունից։ Այս էջը բացատրում է ընդհանուր տրամաբանությունը, ոչ թե ճշգրիտ թվերը։",
          nextLevel: "Ընթացքի մեջ ես դեպի {{level}} լևել",
          maxLevelReached: "Դու հասել ես ամենաբարձր լևելին 🏆",
          howTitle: "Ինչպես ես ստանում XP",
          howSub: "Գրեթե ամեն ինչ, ինչ անում ես հարթակում ու օգնում ես ուրիշներին կամ առաջ ես գնում, հաշվվում է քո լևելի մեջ։",
          categories: {
            apply: { title: "Դիմում և ընդունում", desc: "Հարթակի միջոցով ծրագրերին դիմելը և ընդունվելը։" },
            attend: { title: "Մասնակցություն", desc: "Փաստացի մասնակցությունը ծրագրերին ու իրադարձություններին, որոնց գրանցվել ես։" },
            community: { title: "Համայնքներ", desc: "Համայնք ստեղծելը կամ ուրիշի ստեղծած համայնքին միանալը։" },
            voice: { title: "Կիսվիր քո ձայնով", desc: "Փոստեր հրապարակելը և իրական արձագանք ստանալը ուրիշներից։" },
            mentorship: { title: "Մենթորություն", desc: "Buddy մենթոր կամ mentee լինելը՝ մինչև վերջ հասցնելով։" },
            trust: { title: "Վստահություն և պրոֆիլ", desc: "Հաշիվը հաստատելը, պրոֆիլը լրացնելը, CV-ի ավելացումը։" },
            reviews: { title: "Կարծիքներ", desc: "Ազնիվ արձագանք թողնելը ծրագրի ավարտից հետո։" },
            streak: { title: "Կայունություն", desc: "Կանոնավոր վերադարձը, ամեն օր ակտիվ լինելը կարևոր է։" },
            tasks: { title: "Առաջադրանքներ", desc: "Ժամանակ առ ժամանակ թիմի կողմից դրված առաջադրանքների կատարումը։" },
            referrals: { title: "Հրավերներ", desc: "Ընկերներին հարթակ բերելը։" },
          },
          certTitle: "Սերտիֆիկատներ և XP",
          certSub: "Ծրագրերը, որոնք տալիս են greencoin, նաև տալիս են XP և սերտիֆիկատ, երբ դու իրականում մասնակցում ես և ավարտում ես դրանք։",
          certSteps: {
            participate: { title: "Մասնակցիր միջոցառմանը", desc: "Գրանցվիր և իրականում ներկա եղիր։ Կազմակերպիչները նշում են ներկայությունը ծրագրի ավարտից հետո։" },
            certificate: { title: "Ստացիր XP + սերտիֆիկատ", desc: "Ավարտված ծրագրերը ավելացնում են XP քո լևելի համար, և իրավասու ծրագրերը տալիս են սերտիֆիկատ քո հաշվին։" },
            bio: { title: "Ցույց տուր քո պրոֆիլում", desc: "Քո սերտիֆիկատները գտնվում են քո պրոֆիլում՝ դասավորված ըստ կարևորության և ստացման ժամանակի։" },
          },
          tiersTitle: "Աստիճաններ",
          tiersSub: "Լևելի աճին զուգահեռ քո բեյջը անցնում է հինգ աստիճանով։",
          tierNames: { bronze: "Բրոնզ", silver: "Արծաթ", gold: "Ոսկի", diamond: "Ադամանդ", legend: "Լեգենդ" },
          tierDescs: {
            bronze: "Բոլորը սկսում են այստեղից։",
            silver: "Կայուն, ակտիվ անդամներ։",
            gold: "Լրջորեն ներգրավված օգտատերեր։",
            diamond: "Երկարաժամկետ ներդրում ունեցողներ։",
            legend: "Հարթակի ամենանվիրված անդամները։",
          },
          youAreHere: "Դու այստեղ ես",
          greencoins: "greencoin",
          tasksLink: "Առաջադրանքներ",
          back: "Հետ",
        },
        tasks: {
          title: "Առաջադրանքներ",
          subtitle: "Արագ քայլեր, որոնցով ստանում եք լրացուցիչ XP և greencoin: Ոմանք կրկնվում են օրական կամ ամսական։",
          loading: "Բեռնվում են առաջադրանքները...",
          empty: "Առաջադրանքներ հիմա չկան, ստուգեք ավելի ուշ։",
          frequencyOnce: "Մեկանգամյա",
          frequencyDaily: "Օրական",
          frequencyMonthly: "Ամսական",
          xpAmount: "{{amount}} XP",
          completeBtn: "Կատարել",
          doneBtn: "Կատարված է",
          savingEllipsis: "Պահպանվում է...",
          completed: "+{{xp}} XP!",
          completedWithCoins: "+{{xp}} XP, +{{coins}} greencoin!",
          completeFailed: "Չհաջողվեց կատարել առաջադրանքը: Փորձեք նորից։",
          back: "Հետ",
        },
        pro: {
          title: "Greenwich Pro",
          subtitle: "Վճարովի փաթեթ նրանց համար, ովքեր ուզում են ավելի շատ վերահսկողություն իրենց պրոֆիլի և հաջորդ հնարավորության որոնման վրա։",
          plans: { "1m": "1 ամիս", "3m": "3 ամիս", "6m": "6 ամիս" },
          bestValue: "Լավագույն արժեք",
          perMonth: "{{price}} ֏ / ամիս",
          totalBilled: "Ընդամենը {{total}} ֏ {{months}} ամսվա համար",
          perksTitle: "Ինչ է տալիս Pro-ն",
          perks: {
            design: { title: "Անհատականացված պրոֆիլի դիզայն", desc: "Հարմարեցրու քո պրոֆիլը սեփական տեսքով։" },
            frame: { title: "Անհատականացված ավատարի շրջանակ", desc: "Առանձնացիր էքսկլյուզիվ շրջանակով քո լուսանկարի շուրջ։" },
            views: { title: "Տես, ով է դիտել քո պրոֆիլը", desc: "Թե՛ առանձին օգտատերեր, թե՛ կազմակերպություններ, ամսաթվերով՝ բաժանորդագրության ողջ ընթացքում։" },
            matches: { title: "Ամենահամապատասխան նախագծերը՝ ուղիղ քեզ մոտ", desc: "Ստացիր քո լավագույն համապատասխանությունները էլ. փոստով, Telegram բոտով կամ ուղիղ հարթակում՝ ընտրելով ալիքը։" },
            shop: { title: "Էքսկլյուզիվ greencoin պարգևներ", desc: "Ծախսիր քո greencoin-ները էքսկլյուզիվ իրերի վրա, ոչ միայն սովորականների։" },
            early: { title: "Վաղ հասանելիություն", desc: "Տես նոր հրապարակված հնարավորությունները 6 ժամ առաջ՝ մինչև մյուսները։" },
          },
          statusActive: "Քո Pro-ն ակտիվ է մինչև {{date}}",
          statusNone: "Դու դեռ Pro չունես",
          paymentComingSoon: "Օնլայն վճարումը հենց հիմա կարգավորվում է, Pro-ի գնումը կայքում դեռ հասանելի չէ։",
          choosePlan: "Ընտրիր փաթեթ, ապա վճարիր բանկային փոխանցումով",
          payTitle: "Վճարում բանկային փոխանցումով",
          payBank: "Բանկ",
          payAccount: "Հաշվեհամար",
          payRecipient: "Ստացող",
          payReference: "Վճարման նպատակ",
          payReferenceHint: "Նշիր ճշգրիտ, որպեսզի կարողանանք կապել փոխանցումը քո հաշվի հետ։",
          submitPayment: "Վճարել",
          signInToPay: "Մուտք գործիր՝ գնելու համար",
          submitting: "Ուղարկվում է...",
          submitSuccess: "Շնորհակալություն! Կստուգենք փոխանցումը և կակտիվացնենք Pro-ն 24 ժամվա ընթացքում։",
          pendingNote: "Քո {{plan}} հայտն սպասման մեջ է։ Ստուգում ենք փոխանցումը և շուտով կակտիվացնենք Pro-ն։",
          interestTitle: "Մեկ պահ",
          interestBody: "Մենք ավարտին ենք հասցնում Pro-ի օնլայն վճարումը։ Սեղմիր ներքևում, և կիմացնենք էլ. փոստով, հենց պատրաստ լինի։",
          interestSubmit: "Ինձ իմացնել",
          interestDoneTitle: "Շնորհակալություն!",
          interestDoneBody: "Գրանցեցինք քո հետաքրքրությունը և կգրենք էլ. փոստով, հենց Pro-ի գնումը հասանելի դառնա։",
          interestClose: "Փակել",
          payWithCard: "Վճարել քարտով",
          redirectingToBank: "Վերահասցեավորում ենք բանկ...",
          cardPaymentSuccess: "Վճարումը հաջողվեց, Pro-ն այժմ ակտիվ է։",
          cardPaymentFailed: "Վճարումը չհաջողվեց։ Կարող ես փորձել կրկին։",
          cardPaymentError: "Վճարման ժամանակ խնդիր առաջացավ։ Փորձիր կրկին։",
          extendPrompt: "Դու արդեն ունես Pro։",
          extendLink: "Ուզո՞ւմ ես այլ փաթեթ։ Գնել նորից",
          historyTitle: "Գնումների պատմություն",
          historyEmpty: "Գնումներ դեռ չկան։",
          historyReceipt: "Անդորրագիր",
          receiptTitle: "Վճարման անդորրագիր",
          receiptOrder: "Պատվեր",
          receiptDate: "Ամսաթիվ",
          receiptPlan: "Փաթեթ",
          receiptAmount: "Գումար",
          receiptCard: "Քարտ",
          receiptApproval: "Հաստատման կոդ",
          receiptClose: "Փակել",
          receiptPrint: "Տպել / Պահպանել որպես PDF",
          back: "Հետ",
        },
        paymentConfirmation: {
          titleSuccess: "Վճարումը հաջողվեց",
          titleFailed: "Վճարումը ձախողվեց",
          titlePending: "Ստուգում ենք վճարումը...",
          subtitleSuccess: "Ձեր գնումը հաստատված է և ակտիվ է ձեր հաշվում։",
          subtitleFailed: "Բանկը չկարողացավ ավարտել վճարումը։ Գումար չի գանձվել։",
          subtitlePending: "Մի պահ... սա տևում է մի քանի վայրկյան։",
          viewReceipt: "Տեսնել անդորրագրի մանրամասները",
          hideReceipt: "Թաքցնել մանրամասները",
          downloadReceipt: "Ներբեռնել անդորրագիրը",
          continuePro: "Անցնել Pro-ին",
          backToFeed: "Վերադառնալ ֆիդ",
          tryAgain: "Փորձել կրկին",
          refundNote: "Մտափոխվե՞լ եք։ Կարող եք վերադարձ պահանջել 7 օրվա ընթացքում՝",
          refundNoteLink: "Կարգավորումներ → Pro → Վճարումներ",
          notFound: "Չհաջողվեց գտնել այս վճարումը։",
        },
        shop: {
          title: "Greencoin խանութ",
          subtitle: "Ծախսիր հարթակում վաստակած greencoin-ները իրական պարգևների վրա։",
          greencoins: "greencoin",
          loading: "Բեռնվում է...",
          empty: "Այստեղ դեռ ոչինչ չկա, ստուգիր ավելի ուշ։",
          everydayTitle: "Առօրյա պարգևներ",
          exclusiveTitle: "Էքսկլյուզիվ պարգևներ",
          exclusiveSub: "Հասանելի է միայն Pro անդամներին։",
          exclusive: "Pro",
          proOnly: "Միայն Pro",
          redeem: "Ստանալ",
          confirmRedeem: "Ստանալ «{{name}}»-ը {{cost}} greencoin-ով?",
          redeemSuccess: "«{{name}}»-ը ստացվեց! Մեր թիմը կկապվի առաքման վերաբերյալ։",
          redeemError: "Չհաջողվեց ստանալ այս իրը։ Փորձիր կրկին։",
          cancel: "Չեղարկել",
          redeeming: "Ստացվում է...",
          redeemSuccessTitle: "Ստացվեց!",
          qrHint: "Ցույց տուր այս QR կոդը ստանալու վայրում։",
          codeHint: "Ցույց տուր կամ մուտքագրիր այս կոդը ստանալու վայրում։",
          done: "Պատրաստ է",
          myPurchases: "Իմ գնումները",
          myPurchasesSub: "Այն ամենը, ինչ ստացել ես, քո ստացման կոդերով։",
          noPurchases: "Դու դեռ ոչինչ չես ստացել։",
          showCode: "Ցույց տալ կոդը",
          hideCode: "Թաքցնել կոդը",
          back: "Հետ",
        },
        donate: {
          heroTitle: "Աջակցեք հայ երիտասարդությանը",
          heroSub: "Միացեք մեր աջակիցների համայնքին և օգնեք ստեղծել հնարավորություններ հայ երիտասարդ առաջնորդների հաջորդ սերնդի համար։",
          missionTitle: "Մեր առաքելությունը",
          missionSub: "Կրթության միջոցով հզորացնել հայ երիտասարդությանը",
          quote: "«Մեր առաքելությանը աջակցելով՝ դուք ներդրում եք անում հայ երիտասարդության ապագայում։»",
          quoteBody: "Ձեր ներդրումը օգնում է մեզ ստեղծել կրթական ծրագրեր, ապահովել ուղեկցում և բացել նոր աճի հնարավորություններ։ Յուրաքանչյուր նվիրաբերություն մեզ մոտեցնում է այդ տեսլականին։",
          statYouth: "Ազդեցություն երիտասարդների վրա",
          statSuccess: "Ծրագրի հաջողություն",
          statPrograms: "Ստեղծված ծրագրեր",
          chooseTier: "Ընտրեք աջակցության մակարդակը",
          chooseTierSub: "Ընտրեք ամսական աջակցություն կամ մուտքագրեք գումար",
          popular: "Թեժ",
          perMonth: "ամսական",
          customAmount: "Կամ մուտքագրեք գումարը",
          minUsd: "Նվազագույնը ${{amount}} ({{amd}} դրամ)",
          thankYou: "Շնորհակալություն։ 🎉",
          thankBody: "Ձեր ${{amount}} ամսական աջակցությունը ակտիվ է։ Հաստատումը ուղարկվել է {{email}}։",
          whatNext: "Ինչ է լինում հաջորդը՝",
          next1: "Բարի գալուստի նամակ՝ 24 ժամվա ընթացքում",
          next2: "Ամսական կտրոն՝ ձեր էլ․ փոստին",
          next3: "Աջակցի առավելությունները սկսում են անմիջապես",
          makeAnother: "Կատարել ևս մեկ նվիրաբերություն",
          supportLevel: "Աջակցության մակարդակ՝",
          custom: "Անհատական",
          quickAmount: "Արագ գումար՝",
          monthly: "Ամսական՝",
          recurringNote: "Կրկնվող ամսական նվիրաբերություն",
          cancelAnytime: "Չեղարկել կամ փոխել ցանկացած ժամանակ",
          yourInfo: "Ձեր տվյալները",
          fullName: "Ամբողջական անուն",
          emailReq: "Էլ․ հասցե *",
          paymentMethod: "Վճարման եղանակ",
          bmcTitle: "Buy Me a Coffee",
          bmcSub: "Պարզ, մեկանգամյա կամ ամսական աջակցություն",
          processing: "Մշակվում է...",
          continueBmc: "Շարունակել Buy Me a Coffee",
          redirectTitle: "Բացվում է անվտանգ վճարման էջը...",
          redirectBody: "Buy Me a Coffee-ն բացվեց նոր ներդիրում՝ ձեր ${{amount}} նվիրաբերությունն ավարտելու համար։ Խնդրում ենք ավարտել վճարումն այնտեղ։ Այս էջը հնարավորություն չունի իմանալու, երբ այն ավարտվի։",
          reopenPayment: "Կրկին բացել վճարման էջը",
          backToForm: "Վերադառնալ ձևին",
          secureNote: "Ապահով և գաղտնագրված վճարում",
          termsAgree: "Շարունակելով՝ դուք համաձայնում եք մեր",
          terms: "Պայմաններին",
          and: "և",
          privacyPolicy: "Գաղտնիության քաղաքականությանը",
          whyMonthly: "Ինչու ամսական աջակցություն՞",
          whyItems: [
            ["Կայուն ազդեցություն", "Երկարաժամկետ ծրագրերի պլանավորում"],
            ["Կանխատեսելի ֆինանսավորում", "Ավելի շատ երիտասարդների սպասարկում"],
            ["Ճկուն", "Փոխել կամ չեղարկել ցանկացած ժամանակ"],
            ["Հարկային նպաստներ", "Ամսական կտրոններ հաշվետվության համար"],
          ],
          alertMin: "Խնդրում ենք մուտքագրել առնվազն ${{min}}",
          alertEmail: "Խնդրում ենք մուտքագրել էլ․ հասցեն։",
          alertPayment: "Խնդրում ենք ընտրել վճարման եղանակը։",
          alertCardLogin: "Քարտով նվիրատվության համար խնդրում ենք մուտք գործել։",
          alertCardError: "Վճարման ժամանակ խնդիր առաջացավ։ Փորձիր կրկին։",
          bmcToast: "☕ Ընտրվել է Buy Me a Coffee",
          cardTitle: "Վճարել քարտով",
          cardSub: "Ակնթարթային միանվագ նվիրատվություն դրամով",
          continueCard: "Նվիրաբերել քարտով",
          redirectingToBank: "Վերահասցեավորում ենք բանկ...",
          cardPaymentSuccess: "Շնորհակալություն, ձեր նվիրատվությունն ընդունվեց!",
          cardPaymentFailed: "Վճարումը ձախողվեց։ Կարող եք փորձել կրկին։",
          cardPaymentError: "Վճարման ժամանակ խնդիր առաջացավ։ Փորձիր կրկին։",
          tier1n: "Աջակից", tier1d: "Հիմնական աջակցություն մեր առաքելությանը", tier1p0: "Շնորհակալության նամակ", tier1p1: "Ամսական տեղեկագիր",
          tier2n: "Ընկեր", tier2d: "Օգնել ֆինանսավորել ուսումնական նյութերը", tier2p0: "Բոլոր նախորդ առավելությունները", tier2p1: "Թվային վկայական", tier2p2: "Անուն աջակիցների ցանկում",
          tier3n: "Չեմպիոն", tier3d: "Հովանավորել երիտասարդական ծրագիր", tier3p0: "Բոլոր նախորդ առավելությունները", tier3p1: "Բացառիկ թարմացումներ", tier3p2: "Թվային նշան",
          tier4n: "Առաջնորդ", tier4d: "Նշանակալի ազդեցություն", tier4p0: "Բոլոր նախորդ առավելությունները", tier4p1: "Շնորհակալության տեսանյութ", tier4p2: "Ճանաչում կայքում",
        },
        contact: {
          badge: "Մենք այստեղ ենք օգնելու",
          title: "Կապվեք մեզ հետ",
          subtitle: "Կապվեք մեր թիմի հետ՝ իմանալու հնարավորությունների, գործընկերությունների կամ մասնակցության մասին։",
          email: "Էլ․ փոստ",
          phone: "Հեռախոս",
          followJourney: "Հետևեք մեր ճանապարհին",
          quickAskTitle: "Արագ պատասխան է պետք",
          quickAskSubtitle: "Հարցրու մեր AI օգնականին՝ ներքևի ձևի պատասխանին սպասելու փոխարեն։",
          faqTitle: "Հաճախ տրվող հարցեր",
          tabGeneral: "Ընդհանուր",
          tabPrograms: "Ծրագրեր",
          tabPartnerships: "Գործընկերություններ",
          sendMessage: "Ուղարկել հաղորդագրություն",
          replyWithin: "Պատասխան կտանք 24 ժամվա ընթացքում",
          sentTitle: "Հաղորդագրությունը ուղարկվեց։ 🎉",
          sentBody: "Շնորհակալություն Greenwich-ին դիմելու համար։ Մեր թիմը շուտով կպատասխանի։",
          sendError: "Հաղորդագրությունն ուղարկելիս սխալ առաջացավ։ Խնդրում ենք փորձել կրկին։",
          yourName: "Ձեր անունը",
          emailPlaceholder: "Էլ․ հասցե",
          messagePlaceholder: "Ձեր հաղորդագրությունը...",
          sending: "Ուղարկվում է...",
          sendBtn: "Ուղարկել",
          responseTime: "Պատասխանի ժամանակ՝ մինչև 24 ժամ",
          ctaTitle: "Պատրա՞ստ եք սկսել ձեր ճանապարհը",
          ctaSub: "Միացեք հազարավոր հայ երիտասարդների, ովքեր Greenwich-ի միջոցով գտել են իրենց ուղին։",
          browseOpps: "Դիտել հնարավորությունները",
          learnMore: "Իմանալ ավելին մեր մասին",
          faqG1q: "Ի՞նչ է Greenwich-ը։", faqG1a: "Greenwich-ը թվային հարթակ է, որը կապում է հայ երիտասարդությանը համաշխարհային հնարավորությունների հետ՝ կրթություն, փոխանակումներ և կարիերա։",
          faqG2q: "Ով կարող է օգտագործել Greenwich-ը՞", faqG2a: "14-35 տարեկան հայ երիտասարդներ, ուսանողներ, մասնագետներ և բոլորը, ովքեր փնտրում են միջազգային հնարավորություններ։",
          faqP1q: "Ինչպիսի՞ ծրագրեր եք առաջարկում։", faqP1a: "Մենք առաջարկում ենք փոխանակման ծրագրեր, կրթաթոշակներ, թարմացումներ, կամավորություն և մշակութային փոխանակումներ։",
          faqP2q: "Ինչպե՞ս դիմել ծրագրերին։", faqP2a: "Ստեղծեք հաշիվ, ուսումնասիրեք հնարավորությունները և ուղարկեք դիմումները մեր համակարգով։",
          faqPr1q: "Իմ կազմակերպությունը կարո՞ղ է գործընկեր լինել։", faqPr1a: "Այո։ Մենք բարի երևույթ ենք համարում գործընկերություն կրթական հաստատությունների, ՀԿ-ների և ընկերությունների հետ։",
          faqPr2q: "Ի՞նչ են գործընկերության առավելությունները։", faqPr2a: "Գործընկերները մուտք են ստանում տաղանդների շրջանակ, համատեղ միջոցառումներ և տեսանելիություն ցանցում։",
        },
        whoWeAre: {
          heroLabel: "Հիմնված 2025 · Հայաստան",
          heroTitle1: "Կապել երիտասարդությանը",
          heroTitle2: "աշխարհի հետ",
          heroBody: "Greenwich-ը կապում է հայ երիտասարդությանը (14-35) տեղական և համաշխարհային հնարավորությունների հետ՝ կրթաթոշակներից մինչև կամավորություն և մշակութային ծրագրեր։",
          seeMore: "Տեսնել ավելին →",
          sectionLabel: "Մեր մասին",
          overviewTitle1: "Հարթակ, որը կառուցված է",
          overviewTitle2: "երիտասարդների համար",
          overviewP1: "Greenwich.am-ը թվային հարթակ է, որը կապում է երիտասարդներին կրթական, սոցիալական և մասնագիտական հնարավորությունների հետ ամբողջ աշխարհում։ Հիմնվելով Հայաստանում 2025-ի սկզբին, այն սկսել է Telegram-ալիքից և արագ զարգացել վեբ հարթակի, որը միավորում է երիտասարդներին և կազմակերպություններին մեկ վստահելի էկոհամակարգում։",
          overviewP2: "Greenwich-ը օգնում է գտնել հաստատված նախագծեր, կառուցել թվային պորտֆել և մուտք գործել համաշխարհային հնարավորություններ մեկ տեղում։",
          statAge: "Թիրախային տարիք",
          statYear: "Հիմնման տարի",
          statOpp: "Հայտարարված հնարավորություններ",
          whyLabel: "Ինչու Greenwich՞",
          whyTitle1: "Բոլոր հնարավորությունները,",
          whyTitle2: "մեկ վստահելի տեղում",
          whyBody: "Հնարավորություններ գտնելը դժվար կարող է լինել՝ դրանք ցրված են կայքերում և սոցիալական ցանցերում։ Greenwich-ը միավորում է ամեն ինչ մեկ տեղում։",
          regionAmerica: "Ամերիկա", regionAsia: "Ասիա", regionEurope: "Եվրոպա",
          quote: "«Մենք ձգտում ենք կառուցել վստահելի թվային էկոհամակարգ, որը կապում է երիտասարդներին և կազմակերպությունները, տեսանելի է դարձնում մասնակցությունը։»",
          visionLabel: "Տեսլական",
          visionTitle1: "Մեր",
          visionTitle2: "տեսլականը",
          visionTitle3: "համաշխարհային",
          visionTitle4: "երիտասարդության համար",
          visionBody: "Մեր տեսլականը միասնական համաշխարհային հարթակ ստեղծելն է, որտեղ յուրաքանչյուր երիտասարդ հավասար մուտք ունի հնարավորություններին՝ անկախ տեղից։",
          missionLabel: "Առաքելություն",
          missionTitle1: "Կրթել երիտասարդությանը",
          missionTitle2: "տեխնոլոգիայի միջոցով",
          missionBody1: "Մեր առաքելությունն է դարձնել համաշխարհային հնարավորությունները մատչելի, կառուցված և թափանցիկ երիտասարդների համար։",
          missionBody2: "Տեխնոլոգիայի և համայնքի միջոցով մենք օգնում ենք երիտասարդներին բացահայտել իրենց ներուժը։",
          sdgLabel: "Կայունություն",
          sdgTitle1: "Խթանել",
          sdgTitle2: "Կայուն զարգացման նպատակները",
          sdgBody: "Greenwich.am-ը նվիրված է ՄԱԿ-ի կայուն զարգացման նպատակներին՝ հզորացնելով երիտասարդների մասնակցությունը։",
          sdgChip1: "Որակյալ կրթություն", sdgChip2: "Արժանապատիվ աշխատանք", sdgChip3: "Նվազեցնել անհավասարությունները", sdgChip4: "Կլիմայի գործողություն", sdgChip5: "Ուժեղ հաստատություններ",
          ctaTitle1: "Պատրա՞ստ եք բացահայտել",
          ctaTitle2: "ձեր հնարավորությունը՞",
          ctaSub: "Միացեք հազարավոր երիտասարդ հայերի, ովքեր արդեն աճում են Greenwich-ի հետ։",
          getStarted: "Սկսել →",
        },
        notifications: {
          title: "Ծանուցումներ",
          newBadge: "{{count}} նոր",
          markAllRead: "Նշել բոլորը որպես կարդացված",
          total: "Ընդամենը",
          unread: "Չկարդացված",
          likes: "Հավանումներ",
          follows: "Հետևորդներ",
          filter: "Ֆիլտր՝",
          all: "Բոլորը",
          unreadTab: "Չկարդացված",
          readTab: "Կարդացված",
          allTypes: "Բոլոր տեսակները",
          comments: "Մեկնաբանություններ",
          noneTitle: "Ծանուցումներ չեն գտնվել",
          noneUnread: "Չկարդացված ծանուցումներ չկան։",
          noneDefault: "Երբ ստանաք ծանուցումներ, դրանք կհայտնվեն այստեղ։",
          showAll: "Ցույց տալ բոլոր ծանուցումները",
          today: "Այսօր",
          yesterday: "Երեկ",
          markRead: "Կարդացած",
          deleteTitle: "Ջնջել ծանուցումը",
          deleting: "Ջնջվում է...",
          footer: "Ցուցադրվում է {{shown}}-ը {{total}} ծանուցումից",
          someone: "Ինչ-որ մեկը",
          msgLike: "{{name}}-ը հավանեց ձեր գրառումը",
          msgComment: "{{name}}-ը մեկնաբանեց ձեր գրառումը",
          msgFollow: "{{name}}-ը սկսեց հետևել ձեզ",
          msgFollowReq: "{{name}}-ը ուզում է հետևել ձեզ",
          msgMessage: "{{name}}-ը հաղորդագրություն ուղարկեց",
          msgVerify: "Ձեր կազմակերպությունը հաստատված է։",
          msgMention: "{{name}}-ը նշեց ձեզ գրառման մեջ",
          msgNew: "Նոր ծանուցում",
          justNow: "Հենց հիմա",
          timeAgo: "{{n}} ր առաջ",
          hourAgo: "{{n}} ժ առաջ",
          dayAgo: "{{n}} օր առաջ",
        },
        search: {
          likes: "Հավանումներ",
          comments: "Մեկնաբանություններ",
          tabAll: "Բոլորը",
          tabUsers: "Օգտատերեր",
          tabOrganizations: "Կազմակերպություններ",
          tabProjects: "Նախագծեր",
          tabHashtags: "Հեշթեգեր",
          tabCommunities: "Համայնքներ",
          tabPosts: "Գրառումներ",
          heroTitle: "Փնտրել Greenwich-ում",
          heroSubtitle: "Բացահայտեք մարդկանց, կազմակերպություններին, համայնքներին և բովանդակությունը հարթակում",
          searchPlaceholder: "Փնտրեք օգտատերերի, կազմակերպությունների, համայնքների, գրառումների...",
          filtersBtn: "Զտիչներ",
          sortBy: "Դասավորել ըստ՝",
          sortRelevance: "Համապատասխանության",
          sortNewest: "Նորագույն",
          sortPopular: "Ամենահայտնի",
          sortName: "Անվան (Ա-Ֆ)",
          dateRange: "Ժամանակահատված՝",
          dateAll: "Ամբողջ ժամանակ",
          dateToday: "Այսօր",
          dateWeek: "Այս շաբաթ",
          dateMonth: "Այս ամիս",
          locationLabel: "Վայր՝",
          locationPlaceholder: "Մուտքագրեք վայրը",
          verifiedOnly: "Միայն հաստատված",
          clearFilters: "Մաքրել զտիչները",
          searchingFor: "Փնտրում ենք «{{term}}»...",
          emptyTitle: "Փնտրեք Greenwich հարթակում",
          emptyDescription: "Գտեք մարդկանց, կազմակերպություններին, գրառումներ և համայնքներ հարթակում",
          browseCategory: "Դիտել {{category}}",
          trendingHeading: "Հայտնի որոնումներ",
          trendingTerms: [
            "Կրթություն", "Erasmus", "Աշխատանք", "Միջազգային", "երիտասարդականծրագրեր",
            "ամառայինաշխատանք", "կրթաթոշակիորոնում", "gap year", "Համայնք", "Կազմակերպություն",
            "Միջոցառում", "Ուսում արտերկրում", "Լրիվ կրթաթոշակներ", "Ֆելոուշիփ", "Դրամաշնորհներ",
          ],
          resultsHeading: "Արդյունքներ",
          pageOf: "Էջ {{current}}-ը {{total}}-ից",
          noResultsFor: "«{{term}}» հարցման համար արդյունքներ չեն գտնվել",
          noResultsHint: "Փորձեք փոփոխել որոնման բառերը կամ զտիչները",
          previous: "Նախորդ",
          next: "Հաջորդ",
          pillUser: "Օգտատեր",
          pillOrg: "Կազմ.",
          pillProgram: "Նախագիծ",
          pillOrganizationFull: "Կազմակերպություն",
          pillCommunity: "Համայնք",
          pillPost: "Գրառում",
          metaFollowers: "հետևորդ",
          metaPosts: "գրառում",
          metaMembers: "անդամ",
          btnFollowing: "Հետևում եք",
          btnRequested: "Հարցումն ուղարկված է",
          btnFollow: "Հետևել",
          viewCommunity: "Դիտել համայնքը",
          viewPost: "Դիտել գրառումը",
          viewOrg: "Դիտել կազմակերպությունը",
          viewProgram: "Դիտել նախագիծը",
          untitledProgram: "Անանուն նախագիծ",
          viewProfile: "Դիտել պրոֆիլը",
          viewShort: "Դիտել",
          statFollowers: "Հետևորդներ",
          statPosts: "Գրառումներ",
          statMembers: "Անդամներ",
          unknown: "Անհայտ",
          unknownUser: "Անհայտ օգտատեր",
          today: "Այսօր",
          yesterday: "Երեկ",
        },
        dashboard: {
          pleaseLoginSave: "Պահպանելու համար մուտք գործեք",
          saveFailed: "Չհաջողվեց պահպանել",
          saveError: "Պահպանելիս սխալ։",
          imageTooBig: "Նկարի չափը պետք է լինի 5 ՄԲ-ից փոքր",
          imageTypes: "Թույլատրվում են միայն JPEG, PNG և GIF",
          coverFailed: "Կազմի նկարը թարմացնել չհաջողվեց",
          coverError: "Կազմի նկարը թարմացնելիս սխալ",
          avatarFailed: "Պրոֆիլի նկարը թարմացնել չհաջողվեց",
          avatarError: "Պրոֆիլի նկարը թարմացնելիս սխալ",
          loginUpload: "Վերբեռնելու համար մուտք գործեք",
          uploadFailed: "Վերբեռնումը ձախողվեց",
          uploadError: "Վերբեռնելիս սխալ",
          deleteFileFailed: "Ֆայլը ջնջել չհաջողվեց",
          deleteFileError: "Ֆայլը ջնջելիս սխալ",
          navAbout: "Իմ մասին",
          navPosts: "Գրառումներ",
          navReports: "Հաշվետվություններ",
          navPortfolio: "Պորտֆոլիո",
          navCertificates: "Վկայականներ",
          navApplications: "Իմ դիմումները",
          editProfileBtn: "Խմբագրել պրոֆիլը",
          tabAbout: "Իմ մասին",
          tabPosts: "Գրառումներ",
          tabReports: "Հաշվետվություններ և լիցենզիաներ",
          tabPortfolio: "Պորտֆոլիո",
          tabCertificates: "Վկայականներ",
          tabApplications: "Իմ դիմումները",
          firstName: "Անուն *",
          firstNamePh: "Անուն",
          lastName: "Ազգանուն",
          titlePosition: "Պաշտոն / Դիրք",
          titlePh: "Ավագ պրոդուկտի մենեջեր",
          emailLabel: "Էլ. փոստ *",
          emailPh: "example@email.com",
          invalidEmail: "Խնդրում ենք մուտքագրել վավեր էլ. փոստի հասցե",
          phoneLabel: "Հեռախոս",
          phonePh: "+1234567890",
          locationLabel: "Տեղակայություն",
          locationPh: "Մուտքագրեք տեղակայությունը",
          websiteLabel: "Կայք",
          websitePh: "https://example.com",
          bioLabel: "Կենսագրություն",
          bioPh: "Պատմեք մեզ ձեր մասին...",
          interestsLabel: "Հետաքրքրություններ",
          addInterestPh: "Ավելացնել հետաքրքրություն (Enter)",
          addBtn: "Ավելացնել",
          maxInterests: "Ընտրված է {{count}}/5 — օգտագործվում է ձեզ ծրագրեր առաջարկելու համար",
          saveChanges: "Պահպանել փոփոխությունները",
          saving: "Պահպանվում է...",
          cancel: "Չեղարկել",
          noBio: "Կենսագրություն դեռ չկա:",
          nameLabel: "Անուն",
          emailInfoLabel: "Էլ. փոստ",
          phoneInfoLabel: "Հեռախոս",
          locationInfoLabel: "Տեղակայություն",
          websiteInfoLabel: "Կայք",
          interestsHeader: "Հետաքրքրություններ",
          whatsOnMind: "Ինչի՞ մասին եք մտածում",
          photosBtn: "Լուսանկարներ",
          postBtn: "Հրապարակել",
          loadingPosts: "Գրառումները բեռնվում են...",
          noPostsYet: "Գրառումներ դեռ չկան",
          noCommentsYet: "Մեկնաբանություններ դեռ չկան",
          writeReplyPh: "Գրեք պատասխան...",
          writeCommentPh: "Գրեք մեկնաբանություն...",
          postFeedbackEmpty: "Խնդրում ենք ավելացնել բովանդակություն կամ նկար:",
          postFeedbackLoginRequired: "Հրապարակելու համար մուտք գործեք:",
          postCreateFailed: "Գրառումը ստեղծել չհաջողվեց",
          postCreateError: "Գրառում ստեղծելիս սխալ:",
          postCreated: "Գրառումը հաջողությամբ ստեղծվեց:",
          linkCopied: "Հղումը պատճենվեց",
          maxImages: "Կարող եք վերբեռնել առավելագույնը 10 նկար",
          imageTooLarge: "{{name}} նկարը չափազանց մեծ է",
          notAnImage: "{{name}}-ը նկար չէ",
          uploadedDocuments: "Վերբեռնված փաստաթղթեր",
          portfolioItems: "Պորտֆոլիոյի նյութեր",
          uploadFileBtn: "Վերբեռնել ֆայլ",
          addItemBtn: "Ավելացնել նյութ",
          previewBtn: "Նախադիտում",
          downloadBtn: "Ներբեռնել",
          openBtn: "Բացել",
          deleteBtn: "Ջնջել",
          confirmDeleteFile: "Վստա՞հ եք, որ ցանկանում եք ջնջել այս ֆայլը:",
          myCertificates: "Իմ վկայականները",
          addCertificateBtn: "Ավելացնել վկայական",
          certTitlePh: "Վկայականի վերնագիր *",
          certIssuerPh: "Տրամադրող կազմակերպություն",
          certDatePh: "Տրման ամսաթիվ (օր. 2026-01-15)",
          certLocationPh: "Վայրը (քաղաք, երկիր)",
          certRolePh: "Ձեր դերը / գործունեությունը",
          certDescPh: "Նկարագրություն (ընտրովի)",
          cvHeader: "ինքնակենսագրական (CV)",
          cvUploadBtn: "Վերբեռնել CV",
          cvReplaceBtn: "Փոխարինել CV-ն",
          cvUploadedNote: "Տեսանելի է կազմակերպիչներին, երբ դիմում եք ծրագրին:",
          cvEmptyNote: "Ավելացրեք ձեր CV-ն PDF ձևաչափով, որպեսզի կազմակերպիչները տեսնեն այն դիմելիս:",
          saveCertificate: "Պահպանել վկայականը",
          savingEllipsis: "Պահպանվում է…",
          noCertificatesYet: "Վկայականներ դեռ ավելացված չեն:",
          issuedByOrganizerFor: "Տրված է {{org}}-ի կողմից՝ {{program}} ծրագրի համար",
          issuedByOrganizer: "Տրված է {{org}}-ի կողմից",
          theOrganizer: "կազմակերպչի",
          viewPdf: "Դիտել PDF",
          confirmDeleteCertificate: "Ջնջե՞լ այս վկայականը:",
          certTitleRequired: "Վերնագիրը պարտադիր է:",
          certFileRequired: "Խնդրում ենք կցել վկայականը որպես PDF:",
          certFilePdfOnly: "Վկայականները պետք է վերբեռնվեն PDF ֆորմատով:",
          certAddFailed: "Վկայականն ավելացնել չհաջողվեց:",
          certDeleteFailed: "Վկայականը ջնջել չհաջողվեց:",
          programsAppliedTo: "Ծրագրեր, որոնց դիմել եմ",
          loadingApplications: "Դիմումները բեռնվում են…",
          noApplicationsYet: "Դուք դեռ չեք դիմել որևէ ծրագրի:",
          browsePrograms: "Դիտել ծրագրերը",
          appliedOn: "Դիմել է {{date}}",
          statusPending: "⏳ Սպասվում է պատասխան",
          statusAccepted: "✅ Ընդունված է",
          statusRejected: "❌ Չի ընդունվել",
          statusAttended: "🎓 Մասնակցությունը հաստատված է",
          certIssuedSeeTab: "Վկայականը տրված է, տե՛ս Վկայականներ ներդիրը",
          certPending: "Վկայականը սպասման մեջ է",
          viewSubmission: "Դիտել իմ դիմումը",
          programFallback: "Ծրագիր",
          statsPosts: "Գրառումներ",
          statsFollowers: "Հետևորդներ",
          statsFollowing: "Հետևում է",
          totalPostsLabel: "Ընդհանուր գրառումներ.",
          openPosts: "Բացել գրառումները",
          noUsersYet: "Դեռ ցուցադրելու օգտատերեր չկան:",
          unsavedTitle: "Չպահպանված փոփոխություններ",
          unsavedMessage: "Դուք ունեք չպահպանված փոփոխություններ: Ցանկանո՞ւմ եք պահպանել դրանք:",
          dontSave: "Չպահպանել",
          changeCoverPhoto: "Փոխել կազմի նկարը",
          coverLabel: "Կազմ",
          changeProfilePhoto: "Փոխել պրոֆիլի նկարը",
          reportAction: "Բողոքել",
          saveBtn: "Պահպանել",
        },
        messages: {
          justNow: "Հենց հիմա",
          errNoContent: "Խնդրում ենք գրել հաղորդագրություն կամ ընտրել նկար",
          errNoConversation: "Ակտիվ զրույց չկա",
          confirmDeleteMessage: "Ջնջե՞լ այս հաղորդագրությունը:",
          errDeleteMessage: "Հաղորդագրությունը ջնջել չհաջողվեց",
          errNoGroup: "Ակտիվ խումբ չկա",
          confirmDeleteConversation: "Ջնջե՞լ այս զրույցը:",
          conversationDeleted: "Զրույցը ջնջվեց",
          errDeleteConversation: "Զրույցը ջնջել չհաջողվեց",
          confirmLeaveGroup: "Լքե՞լ այս խումբը:",
          leftGroupSuccess: "Դուք հաջողությամբ լքեցիք խումբը",
          errLeaveGroup: "Խումբը լքել չհաջողվեց",
          joinedGroupSuccess: "Դուք հաջողությամբ միացաք խմբին!",
          errJoinGroup: "Խմբին միանալ չհաջողվեց",
          errFileTooLarge: "Ֆայլի չափը պետք է լինի 10ՄԲ-ից պակաս",
          errSelectImage: "Խնդրում ենք ընտրել նկարի ֆայլ",
          errSendMessage: "Հաղորդագրությունը ուղարկել չհաջողվեց",
          errCreateConversation: "Զրույցը ստեղծել չհաջողվեց",
          errStartConversation: "Զրույցը սկսել չհաջողվեց",
          emojiRecent: "Վերջին",
          emojiSmileys: "Ժպիտիկներ",
          emojiHearts: "Սրտեր",
          emojiHands: "Ձեռքեր",
          emojiAnimals: "Կենդանիներ",
          emojiFood: "Ուտելիք",
          emojiTravel: "Ճամփորդություն",
          emojiSymbols: "Նշաններ",
          emojiWeather: "Եղանակ",
          signInTitle: "Մուտք գործեք շարունակելու համար",
          signInSubtitle: "Դիտեք և ուղարկեք հաղորդագրություններ",
          logIn: "Մուտք",
          title: "Հաղորդագրություններ",
          newTooltip: "Նոր",
          tabDirect: "Անձնական",
          tabGroups: "Խմբեր",
          searchPlaceholder: "Որոնել...",
          loading: "Բեռնվում է...",
          noConversations: "Դեռ զրույցներ չկան",
          startChat: "Սկսել զրույց",
          unknown: "Անհայտ",
          sharedAPost: "📤 Կիսվել է գրառմամբ",
          noMessagesYet: "Դեռ հաղորդագրություններ չկան",
          noGroups: "Դեռ խմբեր չկան",
          browseGroups: "Դիտել խմբերը",
          tagPrivate: "Փակ",
          tagAdmin: "Ադմին",
          membersCount: "{{count}} անդամ",
          someoneTyping: "{{name}}-ը գրում է...",
          online: "Առցանց",
          offline: "Ցանցից դուրս",
          typing: "Գրում է...",
          viewProfileTooltip: "Դիտել պրոֆիլը",
          infoTooltip: "Տեղեկություններ",
          leaveGroupTooltip: "Լքել խումբը",
          loadingMessages: "Հաղորդագրությունները բեռնվում են...",
          beFirstToSayHello: "Առաջինը բարևե՛ք!",
          joinGroupToChat: "Միացեք խմբին զրուցելու համար",
          sharedPost: "Կիսված գրառում",
          tapToView: "Հպեք դիտելու համար →",
          deleteMessageTooltip: "Ջնջել հաղորդագրությունը",
          joinToSend: "Հաղորդագրություններ ուղարկելու համար միացեք այս խմբին",
          join: "Միանալ",
          attachTooltip: "Կցել",
          emojisTooltip: "Էմոջիներ",
          messagePlaceholder: "Հաղորդագրություն {{name}}-ին...",
          yourMessages: "Ձեր հաղորդագրությունները",
          yourGroups: "Ձեր խմբերը",
          selectConversation: "Ընտրեք զրույց կամ սկսեք նոր մեկը",
          selectGroup: "Ընտրեք խումբ զրուցելու համար",
          newConversation: "Նոր զրույց",
          newMessageTitle: "Նոր հաղորդագրություն",
          noUsersAvailable: "Հասանելի օգտատերեր չկան",
          mutualFollowersOnly: "Դուք կարող եք գրել միայն փոխադարձ հետևորդներին",
          conversationInfoTitle: "Զրույցի մասին",
          deleteConversation: "Ջնջել զրույցը",
          groupInfoTitle: "Խմբի մասին",
          membersCountDot: "{{count}} անդամ ·",
          public: "Բաց",
          leaveGroup: "Լքել խումբը",
          joinGroup: "Միանալ խմբին",
        },
        feed: {
          seeMore: "Տեսնել ավելին",
          seeLess: "Փակել",
          noPostsYet: "Դեռ գրառումներ չկան։ Եղեք առաջինը։",
          loadFailed: "Ժապավենը բեռնել չհաջողվեց։ Փորձեք ավելի ուշ։",
          justNow: "Հենց հիմա",
          minAgo: "{{n}} ր առաջ",
          hourAgo: "{{n}} ժ առաջ",
          dayAgo: "{{n}} օր առաջ",
          loginToLike: "Հավանելու համար մուտք գործեք",
          followRequestSent: "Հետևելու հարցումը ուղարկվեց։",
          failedFollowReq: "Հարցումը ուղարկել չհաջողվեց",
          replyPosted: "Պատասխանը հրապարակվեց։",
          commentAdded: "Մեկնաբանությունը ավելացվեց։",
          failedComment: "Մեկնաբանությունը ավելացնել չհաջողվեց։",
          failedLike: "Հավանել չհաջողվեց։",
          failedSave: "Պահպանել չհաջողվեց։",
        },
      },
      settings: {
        title: "Կարգավորումներ",
        subtitle: "Կառավարեք ձեր հաշվի նախընտրությունները և բովանդակությունը",
        sidebar: {
          account: "Հաշիվ",
          accountSettings: "Հաշվի կարգավորումներ",
          savedLiked: "Պահպանված և հավանած",
          preferences: "Նախընտրություններ",
          privacySecurity: "Գաղտնիություն և անվտանգություն",
          notifications: "Ծանուցումներ",
          pro: "Pro",
          archive: "Արխիվ",
          yourActivity: "Ձեր ակտիվությունը",
          howOthersInteract: "Ինչպես կարող են ուրիշները փոխազդել ձեզ հետ",
          interactionsLabel: "Հաղորդագրություններ, մեկնաբանություններ և սահմանափակումներ",
          accessibility: "Հասանելիություն",
          dataPermissions: "Արխիվացում, ներբեռնում և թույլտվություններ",
          support: "Աջակցություն",
        },
        interactions: {
          title: "Ինչպես կարող են ուրիշները փոխազդել ձեզ հետ",
          subtitle: "Կառավարեք, թե ով կարող է գրել ձեզ, մեկնաբանել ձեր գրառումները, և ում եք սահմանափակել:",
          messagesHeading: "Հաղորդագրություններ",
          messagesSubtitle: "Ով կարող է սկսել նոր զրույց ձեզ հետ:",
          everyone: "Բոլորը",
          followersBack: "Ձեզ հետևող մարդիկ",
          noOne: "Ոչ ոք",
          commentsHeading: "Մեկնաբանություններ",
          commentsSubtitle: "Ով կարող է մեկնաբանել ձեր գրառումները:",
          yourFollowers: "Ձեր հետևորդները",
          turnOffComments: "Անջատել մեկնաբանությունները",
          restrictedHeading: "Սահմանափակված հաշիվներ",
          restrictedSubtitle: "Սահմանափակված մարդիկ չեն կարող մեկնաբանել ձեր գրառումները: Նրանք դեռ կարող են տեսնել ձեր հանրային պրոֆիլը և հետևել ձեզ։ Սա ավելի մեղմ է, քան արգելափակումը:",
          searchPlaceholder: "Փնտրեք անվան կամ օգտանվան միջոցով…",
          searching: "Փնտրում ենք…",
          noUsersFound: "Օգտատերեր չեն գտնվել:",
          restrictBtn: "Սահմանափակել",
          noneRestricted: "Դուք ոչ ոքի չեք սահմանափակել:",
          unrestrictBtn: "Հանել սահմանափակումը",
        },
        archive: {
          title: "Արխիվ",
          subtitle: "Ձեր արխիվացրած գրառումները թաքցված են ձեր պրոֆիլից։ Միայն դուք եք տեսնում այս ցանկը:",
          emptyTitle: "Արխիվում ոչինչ չկա",
          emptyBody: "Արխիվացրեք գրառում դրա ընտրանքների ցանկից, և այն կհայտնվի այստեղ:",
          unarchiveBtn: "Հանել արխիվից",
        },
        activity: {
          title: "Ձեր ակտիվությունը",
          subtitle: "Արագ ակնարկ, թե վերջերս ինչով եք զբաղվել:",
          filterLiked: "Հավանած",
          filterSaved: "Պահպանված",
          filterCommented: "Մեկնաբանված",
          filterSearches: "Որոնումներ",
          empty: "Այստեղ դեռ ոչինչ չկա:",
        },
        accessibility: {
          title: "Հասանելիություն",
          subtitle: "Կարգավորեք, թե ինչպես է կայքը վարվում ձեզ համապատասխան:",
          reduceMotion: "Նվազեցնել շարժումը",
          reduceMotionDesc: "Անջատում է անիմացիաները և անցումները ողջ կայքում:",
        },
        dataExport: {
          title: "Արխիվացում և ներբեռնում",
          subtitle: "Ներբեռնեք ձեր տվյալների պատճենը:",
          downloadHeading: "Ներբեռնել ձեր տվյալները",
          downloadDesc: "Ստացեք JSON ֆայլ ձեր պրոֆիլով, գրառումներով և հայտերով:",
          preparing: "Պատրաստվում է…",
          downloadBtn: "Ներբեռնել",
          scopeHint: "Ընտրեք ամեն ինչ, կամ միայն ձեր տվյալների մի մասը:",
          scopeAll: "Ամեն ինչ",
          scopeProfile: "Միայն պրոֆիլը",
          scopePrograms: "Ծրագրերի հայտեր",
          scopeBuddy: "Buddy մենթորություն",
          scopeMessages: "Հաղորդագրություններ",
          permissionsTitle: "🔐 Կայքի թույլտվություններ",
          permissionsSubtitle: "Ինչ է ձեր բրաուզերը թույլ տալիս Greenwich-ին, և ինչպես փոխել դա:",
          permissionsPara1: "Greenwich-ը ձեր բրաուզերից խնդրում է միայն մեկ թույլտվություն՝ ծանուցումներ, որպեսզի ձեզ ահազանգի հավանումների, մեկնաբանությունների, հետևումների և հաղորդագրությունների մասին, նույնիսկ երբ ներդիրը փակ է: Այն չի պահանջում ձեր տեսախցիկը, խոսափողը կամ տեղադրությունը:",
          permissionsPara2: "Դուք կարող եք ցանկացած պահի վերանայել կամ չեղարկել այս թույլտվությունը ձեր բրաուզերի կայքի կարգավորումներից՝ սեղմելով կողպեքի պատկերակը հասցեագոտու կողքին, greenwich.am-ում գտնվելիս:",
        },
        toasts: {
          failedToSave: "Պահպանել չհաջողվեց:",
          userRestricted: "Օգտատերը սահմանափակվեց:",
          failedToRestrict: "Օգտատիրոջը սահմանափակել չհաջողվեց:",
          userUnrestricted: "Օգտատիրոջ սահմանափակումը հանվեց:",
          failedToUnrestrict: "Սահմանափակումը հանել չհաջողվեց:",
          postUnarchived: "Գրառումը հանվեց արխիվից, այն կրկին ձեր պրոֆիլում է:",
          failedToUnarchive: "Գրառումը արխիվից հանել չհաջողվեց:",
          failedToExport: "Ձեր տվյալները արտահանել չհաջողվեց:",
        },
        account: {
          title: "Հաշվի տվյալներ",
          subtitle: "Կառավարեք ձեր անձնական տվյալներն ու նախընտրությունները",
          firstName: "Անուն",
          lastName: "Ազգանուն",
          email: "Էլ․ հասցե",
          phone: "Հեռախոս",
          location: "Գտնվելու վայր",
          bio: "Ինքնակենսագրություն",
          bioPlaceholder: "Պատմեք ձեր մասին...",
          profileColor: "Պրոֆիլի հիմնական գույնը",
          profileColorHint: "Երևում է ձեր հանրային պրոֆիլում․ ընտրեք ձերը կամ թողեք լռելյայնը։",
          saveChanges: "Պահպանել փոփոխությունները",
          profileUpdated: "Պրոֆիլը հաջողությամբ թարմացվեց։",
          profileUpdateError: "Պրոֆիլը թարմացնելիս խնդիր առաջացավ",
          accountDeleted: "Հաշիվը հաջողությամբ ջնջվեց։",
          changePasswordTitle: "Փոխել գաղտնաբառը",
          changePasswordSubtitle: "Թարմացրեք գաղտնաբառը, որով մուտք եք գործում:",
          currentPassword: "Ընթացիկ գաղտնաբառ",
          newPassword: "Նոր գաղտնաբառ",
          confirmNewPassword: "Հաստատեք նոր գաղտնաբառը",
          newPasswordPlaceholder: "Առնվազն 8 նիշ",
          confirmNewPasswordPlaceholder: "Կրկնեք նոր գաղտնաբառը",
          updatePassword: "Թարմացնել գաղտնաբառը",
          passwordFieldsRequired: "Խնդրում ենք լրացնել գաղտնաբառի բոլոր դաշտերը:",
          passwordTooShort: "Նոր գաղտնաբառը պետք է լինի առնվազն 8 նիշ:",
          passwordMismatch: "Նոր գաղտնաբառը և հաստատումը չեն համընկնում:",
          passwordUpdated: "Գաղտնաբառը հաջողությամբ թարմացվեց:",
          passwordUpdateFailed: "Գաղտնաբառը թարմացնել չհաջողվեց:",
          activeSessionsTitle: "Ակտիվ սեսիաներ",
          activeSessionsSubtitle: "Տեսեք, թե որտեղ եք մուտք գործած, և դուրս եկեք այլ սարքերից:",
          manage: "Կառավարել →",
        },
        savedLiked: {
          title: "Պահպանված և հավանած գրառումներ",
          subtitle: "Գրառումներ, որոնք պահպանել կամ հավանել եք",
          emptyTitle: "Պահպանված կամ հավանած գրառումներ չկան",
          emptySubtitle: "Ձեր պահպանած կամ հավանած գրառումները կհայտնվեն այստեղ։",
          savedCount: "Պահպանված",
          likedCount: "Հավանած",
          badgeSaved: "Պահպանված",
          badgeLiked: "Հավանած",
          loadingPosts: "Գրառումները բեռնվում են...",
          unknownAuthor: "Անհայտ",
        },
        privacy: {
          title: "Գաղտնիություն և անվտանգություն",
          subtitle: "Կառավարեք ձեր գաղտնիության և անվտանգության կարգավորումները",
          accountPrivacy: "Հաշվի գաղտնիություն",
          accountPrivacySubtitle: "Ընտրեք՝ ով կարող է տեսնել ձեր պրոֆիլը և գրառումները",
          visibility: {
            public: "Հասանելի բոլորին",
            private: "Մասնավոր",
            friends: "Միայն ընկերներին",
          },
          language: "Լեզու",
          languageSubtitle: "Ընտրեք նախընտրելի լեզուն",
          contentLanguage: "Բովանդակության լեզու",
          contentLanguageSubtitle: "Ինչ լեզվով են ցուցադրվում ծրագրերն ու հնարավորությունները, անկախ ձեր ինտերֆեյսի լեզվից",
          market: "Երկիր",
          marketSubtitle: "Փոխեք Հայաստանի և Ֆրանսիայի Greenwich-ի տարբերակների միջև",
          twoFactor: "Երկփուլային նույնականացում",
          twoFactorSubtitle: "Ավելացրեք անվտանգության լրացուցիչ շերտ",
          privateAccount: "Մասնավոր հաշիվ և հետևելու հայտեր",
          privateAccountSubtitle: "Պահանջել հաստատում, նախքան մարդիկ կհետևեն ձեզ",
          notificationsRow: "Ծանուցումներ",
          notificationsRowSubtitle: "Ընտրեք՝ ինչ ազդանշաններ եք ստանում էլ. փոստով, push-ով և հավելվածում, և սահմանեք հանգիստ ժամեր",
          security: "Անվտանգություն",
          securitySubtitle: "Երկփուլային նույնականացում, էլ. փոստի փոփոխություն, կապակցված հաշիվներ",
          blockedAccounts: "Արգելափակված հաշիվներ",
          blockedAccountsSubtitle: "Ձեր արգելափակած մարդիկ չեն կարող տեսնել ձեր պրոֆիլը կամ կապվել ձեզ հետ",
          mutedAccounts: "Խլացված հաշիվներ",
          mutedAccountsSubtitle: "Նրանց գրառումները անաղմուկ թաքցված են ձեր լենտայից",
          manage: "Կառավարել →",
          dangerZone: "Վտանգավոր հատված",
        },
        deleteModal: {
          heading: "Ինչու՞ եք ցանկանում ջնջել ձեր հաշիվը",
          selectReason: "Ընտրեք պատճառը",
          reasonPrivacy: "Գաղտնիության մտահոգություններ",
          reasonNotUseful: "Օգտակար չէ",
          reasonTooManyEmails: "Չափազանց շատ ծանուցումներ",
          reasonOther: "Այլ",
          writeReason: "Գրեք ձեր պատճառը...",
          pleaseSelectReason: "Խնդրում ենք ընտրել պատճառը",
          areYouSure: "Վստա՞հ եք",
          cannotBeUndone: "Այս գործողությունը հնարավոր չէ հետարկել: Ձեր բոլոր տվյալները ընդմիշտ կջնջվեն:",
          yesDelete: "Այո, ջնջել",
          error: "Հաշիվը ջնջելիս սխալ առաջացավ: Խնդրում ենք կրկին փորձել:",
        },
        notifications: {
          title: "Ծանուցումներ",
          subtitle: "Կառավարեք՝ ինչպես և երբ ստանաք ծանուցումներ",
          pushTitle: "Push ծանուցումներ",
          pushSubtitle: "Ստացեք բրաուզերի ծանուցումներ",
        },
        languages: {
          en: "Անգլերեն",
          hy: "Հայերեն",
          ru: "Ռուսերեն",
          de: "Գերմաներեն",
          es: "Իսպաներեն",
          fr: "Ֆրանսերեն",
        },
        pro: {
          title: "Greenwich Pro",
          subtitle: "Կառավարեք ձեր Pro արտոնությունները՝ անհատականացված դիզայն, ավատարի շրջանակ և պրոֆիլի դիտումների պատմություն։",
          statusActive: "Քո Pro-ն ակտիվ է մինչև {{date}}",
          statusNone: "Դու դեռ Pro չունես։",
          learnMore: "Իմացիր ավելին Pro-ի մասին",
          frameTitle: "Ավատարի շրջանակ",
          frameNone: "Ոչ մի", frameGold: "Ոսկեգույն", frameEmerald: "Զմրուխտագույն", frameRoyal: "Արքայական",
          designTitle: "Պրոֆիլի դիզայն",
          designNone: "Ոչ մի", designSunset: "Մայրամուտ", designOcean: "Օվկիանոս", designForest: "Անտառ", designMidnight: "Կեսգիշեր",
          save: "Պահպանել", saving: "Պահպանվում է...",
          customizationSaved: "Անհատականացումը պահպանվեց։",
          customizationError: "Անհատականացումը պահպանել չհաջողվեց։",
          channelTitle: "Նախագծերի առաջարկների առաքում",
          channelSubtitle: "Ընտրիր, թե որտեղ ես ուզում ստանալ քո լավագույն համապատասխանությունները։",
          channelPlatform: "Հարթակում", channelEmail: "Էլ. փոստով", channelTelegram: "Telegram բոտով",
          comingSoon: "շուտով",
          linkTelegram: "կապել հաշիվդ",
          sendTest: "Ուղարկել իմ առաջարկները հիմա",
          testSent: "Ուղարկվեց! Ստուգիր ընտրած ալիքդ։",
          timingTitle: "Ժամանակ և բովանդակություն",
          timingSubtitle: "Կառավարիր, երբ են գալիս առաջարկները, կլինե՞ն հիշեցումներ, և որքան մանրամասն կլինի յուրաքանչյուրը։",
          deliveryHour: "Առաքման ժամանակ",
          remindersLabel: "Շարունակել ուղարկել, նույնիսկ եթե առաջարկները չեն փոխվել (հիշեցման ռեժիմ)",
          detailLevel: "Հաղորդագրության մանրամասնություն",
          detail_brief: "Կարճ", detail_detailed: "Մանրամասն",
          sourceTitle: "Ինչպես են ընտրվում առաջարկները",
          sourceAi: "AI մեչինգ (խորհուրդ է տրվում)", sourceCategories: "Ես ինքս կընտրեմ կատեգորիաները",
          sourceAiHint: "Խորհուրդ է տրվում ճշգրտության համար։ Առաջարկները դասակարգվում են ըստ քո ակտիվության հարթակում։",
          category_education: "Կրթություն", category_scholarship: "Կրթաթոշակ", category_fellowship: "Ֆելոուշիփ",
          category_erasmusplus: "Erasmus+", category_training: "Թրեյնինգ", category_grant: "Դրամաշնորհ",
          category_internship: "Պրակտիկա", category_conference: "Կոնֆերանս", category_online: "Օնլայն",
          category_volunteering: "Կամավորություն", category_event: "Միջոցառում", category_award: "Մրցանակ",
          viewsTitle: "Ով է դիտել քո պրոֆիլը",
          viewsSubtitle: "Տեսանելի է միայն այնքան ժամանակ, քանի դեռ քո Pro բաժանորդագրությունը ակտիվ է։",
          viewsLocked: "Ստացիր Pro՝ տեսնելու համար, թե ով է դիտել քո պրոֆիլը։",
          viewsCountToday: "Այսօր {{count}} մարդ դիտել է քո պրոֆիլը։",
          viewsEmpty: "Այս Pro շրջանում պրոֆիլի դիտումներ դեռ չկան։",
          loading: "Բեռնվում է...",
          billingTitle: "Վճարումներ և վերադարձներ",
          billingSubtitle: "Ձեր նախկին գնումները՝ 7 օրվա ընթացքում վերադարձ պահանջելու հնարավորությամբ։",
          billingEmpty: "Գնումներ դեռ չկան։",
          requestRefund: "Պահանջել վերադարձ",
          refundWindowExpired: "Վերադարձի ժամկետն անցել է",
          refundStatusRequested: "Վերադարձը պահանջված է, ուսումնասիրվում է",
          refundStatusApproved: "Վերադարձը հաստատված է",
          refundStatusRejected: "Վերադարձի հայցը մերժվել է",
          refundStatusRefunded: "Վերադարձված է",
          refundModalTitle: "Պահանջել վերադարձ",
          refundModalSubtitle: "Պատմեք, թե ինչ է պատահել։ Սա օգնում է մեզ բարելավվել և անհրաժեշտ է վերադարձը մշակելու համար։",
          refundReasonLabel: "Պատճառ",
          selectReason: "Ընտրեք պատճառ",
          reason_not_what_expected: "Սպասածից տարբեր էր",
          reason_found_cheaper_elsewhere: "Ավելի էժան տարբերակ գտա այլ տեղ",
          reason_technical_issues: "Տեխնիկական խնդիրներ ունեցա",
          reason_accidental_purchase: "Պատահական գնում",
          reason_no_longer_needed: "Այլևս անհրաժեշտ չէ",
          reason_bought_wrong_plan: "Սխալ փաթեթ գնեցի",
          reason_unsatisfied_with_features: "Գոհ չեմ հնարավորություններից",
          reason_other: "Այլ",
          ratingLabel: "Ինչպե՞ս կգնահատեիք ձեր փորձը",
          commentLabel: "Ուրիշ բան ավելացնե՞լ եք ուզում (ոչ պարտադիր)",
          commentPlaceholder: "Պատմեք ավելին...",
          talkToSupport: "Նախընտրու՞մ եք նախ խոսել ինչ-որ մեկի հետ",
          talkToSupportLink: "Խոսել աջակցության հետ",
          submitRefund: "Ուղարկել վերադարձի հայցը",
          submittingRefund: "Ուղարկվում է...",
          refundSubmitted: "Վերադարձի հայցն ուղարկված է, շուտով կքննարկենք։",
          refundError: "Չհաջողվեց ուղարկել հայցը։ Փորձեք կրկին։",
        },
        confirmLogout: "Վստա՞հ եք, որ ուզում եք դուրս գալ։",
      },
      feed: {
        sidebarExplore: "Ուսումնասիրել",
        photos: "Լուսանկարներ",
        postBtn: "Հրապարակել",
        whatsOnMind: "Ի՞նչ եք մտածում",
        recommendedForYou: "Առաջարկվում է ձեզ",
        programsForYou: "Ծրագրեր ձեզ համար",
        programsForYouFallback: "Ծրագիր",
        programsForYouPopularHint: "Հանրաճանաչ հենց հիմա․ պահպանեք կամ դիմեք ծրագրերին՝ սա անհատականացնելու համար։",
        seeAll: "Տեսնել բոլորը",
        followPeopleHint: "Հետևեք մարդկանց, որպեսզի տեսնեք նրանց այստեղ",
        loading: "Բեռնվում է...",
        close: "Փակել",
        noFollowersYet: "Հետևորդներ դեռ չկան",
        noFollowingYet: "Դեռ ոչ ոքի չեք հետևում",
        unknown: "Անհայտ",
        viewAllFollowing: "Տեսնել բոլոր {{count}} հետևածներին",
        noRecommendationsYet: "Առաջարկներ դեռ չկան",
        recommendationsHint: "Հետևեք մարդկանց կամ ուսումնասիրեք՝ առաջարկներ ստանալու համար",
        alreadyFollowing: "Արդեն հետևում եք",
        reasonViolent: "Բռնի բովանդակություն",
        reasonDescSpam: "Սա սպամ է",
        reasonDescInappropriate: "Պարունակում է 18+ կամ բացահայտ բովանդակություն",
        reasonDescViolent: "Պարունակում է բռնի, արյունոտ կամ անհանգստացնող բովանդակություն",
        reasonDescHarassment: "Ոտնձգություն կամ բուլինգ",
        reasonDescHateSpeech: "Խրախուսում է ատելություն կամ բռնություն",
        reasonDescMisinformation: "Կեղծ կամ մոլորեցնող տեղեկատվություն",
        reasonDescOther: "Այլ պատճառ",
        reportComment: "Բողոքարկել մեկնաբանությունը",
        reportSelectReasonHint: "Խնդրում ենք ընտրել այս {{type}}-ը բողոքարկելու պատճառը: Այս գործողությունն անանուն է:",
        additionalDetails: "Լրացուցիչ մանրամասներ (ընտրովի)",
        reportDetailsPlaceholder: "Ավելացրեք մանրամասներ ձեր բողոքի մասին...",
        submitReport: "Ուղարկել բողոքը",
        editPost: "Խմբագրել գրառումը",
        archivePost: "Արխիվացնել գրառումը",
        archiving: "Արխիվացվում է…",
        commentWillBeDeleted: "Այս մեկնաբանությունը կջնջվի ընդմիշտ: Այս գործողությունը հնարավոր չէ հետարկել:",
        sendAndShare: "Ուղարկել և կիսվել",
        imagePost: "Նկարով գրառում",
        sendToMutualFollows: "Ուղարկել փոխադարձ հետևորդներին",
        loadingMutualFollows: "Փոխադարձ հետևորդները բեռնվում են...",
        showLess: "Ցույց տալ քիչը",
        showAllUsers: "Ցույց տալ բոլոր {{count}} օգտատերերին",
        shareOnSocialMedia: "Կիսվել սոցիալական ցանցերում",
        failedToCopyLink: "Հղումը պատճենել չհաջողվեց",
        failedToLikeComment: "Մեկնաբանությունը հավանել չհաջողվեց:",
        commentDeletedToast: "Մեկնաբանությունը ջնջվեց:",
        failedToDeleteComment: "Մեկնաբանությունը ջնջել չհաջողվեց",
        postArchivedToast: "Գրառումն արխիվացվեց: Կարող եք գտնել այն Կարգավորումներ → Արխիվ բաժնում:",
        reportSubmittedToast: "Բողոքն ուղարկվեց հաջողությամբ",
        failedToSubmitReport: "Բողոքն ուղարկել չհաջողվեց",
        maxImagesError: "Կարող եք վերբեռնել առավելագույնը 10 նկար",
        postContentEmptyError: "Գրառման բովանդակությունը չի կարող դատարկ լինել",
        pleaseLogInToEdit: "Խնդրում ենք մուտք գործել՝ գրառումները խմբագրելու համար",
        postUpdatedToast: "Գրառումը հաջողությամբ թարմացվեց:",
        cannotSendPostError: "Հնարավոր չէ ուղարկել գրառումը՝ բացակայող տվյալներ",
        postNotFoundError: "Գրառումը չի գտնվել",
        pleaseAddContentError: "Խնդրում ենք ավելացնել բովանդակություն կամ նկար",
        pleaseLogInToPost: "Խնդրում ենք մուտք գործել՝ հրապարակելու համար",
        postCreatedToast: "Գրառումը հաջողությամբ ստեղծվեց:",
        cannotConnectError: "Հնարավոր չէ միանալ սերվերին: Ստուգեք ինտերնետ կապը",
        cannotCopyProfileLinkError: "Հնարավոր չէ պատճենել պրոֆիլի հղումը՝ օգտատերը բեռնված չէ",
        postDeletedByAdmin: "Գրառումը ջնջվեց ադմինի կողմից:",
        failedToDeletePost: "Գրառումը ջնջել չհաջողվեց",
        failedToArchivePost: "Գրառումն արխիվացնել չհաջողվեց",
        failedToUpdatePost: "Գրառումը թարմացնել չհաջողվեց:",
        failedToCreatePost: "Գրառումը ստեղծել չհաջողվեց:",
        replaceImages: "Փոխարինել նկարները",
        addImages: "Ավելացնել նկարներ",
      },
    },
  },
  ru: {
    translation: {
      common: {
        saving: "Сохранение...",
        refresh: "Обновить",
        logout: "Выйти",
        deleteAccount: "Удалить аккаунт",
        viewPost: "Открыть пост",
        unsave: "Убрать из сохранённых",
        unlike: "Убрать лайк",
        members: "участников",
        posts: "Посты",
        editProfile: "Редактировать профиль",
        unknownUser: "Неизвестный пользователь",
        exploreUsers: "Исследовать пользователей",
        showAll: "Показать все",
        searchMutualFollows: "Поиск взаимных подписок...",
        myPosts: "Мои посты",
        likedPosts: "Понравившиеся посты",
        savedPosts: "Сохранённые посты",
        organizationPosts: "Посты организации",
      },
      navbar: {
        home: "Главная",
        feed: "Лента",
        community: "Сообщество",
        projects: "Программы",
        organizations: "Организации",
        donateNow: "Пожертвовать",
        pro: "Greenwich Pro",
        buddy: "Buddy",
        greencoins: "Гринкоины",
        shop: "Магазин Greenwich",
        settings: "Настройки",
        contactUs: "Связаться с нами",
        whoWeAre: "Кто мы",
        account: "Аккаунт",
        editProfile: "Редактировать профиль",
        howItWorks: "Как это работает",
        logOut: "Выйти",
        viewDashboard: "Посмотреть вашу панель",
        adminDashboard: "Панель администратора",
        verifiedOrganizations: "Проверенные организации",
        adminPanel: "Панель администратора",
        searchPlaceholder: "Поиск пользователей, постов, сообществ, организаций...",
        searching: "Поиск...",
        searchMinChars: "Введите хотя бы 2 символа для поиска",
        users: "Пользователи",
        communities: "Сообщества",
        posts: "Посты",
        noResults: "Результаты не найдены для",
        seeAllResults: "Показать все результаты",
        organization: "Организация",
        user: "Пользователь",
        postBy: "Пост от",
        tryDifferentKeywords: "Попробуйте другие ключевые слова",
        searchMembers: "Поиск участников",
        loginToSearch: "Пожалуйста, войдите для использования поиска",
        sessionExpired: "Сессия истекла. Пожалуйста, войдите снова.",
        serverError: "Ошибка сервера. Пожалуйста, попробуйте позже.",
        searchFailed: "Поиск не удался",
        networkError: "Ошибка сети. Пожалуйста, проверьте подключение и попробуйте снова.",
        language: "Язык",
        selectLanguage: "Выберите язык",
        messages: "Сообщения",
        cancel: "Отмена",
      },
      notifications: {
        title: "Уведомления",
        markAllRead: "Отметить все как прочитанные",
        marking: "Отмечается...",
        loading: "Загрузка...",
        allCaughtUp: "Все прочитано!",
        noNew: "Новых уведомлений нет",
        liked: "оценил(а) ваш пост",
        commented: "прокомментировал(а) ваш пост",
        followed: "начал(а) подписку на вас",
        followRequest: "хочет подписаться на вас",
        followAccepted: "принял(а) вашу заявку на подписку",
        sentMessage: "отправил(а) вам сообщение",
        postRemoved: "ваш пост был удалён администратором",
        genericNotification: "отправил(а) уведомление",
        reason: "Причина",
        admin: "Админ",
        processing: "Обработка...",
        accept: "Принять",
        decline: "Отклонить",
        total: "всего",
        unread: "непрочитано",
        refresh: "Обновить",
        justNow: "сейчас",
        dismiss: "Скрыть",
        missingFollowData: "Невозможно обработать: отсутствуют данные заявки на подписку.",
        followActionFailed: "Не удалось {{action}} заявку на подписку. Попробуйте снова.",
        networkError: "Ошибка сети. Попробуйте снова.",
        avatarAlt: "Аватар",
        viewProfile: "Посмотреть профиль {{name}}",
        someone: "Кто-то",
      },
      messageModal: {
        sendMessage: "Отправить сообщение",
        noMutualFollows: "Пока нет взаимных подписок",
        noMutualFollowsHint: "Подпишитесь на людей и дождитесь, пока они подпишутся в ответ, чтобы написать им.",
        mutualFollowsCount: "{{count}} взаимных подписок",
        org: "Орг.",
        user: "Пользователь",
        mutualFollow: "Взаимная подписка",
        cancel: "Отмена",
        verified: "Подтверждено",
      },
      postModal: {
        reply: "Ответить",
        report: "Пожаловаться",
        delete: "Удалить",
        save: "Сохранить",
        share: "Поделиться",
        writeReply: "Написать ответ...",
        writeComment: "Написать комментарий...",
        noCommentsYet: "Комментариев пока нет",
        deletePost: "Удалить пост",
        deleteComment: "Удалить комментарий",
        cancel: "Отмена",
        areYouSure: "Вы уверены?",
        postWillBeDeleted: "Этот пост будет удалён навсегда.",
        deleteThisComment: "Удалить этот комментарий?",
        reportPost: "Пожаловаться на пост",
        reasonSpam: "Спам",
        reasonInappropriate: "Неприемлемый контент",
        reasonHarassment: "Домогательство",
        reasonHateSpeech: "Язык вражды",
        reasonMisinformation: "Дезинформация",
        reasonOther: "Другое",
        linkCopied: "Ссылка скопирована!",
        beFirstComment: "Будьте первым, кто оставит комментарий!",
        comment: "Комментарий",
        comments: "Комментарии",
        justNow: "Только что",
        minutesAgo: "{{m}} мин назад",
        hoursAgo: "{{h}} ч назад",
        daysAgo: "{{day}} дн назад",
        unknown: "Неизвестно",
        me: "Я",
        replyPosted: "Ответ опубликован!",
        commentAdded: "Комментарий добавлен!",
        postDeleted: "Публикация удалена.",
        commentDeleted: "Комментарий удалён.",
        reportSubmitted: "Жалоба отправлена.",
        failedLoadPost: "Не удалось загрузить публикацию.",
        loadingPost: "Загрузка публикации...",
        postNotFound: "Публикация не найдена.",
        like: "Нравится",
        likes: "Нравится",
        submit: "Отправить",
        user: "Пользователь",
      },
      authPages: {
        orgReg: {
          stepProfileShort: "Профиль", stepProfileLong: "Профиль организации",
          stepContactShort: "Контакты", stepContactLong: "Контакты и сети", stepContactMedium: "Контакты",
          stepTeamShort: "Команда", stepTeamLong: "Команда и безопасность",
          stepVerification: "Аккаунт",
          back: "Назад",
          loadingOrgData: "Загружаем данные вашей организации...",
          continueStep2: "Продолжить к шагу 2",
          continueStep3: "Продолжить к шагу 3",
          continueVerification: "Продолжить к верификации",
          orgNameTitle: "Название организации",
          orgNameTooltip: "Укажите название организации на разных языках. Армянская версия обязательна.",
          orgNameDesc: "Укажите название вашей организации на разных языках",
          language: "Язык",
          orgNameLabel: "Название орг.",
          orgNamePlaceholder: "Введите название организации",
          addNameInAnotherLanguage: "Добавить название на другом языке",
          orgTypeTitle: "Тип организации",
          selectOrgType: "Выберите тип организации",
          typesSelected: "выбрано типов: {{count}}",
          specifyOrgType: "Укажите тип вашей организации...",
          ageGroupsTitle: "Целевые возрастные группы",
          ageGroups: {
            all: "Все возрастные группы",
            "0-12": "Дети (0-12)",
            "13-17": "Подростки (13-17)",
            "18-25": "Молодёжь (18-25)",
            "26-35": "Взрослые (26-35)",
            "36-50": "Средний возраст (36-50)",
            "51-65": "Старшее поколение (51-65)",
            "65+": "Пожилые (65+)",
          },
          orgNameLanguages: {
            Armenian: "Армянский",
            English: "Английский",
            Russian: "Русский",
            French: "Французский",
            German: "Немецкий",
            Spanish: "Испанский",
            Other: "Другой",
          },
          focusAreasTitle: "Направления деятельности",
          selectFocusAreas: "Выберите направления деятельности",
          areasSelected: "выбрано направлений: {{count}}",
          specifyFocusArea: "Укажите ваше направление деятельности...",
          detailsTitle: "Информация об организации",
          briefDescription: "Краткое описание",
          briefDescriptionPlaceholder: "Опишите цель, деятельность и влияние вашей организации...",
          missionStatement: "Миссия",
          missionPlaceholder: "В чём заключается миссия и ценности вашей организации?",
          yearEstablished: "Год основания",
          legalForm: "Правовая форма",
          selectLegalForm: "Выберите правовую форму",
          formsSelected: "выбрано форм: {{count}}",
          specifyLegalForm: "Укажите правовую форму...",
          alertName: "Пожалуйста, укажите название вашей организации",
          alertOrgType: "Пожалуйста, выберите хотя бы один тип организации",
          alertAudience: "Пожалуйста, выберите хотя бы одну целевую возрастную группу",
          alertFocusArea: "Пожалуйста, выберите хотя бы одно направление деятельности",
          alertDescription: "Пожалуйста, заполните краткое описание",
          alertMission: "Пожалуйста, заполните миссию",
          alertYear: "Пожалуйста, укажите год основания организации",
          alertLegalForm: "Пожалуйста, выберите правовую форму",
          step2Title: "Шаг 2: Контакты и сети",
          step2Subtitle: "Как люди могут связаться с вашей организацией?",
          contactInfoTitle: "Контактная информация",
          orgEmail: "Email организации",
          orgEmailPlaceholder: "your.org@example.com",
          orgEmailHint: "Мы вышлем на этот адрес код подтверждения для верификации аккаунта.",
          primaryPhone: "Основной телефон",
          phoneNumberPlaceholder: "Номер телефона",
          website: "Веб-сайт",
          address: "Адрес",
          addressPlaceholder: "Улица, город, страна",
          socialLinks: "Соцсети",
          socialLinkPlaceholder: "https://example.com/profile",
          addLink: "Добавить ссылку",
          networksTitle: "Международные сети",
          networksDesc: "Выберите сети, в которые входит ваша организация",
          customNetworkPlaceholder: "Добавить свою сеть...",
          add: "Добавить",
          alertRequiredFields: "Заполните обязательные поля: email и телефон",
          alertValidEmail: "Пожалуйста, введите корректный email",
          alertValidPhone: "Пожалуйста, введите корректный номер телефона (не менее 6 цифр)",
          alertAddress: "Пожалуйста, укажите адрес вашей организации",
          step3Title: "Шаг 3: Команда и безопасность",
          step3Subtitle: "Управляйте участниками команды и настройками безопасности",
          brandingTitle: "Брендинг организации",
          logoOptional: "Логотип (необязательно)",
          addLogo: "Добавить логотип",
          upTo8mb: "До 8 МБ",
          change: "Изменить",
          orgPresentationOptional: "Презентация организации (необязательно)",
          uploadPresentation: "Загрузить презентацию",
          presentationHint: "PDF, слайды или изображение, до 8 МБ",
          fileAttached: "Файл прикреплён",
          clickToChange: "Нажмите, чтобы изменить",
          teamTitle: "Уполномоченные участники команды",
          teamDesc: "Добавьте участников команды, уполномоченных публиковать контент от имени организации. Каждый получит приглашение по email и попадёт в подтверждённый список только после его принятия.",
          member: "Участник №{{n}}",
          fullNamePlaceholder: "Полное имя",
          rolePlaceholder: "Роль / обязанности",
          teamEmailPlaceholder: "team@org.com",
          addTeamMember: "Добавить участника",
          alertFileSize: "Файлы должны быть меньше 8 МБ.",
          alertMember: "Заполните хотя бы одного уполномоченного участника команды: полное имя, роль и email",
          step4Title: "Шаг 4: Аккаунт и контактное лицо",
          step4Subtitle: "Завершите регистрацию, создав данные для входа. Юридическая верификация проходит позже, из вашего кабинета",
          missingInfoTitle: "Недостающая информация",
          missingInfoDesc: "Сначала завершите шаг 1: Профиль организации.",
          goToStep1: "Перейти к шагу 1",
          submittingRegistration: "Отправляем вашу регистрацию...",
          loginCredentialsTitle: "Данные для входа",
          orDivider: "или завершите через email и пароль",
          username: "Имя пользователя",
          usernamePlaceholder: "например, greenpeace_official",
          usernameValid: "✓ Имя пользователя корректно",
          usernameInvalid: "Не менее 3 символов: только строчные латинские буквы, цифры, _ и .",
          suggestions: "Варианты:",
          email: "Email",
          emailHintPrefix: "Указан на шаге 2. Мы вышлем сюда код подтверждения,",
          changeIt: "изменить",
          password: "Пароль",
          passwordPlaceholder: "Минимум 8 символов",
          confirmPassword: "Подтвердите пароль",
          confirmPasswordPlaceholder: "Введите пароль ещё раз",
          passwordsMatch: "✓ Пароли совпадают",
          passwordsDontMatch: "✗ Пароли не совпадают",
          strengthWeak: "Слабый", strengthMedium: "Средний", strengthStrong: "Надёжный",
          easyPasswordsTitle: "💡 Простые пароли для запоминания (нажмите, чтобы использовать):",
          refresh: "Обновить",
          passwordFormatHint: "Формат: Слово + Слово + Цифры (легко запомнить, сложно угадать)",
          legalRepTitle: "Кто регистрируется",
          legalRepDesc: "Человек, создающий этот аккаунт и уполномоченный действовать от имени организации",
          registrantRoleQuestion: "Вы регистрируетесь как сама организация или как её представитель?",
          registrantRoleOrg: "Организация",
          registrantRoleRep: "Я представитель",
          name: "Имя", firstNamePlaceholder: "Имя",
          surname: "Фамилия", lastNamePlaceholder: "Фамилия",
          position: "Должность", positionPlaceholder: "например, исполнительный директор",
          phone: "Телефон",
          optional: "(необязательно)",
          optionalPlaceholder: "Необязательно",
          verificationTitle: "Юридическая регистрация и верификация",
          verificationDesc: "Эта информация позволяет нашей команде проверить легитимность организации перед публикацией на платформе",
          isInformalQuestion: "Ваша организация неформальная / незарегистрированная группа?",
          formallyRegistered: "Нет, мы официально зарегистрированы",
          informal: "Да, мы неформальная группа",
          informalHint: "Регистрационные данные не нужны. Неформальные группы могут сразу перейти к документам ниже.",
          legalFormFromStep1: "Правовая форма (с шага 1):",
          stateRegNumber: "Государственный регистрационный номер", stateRegNumberPlaceholder: "Номер свидетельства / реестра",
          countryOfReg: "Страна регистрации", countryOfRegPlaceholder: "например, Армения",
          dateOfReg: "Дата регистрации",
          taxId: "ИНН / юридический ID", taxIdPlaceholder: "Идентификационный номер налогоплательщика",
          vatNumber: "Номер НДС", vatNumberPlaceholder: "например, AM12345678",
          registeredAddress: "Юридический адрес регистрации", registeredAddressPlaceholder: "Адрес, указанный в реестре",
          documentsTitle: "Документы",
          optionalParen: "(необязательно)",
          registrationDoc: "Свидетельство о регистрации",
          vatCertificate: "Свидетельство НДС",
          stateSeal: "Государственная печать",
          passportScan: "Скан паспорта",
          uploadShort: "+ Загрузить",
          docHint: "PDF или изображение, до 8 МБ",
          completeRegistration: "Завершить регистрацию",
          submittingBtn: "Отправка...",
          alertUsernameRequired: "Необходимо указать имя пользователя",
          alertUsernameFormat: "Имя пользователя должно содержать 3-20 символов: только строчные латинские буквы, цифры, подчёркивания и точки",
          alertMissingEmail: "Отсутствует email организации. Вернитесь на шаг 2",
          alertPasswordRequired: "Необходимо указать пароль",
          alertPasswordsMismatch: "Пароли не совпадают",
          alertPasswordLength: "Пароль должен содержать не менее 8 символов",
          alertRegistrantRole: "Укажите, регистрируетесь ли вы как организация или как представитель",
          alertRepName: "Укажите имя законного представителя",
          alertRepSurname: "Укажите фамилию законного представителя",
          alertRepPosition: "Укажите должность законного представителя",
          alertStateRegId: "Для официально зарегистрированной организации требуется государственный регистрационный номер",
          alertCountry: "Укажите страну регистрации",
          alertRegDate: "Укажите дату регистрации",
          alertLegalId: "Укажите ИНН / юридический ID",
          alertRegAddress: "Укажите юридический адрес регистрации",
          alertVat: "Укажите номер НДС",
          alertCaptcha: "Пожалуйста, пройдите проверку CAPTCHA",
          alertFileTooLarge: "Файл слишком большой (макс. 8 МБ)",
          successEmailVerify: "✅ Регистрация отправлена! Проверьте email для получения кода подтверждения.",
          successRegistered: "✅ Регистрация прошла успешно!",
          successSocial: "Регистрация через соцсеть прошла успешно!",
          errorRegistrationFailed: "Не удалось завершить регистрацию. Попробуйте ещё раз.",
          errorSocialFailed: "Не удалось выполнить регистрацию через соцсеть. Попробуйте ещё раз.",
        },
        backToLogin: "Назад ко входу",
        enterEmail: "Пожалуйста, введите ваш email.",
        somethingWrong: "Что-то пошло не так. Попробуйте снова.",
        checkYourEmail: "Проверьте вашу почту",
        resetEmailSent: "Если аккаунт с {{email}} существует, мы отправили ссылку для сброса пароля. Она действительна 1 час.",
        forgotTitle: "Забыли пароль?",
        forgotSubtitle: "Введите email, и мы вышлем ссылку для сброса.",
        email: "Email",
        sending: "Отправка…",
        sendResetLink: "Отправить ссылку",
        confirmEmailTitle: "Подтвердите вашу почту",
        confirmEmailSubtitle: "Мы отправили 6-значный код на {{email}}. Введите его ниже, чтобы активировать аккаунт.",
        yourEmail: "ваша почта",
        confirmationCode: "Код подтверждения",
        confirmBtn: "Подтвердить",
        verifying: "Подтверждение…",
        resendCode: "Отправить код повторно",
        resendCodeIn: "Повторно через {{seconds}} с",
        codeResent: "Новый код отправлен на вашу почту.",
        missingResetInfo: "В этой ссылке отсутствует необходимая информация. Запросите новую.",
        passwordTooShort: "Пароль должен содержать не менее 8 символов.",
        passwordsDontMatch: "Пароли не совпадают.",
        failedResetPassword: "Не удалось сбросить пароль.",
        passwordUpdated: "Пароль обновлён",
        redirecting: "Перенаправляем на вход…",
        chooseNewPassword: "Выберите новый пароль",
        forAccount: "для {{email}}",
        yourAccount: "вашего аккаунта",
        newPassword: "Новый пароль",
        confirmNewPassword: "Подтвердите новый пароль",
        atLeast8Chars: "Не менее 8 символов",
        reenterPassword: "Введите пароль повторно",
        updating: "Обновление…",
        updatePassword: "Обновить пароль",
        resendLink: "Отправить ссылку повторно",
        resendLinkIn: "Повторно через {{seconds}} с",
        linkResent: "Новая ссылка уже летит к вам.",
        checkSpamHint: "Не пришло? Загляните в папку «Спам», письмо может идти минуту.",
        oauthNoticeTitle: "Вы входите через {{provider}}",
        oauthNoticeDesc: "У этого аккаунта нет пароля, поэтому сбрасывать нечего, просто войдите через {{provider}} на странице входа.",
        socialAccountGeneric: "соцсеть",
        goToLogin: "Перейти ко входу",
        passwordReqLength: "Не менее 8 символов",
        passwordReqMatch: "Пароли совпадают",
        login: "Вход",
        password: "Пароль",
        forgotPassword: "Забыли пароль?",
        loading: "Загрузка...",
        continueBtn: "Продолжить",
        or: "или",
        dontHaveAccount: "Нет аккаунта?",
        register: "Зарегистрироваться",
        socialLoginFailed: "Не удалось войти через соцсеть.",
        chooseAccountType: "Выберите тип аккаунта",
        selectHowToUse: "Выберите, как вы хотите использовать нашу платформу",
        player: "Игрок",
        playerDescLong: "Участвуйте в турнирах и соревнуйтесь с другими игроками",
        playerDescShort: "Участвовать и соревноваться",
        organizer: "Организатор",
        organizerDescLong: "Создавайте и управляйте турнирами",
        organizerDescShort: "Создавать и управлять",
        pendingApproval: "Ваш аккаунт ожидает одобрения. Пожалуйста, дождитесь одобрения администратором.",
        loginFailed: "Не удалось войти. Попробуйте снова.",
        invalidCredentials: "Неверный email или пароль.",
        socialRegisterFailed: "Не удалось зарегистрироваться через соцсеть. Попробуйте снова.",
        loggingIn: "Выполняется вход...",
        showPassword: "Показать пароль",
        hidePassword: "Скрыть пароль",
        registrationVisual: "Изображение регистрации",
        togglePasswordVisibility: "Показать/скрыть пароль",
        registerAsOrg: "Зарегистрироваться как организация",
        registerAsUser: "Зарегистрироваться как пользователь",
        fillRequired: "Пожалуйста, заполните все обязательные поля",
        nameLength: "Имя должно содержать 2-20 символов",
        surnameLength: "Фамилия должна содержать 2-20 символов",
        invalidEmail: "Пожалуйста, введите корректный email",
        useRealEmail: "Пожалуйста, используйте настоящий email",
        invalidPhone: "Пожалуйста, введите корректный номер телефона (+374XXXXXXXX или 0XXXXXXXX)",
        passwordLength: "Пароль должен содержать 6-20 символов",
        passwordLetterNumber: "Пароль должен содержать хотя бы одну букву и одну цифру",
        passwordTooWeak: "Пожалуйста, выберите более надёжный пароль",
        passwordsNoMatch: "Пароли не совпадают",
        mustAgreeTerms: "Вы должны согласиться с условиями использования",
        completeCaptcha: "Пожалуйста, пройдите проверку CAPTCHA",
        registrationFailed: "Регистрация не удалась",
        registrationError: "Произошла ошибка при регистрации",
        registrationTimeout: "Регистрация занимает больше времени, чем ожидалось. Проверьте соединение и попробуйте снова.",
        socialRegFailed: "Не удалось зарегистрироваться через соцсеть",
        createAccount: "Создать аккаунт",
        orRegisterEmail: "или зарегистрируйтесь через email",
        name: "Имя",
        surname: "Фамилия",
        phoneOptional: "Телефон",
        phoneExample: "Например: +374 98 123 456",
        confirmPassword: "Подтвердите пароль",
        confirmYourPassword: "Подтвердите ваш пароль",
        passwordPlaceholderHint: "Не менее 6 символов, с буквой и цифрой",
        charsMin: "6+ симв.",
        letter: "буква",
        number: "цифра",
        passwordsMatch: "Пароли совпадают",
        passwordsDontMatchShort: "Пароли не совпадают",
        agreeToTerms: "Я согласен с",
        termsConditions: "Условиями использования",
        and: "и",
        privacyPolicy: "Политикой конфиденциальности",
        registering: "Регистрация...",
        registerBtn: "Зарегистрироваться",
      },
      followButton: {
        pleaseLogin: "Пожалуйста, войдите, чтобы подписываться на пользователей",
        userIdMissing: "Невозможно подписаться: отсутствует ID пользователя",
        requestSent: "Заявка на подписку отправлена!",
        failedSendRequest: "Не удалось отправить заявку на подписку",
        noRequestId: "ID заявки не найден",
        requestAccepted: "Заявка на подписку принята!",
        failedAccept: "Не удалось принять заявку на подписку",
        requestRejected: "Заявка на подписку отклонена",
        failedReject: "Не удалось отклонить заявку на подписку",
        unfollowedSuccess: "Подписка успешно отменена",
        unfollowIdMissing: "Невозможно отписаться: отсутствует ID пользователя",
        failedUnfollow: "Не удалось отписаться от пользователя",
        noRequestIdCancel: "ID заявки не найден для отмены",
        requestCancelled: "Заявка на подписку отменена",
        failedCancel: "Не удалось отменить заявку на подписку",
        userUnavailable: "Пользователь недоступен",
        loading: "Загрузка...",
        acceptRequest: "Принять заявку",
        reject: "Отклонить",
        mutualFollow: "Взаимная подписка",
        following: "Вы подписаны",
        unfollow: "Отписаться",
        requestSentBtn: "Заявка отправлена",
        follow: "Подписаться",
      },
      followSettings: {
        pleaseLogin: "Пожалуйста, войдите, чтобы просмотреть настройки",
        failedLoad: "Не удалось загрузить настройки",
        settingsSaved: "Настройки успешно сохранены!",
        failedSave: "Не удалось сохранить настройки",
        loadingSettings: "Загрузка настроек...",
        title: "Настройки подписок",
        subtitle: "Управляйте тем, как другие могут подписываться на вас",
        followRequests: "Заявки на подписку",
        followRequestsDesc: "Управляйте тем, нужно ли людям ваше одобрение, чтобы подписаться на вас",
        requireApproval: "Требовать одобрение для подписчиков",
        approvalOnDesc: "Люди должны отправить заявку, чтобы подписаться на вас",
        approvalOffDesc: "Любой может подписаться на вас без одобрения",
        whenOn: "Когда ВКЛЮЧЕНО:",
        onPoint1: "Пользователи должны отправить заявку на подписку",
        onPoint2: "Вы можете одобрять или отклонять заявки",
        onPoint3: "У вас полный контроль над тем, кто на вас подписан",
        onPoint4: "Идеально для приватных аккаунтов",
        whenOff: "Когда ВЫКЛЮЧЕНО:",
        offPoint1: "Любой может подписаться на вас мгновенно",
        offPoint2: "Одобрение не требуется",
        offPoint3: "Отлично для публичных персон и организаций",
        offPoint4: "Максимизирует ваш охват",
        notifications: "Уведомления",
        notificationsDesc: "Управляйте тем, как вы получаете уведомления о заявках на подписку",
        emailNotifications: "Email-уведомления",
        emailNotifDesc: "Получайте email-оповещения о новых заявках на подписку",
        pushNotifications: "Push-уведомления",
        pushNotifDesc: "Получайте уведомления браузера о заявках на подписку",
        inAppNotifications: "Уведомления в приложении",
        inAppNotifDesc: "Видеть уведомления внутри приложения",
        followers: "Подписчики",
        following: "Подписки",
        pendingRequests: "Ожидающие заявки",
        resetDefaults: "Сбросить по умолчанию",
        saving: "Сохранение...",
        saveSettings: "Сохранить настройки",
      },
      followRequestsPage: {
        failedLoad: "Не удалось загрузить заявки на подписку",
        serverError: "Ошибка сервера: {{status}}",
        acceptedRequest: "Вы приняли заявку от {{name}}!",
        failedAccept: "Не удалось принять заявку на подписку. Попробуйте снова.",
        rejectedRequest: "Заявка от {{name}} отклонена",
        failedReject: "Не удалось отклонить заявку на подписку. Попробуйте снова.",
        needMutualToMessage: "Вам нужна взаимная подписка, чтобы написать {{name}}",
        failedStartConversation: "Не удалось начать разговор",
        justNow: "Только что",
        minAgo: "{{n}} мин назад",
        hourAgo: "{{n}} ч назад",
        dayAgo: "{{n}} дн назад",
        loadingRequests: "Загрузка заявок на подписку...",
        title: "Заявки на подписку",
        pending: "{{count}} ожидает",
        requestCount: "{{count}} заявка",
        requestCountPlural: "{{count}} заявок",
        refreshing: "Обновление...",
        refresh: "Обновить",
        organization: "Организация",
        wantsToFollow: "Хочет подписаться на вас",
        accept: "Принять",
        decline: "Отклонить",
        sendMessage: "Отправить сообщение",
        noRequests: "Нет ожидающих заявок на подписку",
        noRequestsDesc: "Когда кто-то захочет подписаться на вас, его заявка появится здесь.",
        checkNewRequests: "Проверить новые заявки",
      },
      messagesWidget: {
        messages: "Сообщения",
        newMessage: "Новое сообщение",
        fullScreen: "Полный экран",
        close: "Закрыть",
        members: "участников",
        online: "В сети",
        delete: "Удалить",
        sharedPost: "Общий пост",
        sharedPostMessage: "📤 Поделился постом от {{name}}",
        unknown: "Неизвестно",
        post: "Пост",
        tapToView: "Нажмите, чтобы посмотреть пост →",
        sharingPost: "Отправка поста",
        from: "От: {{name}}",
        typeMessage: "Введите сообщение...",
        direct: "Личные",
        groups: "Группы",
        noConversations: "Разговоров пока нет",
        startNewChat: "Начать новый чат",
        noMessages: "Нет сообщений",
        noGroups: "Групп пока нет",
        browseGroups: "Просмотреть группы",
        someone: "Кто-то",
        newMessageTitle: "Новое сообщение",
        searchFollowed: "Поиск среди подписок...",
        organization: "Организация",
        user: "Пользователь",
        notFollowingAnyone: "Вы пока ни на кого не подписаны",
        followToMessage: "Подпишитесь на людей, чтобы начать переписку",
        confirmDeleteMessage: "Удалить это сообщение?",
        emojis: "Эмодзи",
        recent: "Недавние",
        smileys: "Смайлы",
        hearts: "Сердца",
        hands: "Руки",
        animals: "Животные",
        food: "Еда",
        travel: "Путешествия",
        symbols: "Символы",
        weather: "Погода",
      },
      searchModal: {
        placeholder: "Поиск пользователей, организаций, постов, сообществ...",
        postThumbnail: "Миниатюра поста",
        all: "Все",
        organizations: "Организации",
        players: "Игроки",
        posts: "Посты",
        communities: "Сообщества",
        searching: "Поиск...",
        users: "Пользователи",
        noResultsFor: 'Ничего не найдено по запросу "{{query}}"',
        tryDifferentKeywords: "Попробуйте другие ключевые слова",
        seeAllResultsFor: 'Показать все результаты по "{{query}}"',
        recentSearches: "Недавние поиски",
        clearAll: "Очистить всё",
        searchPlatform: "Поиск по платформе Greenwich",
        findPeopleEtc: "Находите людей, организации, посты и сообщества",
        organization: "Организация",
        administrator: "Администратор",
        communityMember: "Участник сообщества",
        verifiedOrganization: "Проверенная организация",
        followers: "подписчиков",
        postsCount: "постов",
        following: "Вы подписаны",
        follow: "Подписаться",
        hAgo: "{{n}} ч назад",
        dAgo: "{{n}} дн назад",
        user: "Пользователь",
        noContent: "Нет содержимого",
        likes: "лайков",
        comments: "комментариев",
        community: "Сообщество",
        members: "участников",
        privateCommunity: "Приватное сообщество",
        searchFailed: "Поиск не удался. Попробуйте позже.",
        serverError: "Ошибка сервера. Попробуйте позже.",
        cannotConnect: "Не удалось подключиться к серверу. Проверьте соединение и попробуйте снова.",
        networkError: "Ошибка сети. Попробуйте позже.",
      },
      onboarding: {
        skip: "Пропустить",
        skipTour: "Пропустить тур",
        back: "Назад",
        next: "Далее",
        start: "Начать",
        getStarted: "Начать работу",
        steps: {
          welcome:       { title: "Добро пожаловать в Greenwich!", subtitle: "Ваш новый дом для общения", content: "Мы так рады видеть вас здесь! Привет, я Эрика AI, и я буду направлять вас, пока вы изучаете и открываете всё, что может предложить наша платформа.", expression: "Рада знакомству! " },
          navigation:    { title: "Меню навигации", subtitle: "Ваш компас по Greenwich", content: "Это ваше меню навигации! Отсюда вы можете перейти на Главную, в Профиль, Сообщения и Уведомления.", expression: "Навигация по Greenwich!" },
          "create-post": { title: "Создать пост", subtitle: "Поделитесь своим голосом", content: "Пишите свои мысли, загружайте фото, делитесь видео, расскажите миру свою историю. Ваш голос важен, пусть все его услышат!", expression: "Создайте что-то! " },
          "feed-posts":  { title: "Ваша лента", subtitle: "Всё действие в одном месте", content: "Здесь вы увидите посты от людей и организаций, на которых подписаны. Ставьте лайки, комментируйте, сохраняйте и делитесь!", expression: "Лента потрясающего контента!" },
          greencoins:    { title: "Рынок Greencoin", subtitle: "Тратьте то, что зарабатываете", content: "Зарабатывайте Greencoin за активность, а затем тратьте их здесь, на реальные награды и привилегии на рынке.", expression: "Время покупок! " },
          buddy:         { title: "Greenwich Buddy", subtitle: "Найдите ментора или станьте им", content: "Buddy находит вам ментора, который уже прошёл путь, который вы хотите пройти, или позволяет вам самим стать ментором и направить кого-то другого.", expression: "Давайте знакомиться! " },
          search:        { title: "Поиск", subtitle: "Откройте для себя всё", content: "Находите новых друзей, организации, посты и темы, которые вам интересны.", expression: "Ищете? " },
          programs:      { title: "Программы и проекты", subtitle: "Возможности, которые вас ждут", content: "Открывайте текущие проекты и программы. Отслеживайте прогресс, смотрите обновления и участвуйте в инициативах, создающих реальное влияние.", expression: "Строим будущее! " },
          messages:      { title: "Сообщения", subtitle: "Где происходит волшебство", content: "Отправляйте личные сообщения, создавайте групповые беседы, делитесь фото и узнавайте, когда сообщения прочитаны.", expression: "Общайтесь с друзьями! " },
          notifications: { title: "Уведомления", subtitle: "Будьте в курсе", content: "Видите лайки, новые комментарии, заявки на подписку и сообщения. Никогда не пропустите важное обновление!", expression: "У вас есть уведомления!" },
          organization:  { title: "Организации", subtitle: "Надёжно. Признано. Значимо.", content: "Ваша организация официально верифицирована. Делитесь обновлениями, публикуйте отчёты, взаимодействуйте с участниками и демонстрируйте своё реальное влияние.", expression: "Профессионально! " },
          settings:      { title: "Настройки", subtitle: "Настройте всё под себя", content: "Управляйте конфиденциальностью, темой, настройками уведомлений и информацией об аккаунте.", expression: "Всё под контролем! " },
          communities:   { title: "Сообщества", subtitle: "Стройте своё сообщество", content: "Присоединяйтесь к группам по интересам, участвуйте в обсуждениях, сотрудничайте над проектами и заводите крепкие дружеские связи.", expression: "Радушно! " },
          final:         { title: "Всё готово!", subtitle: "Добро пожаловать в Greenwich!", content: "Теперь вы знаете все основные функции Greenwich. Будьте добры, делитесь замечательным контентом, общайтесь с прекрасными людьми и получайте удовольствие!", expression: "Добро пожаловать! " },
        },
      },
      accountProfile: {
        successSaved: "✅ Профиль успешно сохранён! Перенаправление...",
        debugImages: "Debug Images",
        editCover: "Изменить обложку",
        verifiedOrg: "Верифицированная организация",
        placeholderFullName: "Ваше полное имя",
        placeholderHeadline: "Профессиональный заголовок",
        placeholderLocation: "📍 Локация",
        placeholderEmail: "Email",
        placeholderPhone: "Телефон",
        aboutMe: "Обо мне",
        aboutPlaceholder: "Расскажите о себе, своих увлечениях и о том, что вас мотивирует...",
        quickActions: "Быстрые действия",
        myPosts: "Мои посты",
        likedPosts: "Понравившиеся посты",
        savedPosts: "Сохранённые посты",
        areasOfInterest: "Сферы интересов",
        edit: "Изменить",
        save: "Сохранить",
        selectInterestsGuide: "Выберите сферы ваших интересов:",
        noInterestsYet: "Интересы пока не выбраны",
        profileInformation: "Информация профиля",
        profileInfoNote: "Информация профиля будет обновлена после сохранения.",
        tipsTitle: "Советы для лучшего результата:",
        tip1: "Используйте качественные изображения (JPEG или PNG)",
        tip2: "Изображение профиля должно быть квадратным (соотношение 1:1)",
        tip3: "Обложка должна быть широкой (соотношение 16:9)",
        tip4: "Изменения автоматически сохраняются в вашей панели",
        cancel: "Отмена",
        saving: "Сохранение...",
        saveProfile: "Сохранить профиль",
        alertImageTooLarge: "Размер изображения должен быть менее 5 МБ",
        alertInvalidImageType: "Разрешены только изображения JPEG, PNG и GIF",
        alertErrorPrefix: "❌ Ошибка: ",
        errorUpdateFailed: "Обновление не удалось. Попробуйте снова.",
        errorUnexpected: "Произошла непредвиденная ошибка. Попробуйте снова.",
      },
      adminProgramsReview: {
        deleteTitle: "Удалить программу?",
        deleteSub: "Это действие нельзя отменить.",
        cancel: "Отмена",
        delete: "Удалить",
        needsEditSendTitle: "Требует правок, отправить комментарий",
        sendMessageTitle: "Отправить сообщение организации",
        needsEditSendSub: "Статус изменится на «требует правок». Организация получит ваше сообщение.",
        sendMessageSub: "Отправьте сообщение без изменения статуса программы.",
        program: "Программа",
        quickTemplates: "Быстрые шаблоны",
        template1Label: "Недостаёт информации",
        template1Text: "В вашей заявке отсутствует необходимая информация. Пожалуйста, обновите следующие поля и отправьте заявку повторно:\n\n• [Укажите недостающие поля]\n\nПосле обновления заявка будет рассмотрена снова.",
        template2Label: "Не соответствует требованиям",
        template2Text: "К сожалению, ваша программа в настоящее время не соответствует требованиям платформы. А именно:\n\n• [Опишите проблему]\n\nПожалуйста, ознакомьтесь с нашими правилами подачи заявок и рассмотрите возможность повторной отправки с необходимыми изменениями.",
        template3Label: "Обновить и отправить снова",
        template3Text: "Спасибо за отправку вашей программы. Мы не смогли одобрить её в текущем виде, но рекомендуем внести следующие изменения и отправить снова:\n\n• [Перечислите необходимые изменения]\n\nМы с нетерпением ждём вашу обновлённую заявку.",
        template4Label: "Повторная заявка",
        template4Text: "Похоже, похожая программа уже существует на нашей платформе. Пожалуйста, проверьте существующие списки перед повторной отправкой, либо свяжитесь с нами, если считаете это ошибкой.",
        messagePlaceholder: "Напишите ваше сообщение здесь…",
        feedbackHint: "Организация увидит это сообщение и сможет отредактировать и отправить заявку снова.",
        needsEditAndSend: "Требует правок и отправить",
        sendMessage: "Отправить сообщение",
        pageTitle: "Проверка программ",
        pageSubtitle: "Заявки организаций. Одобренные появляются в /programs",
        pendingChip: "{{count}} на рассмотрении",
        refresh: "Обновить",
        tabPending: "На рассмотрении",
        tabApproved: "Одобрено",
        tabNeedsEdit: "Требует правок",
        tabRejected: "Отклонено",
        tabAll: "Все",
        loadingPrograms: "Загружаем программы…",
        noProgramsAll: "Программ нет",
        noProgramsFiltered: "Нет программ со статусом «{{status}}»",
        statusWordPending: "на рассмотрении",
        statusWordApproved: "одобрено",
        statusWordNeedsEdit: "требует правок",
        statusWordRejected: "отклонено",
        nothingToShow: "Здесь пока нечего показать.",
        saving: "Сохранение…",
        titlePlaceholder: "Название",
        categoryPlaceholder: "Категория",
        descriptionPlaceholder: "Описание",
        uploadImage: "Загрузить изображение",
        remove: "Удалить",
        pasteImageUrl: "Или вставьте ссылку на изображение…",
        save: "Сохранить",
        statusPending: "На рассмотрении",
        statusApproved: "Одобрено",
        statusNeedsEdit: "Требует правок",
        statusRejected: "Отклонено",
        defaultOrgName: "Организация",
        feedbackSent: "Комментарий отправлен",
        sendMessageTooltip: "Отправить сообщение",
        editTooltip: "Изменить",
        deleteTooltip: "Удалить",
        lastFeedback: "Последний комментарий",
        approve: "Одобрить",
        needsEdit: "Требует правок",
        reject: "Отклонить",
        waitingForEdits: "Ожидаем правок от организации",
        visibleInPrograms: "Видна в /programs",
        revoke: "Отозвать",
        reApprove: "Одобрить повторно",
        sendFeedback: "Отправить комментарий",
        deadline: "Срок подачи",
        location: "Локация",
        education: "Образование",
        organization: "Организация",
        description: "Описание",
        openProgram: "Открыть программу",
        view: "Смотреть",
        toastApproved: "Программа одобрена",
        toastNeedsEdit: "Отмечено как «требует правок»",
        toastRejected: "Программа отклонена",
        toastDone: "Готово",
        toastFeedbackSent: "Комментарий отправлен организации",
        toastDeleted: "Программа удалена",
        toastUpdated: "Программа обновлена",
        toastImageTooLarge: "Размер изображения должен быть меньше 5 МБ",
      },
      orgSettings: {
        pageTitle: "Настройки организации",
        pageSubtitle: "Управляйте регистрационными данными и информацией вашей организации",
        tabProfile: "Профиль организации",
        tabContact: "Контакты и сети",
        tabTeam: "Команда и безопасность",
        tabVerification: "Верификация",
        edit: "Изменить",
        save: "Сохранить",
        saving: "Сохранение...",
        notSet: "Не указано",
        step1Title: "Шаг 1: Профиль организации",
        orgNames: "Названия организации",
        langArmenian: "Армянский",
        langEnglish: "Английский",
        langRussian: "Русский",
        orgNamePlaceholder: "Название организации",
        addName: "Добавить название",
        orgType: "Тип организации",
        addCustomTypePlaceholder: "Добавить свой тип",
        description: "Описание",
        mission: "Миссия",
        focusAreas: "Направления деятельности",
        establishedYear: "Год основания",
        legalForm: "Организационно-правовая форма",
        step2Title: "Шаг 2: Контакты и сети",
        contactEmail: "Контактный email",
        primaryPhone: "Основной телефон",
        secondaryPhone: "Дополнительный телефон",
        address: "Адрес",
        website: "Сайт",
        socialLinks: "Ссылки на соцсети",
        socialLinkPlaceholder: "https://...",
        addLink: "Добавить ссылку",
        noSocialLinks: "Ссылок на соцсети нет",
        networks: "Сети",
        step3Title: "Шаг 3: Команда и безопасность",
        secureSealText: "Текст защищённой печати",
        authorizedMembers: "Уполномоченные члены команды",
        memberNum: "Участник №{{n}}",
        fullNamePlaceholder: "Полное имя",
        rolePlaceholder: "Роль",
        emailPlaceholder: "Email",
        addMember: "Добавить участника",
        noMembers: "Участники не добавлены",
        step4Title: "Шаг 4: Верификация и вход",
        username: "Имя пользователя",
        email: "Email",
        representativeName: "Имя представителя",
        representativeEmail: "Email представителя",
        stateRegistrationId: "Номер госрегистрации",
        vatNumber: "Номер НДС",
        alertSavedSuccess: "Настройки успешно сохранены!",
        alertErrorSaving: "Ошибка сохранения: ",
        alertErrorSavingSettings: "Ошибка сохранения настроек: ",
      },
      orgAccountProfile: {
        editCover: "Изменить обложку",
        followers: "Подписчики",
        following: "Подписки",
        placeholderOrgName: "Название организации",
        placeholderOrgType: "Тип организации / Заголовок",
        placeholderLocation: "📍 Локация",
        placeholderEmail: "Email",
        placeholderPhone: "Телефон",
        quickActions: "Быстрые действия",
        myPosts: "Мои посты",
        likedPosts: "Понравившиеся посты",
        savedPosts: "Сохранённые посты",
        aboutOrg: "О организации",
        aboutPlaceholder: "Расскажите об истории, миссии и мотивации вашей организации...",
        areasOfInterest: "Сферы интересов",
        edit: "Изменить",
        save: "Сохранить",
        selectInterestsGuide: "Выберите сферы ваших интересов:",
        noInterestsYet: "Интересы пока не выбраны",
        createPost: "Создать пост",
        postPlaceholder: "Поделитесь своими мыслями...",
        addPhoto: "Добавить фото",
        post: "Опубликовать",
        orgPosts: "Посты организации",
        noPostsYet: "Постов пока нет. Поделитесь своим первым постом выше!",
        orgActivities: "Деятельность организации",
        activityNamePlaceholder: "Название мероприятия или проекта",
        partnerOrgPlaceholder: "Организация-партнёр",
        activityDescPlaceholder: "Опишите деятельность и достижения вашей организации...",
        addActivity: "Добавить деятельность",
        previewProfile: "Просмотр профиля",
        saveContinue: "Сохранить и перейти в панель",
        defaultOrgFallback: "Организация",
        coverAlt: "Обложка",
        profileAlt: "Профиль",
        verifiedOrgTitle: "Проверенная организация",
        uploadAlt: "Загрузить",
        postPreviewAlt: "Превью поста",
        postAlt: "Пост",
        alertPleaseLogin: "Пожалуйста, войдите снова",
        alertInvalidResponse: "Сервер вернул некорректный ответ. Подробности в консоли.",
        alertErrorCreating: "Ошибка при создании поста: ",
        alertNetworkError: "Ошибка сети: ",
        alertEnterContent: "Пожалуйста, введите текст или добавьте изображение",
        alertPostSuccess: "Пост успешно создан!",
        interests: {
          environment: "Экология", education: "Образование", technology: "Технологии", health: "Здоровье",
          artsCulture: "Искусство и культура", communityDevelopment: "Развитие сообщества", humanRights: "Права человека",
          socialInclusion: "Социальная инклюзия", internationalExchanges: "Международные обмены", entrepreneurship: "Предпринимательство",
        },
      },
      orgProgramSubmit: {
        greencoinToggle: "Награждать участников greencoins",
        greencoinPitch: "Программы с greencoins привлекают больше заявок. Участники, завершившие эту программу, получат указанное ниже количество, которое можно обменять в нашем магазине наград. Стоимость списывается с баланса greencoins вашей организации в момент подтверждения каждого участника.",
        greencoinAmountLabel: "Greencoins на участника",
        greencoinBalance: "Ваш баланс: {{balance}}",
        greencoinLowBalance: "Это больше, чем ваш текущий баланс. Пополните его до того, как участники начнут завершать программу, иначе кто-то может остаться без награды.",
        successTitle: "Программа отправлена!",
        successBodyPre: "Ваша программа теперь ",
        successBodyBold: "ожидает рассмотрения администратором",
        successBodyPost: ". Она появится в /programs после одобрения.",
        viewMySubmissions: "Смотреть мои заявки",
        submitAnother: "Отправить ещё одну",
        title: "Отправить программу",
        subtitle: "Те же поля, что и в форме администратора, рассматривается перед публикацией",
        defaultOrgName: "Организация",
        uploadCoverImage: "Загрузить обложку",
        coverImageHint: "Рекомендуется: 1200×630px",
        coverImageAlt: "Обложка",
        programTitle: "Название программы",
        programTitlePlaceholder: "напр. Erasmus+ Youth Exchange 2026",
        description: "Описание",
        descriptionPlaceholder: "Что предлагает программа, для кого она…",
        categories: "Категории",
        categoriesHint: " (множественный выбор, как у администратора)",
        sectors: "Сферы",
        sectorsHint: " (множественный выбор, как у администратора)",
        programUrl: "Ссылка на программу / заявку",
        source: "Источник",
        location: "Локация",
        locationPlaceholder: "напр. Ереван, Армения",
        format: "Формат",
        formatPlaceholder: "напр. Online, Hybrid, On-site",
        educationLevel: "Уровень образования",
        eduAny: "Любой / Не указано",
        eduHighSchool: "Школа",
        eduStudent: "Студент",
        eduUndergrad: "Бакалавриат",
        eduGrad: "Магистратура",
        eduDoctoral: "Докторантура",
        eduProfessional: "Профессиональный",
        startDate: "Дата начала",
        endDate: "Дата окончания",
        deadline: "Срок подачи заявки",
        fundingType: "Тип финансирования",
        fundingTypePlaceholder: "напр. Полное финансирование, Частичное…",
        targetGroup: "Целевая группа",
        targetGroupPlaceholder: "напр. Молодёжь 18-30, исследователи…",
        requirements: "Требования / право на участие",
        requirementsPlaceholder: "Возраст, гражданство, уровень языка и т.д. (добавляется к описанию для рецензентов)",
        reviewNotice: "Требуется проверка администратором. Категории и сферы соответствуют публичным фильтрам страницы Программы после одобрения.",
        submitting: "Отправка…",
        submitForReview: "Отправить на проверку ✓",
        errorTitleDesc: "Название и описание обязательны.",
        errorCategory: "Выберите хотя бы одну категорию (как в форме администратора).",
        errorSector: "Выберите хотя бы одну сферу (как в форме администратора).",
        errorSubmitFailed: "Отправка не удалась. Попробуйте снова.",
        errorNetwork: "Ошибка сети. Попробуйте снова.",
        sectorLabels: {
          ecology: "Экология", international: "Международное", technology: "Технологии", medical: "Медицина",
          education: "Образование", business: "Бизнес", arts: "Искусство и культура", science: "Наука",
          sports: "Спорт", agriculture: "Сельское хозяйство", local: "Местное", media: "Медиа",
        },
        categoryLabels: {
          education: "Образование", scholarship: "Стипендия", fellowship: "Фелоушип", erasmusplus: "Erasmus Plus",
          training: "Тренинг", grant: "Грант", internship: "Стажировка", conference: "Конференция",
          online: "Онлайн", volunteering: "Волонтёрство", event: "Событие", award: "Награда",
        },
      },
      organizationGreencoins: {
        back: "Назад",
        title: "Кошелёк Greencoin",
        subtitle: "Покупай greencoins и трать их на награды участникам, завершившим твои программы.",
        balanceLabel: "Текущий баланс",
        buyTitle: "Купить greencoins",
        buyNote: "Оплата сейчас подтверждается вручную. Отправь заявку ниже, и наша команда свяжется, чтобы подтвердить оплату и сразу пополнить баланс.",
        selfServiceLocked: "Прямая покупка greencoins пока недоступна. Свяжитесь с нашей командой, и мы всё настроим.",
        buyButton: "Купить сейчас",
        sending: "Отправка...",
        requestSent: "Заявка отправлена. Мы свяжемся для подтверждения оплаты.",
        requestError: "Не удалось отправить заявку. Попробуйте ещё раз.",
        pendingTitle: "Ожидающие заявки",
        pendingStatus: "Ждёт подтверждения",
        historyTitle: "История",
        historyEmpty: "Пока нет транзакций.",
        txTopup: "Пополнение баланса",
        txSpend: "Награда выплачена участнику",
        perksTitle: "Что дают greencoins",
        perks: {
          reward: { title: "Награждай участников", desc: "Прикрепи greencoin-награду к своим программам, чтобы участники, завершившие их, получали её автоматически." },
          completion: { title: "Больше завершений", desc: "Программы с наградой показывают более высокую конверсию из записи в завершение." },
          flexible: { title: "Гибкие суммы", desc: "Установи любую награду для каждой программы и купи ровно столько greencoins, сколько нужно." },
        },
        greencoinsLabel: "greencoins",
        amdPerCoin: "AMD / coin",
        payTitle: "Оплата банковским переводом",
        payBank: "Банк",
        payAccount: "Номер счёта",
        payRecipient: "Получатель",
        payReferenceHint: "Укажи название организации как назначение платежа, чтобы мы могли сопоставить перевод.",
        interestTitle: "Пока не запущено",
        interestBody: "Покупка greencoins пока недоступна на сайте. Оставь email, и мы сообщим, как только она заработает.",
        interestEmailPlaceholder: "you@organization.org",
        interestSubmit: "Уведомить меня",
        interestError: "Не удалось отправить. Попробуйте ещё раз.",
        payWithCard: "Оплатить картой",
        redirectingToBank: "Перенаправляем в банк...",
        cardPaymentSuccess: "Оплата прошла успешно, баланс пополнен!",
        cardPaymentFailed: "Оплата не прошла. Можно попробовать ещё раз.",
        cardPaymentError: "Во время оплаты произошла ошибка. Попробуйте ещё раз.",
        interestDoneTitle: "Спасибо!",
        interestDoneBody: "Мы записали твой интерес и напишем на почту, как только покупка greencoins станет доступна.",
        interestClose: "Закрыть",
      },
      organizationPanel: {
        back: "Назад",
        title: "Панель организации",
        subtitle: "Активность вашей организации, опубликованные проекты и greencoin-награды, всё в одном месте.",
        loading: "Загрузка...",
        tabOverview: "Обзор",
        tabPrograms: "Проекты",
        tabGreencoins: "Greencoins",
        statsTitle: "Общая картина",
        statProfileViews: "Просмотры профиля",
        statFollowers: "Подписчики",
        statPrograms: "Проекты",
        statProgramViews: "Просмотры проектов",
        statApplyClicks: "Клики «откликнуться»",
        statApplicants: "Заявители",
        statusApproved: "одобрено",
        statusPending: "на проверке",
        programsTitle: "Ваши проекты",
        publishNew: "Опубликовать проект",
        noPrograms: "Вы ещё не опубликовали ни одного проекта.",
        viewsLabel: "просмотров",
        clicksLabel: "кликов",
        manageAll: "Управлять всеми заявками",
        status: {
          approved: "Одобрено",
          pending: "На проверке",
          needs_edit: "Нужна правка",
          rejected: "Отклонено",
        },
        greencoinsTitle: "Greencoin-награды",
        buyGreencoins: "Купить greencoins",
        balanceLabel: "Баланс кошелька",
        rewardsNote: "Задай, сколько greencoins получает участник за завершение каждого проекта. Сумму можно менять в любой момент, даже когда проект уже идёт.",
        noApprovedPrograms: "Пока нет одобренных проектов.",
        rewardLabel: "Greencoin-награда",
        rewardSaveError: "Не удалось сохранить награду. Попробуйте ещё раз.",
        lowBalanceWarning: "Баланс кошелька меньше этой награды. Пополни его, чтобы участники получали выплату.",
        tabUsers: "Пользователи",
        users: {
          title: "Создать аккаунт пользователя",
          subtitle: "Создай логин и пароль для того, кто не будет регистрироваться сам: это обычный аккаунт, не привязанный к твоей организации. Он входит по этим данным и сам настраивает свой публичный профиль (фото, обложку, описание, акцентный цвет) в Настройках.",
          namePlaceholder: "Имя",
          surnamePlaceholder: "Фамилия (необязательно)",
          emailPlaceholder: "Email",
          passwordPlaceholder: "Пароль",
          createBtn: "Создать аккаунт",
          creating: "Создаём...",
          created: "Аккаунт создан для {{email}}",
          createError: "Не удалось создать аккаунт. Попробуйте ещё раз.",
          listTitle: "Созданные вами аккаунты",
          empty: "Вы ещё не создавали аккаунты пользователей.",
        },
      },
      greencoinsPage: {
        back: "Назад",
        title: "Гринкоины",
        subtitle: "Зарабатывай гринкоины на платформе и трать их в магазине Greenwich.",
        balanceLabel: "Твой баланс",
        goToShop: "Перейти в магазин",
        tabEarned: "Заработано",
        tabSpent: "Потрачено",
        tabWays: "Как заработать",
        earnedEmpty: "Пока нет заработанных гринкоинов. Начни с заполнения профиля или участия в программе.",
        spentEmpty: "Пока нет покупок.",
        waysIntro: "Повседневные способы заработать гринкоины на Greenwich:",
        aboutTitle: "Что такое greencoins?",
        aboutBody: "Greencoins не деньги, а внутренняя система признания Greenwich: их получаешь за активность и вовлечённость на платформе. Сейчас их нельзя обменять на настоящие деньги, но в будущем эта опция появится.",
        aboutPerks: {
          redeem: { title: "Настоящие призы", desc: "Обменивай заработанное на реальные призы и бонусы в Greenwich Shop." },
          motivation: { title: "Признание, а не валюта", desc: "Способ измерить и отметить реальный вклад, а не деньги." },
          future: { title: "Вывод в деньги: позже", desc: "Обменять greencoins на настоящие деньги пока нельзя, но это уже в наших планах." },
        },
        stat5x: "Посты и проекты с greencoin-наградой получают примерно в 5 раз больше интереса от участников.",
        actions: {
          account_verified: "Подтверждение аккаунта",
          profile_complete: "Заполнение профиля",
          onboarding_complete: "Завершение онбординга",
          program_apply: "Подача заявки на программу",
          program_apply_milestone_10: "Подача заявок на 10 программ (единоразово)",
          program_accepted: "Принятие в программу",
          event_attended: "Прохождение/участие в программе",
          project_joined: "Вступление в проект/сообщество",
          review_written: "Написание отзыва",
          daily_login: "Ежедневный вход",
          login_streak_7: "7-дневная серия входов",
          buddy_mentee_completed: "Завершение Buddy-менторства как менти",
          buddy_mentor_completed: "Завершение Buddy-менторства как ментор",
          buddy_mentor_certificate: "Получение сертификата Buddy-ментора",
          referral_signup: "Каждый друг, который зарегистрировался по вашей ссылке",
          social_event_participation: "Участие в значимом социальном/общественном мероприятии",
        },
      },
      orgMySubmissions: {
        title: "Мои заявки",
        subtitle: "Отслеживайте и управляйте отправленными программами",
        refresh: "Обновить",
        greencoinWallet: "Кошелёк Greencoin",
        submitNew: "Отправить новую",
        statTotal: "Всего",
        statPending: "На рассмотрении",
        statApproved: "Одобрено",
        statNeedsEdit: "Требует правок",
        loading: "Загружаем ваши заявки…",
        emptyTitleAll: "Заявок пока нет",
        emptyTitleFiltered: "Нет программ со статусом «{{filter}}»",
        emptyBodyAll: "Отправьте свою первую программу, чтобы начать.",
        emptyBodyFiltered: "У вас пока нет программ со статусом «{{filter}}».",
        submitProgram: "Отправить программу",
        filterNames: { pending: "на рассмотрении", approved: "одобрено", rejected: "отклонено" },
        statusPending: "На рассмотрении",
        statusApproved: "Одобрено",
        statusRejected: "Не одобрено",
        submitted: "Отправлено {{date}}",
        editResubmitHeading: "Редактировать и отправить снова",
        fieldTitle: "Название программы *",
        fieldTitlePlaceholder: "Название",
        fieldWebsite: "Сайт / Ссылка на заявку",
        fieldUrlPlaceholder: "https://…",
        fieldLocation: "Локация",
        fieldLocationPlaceholder: "Город, страна или Online",
        fieldDeadline: "Срок подачи",
        fieldDescription: "Описание *",
        fieldDescriptionPlaceholder: "Опишите вашу программу…",
        fieldRequirements: "Требования",
        fieldRequirementsPlaceholder: "Требования к участникам…",
        fieldBenefits: "Преимущества",
        fieldBenefitsPlaceholder: "Что получают участники…",
        fieldCoverImage: "Ссылка на обложку",
        cancel: "Отмена",
        resubmitForReview: "Отправить на повторную проверку",
        viewProgram: "Смотреть программу",
        messageFromAdmin: "Сообщение от администратора",
        feedbackCta: "Пожалуйста, ознакомьтесь с комментарием выше и отправьте программу повторно с необходимыми изменениями.",
        pendingNotice: "Ваша программа находится на рассмотрении. Мы сообщим вам, как только будет принято решение.",
        approvedNotice: "Ваша программа опубликована и видна на странице Программы.",
        viewArrow: "Смотреть →",
        editAndResubmit: "Редактировать и отправить снова",
        updateAndResubmit: "Обновить и отправить снова",
        resubmittedToast: "🔄 Отправлено на повторную проверку!",
        savedLocallyToast: "🔄 Сохранено локально, синхронизируется при подключении к сети.",
        statusNeedsEdit: "Требует правок",
        applications: "Заявки участников",
        withdraw: "Отозвать",
        confirmWithdraw: "Отозвать эту заявку? Это действие нельзя отменить.",
        withdrawnToast: "Заявка отозвана",
        withdrawFailedToast: "Не удалось отозвать заявку",
      },
      shareMenu: {
        sharePost: "Поделиться постом",
        copyLink: "Скопировать ссылку",
        defaultShareText: "Посмотрите этот пост",
      },
      userPublicProfile: {
        loginRequired: "Чтобы просматривать профили, необходимо войти в систему.",
        loadingProfile: "Загрузка профиля...",
        userNotFound: "Пользователь не найден",
        goBack: "Назад",
        failedLoadProfile: "Не удалось загрузить профиль.",
        failedLoadPosts: "Не удалось загрузить посты.",
        justNow: "Только что",
        minutesAgo: "{{n}} мин. назад",
        hoursAgo: "{{n}} ч. назад",
        daysAgo: "{{n}} дн. назад",
        confirmBlock: "Заблокировать {{name}}? Этот пользователь не сможет подписаться на вас или написать вам.",
        userMuted: "Пользователь заглушён, его посты скрыты из вашей ленты",
        userUnmuted: "Пользователь больше не заглушён",
        userBlocked: "Пользователь заблокирован",
        userUnblocked: "Пользователь разблокирован",
        failedToMuteUser: "Не удалось заглушить пользователя",
        failedToUnmuteUser: "Не удалось снять заглушение с пользователя",
        failedToBlockUser: "Не удалось заблокировать пользователя",
        failedToUnblockUser: "Не удалось разблокировать пользователя",
        reportSubmitted: "Жалоба отправлена. Спасибо, что помогаете поддерживать безопасность сообщества.",
        failedSubmitReport: "Не удалось отправить жалобу",
        needMutualFollowMessage: "Чтобы отправлять сообщения, вы должны подписаться друг на друга",
        messageSent: "Сообщение отправлено!",
        failedSendMessage: "Не удалось отправить сообщение",
        failedStartConversation: "Не удалось начать беседу",
        profileLinkCopied: "Ссылка на профиль скопирована!",
        failedShareProfile: "Не удалось поделиться профилем",
        back: "Назад",
        coverAlt: "Обложка",
        verified: "Подтверждён",
        verifiedOrg: "Подтверждённая организация",
        organization: "Организация",
        communityMember: "Участник сообщества",
        approved: "Одобрено",
        message: "Написать",
        copied: "Скопировано!",
        copyLink: "Скопировать ссылку",
        shareOnFacebook: "Поделиться в Facebook",
        moreOptions: "Дополнительные опции",
        pleaseWait: "Пожалуйста, подождите…",
        unmute: "Включить звук",
        mutePosts: "Заглушить посты",
        unblock: "Разблокировать",
        blockUser: "Заблокировать пользователя",
        reportUser: "Пожаловаться на пользователя",
        postsLabel: "Посты",
        aboutLabel: "О себе",
        reportsTabLabel: "Отчёты",
        portfolioLabel: "Портфолио",
        certificatesLabel: "Сертификаты",
        followersLabel: "Подписчики",
        followingLabel: "Подписки",
        joined: "Присоединился {{date}}",
        quickMessagePlaceholder: "Отправить короткое сообщение…",
        noPostsYet: "Пока нет постов",
        postImageAlt: "Изображение поста {{n}}",
        postAlt: "Пост",
        nameLabel: "Имя",
        emailLabel: "Эл. почта",
        phoneLabel: "Телефон",
        locationLabel: "Местоположение",
        interestsLabel: "Интересы",
        missionLabel: "Миссия",
        reportsTitle: "Отчёты и лицензии",
        noReportsYet: "Отчёты пока не загружены.",
        view: "Просмотр",
        download: "Скачать",
        noPortfolioYet: "В портфолио пока ничего нет.",
        noCertificatesYet: "Сертификаты пока не добавлены.",
        viewPdf: "Открыть PDF",
        noFollowersYet: "Пока нет подписчиков",
        orgBadge: "Орг.",
        followsYou: "Подписан на вас",
        friends: "Друзья",
        notFollowingAnyone: "Пока ни на кого не подписан",
        mutual: "Взаимно",
        previewNotAvailable: "Предпросмотр недоступен для этого типа файла.",
        reportModalTitle: "Пожаловаться на {{name}}",
        reportModalSubtitle: "Выберите причину. Это анонимно для пользователя, на которого вы жалуетесь.",
        reportReasons: {
          spam: "Спам",
          inappropriate: "Неприемлемый контент",
          harassment: "Домогательства",
          hateSpeech: "Язык вражды",
          misinformation: "Дезинформация",
          other: "Другое",
        },
        detailsPlaceholder: "Дополнительные детали (необязательно)",
        cancel: "Отмена",
        submitting: "Отправка…",
        submitReport: "Отправить жалобу",
        comments: "Комментарии",
        noCommentsYet: "Комментариев пока нет. Будьте первым!",
        addCommentPlaceholder: "Добавить комментарий…",
        interests: {
          environment: "Экология", education: "Образование", technology: "Технологии", health: "Здоровье",
          artsCulture: "Искусство и культура", communityDevelopment: "Развитие сообщества", humanRights: "Права человека",
          socialInclusion: "Социальная инклюзия", internationalExchanges: "Международные обмены", entrepreneurship: "Предпринимательство",
        },
      },
      blockedMuted: {
        pleaseLogin: "Пожалуйста, войдите, чтобы просмотреть эту страницу",
        backToSettings: "Назад к настройкам",
        blockedTitle: "Заблокированные аккаунты",
        blockedSubtitle: "Заблокированные вами люди не могут подписаться на вас, писать вам или видеть ваш профиль.",
        failedLoadBlocked: "Не удалось загрузить заблокированные аккаунты",
        userUnblocked: "Пользователь разблокирован",
        failedUnblock: "Не удалось разблокировать пользователя",
        noBlocked: "Нет заблокированных аккаунтов",
        blockedEmptyHint: "Заблокированные вами аккаунты появятся здесь.",
        unblocking: "Разблокировка…",
        unblock: "Разблокировать",
        mutedTitle: "Отключённые аккаунты",
        mutedSubtitle: "Их посты скрыты из вашей ленты. Вы всё ещё подписаны друг на друга и можете переписываться как обычно. Они не получают уведомлений.",
        failedLoadMuted: "Не удалось загрузить отключённые аккаунты",
        userUnmuted: "Уведомления включены обратно",
        failedUnmute: "Не удалось включить уведомления",
        noMuted: "Нет отключённых аккаунтов",
        mutedEmptyHint: "Отключённые вами аккаунты появятся здесь.",
        unmuting: "Включение…",
        unmute: "Включить",
        loading: "Загрузка...",
      },
      orgDashboard: {
        organization: "Организация",
        noLocation: "Местоположение не указано",
        noEmail: "Email не указан",
        aboutOrg: "О организации",
        noDescription: "Описания пока нет",
        areasOfInterest: "Сферы интересов",
        noInterests: "Интересы пока не выбраны",
        welcomeTitle: "Добро пожаловать в панель вашей организации",
        welcomeMessage: "С возвращением, {{name}}! Это панель вашей организации, где можно управлять профилем и активностями.",
        quickActions: "Быстрые действия",
        panel: "Панель организации",
        editProfile: "Редактировать профиль",
        viewActivities: "Посмотреть активности",
        settings: "Настройки",
        recentActivity: "Недавняя активность",
        profileCompleted: "Профиль организации успешно заполнен",
        interestsUpdated: "Интересы обновлены",
        today: "Сегодня",
      },
      orgVerification: {
        sectionTitle: "Верификация",
        pitch: "Получите значок верификации и право участвовать в рейтинге организаций. Отправьте юридические документы на быструю проверку.",
        benefitBadge: "Значок верификации в профиле и публикациях",
        benefitRanking: "Право участвовать в рейтинге организаций и попасть в подборки",
        startBtn: "Пройти верификацию",
        resubmitBtn: "Отправить заявку повторно",
        statusPending: "Заявка на верификацию отправлена",
        statusApproved: "Организация верифицирована",
        statusRejected: "Заявка на верификацию отклонена",
        etaHint: "Обычно проверка занимает до недели.",
        modalTitle: "Заявка на верификацию",
        modalSubtitle: "Отправьте юридические данные и документы на проверку",
        registrantRoleQuestion: "Вы сама организация или её представитель?",
        registrantRoleOrg: "Организация",
        registrantRoleRep: "Я представитель",
        name: "Имя",
        surname: "Фамилия",
        position: "Должность",
        phone: "Телефон",
        email: "Email",
        isInformalQuestion: "Ваша организация неформальная / незарегистрированная группа?",
        formallyRegistered: "Нет, официально зарегистрирована",
        informal: "Да, неформальная",
        stateRegNumber: "Номер государственной регистрации",
        countryOfReg: "Страна регистрации",
        dateOfReg: "Дата регистрации",
        taxId: "ИНН / Юридический ID",
        vatNumber: "Номер НДС",
        registeredAddress: "Юридический адрес",
        documentsTitle: "Документы",
        registrationDoc: "Регистрационный документ",
        vatCertificate: "Сертификат НДС",
        stateSeal: "Государственная печать",
        passportScan: "Скан паспорта представителя",
        uploadShort: "Загрузить",
        alreadyUploaded: "уже загружен",
        errorRole: "Укажите, вы организация или её представитель",
        errorRep: "Имя, фамилия и должность представителя обязательны",
        errorLegal: "Все поля юридической регистрации обязательны, если вы не неформальная группа",
        errorSubmit: "Не удалось отправить заявку. Попробуйте снова.",
        fileTooLarge: "Файлы должны быть меньше 8МБ.",
        submitting: "Отправка...",
        submit: "Отправить на проверку",
      },
      supportChat: {
        title: "Поддержка Greenwich",
        welcome: "Привет! Спроси меня о том, как работает Greenwich: программы, заявки, организации, Pro, гринкоины и всё остальное.",
        placeholder: "Напиши свой вопрос...",
        error: "Что-то пошло не так. Попробуй ещё раз.",
        leaveContact: "Поговорить с человеком, оставить контакт",
        contactIntro: "Оставь своё имя и способ связи. Админ свяжется с тобой напрямую.",
        contactNamePlaceholder: "Твоё имя",
        contactInfoPlaceholder: "Email или номер телефона",
        contactNotePlaceholder: "О чём вопрос? (необязательно)",
        contactSubmit: "Отправить",
        contactSending: "Отправка...",
        contactSent: "Спасибо! Админ скоро свяжется с тобой.",
        backToChat: "← Назад к чату",
      },
      activeSessions: {
        pleaseLogin: "Пожалуйста, войдите, чтобы просмотреть эту страницу",
        backToSettings: "Назад к настройкам",
        title: "Активные сессии",
        subtitle: "Устройства, на которых сейчас выполнен вход в ваш аккаунт. Выйдите на тех, что вы не узнаёте.",
        failedLoad: "Не удалось загрузить сессии",
        deviceLoggedOut: "Выход с устройства выполнен",
        failedLogout: "Не удалось выйти с устройства",
        confirmRevokeAll: "Выйти со всех остальных устройств?",
        loggedOutAll: "Выполнен выход со всех остальных устройств",
        failedLogoutAll: "Не удалось выйти с остальных устройств",
        loading: "Загрузка...",
        noSessions: "Отслеживаемых сессий пока нет. Они появятся при входах после запуска этой функции.",
        thisDevice: "Это устройство",
        loggingOut: "Выход…",
        logout: "Выйти",
        logoutOtherDevices: "Выйти с остальных устройств ({{count}})",
        activeJustNow: "Активен только что",
        activeMinAgo: "Активен {{n}} мин назад",
        activeHourAgo: "Активен {{n}} ч назад",
        activeDayAgo: "Активен {{n}} дн назад",
        unknownBrowser: "Неизвестный браузер",
        unknownDevice: "Неизвестное устройство",
        onDevice: "{{browser}} на {{os}}",
      },
      socialAuth: {
        googleLoadFailed: "Не удалось загрузить вход через Google.",
        facebookLoadFailed: "Не удалось загрузить вход через Facebook.",
        googleCancelled: "Вход через Google отменён.",
        googleFailed: "Не удалось войти через Google.",
        facebookCancelled: "Вход через Facebook отменён.",
        facebookFailed: "Не удалось войти через Facebook.",
        signUpWith: "Зарегистрироваться через",
        continueWith: "Продолжить через",
        connectingGoogle: "Подключение к Google...",
        connectingFacebook: "Подключение к Facebook...",
        configHint: "Вход через соцсети временно недоступен.",
      },
      playerInterest: {
        loading: "Загрузка...",
        maxInterests: "Можно выбрать не более 5 интересов",
        selectAtLeastOne: "Пожалуйста, выберите хотя бы один интерес",
        failedSave: "Не удалось сохранить интересы",
        errorSaving: "Произошла ошибка при сохранении ваших интересов",
        detailsTitle: "Заполни свой профиль",
        detailsSubtitle: "Пара быстрых деталей, чтобы тебя могли найти и узнать.",
        usernameLabel: "Имя пользователя",
        usernamePlaceholder: "например, john_doe",
        nameLabel: "Имя",
        surnameLabel: "Фамилия",
        dobLabel: "Дата рождения",
        invalidUsername: "Имя пользователя должно содержать 3-20 символов: строчные буквы, цифры, подчёркивания или точки",
        usernameChecking: "Проверка доступности...",
        usernameAvailable: "Имя пользователя доступно",
        usernameTaken: "Это имя пользователя уже занято",
        nameRequired: "Пожалуйста, введите ваше имя",
        title: "Что тебе интересно?",
        subtitle: "Выбери до 5. Именно это использует наш AI-подбор, чтобы находить программы, которые правда тебе подойдут.",
        selected: "Выбрано",
        skipForNow: "Пропустить пока",
        saving: "Сохранение...",
        continueBtn: "Продолжить",
        interestEnvironment: "Экология",
        interestEducation: "Образование",
        interestTechnology: "Технологии",
        interestHealth: "Здоровье",
        interestArts: "Искусство и культура",
        interestCommunityDev: "Развитие сообщества",
        interestHumanRights: "Права человека",
        interestSocialInclusion: "Социальная инклюзия",
        interestIntlExchanges: "Международные обмены",
        interestEntrepreneurship: "Предпринимательство",
      },
      orgActivities: {
        noToken: "Токен авторизации не найден.",
        confirmDeletePost: "Удалить этот пост?",
        deleteError: "Ошибка удаления: {{message}}",
        noPostsYet: "Постов пока нет",
        organization: "Организация",
        loadingTab: "Загрузка {{tab}}...",
        error: "Ошибка: {{message}}",
        orgCreatedPost: "Ваша организация создала пост",
        noActivityYet: "Активности пока нет",
        title: "Активность организации",
        subtitle: "Отслеживайте посты и взаимодействия",
        all: "Все",
        posts: "Посты",
        liked: "Понравившиеся",
        saved: "Сохранённые",
        profileAlt: "Профиль",
        postAlt: "Пост",
        deleteFailed: "Не удалось удалить",
      },
      activities: {
        noToken: "Токен авторизации не найден. Пожалуйста, войдите снова.",
        unknownApiError: "Неизвестная ошибка API",
        confirmDeletePost: "Вы уверены, что хотите удалить этот пост? Он будет перемещён в корзину на 30 дней перед окончательным удалением.",
        errorDeletingPost: "Ошибка удаления поста: {{message}}",
        justNow: "Только что",
        hoursAgo: "{{n}} ч назад",
        daysAgo: "{{n}} дн назад",
        errorLoadingTitle: "Ошибка загрузки данных",
        tryAgain: "Попробовать снова",
        loadingYour: "Загрузка: {{tab}}...",
        noActivitiesYet: "Активности пока нет. Начните с создания первого поста!",
        noPostsYetCreate: "Постов пока нет. Создайте первый пост из своего профиля!",
        noLikedYet: "Понравившихся постов пока нет. Начните изучать и лайкать посты!",
        noSavedYet: "Сохранённых постов пока нет. Сохраняйте посты, чтобы найти их позже!",
        you: "Вы",
        unknown: "Неизвестно",
        deletePost: "Удалить пост",
        activityPost: "Вы создали новый пост",
        activityLike: "Вы лайкнули пост",
        activitySave: "Вы сохранили пост",
        activityComment: "Вы прокомментировали пост",
        newActivity: "Новая активность",
        title: "Ваша активность",
        subtitle: "Отслеживайте вовлечённость и контент",
        allActivities: "Вся активность",
        myPosts: "Мои посты",
        likedPosts: "Понравившиеся посты",
        savedPosts: "Сохранённые посты",
        profileAlt: "Профиль",
        postAlt: "Пост",
        deleteAlt: "Удалить",
        likesAlt: "Нравится",
        commentsAlt: "Комментарии",
        savesAlt: "Сохранения",
      },
      pages: {
        welcome: {
          skip: "Пропустить",
          next: "Далее",
          slide1Title: "Находите реальные возможности",
          slide1Desc: "Просматривайте проверенные стипендии, гранты, фелоушипы, стажировки и программы обмена, все подобраны для вас с помощью ИИ, в одном месте.",
          slide2Title: "Подавайте заявки в пару кликов",
          slide2Desc: "Заполните профиль один раз, затем подавайте заявки прямо через Greenwich и следите за статусом каждой из них.",
          slide3Title: "Вы не одни на этом пути",
          slide3Desc: "Найдите наставника Greenwich Buddy, присоединитесь к сообществу таких же кандидатов и зарабатывайте гринкоины по пути.",
          consentTitle: "Прежде чем начать",
          consentDesc: "Мы используем необходимые файлы cookie и данные, чтобы Greenwich работал корректно и чтобы улучшить ваш опыт. Продолжая, вы соглашаетесь на использование cookie согласно нашей Политике конфиденциальности.",
          consentAgree: "Согласен и начинаю пользоваться",
          alreadyHaveAccount: "Уже есть аккаунт?",
          logIn: "Войти",
        },
        footer: {
          contactUs: "Связаться с нами",
          whoWeAre: "Кто мы",
          feed: "Лента",
          community: "Сообщество",
          account: "Аккаунт",
          organizations: "Организации",
          contact: "Связаться",
          projects: "Проекты",
          donate: "Пожертвовать",
          terms: "Условия",
          privacy: "Конфиденциальность",
          copyright: "© 2026 Greenwich Армения",
          copyrightLong: "© 2026 Greenwich Армения. Все права защищены.",
        },
        home: {
          hero1: "Молодёжь",
          hero2: "На связи",
          tagline: "Ваша карта мировых возможностей",
          explorePrograms: "Смотреть программы",
          roleCardPlayer: "Я\nучастник",
          roleCardPlayerSub: "Находи программы и подавай заявку за пару кликов",
          roleCardOrganizer: "Я\nорганизатор",
          roleCardOrganizerSub: "Публикуй свои программы и находи участников",
          searchOpportunities: "Поиск возможностей",
          searchCtaText: "Каждый год более 10 000 000 молодых людей по всему миру участвуют в программах по обмену, получают стипендии и проходят стажировки за границей, совершенно бесплатно.",
          searchCtaHint: "Перетащи пузырёк или нажми на него, чтобы узнать, что он предлагает ↓",
          filterScholarship: "Стипендии",
          filterExchange: "Обмен",
          filterVolunteering: "Волонтёрство",
          filterInternship: "Стажировки",
          filterGrant: "Гранты",
          filterEducation: "Образование",
          filterFellowship: "Фелоушипы",
          filterTraining: "Тренинги",
          benefitScholarship: "Покрывает часть или всю стоимость обучения. Во многие стипендии уже включены ежемесячная выплата, жильё и медстраховка, чтобы ты мог полностью сосредоточиться на учёбе за границей.",
          benefitExchange: "Проведи семестр или целый год в университете-партнёре за границей, получи зачёты, которые засчитаются дома, и заведи друзей из десятков стран.",
          benefitVolunteering: "Живи, работай и путешествуй за границей бесплатно. В большинстве волонтёрских программ уже включены жильё, питание и даже небольшая стипендия.",
          benefitInternship: "Получи реальный опыт работы в международной компании или организации. Многие стажировки оплачиваются и открывают двери к будущим предложениям о работе.",
          benefitGrant: "Получи финансирование под свою идею, исследование или проект. Гранты на путешествие, исследование или проект почти никогда не нужно возвращать.",
          benefitEducation: "Учись за границей на любом уровне, от семестрового обмена до полноценного бакалавриата, магистратуры или аспирантуры в зарубежном университете.",
          benefitFellowship: "Присоединяйся к исследовательской или профессиональной программе фелоушип за границей, работай рядом с экспертами и заведи связи, которые останутся с тобой надолго.",
          benefitTraining: "Прокачай практические навыки на коротких курсах и тренингах за границей: профессиональных, технических или soft skills, онлайн или очно.",
          hotNow: "Скоро дедлайн",
          noDeadlinesSoon: "Сейчас нет программ с дедлайном сегодня или завтра",
          programFallback: "Программа",
          untitledProgram: "Программа без названия",
          countriesHeading: "Найди возможности со всего мира",
          deadlineBadge: "Дедлайн",
          daysShort: "д ",
          seeMore: "Смотреть больше",
          viewArrow: "Смотреть →",
          topOrgs: "Лучшие организации месяца",
          topOrgsDesc: "Рейтинг основан на влиянии наших программ, числе участников, отзывах, видимости и других ключевых показателях. Он выделяет организации, которые активно способствуют развитию сообщества, создают значимое вовлечение и устойчивые позитивные изменения.",
          topOrgsDescMobile: "Рейтинг по влиянию, числу участников и отзывам сообщества.",
          orgLabel: "Организация",
          unknown: "Неизвестно",
          seeTopList: "Смотреть топ-список",
          partners: "Партнёры",
          feedbackTitle: "Отзывы участников Greenwich",
          supportedBy: "При поддержке",
          thankYou: "Спасибо!",
          feedbackSent: "Ваш отзыв успешно отправлен.",
          betaVersion: "Бета-версия",
          shareFeedback: "Поделитесь отзывом",
          shareFeedbackSub: "Помогите нам улучшить YouthConnect, ваше мнение важно!",
          ratingOptional: "Оценка (необязательно)",
          inProgress: "В процессе",
          comingSoonLabel: "Скоро",
          craftingSpecial: "Мы готовим что-то особенное.",
          checkBack: "Загляните сюда совсем скоро.",
          heroSubDesktop: "Присоединяйтесь к тысячам увлечённых людей, которые меняют мир к лучшему через значимые программы и международные партнёрства.",
          heroSubMobile: "Открывайте мировые возможности и меняйте мир к лучшему.",
          memberFeedbackSoon: "Отзывы участников",
          supportedBySoon: "При поддержке",
          aiKicker: "AI Matching",
          aiTitle: "Теперь у нас есть AI Matching",
          aiDesc: "Мы сами находим программы, которые тебе интересны, и подбираем их автоматически.",
          aiPoint1: "Сортировка по тому, насколько подходит",
          aiPoint2: "Новая подборка каждый день",
          aiPoint3: "Настройка: меньше минуты",
          aiCta: "Попробовать сейчас",
          buddyKicker: "Greenwich Buddy",
          buddyTitle: "Хочешь научиться новому? Или научить других?",
          buddyDesc: "Стань частью Buddy как ментор или менти и находи новых друзей и связи.",
          buddyPoint1: "Подбор по общим интересам",
          buddyPoint2: "Один сфокусированный месяц",
          buddyPoint3: "Сертификат после 6 менти",
          buddyCta: "Присоединиться к Buddy",
          statsKicker: "Наши достижения",
          trustLabelUsers: "пользователей на платформе",
          trustLabelOpportunities: "опубликованных возможностей",
          trustLabelSatisfaction: "находят проект по душе",
          trustLabelCountries: "стран с активными программами",
        },
        programs: {
          allPrograms: "Все программы",
          greencoinReward: "+{{amount}} greencoins за прохождение",
          greencoinsFilter: "С greencoin-наградой",
          programsFound: "Найдено программ: {{count}}",
          viewDetails: "Подробнее",
          noPrograms: "Программы не найдены",
          adjustFilters: "Попробуйте изменить фильтры.",
          resetFilters: "Сбросить фильтры",
          clear: "Очистить",
          anyAge: "Любой возраст",
          anyTime: "Любое время",
          educationAny: "Любой уровень",
          educationLevelLabel: "Образование",
          educationLevelShort: "Образование",
          educationUndergraduate: "Бакалавриат",
          educationGraduate: "Магистратура",
          educationDoctoral: "Докторантура / PhD",
          educationStudent: "Студент (общее)",
          educationProfessional: "Специалист",
          educationHighSchool: "Средняя школа",
          filtersLabel: "Фильтры",
          ageLabel: "Возраст",
          age18_25: "18-25 лет",
          age25_35: "25-35 лет",
          age35plus: "35+ лет",
          deadlinePassed: "Срок истёк",
          deadlineLabel: "Срок подачи",
          applyDeadlineLabel: "Срок подачи заявки",
          eventDateLabel: "Дата проведения",
          eventDatePassed: "Мероприятие завершено",
          funding: "Финансирование",
          location: "Место",
          pending: "На рассмотрении",
          rejected: "Отклонено",
          approve: "Одобрить",
          reapprove: "Одобрить повторно",
          reject: "Отклонить",
          revoke: "Отозвать",
          edit: "Редактировать",
          delete: "Удалить",
          save: "Сохранить",
          cancel: "Отмена",
          title: "Название",
          description: "Описание",
          saveProgram: "Сохранить",
          unsaveProgram: "Сохранено",
          savePromptLogin: "Войдите, чтобы сохранять программы",
          recommendedTitle: "Рекомендовано для вас",
          popularTitle: "Популярно сейчас",
          recommendedLoading: "Подбираем программы для вас…",
          recommendedEmpty: "Пока нечего рекомендовать. Изучите программы, чтобы получить персональные подборки.",
          heroTitle: "Изучите программы",
          heroSubtitle: "Стипендии, фелоушипы, стажировки, награды и многое другое",
          sourceLabel: "Источник:",
          sourceByAi: "От AI",
          sourceByAdmin: "От администратора",
          sourceByOrganization: "От организации",
          sourceAllOption: "Источник: Все",
          allSectorsOption: "Все сферы",
          sector_ecology: "Экология",
          sector_international: "Международное",
          sector_technology: "Технологии",
          sector_medical: "Медицина",
          sector_education: "Образование",
          sector_business: "Бизнес",
          sector_arts: "Искусство и культура",
          sector_science: "Наука",
          sector_sports: "Спорт",
          sector_agriculture: "Сельское хозяйство",
          sector_local: "Местное",
          sector_media: "Медиа",
          cat_education: "Образование",
          cat_scholarship: "Стипендия",
          cat_fellowship: "Фелоушип",
          cat_erasmusplus: "Erasmus Plus",
          cat_training: "Обучение",
          cat_grant: "Грант",
          cat_internship: "Стажировка",
          cat_conference: "Конференция",
          cat_online: "Онлайн",
          cat_volunteering: "Волонтёрство",
          cat_event: "Мероприятие",
          cat_award: "Награда",
          sub_all_education: "Все образовательные программы",
          sub_abroad: "Учёба за рубежом",
          sub_bachelor: "Бакалавриат",
          sub_master: "Магистратура",
          sub_phd: "Аспирантура",
          sub_online: "Онлайн",
          sub_all_scholarship: "Все стипендии",
          sub_full: "Полная",
          sub_partial: "Частичная",
          sub_government: "Государственная",
          sub_private: "Частная",
          sub_all_fellowship: "Все фелоушипы",
          sub_research: "Исследовательский",
          sub_postdoc: "Постдокторантура",
          sub_visiting: "Приглашённый",
          sub_all_erasmusplus: "Все программы Erasmus+",
          sub_ka1: "KA1: Мобильность",
          sub_ka2: "KA2: Сотрудничество",
          sub_ka3: "KA3: Политика",
          sub_all_training: "Все обучающие программы",
          sub_professional: "Профессиональное",
          sub_technical: "Техническое",
          sub_soft_skills: "Гибкие навыки",
          sub_online_training: "Онлайн",
          sub_all_grant: "Все гранты",
          sub_research_grant: "Исследовательский",
          sub_project_grant: "Проектный",
          sub_travel_grant: "На поездки",
          sub_all_internship: "Все стажировки",
          sub_summer: "Летняя",
          sub_paid: "Оплачиваемая",
          sub_unpaid: "Неоплачиваемая",
          sub_virtual: "Виртуальная",
          sub_all_conference: "Все конференции",
          sub_international_conf: "Международная",
          sub_funded_conf: "С финансированием",
          sub_virtual_conf: "Виртуальная",
          sub_all_online: "Все онлайн-программы",
          sub_online_course: "Курс",
          sub_webinar: "Вебинар",
          sub_mooc: "MOOC",
          sub_all_volunteering: "Все волонтёрские программы",
          sub_local_vol: "Местное",
          sub_international_vol: "Международное",
          sub_evs: "EVS / ESC",
          sub_all_event: "Все мероприятия",
          sub_festival: "Фестиваль",
          sub_competition: "Конкурс",
          sub_summit: "Саммит",
          sub_all_award: "Все награды",
          sub_international_award: "Международная",
          sub_national_award: "Национальная",
          sub_regional_award: "Региональная",
          sub_special_award: "Особое признание",
          deadlineAny: "Любой срок",
          deadlineLast24h: "Последние 24 часа",
          deadlineIn3Days: "В течение 3 дней",
          deadlineIn7Days: "В течение 7 дней",
          deadlineIn30Days: "В течение 30 дней",
          archiveLabel: "Архив",
          archiveShowActive: "Показать активные программы",
          archiveShowArchive: "Показать архив",
          archiveEmpty: "Архив пуст",
          aiMatchingTag: "AI Matching",
          aiThinkingButton: "AI думает…",
          aiMatchedToday: "Подобрано сегодня ✓",
          aiShowAllPrograms: "Показать все программы",
          aiNextMatchIn: "Следующий подбор AI через {{time}}",
          aiNewMatchesIn: "Новые совпадения будут доступны через {{time}}",
          aiShowProgramsMatchedTooltip: "Показать программы, подобранные вам искусственным интеллектом",
          aiOverlaySub: "Сравниваем ваши интересы со всеми открытыми программами…",
          aiCouldNotLoad: "Не удалось загрузить рекомендации",
          tryAgain: "Попробовать снова",
          aiNoStrongMatches: "Пока нет точных совпадений",
          aiBrowseAndSave: "Просмотрите и сохраните несколько программ, чтобы мы могли понять, что вам нравится.",
          programsMatchedCount: "{{count}} программ подобрано для вас",
          aiPhaseReading: "Изучаем ваши интересы…",
          aiPhaseScanning: "Сканируем открытые программы…",
          aiPhaseComparing: "Сравниваем категории и сферы…",
          aiPhaseScoring: "Оцениваем лучшие совпадения…",
          aiPhaseAlmost: "Почти готово…",
          nowLabel: "сейчас",
          unlockPreviewText: "Вы видите {{previewLimit}} из {{count}} программ. Создайте бесплатный аккаунт, чтобы открыть остальные, сохранять избранное и получать напоминания о сроках.",
          unlockMoreWaiting: "Ещё {{count}} программ ждут вас",
          unlockFullListText: "Создайте бесплатный аккаунт, чтобы открыть полный список, сохранять понравившиеся программы и получать напоминания перед истечением сроков.",
          unlockFullListCta: "Открыть полный список, бесплатно",
          orgBarQuestion: "Хотите разместить свою программу?",
          mySubmissions: "Мои заявки",
          submitNew: "Добавить новую",
          categoriesLabel: "Категории",
          sidebarClose: "Закрыть",
          sidebarFilter: "Фильтр",
          deleteConfirmTitle: "Удалить эту программу?",
          deleteConfirmBody: "Это действие нельзя отменить.",
          loadingPrograms: "Загрузка программ…",
          durationLabel: "Продолжительность",
          datesLabel: "Даты",
          targetGroupLabel: "Целевая группа",
          formatLabel: "Формат",
          organizerLabel: "Организатор",
          mediaLabel: "Медиа",
          additionalDetailsLabel: "Дополнительные сведения",
          requirementsLabel: "Требования",
          benefitsLabel: "Преимущества",
          openMediaLabel: "Открыть медиа",
          applyNowLabel: "Подать заявку",
          applyLabel: "Подать заявку",
          copyLinkLabel: "Скопировать ссылку",
          copyLinkTooltip: "Скопировать ссылку для отправки",
          yourApplicationLabel: "Ваша заявка",
          acceptedStatus: "Принято",
          notAcceptedStatus: "Не принято",
          attendedStatus: "Посетил(а)",
          appStatusPendingMsg: "Заявка отправлена, ожидает ответа.",
          appAcceptedMsg: "Принято!",
          appNotAcceptedMsg: "Не принято.",
          appAttendedMsg: "Участие подтверждено.",
          appCertificateMayFollow: "Сертификат может быть выдан позже.",
          rateOrgTitle: "Оцените эту организацию",
          optionalCommentPlaceholder: "Комментарий (необязательно)",
          submitReviewLabel: "Отправить отзыв",
          submittingLabel: "Отправка...",
          thanksForFeedback: "Спасибо за ваш отзыв!",
          starAriaLabel: "{{n}} звезда",
          linkCopiedToast: "🔗 Ссылка скопирована!",
          applicationSubmittedToast: "✅ Заявка отправлена!",
          submitReviewFailedToast: "Не удалось отправить отзыв",
          submitReviewNetworkErrorToast: "Ошибка сети при отправке отзыва",
          loadRecommendationsFailedError: "Не удалось загрузить рекомендации",
        },
        cookie: {
          title: "Файлы cookie и конфиденциальность",
          accept: "Принять",
          reject: "Отклонить",
          learnMore: "Узнать больше",
          bannerTitle: "Мы ценим вашу конфиденциальность",
          bannerDesc: "Продолжая использовать Greenwich, вы соглашаетесь на использование файлов cookie. Мы собираем только необходимые данные для улучшения вашего опыта и корректной работы платформы.",
          decline: "Отказаться",
          acceptContinueFull: "Принять и продолжить",
          requiredTitle: "Требуются файлы cookie",
          requiredBody: "Чтобы продолжить пользоваться Greenwich, необходимо принять использование основных файлов cookie. Они нужны для корректной работы платформы и удобства использования.",
          acceptCookiesContinue: "Принять cookie и продолжить",
        },
        community: {
          title: "Сообщество",
          loading: "Загрузка сообществ...",
          retry: "Повторить",
          createGroup: "Создать группу",
          createShort: "Создать",
          myCommunities: "Мои сообщества",
          myGroupsShort: "Мои группы",
          searchPlaceholder: "Поиск сообществ...",
          filterAll: "Все",
          filterOpen: "Открытые",
          filterClosed: "Закрытые",
          noGroupsSearch: "По запросу «{{term}}» группы не найдены.",
          noGroupsYet: "Групп пока нет. Станьте первым, кто создаст группу!",
          createFirstGroup: "Создать первую группу",
          fetchError: "Не удалось загрузить группы",
          loadError: "Не удалось загрузить сообщества. Попробуйте снова.",
          joinSuccess: "Вы успешно вступили в группу!",
          joinRequestSent: "Заявка отправлена. Владелец группы её рассмотрит.",
          joinFailed: "Не удалось вступить в группу",
          joinError: "Ошибка при вступлении в группу. Попробуйте снова.",
          membersCount: "{{count}} участников",
          public: "Публичная",
          private: "Приватная",
          admin: "Админ",
          closed: "Закрыто",
          manageGroup: "Управлять группой",
          viewGroup: "Открыть группу",
          joining: "Вступаем...",
          registrationClosed: "Регистрация закрыта",
          join: "Вступить",
          noDescriptionAvailable: "Описание отсутствует",
        },
        organizations: {
          topTitle: "Лучшие организации",
          topSubtitle: "Самые популярные организации месяца",
          secondPlace: "Второе место",
          secondDesc: "Отличная организация с большими достижениями",
          firstPlace: "Первое место",
          firstDesc: "Ведущая организация с выдающимися результатами",
          thirdPlace: "Третье место",
          thirdDesc: "Заметная организация, создающая реальные перемены",
          allVerified: "Все проверенные организации",
          loading: "Загрузка организаций...",
          tryAgain: "Повторить попытку",
          noneTitle: "Организации не найдены",
          noneDesc: "На данный момент организации для отображения отсутствуют.",
          refresh: "Обновить",
          loadError: "Не удалось загрузить организации. Попробуйте снова.",
          noDescription: "Описание отсутствует",
          unknownOrg: "Неизвестная организация",
        },
        adminPanel: {
          signOutTitle: "Выйти?",
          signOutBody: "Вы уверены, что хотите выйти из панели администратора?",
          cancel: "Отмена",
          yesLogOut: "Да, выйти",
          viewArrow: "Смотреть →",
          dashboardTitle: "Панель администратора",
          welcomeBack: "С возвращением,",
          navOrganizerApprovals: "Одобрение организаторов",
          navPrograms: "Программы",
          navAnalytics: "Аналитика",
          logoutBtn: "Выйти",
          statTotalOrganizers: "Всего организаторов",
          statPendingOrganizers: "Организаторы на рассмотрении",
          statVerifiedOrganizers: "Проверенные организаторы",
          statRejectedUsers: "Отклонённые пользователи",
          statTotalUsers: "Всего пользователей",
          statRecentRegistrations: "Недавние регистрации",
          statBetaFeedbacks: "Отзывы бета-версии",
          statTotalPosts: "Всего постов",
          statTotalPrograms: "Всего программ",
          statPendingPrograms: "Программы на рассмотрении",
          statTotalCommunities: "Всего сообществ",
          statPendingReports: "Жалобы на рассмотрении",
          reviewLink: "Просмотреть →",
          recentRegistrations: "Недавние регистрации",
          noRecentRegistrations: "Недавних регистраций нет",
          colLogo: "Логотип",
          colName: "Имя",
          colEmail: "Email",
          colOrganization: "Организация",
          colType: "Тип",
          colStatus: "Статус",
          colDate: "Дата",
          colActions: "Действия",
        },
        buddy: {
          title: "Buddy",
          subtitle: "Система персонального менторства: найди опытного человека в теме, которая тебе интересна, или стань таким наставником для того, кто только начинает.",
          backHome: "На главную",
          loading: "Загрузка...",
          roleMentorTitle: "Стать Mentor",
          roleMentorDesc: "Поделись опытом с теми, кто только начинает путь в молодёжных проектах, волонтёрстве, Erasmus+, ESC и похожих возможностях.",
          roleMenteeTitle: "Стать Mentee",
          roleMenteeDesc: "Получи наставника с опытом в интересующих тебя направлениях.",
          mentorInfoTitle: "Роль Mentor 🌟",
          mentorInfoBody: "Mentor: опытный участник, который помогает новичкам разобраться в мире молодёжных проектов, волонтёрства, Erasmus+, ESC и других возможностей.\n\nОбязанности:\n• поддерживать связь с mentee в течение месяца\n• помогать советом и опытом\n• быть уважительным, ответственным и поддерживающим\n• не обещать невозможного\n\nОдин mentor может одновременно вести максимум 3 mentee. После 6 успешно завершённых менторств mentor получает сертификат Greenwich Mentor.",
          menteeInfoTitle: "Роль Mentee 🚀",
          menteeInfoBody: "Mentee: человек, который только начинает свой путь в молодёжных проектах, волонтёрстве или международных программах.\n\nТы можешь выбрать mentor-а с опытом в интересующей тебя области.\nOдин mentee может иметь только одного активного mentor-а.\nМенторство длится 1 месяц.",
          agreeContinue: "Согласен, продолжить",
          cancel: "Отмена",
          back: "Назад",
          step: "Шаг {{current}} из {{total}}",
          formCategoriesMentor: "Выбери до 3 направлений, где у тебя есть опыт",
          formCategoriesMentee: "Выбери до 3 направлений, которые тебе интересны",
          categoriesHint: "Выбрано {{count}}/3",
          formExperience: "Оцени свой опыт в этой области от 1 до 10",
          formExperienceMentee: "Какой у тебя уже есть опыт в этой области? Это поможет подобрать подходящего наставника",
          formExperiencePlaceholder: "1 = опыта нет, 10 = эксперт",
          experiencePrompt: "Выбери количество звёзд",
          experienceLevels: { novice: "Новичок", amateur: "Любитель", pro: "Профи", guru: "Гуру" },
          menteeExperienceLabel: "{{level}} в этой области",
          formProjectsCount: "В скольких проектах ты участвовал(а) по выбранным направлениям вместе взятым?",
          formProjectsCountPlaceholder: "например, 5",
          formHours: "Сколько часов в неделю можешь уделять менторству?",
          formBio: "Короткое био, которое увидят твои mentee (до 200 символов)",
          formBioMenteeLabel: "Чего ты хочешь достичь с ментором? (до 200 символов)",
          formBioPlaceholder: "Расскажи немного о себе...",
          formContact: "Как с тобой сможет связаться подобранный mentee/mentor?",
          contactHint: "Показывается только после принятия заявки. Всё здесь необязательно",
          contactHintMentor: "Показывается только после принятия заявки. Выбери минимум 2 способа связи",
          contactInvalidHint: "Что-то из этого выглядит неверно. Проверь формат телефона, email или Telegram",
          contactMinHint: "Заполни хотя бы 2 способа связи",
          phonePlaceholder: "Номер телефона",
          emailPlaceholder: "Email",
          telegramPlaceholder: "Telegram username",
          instagramPlaceholder: "Instagram",
          facebookPlaceholder: "Facebook",
          formGender: "Твой пол",
          genders: { male: "Мужской", female: "Женский", other: "Другое" },
          formPreferredMenteeGender: "Какого пола должен быть твой mentee?",
          formPreferredMentorGender: "Какого пола должен быть твой mentor?",
          genderPrefs: { any: "Без разницы", male: "Мужской", female: "Женский", same: "Такого же, как у меня" },
          previewLabel: "Превью твоего профиля",
          previewHint: "Именно это увидят mentee при просмотре mentor-ов",
          noRatingsYet: "Оценок пока нет",
          contactLabels: { phone: "Телефон", email: "Email", telegram: "Telegram", instagram: "Instagram", facebook: "Facebook" },
          continueBtn: "Продолжить",
          submitMentor: "Отправить заявку mentor",
          submitMentee: "Сохранить и посмотреть подходящих mentor-ов",
          errPickCategory: "Выбери хотя бы 1 направление",
          errExperience: "Введи число от 1 до 10",
          errBioLength: "Био должно быть не длиннее 100 слов",
          errGeneric: "Что-то пошло не так. Попробуй ещё раз.",
          mentorPendingTitle: "Заявка на рассмотрении",
          mentorPendingBody: "Твоя заявка mentor отправлена админам Greenwich. Сообщим, как только она будет одобрена.",
          mentorRejectedTitle: "Заявка не одобрена",
          mentorRejectedBody: "Твоя заявка mentor не была одобрена в этот раз.",
          mentorApprovedBadge: "Подтверждённый mentor",
          availabilityOn: "Доступен(на) для новых mentee",
          availabilityOff: "Сейчас недоступен(на)",
          toggleAvailability: "Переключить доступность",
          activeMenteesTitle: "Твои активные mentee",
          noActiveMentees: "Активных mentee пока нет.",
          pendingRequestsTitle: "Новые заявки от mentee",
          noPendingRequests: "Заявок пока нет.",
          accept: "Принять",
          decline: "Отклонить",
          completedLabel: "Завершённых менторств",
          mentorsChatBtn: "Чат менторов",
          certificateEarned: "🎓 Ты получил(а) сертификат Greenwich Buddy Mentor!",
          asMentorTab: "Как Mentor",
          asMenteeTab: "Как Mentee",
          matchingMentorsTitle: "Подходящие тебе mentor-ы",
          allMentorsTitle: "Доступные mentor-ы",
          noMatchingMentors: "Сейчас нет свободных подходящих mentor-ов. Попробуй позже.",
          overlapLabel: "совпадений: {{count}}",
          experienceLabel: "Опыт",
          projectsLabel: "Проекты",
          activeLabel: "Активных mentee",
          chooseMentor: "Выбрать этого mentor-а",
          requestSentTitle: "Заявка отправлена ✅",
          requestSentBody: "Mentor уведомлён. Сообщим, как только он ответит.",
          withdrawRequest: "Отозвать заявку",
          youHaveMentorTitle: "Твой mentor",
          youHaveMenteeOf: "Mentee",
          daysLeft: "осталось {{count}} дн.",
          endsOn: "Завершение: {{date}}",
          messageBtn: "Написать",
          viewProfile: "Открыть профиль",
          endMentorship: "Завершить менторство",
          endMentorshipConfirmTitle: "Завершить это менторство?",
          endMentorshipConfirmBody: "Отменить это нельзя. Обоим будет предложено оставить приватную оценку.",
          endMentorshipConfirmYes: "Да, завершить",
          reviewTitle: "Оцени менторство",
          reviewBody: "Это остаётся приватным и никогда не показывается другой стороне.",
          reviewCommentPlaceholder: "Короткий комментарий (необязательно)",
          submitReview: "Отправить оценку",
          reviewThanks: "Спасибо за отзыв ✅",
          skipReview: "Пропустить",
          pendingReviewTitle: "Ждёт вашей оценки",
          pendingReviewBody: "Эти менторства завершились. Оставьте приватную оценку. Другая сторона её никогда не увидит.",
          leaveReview: "Оставить оценку",
          reportBtn: "Пожаловаться",
          reportTitle: "Пожаловаться на {{name}}",
          reportBody: "Расскажите, что произошло в этом Buddy-менторстве. Наша команда рассмотрит обращение. {{name}} этого не увидит.",
          reportDetailsPlaceholder: "Что произошло? (необязательно, поможет быстрее разобраться)",
          reportSubmittedTitle: "Жалоба отправлена",
          reportSubmittedBody: "Спасибо, наша команда рассмотрит обращение. Если вы переживаете за свою безопасность, пожалуйста, свяжитесь с нами напрямую.",
          close: "Закрыть",
          cancel: "Отмена",
          submitting: "Отправка…",
          submitReport: "Отправить жалобу",
          categories: {
            volunteering: "Волонтёрство", intlPractice: "Международная практика", erasmusPlus: "Erasmus+",
            erasmusMundus: "Erasmus Mundus", esc: "ESC", leadership: "Лидерство", networking: "Нетворкинг",
            webinar: "Вебинар", workshop: "Воркшоп", business: "Бизнес", startup: "Стартап",
            hiking: "Хайкинг", training: "Тренинги", eco: "Экология", communitySupport: "Поддержка сообщества",
            organizational: "Организационные навыки", marketing: "Маркетинг", communication: "Коммуникация",
            regionalDev: "Региональное развитие", art: "Искусство", painting: "Рисование", dance: "Танцы",
            singing: "Пение", other: "Другое",
          },
        },
        levels: {
          title: "Уровни и XP",
          subtitle: "Каждый аккаунт растёт по уровням по мере участия в платформе. Эта страница объясняет общую логику, а не точные цифры.",
          nextLevel: "На пути к {{level}} уровню",
          maxLevelReached: "Ты достиг максимального уровня 🏆",
          howTitle: "Как ты получаешь XP",
          howSub: "Практически всё, что ты делаешь на платформе и что помогает другим или продвигает тебя вперёд, засчитывается в уровень.",
          categories: {
            apply: { title: "Заявки и приём", desc: "Подача заявок на программы через платформу и приём на них." },
            attend: { title: "Участие", desc: "Реальное участие в программах и мероприятиях, на которые ты записался." },
            community: { title: "Сообщества", desc: "Создание своего сообщества или вступление в чужое." },
            voice: { title: "Твой голос", desc: "Публикация постов и настоящий отклик от других." },
            mentorship: { title: "Менторство", desc: "Быть Buddy-ментором или менти и довести это до конца." },
            trust: { title: "Доверие и профиль", desc: "Верификация аккаунта, заполнение профиля, добавление CV." },
            reviews: { title: "Отзывы", desc: "Честный отзыв после завершения программы." },
            streak: { title: "Регулярность", desc: "Регулярное возвращение: ежедневная активность имеет значение." },
            tasks: { title: "Задания", desc: "Выполнение заданий, которые время от времени публикует команда." },
            referrals: { title: "Приглашения", desc: "Приведение друзей на платформу." },
          },
          certTitle: "Сертификаты и XP",
          certSub: "Программы с greencoin-наградой также дают XP и сертификат, если ты реально посетил(а) и прошёл(ла) программу.",
          certSteps: {
            participate: { title: "Посети мероприятие", desc: "Запишись и реально приди. Организатор отмечает посещение после завершения программы." },
            certificate: { title: "Получи XP + сертификат", desc: "Пройденные программы добавляют XP к твоему уровню, а подходящие программы выдают сертификат на твой аккаунт." },
            bio: { title: "Покажи это в профиле", desc: "Твои сертификаты хранятся в профиле, упорядоченные по важности и времени получения." },
          },
          tiersTitle: "Ранги",
          tiersSub: "С ростом уровня твой бейдж проходит через пять рангов.",
          tierNames: { bronze: "Бронза", silver: "Серебро", gold: "Золото", diamond: "Алмаз", legend: "Легенда" },
          tierDescs: {
            bronze: "Все начинают отсюда.",
            silver: "Стабильно активные участники.",
            gold: "Серьёзно вовлечённые пользователи.",
            diamond: "Давние, надёжные участники.",
            legend: "Самые преданные платформе.",
          },
          youAreHere: "Ты здесь",
          greencoins: "greencoins",
          tasksLink: "Задания",
          back: "Назад",
        },
        tasks: {
          title: "Задания",
          subtitle: "Быстрые действия за дополнительный XP и greencoins. Некоторые обновляются ежедневно или ежемесячно.",
          loading: "Загрузка заданий...",
          empty: "Пока нет заданий — загляните позже.",
          frequencyOnce: "Разовое",
          frequencyDaily: "Ежедневное",
          frequencyMonthly: "Ежемесячное",
          xpAmount: "{{amount}} XP",
          completeBtn: "Выполнить",
          doneBtn: "Выполнено",
          savingEllipsis: "Сохранение...",
          completed: "+{{xp}} XP!",
          completedWithCoins: "+{{xp}} XP, +{{coins}} greencoins!",
          completeFailed: "Не удалось выполнить задание. Попробуйте ещё раз.",
          back: "Назад",
        },
        pro: {
          title: "Greenwich Pro",
          subtitle: "Платный план для тех, кто хочет больше контроля над своим профилем и поиском следующей возможности.",
          plans: { "1m": "1 месяц", "3m": "3 месяца", "6m": "6 месяцев" },
          bestValue: "Выгоднее всего",
          perMonth: "{{price}} AMD / мес.",
          totalBilled: "Итого {{total}} AMD за {{months}} мес.",
          perksTitle: "Что даёт Pro",
          perks: {
            design: { title: "Кастомный дизайн профиля", desc: "Настрой свой профиль под собственный стиль." },
            frame: { title: "Кастомная рамка аватара", desc: "Выделяйся с эксклюзивной рамкой вокруг фото." },
            views: { title: "Смотри, кто заходил на твой профиль", desc: "И пользователи, и организации, с датами, на весь срок подписки." },
            matches: { title: "Самые подходящие проекты, тебе напрямую", desc: "Получай лучшие совпадения по email, в Telegram-боте или прямо на платформе. Выбирай канал сам." },
            shop: { title: "Эксклюзивные товары за greencoins", desc: "Меняй greencoins на эксклюзивные товары, а не только на повседневные." },
            early: { title: "Ранний доступ", desc: "Видь новые возможности на 6 часов раньше остальных." },
          },
          statusActive: "Твой Pro активен до {{date}}",
          statusNone: "У тебя пока нет Pro",
          paymentComingSoon: "Онлайн-оплата сейчас настраивается, покупка Pro на сайте пока недоступна.",
          choosePlan: "Выбери план, затем оплати банковским переводом",
          payTitle: "Оплата банковским переводом",
          payBank: "Банк",
          payAccount: "Номер счёта",
          payRecipient: "Получатель",
          payReference: "Назначение платежа",
          payReferenceHint: "Укажи точно так, чтобы мы могли сопоставить перевод с твоим аккаунтом.",
          submitPayment: "Оплатить",
          signInToPay: "Войдите, чтобы купить",
          submitting: "Отправка...",
          submitSuccess: "Спасибо! Мы проверим перевод и активируем Pro в течение 24 часов.",
          pendingNote: "Твоя заявка на {{plan}} в ожидании. Проверяем перевод и скоро активируем Pro.",
          interestTitle: "Один момент",
          interestBody: "Мы завершаем настройку онлайн-оплаты Pro. Нажми ниже, и мы напишем на почту, как только всё заработает.",
          interestSubmit: "Уведомить меня",
          interestDoneTitle: "Спасибо!",
          interestDoneBody: "Мы записали твой интерес и напишем на почту, как только покупка Pro станет доступна.",
          interestClose: "Закрыть",
          payWithCard: "Оплатить картой",
          redirectingToBank: "Перенаправляем в банк...",
          cardPaymentSuccess: "Оплата прошла успешно, Pro теперь активен!",
          cardPaymentFailed: "Оплата не прошла. Можно попробовать ещё раз.",
          cardPaymentError: "Во время оплаты произошла ошибка. Попробуйте ещё раз.",
          extendPrompt: "У вас уже есть Pro.",
          extendLink: "Хотите другой план? Купить снова",
          historyTitle: "История покупок",
          historyEmpty: "Покупок пока нет.",
          historyReceipt: "Чек",
          receiptTitle: "Чек об оплате",
          receiptOrder: "Заказ",
          receiptDate: "Дата",
          receiptPlan: "План",
          receiptAmount: "Сумма",
          receiptCard: "Карта",
          receiptApproval: "Код подтверждения",
          receiptClose: "Закрыть",
          receiptPrint: "Печать / Сохранить как PDF",
          back: "Назад",
        },
        paymentConfirmation: {
          titleSuccess: "Оплата прошла успешно",
          titleFailed: "Оплата не прошла",
          titlePending: "Проверяем платёж...",
          subtitleSuccess: "Покупка подтверждена и уже активна на вашем аккаунте.",
          subtitleFailed: "Банк не смог завершить платёж. Деньги не были списаны.",
          subtitlePending: "Секунду, это займёт пару секунд.",
          viewReceipt: "Показать детали чека",
          hideReceipt: "Скрыть детали",
          downloadReceipt: "Скачать чек",
          continuePro: "Перейти в Pro",
          backToFeed: "Назад в ленту",
          tryAgain: "Попробовать снова",
          refundNote: "Передумали? Можно запросить возврат в течение 7 дней в разделе",
          refundNoteLink: "Настройки → Pro → Платежи",
          notFound: "Не удалось найти этот платёж.",
        },
        shop: {
          title: "Магазин Greencoins",
          subtitle: "Трать greencoins, заработанные на платформе, на настоящие награды.",
          greencoins: "greencoins",
          loading: "Загрузка...",
          empty: "Здесь пока пусто, загляни позже.",
          everydayTitle: "Повседневные награды",
          exclusiveTitle: "Эксклюзивные награды",
          exclusiveSub: "Доступно только участникам Pro.",
          exclusive: "Pro",
          proOnly: "Только Pro",
          redeem: "Получить",
          confirmRedeem: "Получить «{{name}}» за {{cost}} greencoins?",
          redeemSuccess: "«{{name}}» получено! Наша команда свяжется по поводу доставки.",
          redeemError: "Не удалось получить этот товар. Попробуйте ещё раз.",
          cancel: "Отмена",
          redeeming: "Получаем...",
          redeemSuccessTitle: "Получено!",
          qrHint: "Покажите этот QR-код при получении.",
          codeHint: "Покажите или назовите этот код при получении.",
          done: "Готово",
          myPurchases: "Мои покупки",
          myPurchasesSub: "Всё, что вы получили, с кодами для выдачи.",
          noPurchases: "Вы пока ничего не получали.",
          showCode: "Показать код",
          hideCode: "Скрыть код",
          back: "Назад",
        },
        donate: {
          heroTitle: "Поддержите армянскую молодёжь",
          heroSub: "Присоединяйтесь к нашему сообществу сторонников и помогите создать возможности для следующего поколения армянских лидеров.",
          missionTitle: "Наша миссия",
          missionSub: "Расширяем возможности армянской молодёжи через образование",
          quote: "«Поддерживая нашу миссию, вы вкладываетесь в будущее армянской молодёжи.»",
          quoteBody: "Ваш вклад помогает нам создавать образовательные программы, обеспечивать наставничество и открывать новые возможности для роста. Каждое пожертвование приближает нас к этой цели.",
          statYouth: "Молодёжь, получившая поддержку",
          statSuccess: "Успешность программ",
          statPrograms: "Созданные программы",
          chooseTier: "Выберите уровень поддержки",
          chooseTierSub: "Выберите ежемесячный уровень поддержки или введите свою сумму",
          popular: "Популярно",
          perMonth: "в месяц",
          customAmount: "Или введите свою сумму",
          minUsd: "Минимум ${{amount}} ({{amd}} драм)",
          thankYou: "Спасибо! 🎉",
          thankBody: "Ваша ежемесячная поддержка в размере ${{amount}} активирована. Подтверждение отправлено на {{email}}.",
          whatNext: "Что дальше:",
          next1: "Приветственное письмо в течение 24 часов",
          next2: "Ежемесячная квитанция на вашу почту",
          next3: "Преимущества поддержки начинают действовать сразу",
          makeAnother: "Сделать ещё одно пожертвование",
          supportLevel: "Уровень поддержки:",
          custom: "Свой вариант",
          quickAmount: "Быстрый выбор суммы:",
          monthly: "Ежемесячно:",
          recurringNote: "Регулярное ежемесячное пожертвование",
          cancelAnytime: "Отменить или изменить в любое время",
          yourInfo: "Ваши данные",
          fullName: "Полное имя",
          emailReq: "Email *",
          paymentMethod: "Способ оплаты",
          bmcTitle: "Buy Me a Coffee",
          bmcSub: "Простая разовая или ежемесячная поддержка",
          processing: "Обработка...",
          continueBmc: "Перейти к Buy Me a Coffee",
          redirectTitle: "Открываем страницу безопасной оплаты...",
          redirectBody: "Мы открыли Buy Me a Coffee в новой вкладке, чтобы вы могли завершить пожертвование на сумму ${{amount}}. Пожалуйста, завершите оплату там. Эта страница не может знать, когда это произойдёт.",
          reopenPayment: "Открыть страницу оплаты снова",
          backToForm: "Назад к форме",
          secureNote: "Безопасный и зашифрованный платёж",
          termsAgree: "Продолжая, вы соглашаетесь с нашими",
          terms: "Условиями",
          and: "и",
          privacyPolicy: "Политикой конфиденциальности",
          whyMonthly: "Почему ежемесячная поддержка?",
          whyItems: [
            [
              "Устойчивое влияние",
              "Позволяет планировать программы на долгий срок",
            ],
            [
              "Предсказуемое финансирование",
              "Помогает нам стабильно поддерживать больше молодых людей",
            ],
            [
              "Гибкость",
              "Изменяйте или отменяйте поддержку в любое время",
            ],
            [
              "Налоговые льготы",
              "Ежемесячные квитанции для налоговой отчётности",
            ],
          ],
          alertMin: "Пожалуйста, введите сумму не менее ${{min}}",
          alertEmail: "Пожалуйста, укажите ваш email.",
          alertPayment: "Пожалуйста, выберите способ оплаты.",
          alertCardLogin: "Войдите в аккаунт, чтобы пожертвовать картой.",
          alertCardError: "Во время оплаты произошла ошибка. Попробуйте ещё раз.",
          bmcToast: "☕ Выбран Buy Me a Coffee",
          cardTitle: "Оплатить картой",
          cardSub: "Мгновенное разовое пожертвование в драмах",
          continueCard: "Пожертвовать картой",
          redirectingToBank: "Перенаправляем в банк...",
          cardPaymentSuccess: "Спасибо, ваше пожертвование прошло!",
          cardPaymentFailed: "Оплата не прошла. Можете попробовать снова.",
          cardPaymentError: "Во время оплаты произошла ошибка. Попробуйте ещё раз.",
          tier1n: "Сторонник",
          tier1d: "Базовая поддержка нашей миссии",
          tier1p0: "Письмо с благодарностью",
          tier1p1: "Ежемесячная рассылка",
          tier2n: "Друг",
          tier2d: "Помощь в финансировании учебных материалов",
          tier2p0: "Все предыдущие преимущества",
          tier2p1: "Цифровой сертификат",
          tier2p2: "Имя в списке сторонников",
          tier3n: "Чемпион",
          tier3d: "Спонсируйте молодёжную программу",
          tier3p0: "Все предыдущие преимущества",
          tier3p1: "Эксклюзивные обновления",
          tier3p2: "Цифровой значок",
          tier4n: "Лидер",
          tier4d: "Внесите значительный вклад",
          tier4p0: "Все предыдущие преимущества",
          tier4p1: "Видео с благодарностью",
          tier4p2: "Упоминание на сайте",
        },
        contact: {
          badge: "Мы здесь, чтобы помочь",
          title: "Свяжитесь с нами",
          subtitle: "Свяжитесь с нашей командой, чтобы узнать больше о возможностях, партнёрстве или участии.",
          email: "Email",
          phone: "Телефон",
          followJourney: "Следите за нашим путём",
          quickAskTitle: "Нужен быстрый ответ?",
          quickAskSubtitle: "Спроси нашего AI-помощника, не дожидаясь ответа на форму ниже.",
          faqTitle: "Часто задаваемые вопросы",
          tabGeneral: "Общее",
          tabPrograms: "Программы",
          tabPartnerships: "Партнёрство",
          sendMessage: "Отправить нам сообщение",
          replyWithin: "Мы ответим вам в течение 24 часов",
          sentTitle: "Сообщение отправлено! 🎉",
          sentBody: "Спасибо, что обратились в Greenwich. Наша команда скоро ответит.",
          sendError: "Не удалось отправить сообщение. Пожалуйста, попробуйте ещё раз.",
          yourName: "Ваше имя",
          emailPlaceholder: "Email адрес",
          messagePlaceholder: "Ваше сообщение...",
          sending: "Отправка...",
          sendBtn: "Отправить сообщение",
          responseTime: "Время ответа: в течение 24 часов",
          ctaTitle: "Готовы начать свой путь?",
          ctaSub: "Присоединяйтесь к тысячам армянской молодёжи, нашедшей свой путь через Greenwich.",
          browseOpps: "Смотреть возможности",
          learnMore: "Узнать больше о нас",
          faqG1q: "Что такое Greenwich?",
          faqG1a: "Greenwich, цифровая платформа, объединяющая армянскую молодёжь с мировыми возможностями в области образования, программ обмена и карьерного развития.",
          faqG2q: "Кто может пользоваться Greenwich?",
          faqG2a: "Армянская молодёжь от 14 до 35 лет, студенты, специалисты и все, кто ищет международные возможности.",
          faqP1q: "Какие типы программ вы предлагаете?",
          faqP1a: "Мы предлагаем программы обмена, стипендии, стажировки, волонтёрские возможности и культурные обмены.",
          faqP2q: "Как подать заявку на программу?",
          faqP2a: "Создайте аккаунт, просмотрите возможности и подайте заявки через нашу систему.",
          faqPr1q: "Может ли моя организация стать партнёром Greenwich?",
          faqPr1a: "Да! Мы рады партнёрству с образовательными учреждениями, НКО и компаниями.",
          faqPr2q: "Какие преимущества у партнёрства?",
          faqPr2a: "Партнёры получают доступ к нашему пулу талантов, могут проводить совместные мероприятия и получают видимость в нашей сети.",
        },
        whoWeAre: {
          heroLabel: "Основано в 2025 · Армения",
          heroTitle1: "Объединяем молодёжь",
          heroTitle2: "с миром",
          heroBody: "Greenwich объединяет армянскую молодёжь (14-35 лет) с мировыми и местными возможностями: от стипендий и обменов до волонтёрства и культурных программ.",
          seeMore: "Узнать больше →",
          sectionLabel: "Кто мы",
          overviewTitle1: "Платформа, созданная",
          overviewTitle2: "для молодых людей",
          overviewP1: "Greenwich.am, цифровая платформа, объединяющая молодых людей с образовательными, социальными и профессиональными возможностями по всему миру. Основанная в Армении в начале 2025 года, она начиналась как Telegram-канал и быстро выросла в инновационную веб-платформу, объединяющую молодёжь и организации в единой доверенной экосистеме.",
          overviewP2: "Greenwich помогает пользователям находить проверенные проекты, создавать цифровое портфолио и получать доступ к мировым возможностям в одном месте.",
          statAge: "Целевая возрастная группа",
          statYear: "Год основания",
          statOpp: "Опубликовано возможностей",
          whyLabel: "Почему Greenwich?",
          whyTitle1: "Все возможности",
          whyTitle2: "в одном надёжном месте",
          whyBody: "Найти возможности может быть непросто: они разбросаны по сайтам, соцсетям и передаются из уст в уста. Многие молодые люди упускают их просто потому, что информация недоступна в одном месте. Greenwich собирает всё воедино.",
          regionAmerica: "Америка",
          regionAsia: "Азия",
          regionEurope: "Европа",
          quote: "«Мы стремимся создать надёжную цифровую экосистему, которая объединяет молодёжь и организации, делает участие видимым и измеримым.»",
          visionLabel: "Видение",
          visionTitle1: "Наше",
          visionTitle2: "видение",
          visionTitle3: "для",
          visionTitle4: "мировой молодёжи",
          visionBody: "Наше видение: создать единую мировую платформу, где каждый молодой человек имеет равный доступ к возможностям независимо от места проживания или происхождения. Мы стремимся создать надёжную цифровую экосистему, которая объединяет молодёжь и организации, делает участие видимым и измеримым и превращает вовлечённость в реальное влияние и долгосрочный рост.",
          missionLabel: "Миссия",
          missionTitle1: "Расширяем возможности молодёжи",
          missionTitle2: "с помощью технологий",
          missionBody1: "Наша миссия: сделать мировые возможности доступными, структурированными и прозрачными для молодых людей повсюду. Мы стремимся объединять мотивированных людей с организациями, поддерживать значимое участие и предоставлять надёжное цифровое пространство, где достижения признаются, а рост поощряется.",
          missionBody2: "С помощью технологий и сообщества мы помогаем молодёжи раскрывать свой потенциал и превращать возможности в реальное влияние.",
          sdgLabel: "Устойчивое развитие",
          sdgTitle1: "Продвижение",
          sdgTitle2: "целей устойчивого развития",
          sdgBody: "Greenwich.am привержен продвижению Целей устойчивого развития ООН, вовлекая молодых людей в социальные, образовательные и общественные инициативы.",
          sdgChip1: "Качественное образование",
          sdgChip2: "Достойная работа",
          sdgChip3: "Сокращение неравенства",
          sdgChip4: "Борьба с изменением климата",
          sdgChip5: "Сильные институты",
          ctaTitle1: "Готовы открыть",
          ctaTitle2: "свою возможность?",
          ctaSub: "Присоединяйтесь к тысячам молодых армян, которые уже растут вместе с Greenwich.",
          getStarted: "Начать →",
        },
        notifications: {
          title: "Уведомления",
          newBadge: "{{count}} новых",
          markAllRead: "Отметить всё как прочитанное",
          total: "Всего",
          unread: "Непрочитанные",
          likes: "Отметки «нравится»",
          follows: "Подписки",
          filter: "Фильтр:",
          all: "Все",
          unreadTab: "Непрочитанные",
          readTab: "Прочитанные",
          allTypes: "Все типы",
          comments: "Комментарии",
          noneTitle: "Уведомления не найдены",
          noneUnread: "У вас нет непрочитанных уведомлений.",
          noneDefault: "Когда у вас появятся уведомления, они отобразятся здесь.",
          showAll: "Показать все уведомления",
          today: "Сегодня",
          yesterday: "Вчера",
          markRead: "Отметить прочитанным",
          deleteTitle: "Удалить уведомление",
          deleting: "Удаление...",
          footer: "Показано {{shown}} из {{total}} уведомлений",
          someone: "Кто-то",
          msgLike: "{{name}} оценил(а) вашу публикацию",
          msgComment: "{{name}} прокомментировал(а) вашу публикацию",
          msgFollow: "{{name}} начал(а) подписку на вас",
          msgFollowReq: "{{name}} хочет подписаться на вас",
          msgMessage: "{{name}} отправил(а) вам сообщение",
          msgVerify: "Ваша организация была проверена!",
          msgMention: "{{name}} упомянул(а) вас в публикации",
          msgNew: "Новое уведомление",
          justNow: "Только что",
          timeAgo: "{{n}} мин назад",
          hourAgo: "{{n}} ч назад",
          dayAgo: "{{n}} дн назад",
        },
        search: {
          likes: "Отметки «нравится»",
          comments: "Комментарии",
          tabAll: "Все",
          tabUsers: "Пользователи",
          tabOrganizations: "Организации",
          tabProjects: "Проекты",
          tabHashtags: "Хэштеги",
          tabCommunities: "Сообщества",
          tabPosts: "Посты",
          heroTitle: "Поиск по Greenwich",
          heroSubtitle: "Находите людей, организации, сообщества и контент на платформе",
          searchPlaceholder: "Искать пользователей, организации, сообщества, посты...",
          filtersBtn: "Фильтры",
          sortBy: "Сортировать по:",
          sortRelevance: "Релевантности",
          sortNewest: "Новизне",
          sortPopular: "Популярности",
          sortName: "Имени (А-Я)",
          dateRange: "Период:",
          dateAll: "За всё время",
          dateToday: "Сегодня",
          dateWeek: "На этой неделе",
          dateMonth: "В этом месяце",
          locationLabel: "Местоположение:",
          locationPlaceholder: "Введите местоположение",
          verifiedOnly: "Только проверенные",
          clearFilters: "Сбросить фильтры",
          searchingFor: "Ищем «{{term}}»...",
          emptyTitle: "Поиск по платформе Greenwich",
          emptyDescription: "Находите людей, организации, посты и сообщества на платформе",
          browseCategory: "Смотреть {{category}}",
          trendingHeading: "Популярные запросы",
          trendingTerms: [
            "Образование", "Erasmus", "Работа", "Международное", "молодежныепрограммы",
            "летняяработа", "поискстипендий", "gap year", "Сообщество", "Организация",
            "Мероприятие", "Учёба за рубежом", "Полные стипендии", "Фелоушип", "Гранты",
          ],
          resultsHeading: "Результаты",
          pageOf: "Страница {{current}} из {{total}}",
          noResultsFor: "По запросу «{{term}}» ничего не найдено",
          noResultsHint: "Попробуйте изменить условия поиска или фильтры",
          previous: "Назад",
          next: "Далее",
          pillUser: "Пользователь",
          pillOrg: "Орг.",
          pillProgram: "Проект",
          pillOrganizationFull: "Организация",
          pillCommunity: "Сообщество",
          pillPost: "Пост",
          metaFollowers: "подписчиков",
          metaPosts: "постов",
          metaMembers: "участников",
          btnFollowing: "Вы подписаны",
          btnRequested: "Запрос отправлен",
          btnFollow: "Подписаться",
          viewCommunity: "Смотреть сообщество",
          viewPost: "Смотреть пост",
          viewOrg: "Смотреть организацию",
          viewProgram: "Смотреть проект",
          untitledProgram: "Проект без названия",
          viewProfile: "Смотреть профиль",
          viewShort: "Смотреть",
          statFollowers: "Подписчики",
          statPosts: "Посты",
          statMembers: "Участники",
          unknown: "Неизвестно",
          unknownUser: "Неизвестный пользователь",
          today: "Сегодня",
          yesterday: "Вчера",
        },
        dashboard: {
          pleaseLoginSave: "Пожалуйста, войдите, чтобы сохранить изменения",
          saveFailed: "Не удалось сохранить изменения",
          saveError: "Ошибка при сохранении изменений.",
          imageTooBig: "Размер изображения должен быть не более 5 МБ",
          imageTypes: "Разрешены только изображения JPEG, PNG и GIF",
          coverFailed: "Не удалось обновить обложку",
          coverError: "Ошибка при обновлении обложки",
          avatarFailed: "Не удалось обновить фото профиля",
          avatarError: "Ошибка при обновлении фото профиля",
          loginUpload: "Пожалуйста, войдите, чтобы загружать файлы",
          uploadFailed: "Не удалось загрузить файлы",
          uploadError: "Ошибка при загрузке файла",
          deleteFileFailed: "Не удалось удалить файл",
          deleteFileError: "Ошибка при удалении файла",
          navAbout: "Обо мне",
          navPosts: "Публикации",
          navReports: "Отчёты",
          navPortfolio: "Портфолио",
          navCertificates: "Сертификаты",
          navApplications: "Мои заявки",
          editProfileBtn: "Редактировать профиль",
          tabAbout: "Обо мне",
          tabPosts: "Публикации",
          tabReports: "Отчёты и лицензии",
          tabPortfolio: "Портфолио",
          tabCertificates: "Сертификаты",
          tabApplications: "Мои заявки",
          firstName: "Имя *",
          firstNamePh: "Имя",
          lastName: "Фамилия",
          titlePosition: "Должность",
          titlePh: "Старший продакт-менеджер",
          emailLabel: "Email *",
          emailPh: "example@email.com",
          invalidEmail: "Пожалуйста, введите корректный адрес электронной почты",
          phoneLabel: "Телефон",
          phonePh: "+1234567890",
          locationLabel: "Местоположение",
          locationPh: "Введите местоположение",
          websiteLabel: "Веб-сайт",
          websitePh: "https://example.com",
          bioLabel: "О себе",
          bioPh: "Расскажите о себе...",
          interestsLabel: "Интересы",
          addInterestPh: "Добавить интерес (Enter)",
          addBtn: "Добавить",
          maxInterests: "Выбрано {{count}}/5 — используется, чтобы рекомендовать вам программы",
          saveChanges: "Сохранить изменения",
          saving: "Сохранение...",
          cancel: "Отмена",
          noBio: "Информация о себе пока отсутствует.",
          nameLabel: "Имя",
          emailInfoLabel: "Email",
          phoneInfoLabel: "Телефон",
          locationInfoLabel: "Местоположение",
          websiteInfoLabel: "Веб-сайт",
          interestsHeader: "Интересы",
          whatsOnMind: "О чём вы думаете?",
          photosBtn: "Фото",
          postBtn: "Опубликовать",
          loadingPosts: "Загрузка публикаций...",
          noPostsYet: "Пока нет публикаций",
          noCommentsYet: "Пока нет комментариев",
          writeReplyPh: "Напишите ответ...",
          writeCommentPh: "Напишите комментарий...",
          postFeedbackEmpty: "Пожалуйста, добавьте текст или изображение.",
          postFeedbackLoginRequired: "Войдите в систему, чтобы опубликовать пост.",
          postCreateFailed: "Не удалось создать публикацию",
          postCreateError: "Ошибка при создании публикации.",
          postCreated: "Публикация успешно создана.",
          linkCopied: "Ссылка скопирована",
          maxImages: "Можно загрузить максимум 10 изображений",
          imageTooLarge: "Изображение {{name}} слишком большое",
          notAnImage: "{{name}} не является изображением",
          uploadedDocuments: "Загруженные документы",
          portfolioItems: "Материалы портфолио",
          uploadFileBtn: "Загрузить файл",
          addItemBtn: "Добавить материал",
          previewBtn: "Просмотр",
          downloadBtn: "Скачать",
          openBtn: "Открыть",
          deleteBtn: "Удалить",
          confirmDeleteFile: "Вы уверены, что хотите удалить этот файл?",
          myCertificates: "Мои сертификаты",
          addCertificateBtn: "Добавить сертификат",
          certTitlePh: "Название сертификата *",
          certIssuerPh: "Выдавшая организация",
          certDatePh: "Дата выдачи (напр. 2026-01-15)",
          certLocationPh: "Место (город, страна)",
          certRolePh: "Ваша роль / деятельность",
          certDescPh: "Описание (необязательно)",
          cvHeader: "Резюме (CV)",
          cvUploadBtn: "Загрузить CV",
          cvReplaceBtn: "Заменить CV",
          cvUploadedNote: "Видно организаторам, когда вы подаёте заявку на программу.",
          cvEmptyNote: "Добавьте своё резюме в формате PDF, чтобы организаторы видели его при подаче заявки.",
          saveCertificate: "Сохранить сертификат",
          savingEllipsis: "Сохранение…",
          noCertificatesYet: "Сертификаты пока не добавлены.",
          issuedByOrganizerFor: "Выдан организацией {{org}} за {{program}}",
          issuedByOrganizer: "Выдан организацией {{org}}",
          theOrganizer: "организатором",
          viewPdf: "Просмотреть PDF",
          confirmDeleteCertificate: "Удалить этот сертификат?",
          certTitleRequired: "Название обязательно.",
          certFileRequired: "Пожалуйста, прикрепите сертификат в формате PDF.",
          certFilePdfOnly: "Сертификаты необходимо загружать в формате PDF.",
          certAddFailed: "Не удалось добавить сертификат.",
          certDeleteFailed: "Не удалось удалить сертификат.",
          programsAppliedTo: "Программы, на которые я подавал(а) заявку",
          loadingApplications: "Загрузка заявок…",
          noApplicationsYet: "Вы ещё не подавали заявки ни на одну программу.",
          browsePrograms: "Просмотреть программы",
          appliedOn: "Подано {{date}}",
          statusPending: "⏳ Ожидает ответа",
          statusAccepted: "✅ Принято",
          statusRejected: "❌ Не принято",
          statusAttended: "🎓 Участие подтверждено",
          certIssuedSeeTab: "Сертификат выдан, см. вкладку «Сертификаты»",
          certPending: "Сертификат в ожидании",
          viewSubmission: "Посмотреть мою заявку",
          programFallback: "Программа",
          statsPosts: "Публикации",
          statsFollowers: "Подписчики",
          statsFollowing: "Подписки",
          totalPostsLabel: "Всего публикаций:",
          openPosts: "Открыть публикации",
          noUsersYet: "Пока нет пользователей для отображения.",
          unsavedTitle: "Несохранённые изменения",
          unsavedMessage: "У вас есть несохранённые изменения. Хотите сохранить их?",
          dontSave: "Не сохранять",
          changeCoverPhoto: "Изменить обложку",
          coverLabel: "Обложка",
          changeProfilePhoto: "Изменить фото профиля",
          reportAction: "Пожаловаться",
          saveBtn: "Сохранить",
        },
        messages: {
          justNow: "Только что",
          errNoContent: "Введите сообщение или выберите изображение",
          errNoConversation: "Нет активного диалога",
          confirmDeleteMessage: "Удалить это сообщение?",
          errDeleteMessage: "Не удалось удалить сообщение",
          errNoGroup: "Нет активной группы",
          confirmDeleteConversation: "Удалить этот диалог?",
          conversationDeleted: "Диалог удалён",
          errDeleteConversation: "Не удалось удалить диалог",
          confirmLeaveGroup: "Покинуть эту группу?",
          leftGroupSuccess: "Вы успешно покинули группу",
          errLeaveGroup: "Не удалось покинуть группу",
          joinedGroupSuccess: "Вы успешно присоединились к группе!",
          errJoinGroup: "Не удалось присоединиться к группе",
          errFileTooLarge: "Размер файла должен быть меньше 10МБ",
          errSelectImage: "Пожалуйста, выберите файл изображения",
          errSendMessage: "Не удалось отправить сообщение",
          errCreateConversation: "Не удалось создать диалог",
          errStartConversation: "Не удалось начать диалог",
          emojiRecent: "Недавние",
          emojiSmileys: "Смайлики",
          emojiHearts: "Сердца",
          emojiHands: "Руки",
          emojiAnimals: "Животные",
          emojiFood: "Еда",
          emojiTravel: "Путешествия",
          emojiSymbols: "Символы",
          emojiWeather: "Погода",
          signInTitle: "Войдите, чтобы продолжить",
          signInSubtitle: "Просматривайте и отправляйте сообщения",
          logIn: "Войти",
          title: "Сообщения",
          newTooltip: "Новое",
          tabDirect: "Личные",
          tabGroups: "Группы",
          searchPlaceholder: "Поиск...",
          loading: "Загрузка...",
          noConversations: "Пока нет диалогов",
          startChat: "Начать чат",
          unknown: "Неизвестно",
          sharedAPost: "📤 Поделился постом",
          noMessagesYet: "Сообщений пока нет",
          noGroups: "Пока нет групп",
          browseGroups: "Смотреть группы",
          tagPrivate: "Закрытая",
          tagAdmin: "Админ",
          membersCount: "{{count}} участников",
          someoneTyping: "{{name}} печатает...",
          online: "В сети",
          offline: "Не в сети",
          typing: "Печатает...",
          viewProfileTooltip: "Смотреть профиль",
          infoTooltip: "Информация",
          leaveGroupTooltip: "Покинуть группу",
          loadingMessages: "Загрузка сообщений...",
          beFirstToSayHello: "Будьте первым, кто поздоровается!",
          joinGroupToChat: "Присоединитесь к группе, чтобы общаться",
          sharedPost: "Опубликованный пост",
          tapToView: "Нажмите, чтобы посмотреть →",
          deleteMessageTooltip: "Удалить сообщение",
          joinToSend: "Присоединитесь к этой группе, чтобы отправлять сообщения",
          join: "Присоединиться",
          attachTooltip: "Прикрепить",
          emojisTooltip: "Эмодзи",
          messagePlaceholder: "Сообщение для {{name}}...",
          yourMessages: "Ваши сообщения",
          yourGroups: "Ваши группы",
          selectConversation: "Выберите диалог или начните новый",
          selectGroup: "Выберите группу, чтобы начать общение",
          newConversation: "Новый диалог",
          newMessageTitle: "Новое сообщение",
          noUsersAvailable: "Нет доступных пользователей",
          mutualFollowersOnly: "Вы можете писать только взаимным подписчикам",
          conversationInfoTitle: "О диалоге",
          deleteConversation: "Удалить диалог",
          groupInfoTitle: "О группе",
          membersCountDot: "{{count}} участников ·",
          public: "Открытая",
          leaveGroup: "Покинуть группу",
          joinGroup: "Присоединиться к группе",
        },
        feed: {
          seeMore: "Смотреть больше",
          seeLess: "Свернуть",
          noPostsYet: "Публикаций пока нет. Станьте первым!",
          loadFailed: "Не удалось загрузить ленту. Попробуйте позже.",
          justNow: "Только что",
          minAgo: "{{n}} мин назад",
          hourAgo: "{{n}} ч назад",
          dayAgo: "{{n}} дн назад",
          loginToLike: "Пожалуйста, войдите, чтобы ставить отметки «нравится»",
          followRequestSent: "Заявка на подписку отправлена!",
          failedFollowReq: "Не удалось отправить заявку на подписку",
          replyPosted: "Ответ опубликован!",
          commentAdded: "Комментарий добавлен!",
          failedComment: "Не удалось добавить комментарий.",
          failedLike: "Не удалось поставить отметку «нравится».",
          failedSave: "Не удалось сохранить публикацию.",
        },
      },
      settings: {
        title: "Настройки",
        subtitle: "Управляйте предпочтениями аккаунта и контентом",
        sidebar: {
          account: "Аккаунт",
          accountSettings: "Настройки аккаунта",
          savedLiked: "Сохранённое и лайки",
          preferences: "Предпочтения",
          privacySecurity: "Конфиденциальность и безопасность",
          notifications: "Уведомления",
          pro: "Pro",
          archive: "Архив",
          yourActivity: "Ваша активность",
          howOthersInteract: "Как другие могут с вами взаимодействовать",
          interactionsLabel: "Сообщения, комментарии и ограничения",
          accessibility: "Специальные возможности",
          dataPermissions: "Архивация, скачивание и разрешения",
          support: "Поддержка",
        },
        interactions: {
          title: "Как другие могут с вами взаимодействовать",
          subtitle: "Управляйте тем, кто может писать вам, комментировать ваши посты, и кого вы ограничили.",
          messagesHeading: "Сообщения",
          messagesSubtitle: "Кто может начать с вами новый диалог.",
          everyone: "Все",
          followersBack: "Люди, которые подписаны на вас в ответ",
          noOne: "Никто",
          commentsHeading: "Комментарии",
          commentsSubtitle: "Кто может комментировать ваши посты.",
          yourFollowers: "Ваши подписчики",
          turnOffComments: "Отключить комментарии",
          restrictedHeading: "Ограниченные аккаунты",
          restrictedSubtitle: "Ограниченные пользователи не могут комментировать ваши посты. Они всё ещё видят ваш публичный профиль и могут подписаться на вас. Это мягче, чем блокировка.",
          searchPlaceholder: "Поиск по имени или username…",
          searching: "Ищем…",
          noUsersFound: "Пользователи не найдены.",
          restrictBtn: "Ограничить",
          noneRestricted: "Вы никого не ограничили.",
          unrestrictBtn: "Снять ограничение",
        },
        archive: {
          title: "Архив",
          subtitle: "Архивированные посты скрыты из вашего профиля. Этот список видите только вы.",
          emptyTitle: "В архиве пусто",
          emptyBody: "Архивируйте пост из его меню опций, и он появится здесь.",
          unarchiveBtn: "Восстановить из архива",
        },
        activity: {
          title: "Ваша активность",
          subtitle: "Краткий обзор того, чем вы недавно занимались.",
          filterLiked: "Понравившееся",
          filterSaved: "Сохранённое",
          filterCommented: "Прокомментированное",
          filterSearches: "Поиски",
          empty: "Здесь пока ничего нет.",
        },
        accessibility: {
          title: "Специальные возможности",
          subtitle: "Настройте, как сайт ведёт себя, чтобы вам было удобнее.",
          reduceMotion: "Уменьшить анимацию",
          reduceMotionDesc: "Отключает анимации и переходы на всём сайте.",
        },
        dataExport: {
          title: "Архивация и скачивание",
          subtitle: "Скачайте копию своих данных.",
          downloadHeading: "Скачать ваши данные",
          downloadDesc: "Получите JSON-файл с профилем, постами и заявками.",
          preparing: "Готовим…",
          downloadBtn: "Скачать",
          scopeHint: "Выберите всё сразу или только одну часть ваших данных.",
          scopeAll: "Всё",
          scopeProfile: "Только профиль",
          scopePrograms: "Заявки на программы",
          scopeBuddy: "Buddy-менторство",
          scopeMessages: "Сообщения",
          permissionsTitle: "🔐 Разрешения сайта",
          permissionsSubtitle: "Что ваш браузер разрешает делать Greenwich и как это изменить.",
          permissionsPara1: "Greenwich запрашивает у вашего браузера только одно разрешение: уведомления, чтобы сообщать вам о лайках, комментариях, подписках и сообщениях, даже когда вкладка закрыта. Сайт не запрашивает доступ к камере, микрофону или геолокации.",
          permissionsPara2: "Вы можете в любой момент проверить или отозвать это разрешение в настройках сайта в браузере. Нажмите на значок замка рядом с адресной строкой, находясь на greenwich.am.",
        },
        toasts: {
          failedToSave: "Не удалось сохранить.",
          userRestricted: "Пользователь ограничен.",
          failedToRestrict: "Не удалось ограничить пользователя.",
          userUnrestricted: "Ограничение снято.",
          failedToUnrestrict: "Не удалось снять ограничение.",
          postUnarchived: "Пост восстановлен из архива, он снова в вашем профиле.",
          failedToUnarchive: "Не удалось восстановить пост из архива.",
          failedToExport: "Не удалось экспортировать ваши данные.",
        },
        account: {
          title: "Информация аккаунта",
          subtitle: "Управляйте личными данными и предпочтениями",
          firstName: "Имя",
          lastName: "Фамилия",
          email: "Email",
          phone: "Телефон",
          location: "Местоположение",
          bio: "О себе",
          bioPlaceholder: "Расскажите о себе...",
          profileColor: "Акцентный цвет профиля",
          profileColorHint: "Отображается на вашем публичном профиле. Выберите свой цвет или оставьте стандартный.",
          saveChanges: "Сохранить изменения",
          profileUpdated: "Профиль успешно обновлён!",
          profileUpdateError: "Ошибка обновления профиля",
          accountDeleted: "Аккаунт успешно удалён.",
          changePasswordTitle: "Изменить пароль",
          changePasswordSubtitle: "Обновите пароль, который вы используете для входа.",
          currentPassword: "Текущий пароль",
          newPassword: "Новый пароль",
          confirmNewPassword: "Подтвердите новый пароль",
          newPasswordPlaceholder: "Не менее 8 символов",
          confirmNewPasswordPlaceholder: "Повторите новый пароль",
          updatePassword: "Обновить пароль",
          passwordFieldsRequired: "Пожалуйста, заполните все поля пароля.",
          passwordTooShort: "Новый пароль должен содержать не менее 8 символов.",
          passwordMismatch: "Новый пароль и подтверждение не совпадают.",
          passwordUpdated: "Пароль успешно обновлён.",
          passwordUpdateFailed: "Не удалось обновить пароль.",
          activeSessionsTitle: "Активные сессии",
          activeSessionsSubtitle: "Посмотрите, где вы вошли в аккаунт, и выйдите на других устройствах.",
          manage: "Управлять →",
        },
        savedLiked: {
          title: "Сохранённые и понравившиеся посты",
          subtitle: "Посты, которые вы сохранили или лайкнули",
          emptyTitle: "Нет сохранённых или понравившихся постов",
          emptySubtitle: "Сохранённые и понравившиеся посты появятся здесь.",
          savedCount: "Сохранено",
          likedCount: "Лайки",
          badgeSaved: "Сохранено",
          badgeLiked: "Лайк",
          loadingPosts: "Загрузка постов...",
          unknownAuthor: "Неизвестно",
        },
        privacy: {
          title: "Конфиденциальность и безопасность",
          subtitle: "Настройте конфиденциальность и безопасность",
          accountPrivacy: "Приватность аккаунта",
          accountPrivacySubtitle: "Кто может видеть ваш профиль и посты",
          visibility: {
            public: "Публично",
            private: "Приватно",
            friends: "Только друзья",
          },
          language: "Язык",
          languageSubtitle: "Выберите предпочитаемый язык",
          contentLanguage: "Язык контента",
          contentLanguageSubtitle: "На каком языке показывать программы и возможности, независимо от языка интерфейса",
          market: "Страна",
          marketSubtitle: "Переключение между армянской и французской версией Greenwich",
          twoFactor: "Двухфакторная аутентификация",
          twoFactorSubtitle: "Дополнительный уровень защиты аккаунта",
          privateAccount: "Приватный аккаунт и заявки на подписку",
          privateAccountSubtitle: "Требовать подтверждения, прежде чем на вас смогут подписаться",
          notificationsRow: "Уведомления",
          notificationsRowSubtitle: "Выберите, какие уведомления вы получаете по email, push и в приложении, настройте тихие часы",
          security: "Безопасность",
          securitySubtitle: "Двухфакторная аутентификация, смена email, подключённые аккаунты",
          blockedAccounts: "Заблокированные аккаунты",
          blockedAccountsSubtitle: "Заблокированные вами люди не могут видеть ваш профиль или связаться с вами",
          mutedAccounts: "Аккаунты в игноре",
          mutedAccountsSubtitle: "Их посты незаметно скрыты из вашей ленты",
          manage: "Управлять →",
          dangerZone: "Опасная зона",
        },
        deleteModal: {
          heading: "Почему вы хотите удалить аккаунт?",
          selectReason: "Выберите причину",
          reasonPrivacy: "Опасения по поводу конфиденциальности",
          reasonNotUseful: "Не полезно",
          reasonTooManyEmails: "Слишком много уведомлений",
          reasonOther: "Другое",
          writeReason: "Напишите причину...",
          pleaseSelectReason: "Пожалуйста, выберите причину",
          areYouSure: "Вы уверены?",
          cannotBeUndone: "Это действие нельзя отменить. Все ваши данные будут удалены безвозвратно.",
          yesDelete: "Да, удалить",
          error: "Ошибка при удалении аккаунта. Попробуйте ещё раз.",
        },
        notifications: {
          title: "Уведомления",
          subtitle: "Управляйте уведомлениями",
          pushTitle: "Push-уведомления",
          pushSubtitle: "Получайте уведомления в браузере",
        },
        languages: {
          en: "Английский",
          hy: "Армянский",
          ru: "Русский",
          de: "Немецкий",
          es: "Испанский",
          fr: "Французский",
        },
        pro: {
          title: "Greenwich Pro",
          subtitle: "Управляй своими Pro-привилегиями: кастомный дизайн, рамка аватара и история просмотров профиля.",
          statusActive: "Твой Pro активен до {{date}}",
          statusNone: "У тебя пока нет Pro.",
          learnMore: "Узнать больше о Pro",
          frameTitle: "Рамка аватара",
          frameNone: "Нет", frameGold: "Золотая", frameEmerald: "Изумрудная", frameRoyal: "Королевская",
          designTitle: "Дизайн профиля",
          designNone: "Нет", designSunset: "Закат", designOcean: "Океан", designForest: "Лес", designMidnight: "Полночь",
          save: "Сохранить", saving: "Сохранение...",
          customizationSaved: "Кастомизация сохранена!",
          customizationError: "Не удалось сохранить кастомизацию.",
          channelTitle: "Доставка подходящих проектов",
          channelSubtitle: "Выбери, где ты хочешь получать свои лучшие совпадения по проектам.",
          channelPlatform: "На платформе", channelEmail: "На email", channelTelegram: "В Telegram-боте",
          comingSoon: "скоро",
          linkTelegram: "привязать аккаунт",
          sendTest: "Отправить мои совпадения сейчас",
          testSent: "Отправлено! Проверь выбранный канал.",
          timingTitle: "Время и содержание",
          timingSubtitle: "Настрой, когда приходят подборки, нужны ли напоминания, и насколько подробным будет каждое совпадение.",
          deliveryHour: "Время доставки",
          remindersLabel: "Продолжать присылать, даже если подборка не изменилась (режим напоминаний)",
          detailLevel: "Подробность сообщения",
          detail_brief: "Кратко", detail_detailed: "Подробно",
          sourceTitle: "Как выбираются проекты",
          sourceAi: "AI-мэтчинг (рекомендуется)", sourceCategories: "Выберу категории сам",
          sourceAiHint: "Рекомендуется для точности. Подборка ранжируется по твоей активности на платформе.",
          category_education: "Образование", category_scholarship: "Стипендия", category_fellowship: "Фелоушип",
          category_erasmusplus: "Erasmus+", category_training: "Тренинг", category_grant: "Грант",
          category_internship: "Стажировка", category_conference: "Конференция", category_online: "Онлайн",
          category_volunteering: "Волонтёрство", category_event: "Мероприятие", category_award: "Награда",
          viewsTitle: "Кто смотрел твой профиль",
          viewsSubtitle: "Видно только пока активна твоя Pro-подписка.",
          viewsLocked: "Оформи Pro, чтобы видеть, кто смотрел твой профиль.",
          viewsCountToday: "Сегодня твой профиль посмотрели {{count}} чел.",
          viewsEmpty: "За этот Pro-период просмотров профиля пока нет.",
          loading: "Загрузка...",
          billingTitle: "Платежи и возвраты",
          billingSubtitle: "Ваши прошлые покупки с возможностью запросить возврат в течение 7 дней.",
          billingEmpty: "Покупок пока нет.",
          requestRefund: "Запросить возврат",
          refundWindowExpired: "Срок возврата истёк",
          refundStatusRequested: "Возврат запрошен, на рассмотрении",
          refundStatusApproved: "Возврат одобрен",
          refundStatusRejected: "В возврате отказано",
          refundStatusRefunded: "Возвращено",
          refundModalTitle: "Запросить возврат",
          refundModalSubtitle: "Расскажите, что случилось. Это помогает нам стать лучше и нужно для обработки возврата.",
          refundReasonLabel: "Причина",
          selectReason: "Выберите причину",
          reason_not_what_expected: "Не то, что ожидал(а)",
          reason_found_cheaper_elsewhere: "Нашёл(нашла) дешевле в другом месте",
          reason_technical_issues: "Столкнулся(лась) с техническими проблемами",
          reason_accidental_purchase: "Случайная покупка",
          reason_no_longer_needed: "Больше не нужно",
          reason_bought_wrong_plan: "Купил(а) не тот план",
          reason_unsatisfied_with_features: "Не устроили возможности",
          reason_other: "Другое",
          ratingLabel: "Как бы вы оценили свой опыт?",
          commentLabel: "Хотите добавить что-то ещё? (необязательно)",
          commentPlaceholder: "Расскажите подробнее...",
          talkToSupport: "Хотите сначала с кем-то поговорить?",
          talkToSupportLink: "Написать в поддержку",
          submitRefund: "Отправить запрос на возврат",
          submittingRefund: "Отправка...",
          refundSubmitted: "Запрос на возврат отправлен, скоро рассмотрим.",
          refundError: "Не удалось отправить запрос. Попробуйте ещё раз.",
        },
        confirmLogout: "Вы уверены, что хотите выйти?",
      },
      feed: {
        sidebarExplore: "Обзор",
        photos: "Фото",
        postBtn: "Опубликовать",
        whatsOnMind: "О чём вы думаете?",
        recommendedForYou: "Рекомендуем вам",
        programsForYou: "Программы для вас",
        programsForYouFallback: "Программа",
        programsForYouPopularHint: "Сейчас популярно. Сохраняйте или подавайте заявки на программы, чтобы персонализировать подборку.",
        seeAll: "Смотреть всё",
        followPeopleHint: "Подпишитесь на людей, чтобы видеть их здесь",
        loading: "Загрузка...",
        close: "Закрыть",
        noFollowersYet: "Пока нет подписчиков",
        noFollowingYet: "Вы пока ни на кого не подписаны",
        unknown: "Неизвестно",
        viewAllFollowing: "Показать все подписки ({{count}})",
        noRecommendationsYet: "Пока нет рекомендаций",
        recommendationsHint: "Подписывайтесь на людей или ищите, чтобы получать рекомендации",
        alreadyFollowing: "Вы уже подписаны",
        reasonViolent: "Жестокий контент",
        reasonDescSpam: "Это спам",
        reasonDescInappropriate: "Содержит контент 18+ или откровенный контент",
        reasonDescViolent: "Содержит насилие, кровь или шокирующий контент",
        reasonDescHarassment: "Домогательства или травля",
        reasonDescHateSpeech: "Разжигает ненависть или насилие",
        reasonDescMisinformation: "Ложная или вводящая в заблуждение информация",
        reasonDescOther: "Другая причина",
        reportComment: "Пожаловаться на комментарий",
        reportSelectReasonHint: "Пожалуйста, выберите причину жалобы на этот {{type}}. Это действие анонимно.",
        additionalDetails: "Дополнительные детали (необязательно)",
        reportDetailsPlaceholder: "Расскажите подробнее о вашей жалобе...",
        submitReport: "Отправить жалобу",
        editPost: "Редактировать пост",
        archivePost: "Архивировать пост",
        archiving: "Архивируем…",
        commentWillBeDeleted: "Комментарий будет удалён безвозвратно. Это действие нельзя отменить.",
        sendAndShare: "Отправить и поделиться",
        imagePost: "Пост с изображением",
        sendToMutualFollows: "Отправить взаимным подпискам",
        loadingMutualFollows: "Загружаем взаимные подписки...",
        showLess: "Показать меньше",
        showAllUsers: "Показать всех ({{count}})",
        shareOnSocialMedia: "Поделиться в соцсетях",
        failedToCopyLink: "Не удалось скопировать ссылку",
        failedToLikeComment: "Не удалось лайкнуть комментарий.",
        commentDeletedToast: "Комментарий удалён!",
        failedToDeleteComment: "Не удалось удалить комментарий",
        postArchivedToast: "Пост архивирован. Найдёте его в Настройки → Архив.",
        reportSubmittedToast: "Жалоба успешно отправлена",
        failedToSubmitReport: "Не удалось отправить жалобу",
        maxImagesError: "Можно загрузить максимум 10 изображений",
        postContentEmptyError: "Содержимое поста не может быть пустым",
        pleaseLogInToEdit: "Пожалуйста, войдите, чтобы редактировать посты",
        postUpdatedToast: "Пост успешно обновлён!",
        cannotSendPostError: "Не удалось отправить пост: не хватает данных",
        postNotFoundError: "Пост не найден",
        pleaseAddContentError: "Пожалуйста, добавьте текст или изображение",
        pleaseLogInToPost: "Пожалуйста, войдите, чтобы опубликовать пост",
        postCreatedToast: "Пост успешно опубликован!",
        cannotConnectError: "Не удалось подключиться к серверу. Проверьте интернет-соединение",
        cannotCopyProfileLinkError: "Не удалось скопировать ссылку на профиль: пользователь не загружен",
        postDeletedByAdmin: "Пост удалён администратором.",
        failedToDeletePost: "Не удалось удалить пост",
        failedToArchivePost: "Не удалось архивировать пост",
        failedToUpdatePost: "Не удалось обновить пост.",
        failedToCreatePost: "Не удалось создать пост.",
        replaceImages: "Заменить изображения",
        addImages: "Добавить изображения",
      },
    },
  },
  de: {
    translation: {
      common: {
        saving: "Wird gespeichert...",
        refresh: "Aktualisieren",
        logout: "Abmelden",
        deleteAccount: "Konto löschen",
        viewPost: "Beitrag ansehen",
        unsave: "Aus gespeicherten entfernen",
        unlike: "Gefällt mir entfernen",
        members: "Mitglieder",
        posts: "Beiträge",
        editProfile: "Profil bearbeiten",
        unknownUser: "Unbekannter Benutzer",
        exploreUsers: "Benutzer erkunden",
        showAll: "Alle anzeigen",
        searchMutualFollows: "Gegenseitige Follower suchen...",
        myPosts: "Meine Beiträge",
        likedPosts: "Gelikte Beiträge",
        savedPosts: "Gespeicherte Beiträge",
        organizationPosts: "Organisationsbeiträge",
      },
      navbar: {
        feed: "Feed",
        community: "Community",
        projects: "Programme",
        organizations: "Organisationen",
        donateNow: "Jetzt spenden",
        settings: "Einstellungen",
        contactUs: "Kontakt",
        whoWeAre: "Über uns",
        account: "Konto",
        editProfile: "Profil bearbeiten",
        logOut: "Abmelden",
        viewDashboard: "Ihr Dashboard anzeigen",
        adminDashboard: "Admin-Dashboard",
        verifiedOrganizations: "Verifizierte Organisationen",
        adminPanel: "Admin-Panel",
        searchPlaceholder: "Benutzer, Beiträge, Gemeinschaften, Organisationen suchen...",
        searching: "Suche...",
        searchMinChars: "Geben Sie mindestens 2 Zeichen für die Suche ein",
        users: "Benutzer",
        communities: "Gemeinschaften",
        posts: "Beiträge",
        noResults: "Keine Ergebnisse gefunden für",
        seeAllResults: "Alle Ergebnisse anzeigen",
        organization: "Organisation",
        user: "Benutzer",
        postBy: "Beitrag von",
        tryDifferentKeywords: "Versuchen Sie andere Stichwörter",
        searchMembers: "Mitglieder suchen",
        loginToSearch: "Bitte melden Sie sich an, um die Suche zu verwenden",
        sessionExpired: "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
        serverError: "Serverfehler. Bitte versuchen Sie es später erneut.",
        searchFailed: "Suche fehlgeschlagen",
        networkError: "Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
        language: "Sprache",
        selectLanguage: "Sprache wählen",
        messages: "Nachrichten",
        cancel: "Abbrechen",
      },
      settings: {
        title: "Einstellungen",
        subtitle: "Verwalten Sie Kontoeinstellungen und Inhalte",
        sidebar: {
          account: "Konto",
          accountSettings: "Kontoeinstellungen",
          savedLiked: "Gespeichert & Geliked",
          preferences: "Präferenzen",
          privacySecurity: "Datenschutz & Sicherheit",
          notifications: "Benachrichtigungen",
        },
        account: {
          title: "Kontoinformationen",
          subtitle: "Persönliche Daten und Präferenzen verwalten",
          firstName: "Vorname",
          lastName: "Nachname",
          email: "E-Mail",
          phone: "Telefon",
          location: "Ort",
          bio: "Über mich",
          bioPlaceholder: "Erzählen Sie etwas über sich...",
          profileColor: "Profil-Akzentfarbe",
          profileColorHint: "Wird auf Ihrem öffentlichen Profil angezeigt. Wählen Sie Ihre eigene Farbe oder behalten Sie die Standardfarbe.",
          saveChanges: "Änderungen speichern",
          profileUpdated: "Profil erfolgreich aktualisiert!",
          profileUpdateError: "Fehler beim Aktualisieren des Profils",
        },
        savedLiked: {
          title: "Gespeicherte & gelikte Beiträge",
          subtitle: "Beiträge, die Sie gespeichert oder geliked haben",
          emptyTitle: "Keine gespeicherten oder gelikten Beiträge",
          emptySubtitle: "Gespeicherte oder gelikte Beiträge erscheinen hier.",
          savedCount: "Gespeichert",
          likedCount: "Geliked",
          badgeSaved: "Gespeichert",
          badgeLiked: "Geliked",
          loadingPosts: "Beiträge werden geladen...",
        },
        privacy: {
          title: "Datenschutz & Sicherheit",
          subtitle: "Datenschutz- und Sicherheitseinstellungen steuern",
          accountPrivacy: "Konto-Datenschutz",
          accountPrivacySubtitle: "Wer kann Ihr Profil und Ihre Beiträge sehen",
          visibility: {
            public: "Öffentlich",
            private: "Privat",
            friends: "Nur Freunde",
          },
          language: "Sprache",
          languageSubtitle: "Bevorzugte Sprache auswählen",
          twoFactor: "Zwei-Faktor-Authentifizierung",
          twoFactorSubtitle: "Zusätzliche Sicherheitsebene hinzufügen",
          dangerZone: "Gefahrenzone",
        },
        notifications: {
          title: "Benachrichtigungen",
          subtitle: "Benachrichtigungen verwalten",
          pushTitle: "Push-Benachrichtigungen",
          pushSubtitle: "Browser-Benachrichtigungen erhalten",
        },
        languages: {
          en: "Englisch",
          hy: "Armenisch",
          ru: "Russisch",
          de: "Deutsch",
          es: "Spanisch",
          fr: "Französisch",
        },
        confirmLogout: "Möchten Sie sich wirklich abmelden?",
      },
    },
  },
  es: {
    translation: {
      common: {
        saving: "Guardando...",
        refresh: "Actualizar",
        logout: "Cerrar sesión",
        deleteAccount: "Eliminar cuenta",
        viewPost: "Ver publicación",
        unsave: "Quitar de guardados",
        unlike: "Quitar me gusta",
        members: "miembros",
        posts: "Publicaciones",
        editProfile: "Editar perfil",
        unknownUser: "Usuario desconocido",
        exploreUsers: "Explorar usuarios",
        showAll: "Mostrar todo",
        searchMutualFollows: "Buscar seguidores mutuos...",
        myPosts: "Mis publicaciones",
        likedPosts: "Publicaciones con me gusta",
        savedPosts: "Publicaciones guardadas",
        organizationPosts: "Publicaciones de la organización",
      },
      navbar: {
        feed: "Inicio",
        community: "Comunidad",
        projects: "Programas",
        organizations: "Organizaciones",
        donateNow: "Donar ahora",
        settings: "Configuración",
        contactUs: "Contáctanos",
        whoWeAre: "Quiénes somos",
        account: "Cuenta",
        editProfile: "Editar perfil",
        logOut: "Cerrar sesión",
        viewDashboard: "Ver tu panel",
        adminDashboard: "Panel de administrador",
        verifiedOrganizations: "Organizaciones verificadas",
        adminPanel: "Panel de administrador",
        searchPlaceholder: "Buscar usuarios, publicaciones, comunidades, organizaciones...",
        searching: "Buscando...",
        searchMinChars: "Escribe al menos 2 caracteres para buscar",
        users: "Usuarios",
        communities: "Comunidades",
        posts: "Publicaciones",
        noResults: "No se encontraron resultados para",
        seeAllResults: "Ver todos los resultados",
        organization: "Organización",
        user: "Usuario",
        postBy: "Publicación de",
        tryDifferentKeywords: "Prueba con otras palabras clave",
        searchMembers: "Buscar miembros",
        loginToSearch: "Por favor inicia sesión para usar la búsqueda",
        sessionExpired: "Sesión expirada. Por favor inicia sesión nuevamente.",
        serverError: "Error del servidor. Por favor intenta más tarde.",
        searchFailed: "Búsqueda fallida",
        networkError: "Error de red. Por favor verifica tu conexión e intenta de nuevo.",
        language: "Idioma",
        selectLanguage: "Elegir idioma",
        messages: "Mensajes",
        cancel: "Cancelar",
      },
      settings: {
        title: "Configuración",
        subtitle: "Administra preferencias de cuenta y contenido",
        sidebar: {
          account: "Cuenta",
          accountSettings: "Configuración de cuenta",
          savedLiked: "Guardados y Me gusta",
          preferences: "Preferencias",
          privacySecurity: "Privacidad y seguridad",
          notifications: "Notificaciones",
        },
        account: {
          title: "Información de la cuenta",
          subtitle: "Administra tu información personal y preferencias",
          firstName: "Nombre",
          lastName: "Apellido",
          email: "Correo",
          phone: "Teléfono",
          location: "Ubicación",
          bio: "Biografía",
          bioPlaceholder: "Cuéntanos sobre ti...",
          profileColor: "Color de acento del perfil",
          profileColorHint: "Se muestra en tu perfil público. Elige el tuyo o conserva el predeterminado.",
          saveChanges: "Guardar cambios",
          profileUpdated: "¡Perfil actualizado correctamente!",
          profileUpdateError: "Error al actualizar el perfil",
        },
        savedLiked: {
          title: "Publicaciones guardadas y con Me gusta",
          subtitle: "Publicaciones que guardaste o te gustaron",
          emptyTitle: "No hay guardados ni Me gusta",
          emptySubtitle: "Las publicaciones guardadas o con Me gusta aparecerán aquí.",
          savedCount: "Guardadas",
          likedCount: "Me gusta",
          badgeSaved: "Guardada",
          badgeLiked: "Me gusta",
          loadingPosts: "Cargando publicaciones...",
        },
        privacy: {
          title: "Privacidad y seguridad",
          subtitle: "Controla tu privacidad y seguridad",
          accountPrivacy: "Privacidad de la cuenta",
          accountPrivacySubtitle: "Quién puede ver tu perfil y publicaciones",
          visibility: {
            public: "Público",
            private: "Privado",
            friends: "Solo amigos",
          },
          language: "Idioma",
          languageSubtitle: "Elige tu idioma preferido",
          twoFactor: "Autenticación de dos factores",
          twoFactorSubtitle: "Agrega una capa extra de seguridad",
          dangerZone: "Zona peligrosa",
        },
        notifications: {
          title: "Notificaciones",
          subtitle: "Administra cómo y cuándo recibes notificaciones",
          pushTitle: "Notificaciones push",
          pushSubtitle: "Recibe notificaciones del navegador",
        },
        languages: {
          en: "Inglés",
          hy: "Armenio",
          ru: "Ruso",
          de: "Alemán",
          es: "Español",
          fr: "Francés",
        },
        confirmLogout: "¿Seguro que quieres cerrar sesión?",
      },
    },
  },
  pt: {
    translation: {
      common: {
        saving: "Salvando...",
        refresh: "Atualizar",
        logout: "Sair",
        deleteAccount: "Excluir conta",
        viewPost: "Ver publicação",
        unsave: "Desfavoritar",
        unlike: "Descurtir",
        members: "membros",
        posts: "Publicações",
        editProfile: "Editar perfil",
        unknownUser: "Usuário desconhecido",
        exploreUsers: "Explorar usuários",
        showAll: "Mostrar tudo",
        searchMutualFollows: "Buscar seguidores mutuos...",
        myPosts: "Minhas publicações",
        likedPosts: "Publicações curtidas",
        savedPosts: "Publicações salvas",
        organizationPosts: "Publicações da organização",
      },
      navbar: { feed: "Feed", community: "Comunidade", projects: "Projetos", organizations: "Organizações", donateNow: "Doar", settings: "Configurações", contactUs: "Contato", whoWeAre: "Quem somos", account: "Conta", editProfile: "Editar perfil", logOut: "Sair", viewDashboard: "Seu painel", adminDashboard: "Painel admin", verifiedOrganizations: "Organizações verificadas", adminPanel: "Painel admin", searchPlaceholder: "Buscar...", searching: "Buscando...", searchMinChars: "Digite ao menos 2 caracteres", users: "Usuários", communities: "Comunidades", posts: "Publicações", noResults: "Nenhum resultado para", seeAllResults: "Ver todos", organization: "Organização", user: "Usuário", postBy: "Publicação de", tryDifferentKeywords: "Tente outras palavras", searchMembers: "Buscar membros", loginToSearch: "Faça login para buscar", sessionExpired: "Sessão expirada.", serverError: "Erro do servidor.", searchFailed: "Falha na busca", networkError: "Erro de rede.", language: "Idioma", selectLanguage: "Escolher idioma", messages: "Mensagens", cancel: "Cancelar", },
      settings: {
        title: "Configurações",
        subtitle: "Gerencie sua conta e preferências",
        sidebar: { account: "Conta", accountSettings: "Configuração da conta", savedLiked: "Salvos e curtidos", preferences: "Preferências", privacySecurity: "Privacidade e segurança", notifications: "Notificações", },
        account: { title: "Informações da conta", subtitle: "Gerencie seus dados", firstName: "Nome", lastName: "Sobrenome", email: "E-mail", phone: "Telefone", location: "Localização", bio: "Bio", bioPlaceholder: "Conte sobre você...", profileColor: "Cor de destaque do perfil", profileColorHint: "Exibida no seu perfil público. Escolha a sua ou mantenha a padrão.", saveChanges: "Salvar alterações", profileUpdated: "Perfil atualizado!", profileUpdateError: "Erro ao atualizar.", accountDeleted: "Conta excluída com sucesso.", },
        savedLiked: { title: "Salvos e curtidos", subtitle: "Publicações que você salvou ou curtiu", emptyTitle: "Nada salvo ou curtido", emptySubtitle: "Suas publicações salvas e curtidas aparecerão aqui.", savedCount: "Salvos", likedCount: "Curtidos", badgeSaved: "Salvo", badgeLiked: "Curtido", loadingPosts: "Carregando...", },
        privacy: { title: "Privacidade e segurança", subtitle: "Controle sua privacidade", accountPrivacy: "Privacidade da conta", accountPrivacySubtitle: "Quem pode ver seu perfil", visibility: { public: "Público", private: "Privado", friends: "Só amigos", }, language: "Idioma", languageSubtitle: "Escolha o idioma", twoFactor: "Autenticação em dois fatores", twoFactorSubtitle: "Segurança extra", dangerZone: "Zona de perigo", },
        notifications: { title: "Notificações", subtitle: "Gerencie notificações", pushTitle: "Push", pushSubtitle: "Notificações do navegador", },
        languages: { en: "Inglês", hy: "Armênio", ru: "Russo", de: "Alemão", es: "Espanhol", pt: "Português", fr: "Francês", },
        confirmLogout: "Deseja realmente sair?",
      },
    },
  },
  fr: {
    translation: {
      common: {
        saving: "Enregistrement...",
        refresh: "Actualiser",
        logout: "Déconnexion",
        deleteAccount: "Supprimer le compte",
        viewPost: "Voir la publication",
        unsave: "Retirer des enregistrements",
        unlike: "Ne plus aimer",
        members: "membres",
        posts: "Publications",
        editProfile: "Modifier le profil",
        unknownUser: "Utilisateur inconnu",
        exploreUsers: "Explorer les utilisateurs",
        showAll: "Tout afficher",
        searchMutualFollows: "Rechercher des abonnés mutuels...",
        myPosts: "Mes publications",
        likedPosts: "Publications aimées",
        savedPosts: "Publications enregistrées",
        organizationPosts: "Publications de l'organisation",
      },
      navbar: {
        home: "Accueil",
        feed: "Fil",
        community: "Communauté",
        projects: "Programmes",
        organizations: "Organisations",
        donateNow: "Faire un don",
        pro: "Greenwich Pro",
        buddy: "Buddy",
        greencoins: "Greencoins",
        shop: "Boutique Greenwich",
        settings: "Paramètres",
        contactUs: "Nous contacter",
        whoWeAre: "Qui sommes-nous",
        account: "Compte",
        editProfile: "Modifier le profil",
        howItWorks: "Comment ça marche",
        logOut: "Déconnexion",
        viewDashboard: "Voir votre tableau de bord",
        adminDashboard: "Tableau de bord admin",
        verifiedOrganizations: "Organisations vérifiées",
        adminPanel: "Panneau d'administration",
        searchPlaceholder: "Rechercher utilisateurs, publications, communautés, organisations...",
        searching: "Recherche...",
        searchMinChars: "Saisissez au moins 2 caractères pour rechercher",
        users: "Utilisateurs",
        communities: "Communautés",
        posts: "Publications",
        noResults: "Aucun résultat pour",
        seeAllResults: "Voir tous les résultats",
        organization: "Organisation",
        user: "Utilisateur",
        postBy: "Publication de",
        tryDifferentKeywords: "Essayez d'autres mots-clés",
        searchMembers: "Rechercher des membres",
        loginToSearch: "Veuillez vous connecter pour utiliser la recherche",
        sessionExpired: "Session expirée. Veuillez vous reconnecter.",
        serverError: "Erreur du serveur. Veuillez réessayer plus tard.",
        searchFailed: "Échec de la recherche",
        networkError: "Erreur réseau. Vérifiez votre connexion et réessayez.",
        language: "Langue",
        selectLanguage: "Choisir la langue",
        messages: "Messages",
        cancel: "Annuler",
      },
      notifications: {
        title: "Notifications",
        markAllRead: "Tout marquer comme lu",
        marking: "Marquage...",
        loading: "Chargement...",
        allCaughtUp: "Vous êtes à jour !",
        noNew: "Aucune nouvelle notification",
        liked: "a aimé votre publication",
        commented: "a commenté votre publication",
        followed: "a commencé à vous suivre",
        followRequest: "souhaite vous suivre",
        followAccepted: "a accepté votre demande d'abonnement",
        sentMessage: "vous a envoyé un message",
        postRemoved: "votre publication a été supprimée par un administrateur",
        genericNotification: "a envoyé une notification",
        reason: "Raison",
        admin: "Admin",
        processing: "Traitement...",
        accept: "Accepter",
        decline: "Refuser",
        total: "total",
        unread: "non lues",
        refresh: "Actualiser",
        justNow: "à l'instant",
        dismiss: "Ignorer",
        missingFollowData: "Impossible de traiter : données de la demande d'abonnement manquantes.",
        followActionFailed: "Échec de l'action « {{action}} » sur la demande d'abonnement. Veuillez réessayer.",
        networkError: "Erreur réseau. Veuillez réessayer.",
        avatarAlt: "Avatar",
        viewProfile: "Voir le profil de {{name}}",
        someone: "Quelqu'un",
      },
      messageModal: {
        sendMessage: "Envoyer un message",
        noMutualFollows: "Aucun abonnement mutuel pour le moment",
        noMutualFollowsHint: "Suivez des personnes et attendez qu'elles vous suivent en retour pour leur envoyer un message.",
        mutualFollowsCount: "{{count}} abonnements mutuels",
        org: "Org",
        user: "Utilisateur",
        mutualFollow: "Abonnement mutuel",
        cancel: "Annuler",
        verified: "Vérifié",
      },
      postModal: {
        reply: "Répondre",
        report: "Signaler",
        delete: "Supprimer",
        save: "Enregistrer",
        share: "Partager",
        writeReply: "Écrire une réponse...",
        writeComment: "Écrire un commentaire...",
        noCommentsYet: "Aucun commentaire pour le moment",
        deletePost: "Supprimer la publication",
        deleteComment: "Supprimer le commentaire",
        cancel: "Annuler",
        areYouSure: "Êtes-vous sûr ?",
        postWillBeDeleted: "Cette publication sera définitivement supprimée.",
        deleteThisComment: "Supprimer ce commentaire ?",
        reportPost: "Signaler la publication",
        reasonSpam: "Spam",
        reasonInappropriate: "Contenu inapproprié",
        reasonHarassment: "Harcèlement",
        reasonHateSpeech: "Discours haineux",
        reasonMisinformation: "Désinformation",
        reasonOther: "Autre",
        linkCopied: "Lien copié !",
        beFirstComment: "Soyez le premier à commenter !",
        comment: "Commentaire",
        comments: "Commentaires",
        justNow: "À l'instant",
        minutesAgo: "il y a {{m}} min",
        hoursAgo: "il y a {{h}} h",
        daysAgo: "il y a {{day}} j",
        unknown: "Inconnu",
        me: "Moi",
        replyPosted: "Réponse publiée !",
        commentAdded: "Commentaire ajouté !",
        postDeleted: "Publication supprimée.",
        commentDeleted: "Commentaire supprimé.",
        reportSubmitted: "Signalement envoyé.",
        failedLoadPost: "Échec du chargement de la publication.",
        loadingPost: "Chargement de la publication...",
        postNotFound: "Publication introuvable.",
        like: "J'aime",
        likes: "J'aime",
        submit: "Envoyer",
        user: "Utilisateur",
      },
      authPages: {
        orgReg: {
          stepProfileShort: "Profil", stepProfileLong: "Profil de l'organisation",
          stepContactShort: "Contact", stepContactLong: "Contact et réseaux", stepContactMedium: "Contact",
          stepTeamShort: "Équipe", stepTeamLong: "Équipe et sécurité",
          stepVerification: "Compte",
          back: "Retour",
          loadingOrgData: "Chargement des données de votre organisation...",
          continueStep2: "Continuer à l'étape 2",
          continueStep3: "Continuer à l'étape 3",
          continueVerification: "Continuer vers la vérification",
          orgNameTitle: "Nom de l'organisation",
          orgNameTooltip: "Ajoutez le nom de votre organisation dans différentes langues. La version arménienne est requise.",
          orgNameDesc: "Indiquez le nom de votre organisation dans différentes langues",
          language: "Langue",
          orgNameLabel: "Nom de l'org.",
          orgNamePlaceholder: "Saisir le nom de l'organisation",
          addNameInAnotherLanguage: "Ajouter un nom dans une autre langue",
          orgTypeTitle: "Type d'organisation",
          selectOrgType: "Sélectionner le type d'organisation",
          typesSelected: "{{count}} types sélectionnés",
          specifyOrgType: "Précisez le type de votre organisation...",
          ageGroupsTitle: "Tranches d'âge visées",
          ageGroups: {
            all: "Toutes les tranches d'âge",
            "0-12": "Enfants (0-12)",
            "13-17": "Adolescents (13-17)",
            "18-25": "Jeunes adultes (18-25)",
            "26-35": "Adultes (26-35)",
            "36-50": "Âge mûr (36-50)",
            "51-65": "Adultes seniors (51-65)",
            "65+": "Personnes âgées (65+)",
          },
          orgNameLanguages: {
            Armenian: "Arménien",
            English: "Anglais",
            Russian: "Russe",
            French: "Français",
            German: "Allemand",
            Spanish: "Espagnol",
            Other: "Autre",
          },
          focusAreasTitle: "Domaines d'action",
          selectFocusAreas: "Sélectionner les domaines d'action",
          areasSelected: "{{count}} domaines sélectionnés",
          specifyFocusArea: "Précisez votre domaine d'action...",
          detailsTitle: "Détails de l'organisation",
          briefDescription: "Description brève",
          briefDescriptionPlaceholder: "Décrivez l'objectif, les activités et l'impact de votre organisation...",
          missionStatement: "Énoncé de mission",
          missionPlaceholder: "Quelle est la mission et les valeurs fondamentales de votre organisation ?",
          yearEstablished: "Année de création",
          legalForm: "Forme juridique",
          selectLegalForm: "Sélectionner la forme juridique",
          formsSelected: "{{count}} formes sélectionnées",
          specifyLegalForm: "Précisez la forme juridique...",
          alertName: "Veuillez saisir le nom de votre organisation",
          alertOrgType: "Veuillez sélectionner au moins un type d'organisation",
          alertAudience: "Veuillez sélectionner au moins une tranche d'âge cible",
          alertFocusArea: "Veuillez sélectionner au moins un domaine d'action",
          alertDescription: "Veuillez remplir la description brève",
          alertMission: "Veuillez remplir l'énoncé de mission",
          alertYear: "Veuillez indiquer l'année de création de votre organisation",
          alertLegalForm: "Veuillez sélectionner une forme juridique",
          step2Title: "Étape 2 : Contact et réseaux",
          step2Subtitle: "Comment peut-on joindre votre organisation ?",
          contactInfoTitle: "Coordonnées",
          orgEmail: "E-mail de l'organisation",
          orgEmailPlaceholder: "votre.org@exemple.com",
          orgEmailHint: "Nous enverrons un code de confirmation à cette adresse pour vérifier votre compte.",
          primaryPhone: "Téléphone principal",
          phoneNumberPlaceholder: "Numéro de téléphone",
          website: "Site web",
          address: "Adresse",
          addressPlaceholder: "Rue, ville, pays",
          socialLinks: "Réseaux sociaux",
          socialLinkPlaceholder: "https://exemple.com/profil",
          addLink: "Ajouter un lien",
          networksTitle: "Réseaux internationaux",
          networksDesc: "Sélectionnez les réseaux dont votre organisation fait partie",
          customNetworkPlaceholder: "Ajouter un réseau personnalisé...",
          add: "Ajouter",
          alertRequiredFields: "Veuillez remplir les champs requis : e-mail et téléphone",
          alertValidEmail: "Veuillez saisir une adresse e-mail valide",
          alertValidPhone: "Veuillez saisir un numéro de téléphone valide (au moins 6 chiffres)",
          alertAddress: "Veuillez saisir l'adresse de votre organisation",
          step3Title: "Étape 3 : Équipe et sécurité",
          step3Subtitle: "Gérez les membres de votre équipe et définissez les politiques de sécurité",
          brandingTitle: "Identité visuelle de l'organisation",
          logoOptional: "Logo (facultatif)",
          addLogo: "Ajouter un logo",
          upTo8mb: "Jusqu'à 8 Mo",
          change: "Changer",
          orgPresentationOptional: "Présentation de l'organisation (facultatif)",
          uploadPresentation: "Téléverser une présentation",
          presentationHint: "PDF, diapositives ou image, jusqu'à 8 Mo",
          fileAttached: "Fichier joint",
          clickToChange: "Cliquer pour changer",
          teamTitle: "Membres autorisés de l'équipe",
          teamDesc: "Ajoutez les membres de l'équipe autorisés à publier du contenu au nom de votre organisation. Chaque personne recevra une invitation par e-mail et ne rejoindra la liste confirmée de votre équipe qu'après l'avoir acceptée.",
          member: "Membre n°{{n}}",
          fullNamePlaceholder: "Nom complet",
          rolePlaceholder: "Rôle / Fonction",
          teamEmailPlaceholder: "equipe@org.com",
          addTeamMember: "Ajouter un membre",
          alertFileSize: "Les fichiers doivent faire moins de 8 Mo.",
          alertMember: "Veuillez renseigner le nom complet, le rôle et l'e-mail d'au moins un membre autorisé",
          step4Title: "Étape 4 : Compte et personne de contact",
          step4Subtitle: "Terminez l'inscription avec vos identifiants de connexion. La vérification légale se fait plus tard, depuis votre tableau de bord",
          missingInfoTitle: "Informations manquantes",
          missingInfoDesc: "Veuillez d'abord compléter l'étape 1 : Profil de l'organisation.",
          goToStep1: "Aller à l'étape 1",
          submittingRegistration: "Envoi de votre inscription...",
          loginCredentialsTitle: "Identifiants de connexion",
          orDivider: "ou terminer avec e-mail et mot de passe",
          username: "Nom d'utilisateur",
          usernamePlaceholder: "ex. greenpeace_officiel",
          usernameValid: "✓ Nom d'utilisateur valide",
          usernameInvalid: "Doit contenir au moins 3 caractères : lettres minuscules, chiffres, _ et . uniquement",
          suggestions: "Suggestions :",
          email: "E-mail",
          emailHintPrefix: "Défini à l'étape 2. Nous y enverrons votre code de confirmation,",
          changeIt: "le modifier",
          password: "Mot de passe",
          passwordPlaceholder: "Au moins 8 caractères",
          confirmPassword: "Confirmer le mot de passe",
          confirmPasswordPlaceholder: "Ressaisissez le mot de passe",
          passwordsMatch: "✓ Les mots de passe correspondent",
          passwordsDontMatch: "✗ Les mots de passe ne correspondent pas",
          strengthWeak: "Faible", strengthMedium: "Moyen", strengthStrong: "Fort",
          easyPasswordsTitle: "💡 Mots de passe faciles à retenir (cliquez pour utiliser) :",
          refresh: "Actualiser",
          passwordFormatHint: "Format : Mot + Mot + Chiffres (facile à retenir, difficile à deviner)",
          legalRepTitle: "Qui s'inscrit ?",
          legalRepDesc: "La personne qui crée ce compte et légalement autorisée à agir au nom de l'organisation",
          registrantRoleQuestion: "Vous inscrivez-vous en tant qu'organisation elle-même, ou en tant que son représentant ?",
          registrantRoleOrg: "L'organisation",
          registrantRoleRep: "Je suis un représentant",
          name: "Prénom", firstNamePlaceholder: "Prénom",
          surname: "Nom", lastNamePlaceholder: "Nom de famille",
          position: "Fonction / Titre", positionPlaceholder: "ex. Directeur exécutif",
          phone: "Téléphone",
          optional: "(facultatif)",
          optionalPlaceholder: "Facultatif",
          verificationTitle: "Enregistrement légal et vérification",
          verificationDesc: "Ces informations permettent à notre équipe de vérifier la légitimité de votre organisation avant sa mise en ligne sur la plateforme",
          isInformalQuestion: "Votre organisation est-elle un groupe informel / non enregistré ?",
          formallyRegistered: "Non, nous sommes officiellement enregistrés",
          informal: "Oui, nous sommes informels",
          informalHint: "Aucun détail d'enregistrement n'est requis. Les groupes informels peuvent passer directement aux documents ci-dessous.",
          legalFormFromStep1: "Forme juridique (depuis l'étape 1) :",
          stateRegNumber: "Numéro d'enregistrement public", stateRegNumberPlaceholder: "Numéro de certificat / registre",
          countryOfReg: "Pays d'enregistrement", countryOfRegPlaceholder: "ex. Arménie",
          dateOfReg: "Date d'enregistrement",
          taxId: "N° fiscal / Identifiant légal", taxIdPlaceholder: "Numéro d'identification fiscale",
          vatNumber: "Numéro de TVA", vatNumberPlaceholder: "ex. AM12345678",
          registeredAddress: "Adresse légale enregistrée", registeredAddressPlaceholder: "Adresse figurant au registre",
          documentsTitle: "Documents",
          optionalParen: "(Facultatif)",
          registrationDoc: "Document d'enregistrement",
          vatCertificate: "Certificat de TVA",
          stateSeal: "Cachet officiel",
          passportScan: "Scan du passeport",
          uploadShort: "+ Téléverser",
          docHint: "PDF ou image, 8 Mo maximum",
          completeRegistration: "Finaliser l'inscription",
          submittingBtn: "Envoi...",
          alertUsernameRequired: "Le nom d'utilisateur est requis",
          alertUsernameFormat: "Le nom d'utilisateur doit comporter 3 à 20 caractères : lettres minuscules, chiffres, tirets bas et points uniquement",
          alertMissingEmail: "E-mail de l'organisation manquant. Veuillez revenir à l'étape 2",
          alertPasswordRequired: "Le mot de passe est requis",
          alertPasswordsMismatch: "Les mots de passe ne correspondent pas",
          alertPasswordLength: "Le mot de passe doit comporter au moins 8 caractères",
          alertRegistrantRole: "Veuillez préciser si vous vous inscrivez en tant qu'organisation ou en tant que représentant",
          alertRepName: "Le prénom du représentant légal est requis",
          alertRepSurname: "Le nom du représentant légal est requis",
          alertRepPosition: "La fonction/titre du représentant légal est requis",
          alertStateRegId: "Le numéro d'enregistrement public est requis pour une organisation officiellement enregistrée",
          alertCountry: "Le pays d'enregistrement est requis",
          alertRegDate: "La date d'enregistrement est requise",
          alertLegalId: "Le numéro fiscal / identifiant légal est requis",
          alertRegAddress: "L'adresse légale enregistrée est requise",
          alertVat: "Le numéro de TVA est requis",
          alertCaptcha: "Veuillez compléter le CAPTCHA",
          alertFileTooLarge: "Fichier trop volumineux (8 Mo max)",
          successEmailVerify: "✅ Inscription envoyée ! Vérifiez votre e-mail pour un code de confirmation.",
          successRegistered: "✅ Inscription réussie !",
          successSocial: "Inscription via réseau social réussie !",
          errorRegistrationFailed: "Échec de l'inscription. Veuillez réessayer.",
          errorSocialFailed: "Échec de l'inscription via réseau social. Veuillez réessayer.",
        },
        backToLogin: "Retour à la connexion",
        enterEmail: "Veuillez saisir votre e-mail.",
        somethingWrong: "Une erreur s'est produite. Veuillez réessayer.",
        checkYourEmail: "Vérifiez votre e-mail",
        resetEmailSent: "Si un compte existe pour {{email}}, nous avons envoyé un lien pour réinitialiser votre mot de passe. Il expire dans 1 heure.",
        forgotTitle: "Mot de passe oublié ?",
        forgotSubtitle: "Saisissez votre e-mail et nous vous enverrons un lien de réinitialisation.",
        email: "E-mail",
        sending: "Envoi…",
        sendResetLink: "Envoyer le lien de réinitialisation",
        confirmEmailTitle: "Confirmez votre e-mail",
        confirmEmailSubtitle: "Nous avons envoyé un code à 6 chiffres à {{email}}. Saisissez-le ci-dessous pour activer votre compte.",
        yourEmail: "votre e-mail",
        confirmationCode: "Code de confirmation",
        confirmBtn: "Confirmer",
        verifying: "Confirmation…",
        resendCode: "Renvoyer le code",
        resendCodeIn: "Renvoyer le code dans {{seconds}} s",
        codeResent: "Un nouveau code a été envoyé à votre e-mail.",
        missingResetInfo: "Ce lien de réinitialisation ne contient pas les informations nécessaires. Veuillez en demander un nouveau.",
        passwordTooShort: "Le mot de passe doit comporter au moins 8 caractères.",
        passwordsDontMatch: "Les mots de passe ne correspondent pas.",
        failedResetPassword: "Échec de la réinitialisation du mot de passe.",
        passwordUpdated: "Mot de passe mis à jour",
        redirecting: "Redirection vers la connexion…",
        chooseNewPassword: "Choisissez un nouveau mot de passe",
        forAccount: "pour {{email}}",
        yourAccount: "votre compte",
        newPassword: "Nouveau mot de passe",
        confirmNewPassword: "Confirmer le nouveau mot de passe",
        atLeast8Chars: "Au moins 8 caractères",
        reenterPassword: "Ressaisissez le nouveau mot de passe",
        updating: "Mise à jour…",
        updatePassword: "Mettre à jour le mot de passe",
        resendLink: "Renvoyer le lien",
        resendLinkIn: "Renvoyer le lien dans {{seconds}} s",
        linkResent: "Un nouveau lien de réinitialisation arrive.",
        checkSpamHint: "Vous ne l'avez pas reçu ? Vérifiez vos spams, cela peut prendre une minute.",
        oauthNoticeTitle: "Vous vous êtes connecté avec {{provider}}",
        oauthNoticeDesc: "Ce compte n'a pas de mot de passe, il n'y a donc rien à réinitialiser. Continuez simplement avec {{provider}} depuis la page de connexion.",
        socialAccountGeneric: "un compte social",
        goToLogin: "Aller à la connexion",
        passwordReqLength: "Au moins 8 caractères",
        passwordReqMatch: "Les mots de passe correspondent",
        login: "Connexion",
        password: "Mot de passe",
        forgotPassword: "Mot de passe oublié ?",
        loading: "Chargement...",
        continueBtn: "Continuer",
        or: "ou",
        dontHaveAccount: "Vous n'avez pas de compte ?",
        register: "S'inscrire",
        socialLoginFailed: "Échec de la connexion via réseau social.",
        chooseAccountType: "Choisir le type de compte",
        selectHowToUse: "Sélectionnez comment vous souhaitez utiliser notre plateforme",
        player: "Participant",
        playerDescLong: "Découvrez des bourses, subventions et programmes d'échange, et construisez votre profil",
        playerDescShort: "Découvrir et postuler",
        organizer: "Organisateur",
        organizerDescLong: "Publiez vos programmes et connectez-vous avec la jeunesse",
        organizerDescShort: "Publier et gérer des programmes",
        pendingApproval: "Votre compte est en attente d'approbation. Veuillez attendre l'approbation d'un administrateur.",
        loginFailed: "Échec de la connexion. Veuillez réessayer.",
        invalidCredentials: "E-mail ou mot de passe invalide.",
        socialRegisterFailed: "Échec de l'inscription via réseau social. Veuillez réessayer.",
        loggingIn: "Connexion en cours...",
        showPassword: "Afficher le mot de passe",
        hidePassword: "Masquer le mot de passe",
        registrationVisual: "Visuel d'inscription",
        togglePasswordVisibility: "Afficher/masquer le mot de passe",
        registerAsOrg: "S'inscrire en tant qu'organisation",
        registerAsUser: "S'inscrire en tant qu'utilisateur",
        fillRequired: "Veuillez remplir tous les champs requis",
        nameLength: "Le prénom doit comporter 2 à 20 caractères",
        surnameLength: "Le nom doit comporter 2 à 20 caractères",
        invalidEmail: "Veuillez saisir une adresse e-mail valide",
        useRealEmail: "Veuillez utiliser une adresse e-mail réelle",
        invalidPhone: "Veuillez saisir un numéro de téléphone valide (+374XXXXXXXX ou 0XXXXXXXX)",
        passwordLength: "Le mot de passe doit comporter 6 à 20 caractères",
        passwordLetterNumber: "Le mot de passe doit contenir au moins une lettre et un chiffre",
        passwordTooWeak: "Veuillez choisir un mot de passe plus sécurisé",
        passwordsNoMatch: "Les mots de passe ne correspondent pas",
        mustAgreeTerms: "Vous devez accepter les Conditions d'utilisation",
        completeCaptcha: "Veuillez compléter la vérification CAPTCHA",
        registrationFailed: "Échec de l'inscription",
        registrationError: "Une erreur s'est produite lors de l'inscription",
        registrationTimeout: "L'inscription prend plus de temps que prévu. Vérifiez votre connexion et réessayez.",
        socialRegFailed: "Échec de l'inscription via réseau social",
        createAccount: "Créer un compte",
        orRegisterEmail: "ou inscrivez-vous avec un e-mail",
        name: "Prénom",
        surname: "Nom",
        phoneOptional: "Téléphone",
        phoneExample: "Exemple : +374 98 123 456",
        confirmPassword: "Confirmer le mot de passe",
        confirmYourPassword: "Confirmez votre mot de passe",
        passwordPlaceholderHint: "Au moins 6 caractères, avec une lettre et un chiffre",
        charsMin: "6+ caractères",
        letter: "lettre",
        number: "chiffre",
        passwordsMatch: "Les mots de passe correspondent",
        passwordsDontMatchShort: "Les mots de passe ne correspondent pas",
        agreeToTerms: "J'accepte les",
        termsConditions: "Conditions d'utilisation",
        and: "et",
        privacyPolicy: "Politique de confidentialité",
        registering: "Inscription...",
        registerBtn: "S'inscrire",
      },
      followButton: {
        pleaseLogin: "Veuillez vous connecter pour suivre des utilisateurs",
        userIdMissing: "Impossible de suivre : identifiant utilisateur manquant",
        requestSent: "Demande d'abonnement envoyée !",
        failedSendRequest: "Échec de l'envoi de la demande d'abonnement",
        noRequestId: "Aucun identifiant de demande trouvé",
        requestAccepted: "Demande d'abonnement acceptée !",
        failedAccept: "Échec de l'acceptation de la demande d'abonnement",
        requestRejected: "Demande d'abonnement refusée",
        failedReject: "Échec du refus de la demande d'abonnement",
        unfollowedSuccess: "Désabonnement réussi",
        unfollowIdMissing: "Impossible de se désabonner : identifiant utilisateur manquant",
        failedUnfollow: "Échec du désabonnement",
        noRequestIdCancel: "Aucun identifiant de demande trouvé à annuler",
        requestCancelled: "Demande d'abonnement annulée",
        failedCancel: "Échec de l'annulation de la demande d'abonnement",
        userUnavailable: "Utilisateur indisponible",
        loading: "Chargement...",
        acceptRequest: "Accepter la demande",
        reject: "Refuser",
        mutualFollow: "Abonnement mutuel",
        following: "Abonné(e)",
        unfollow: "Se désabonner",
        requestSentBtn: "Demande envoyée",
        follow: "Suivre",
      },
      followSettings: {
        pleaseLogin: "Veuillez vous connecter pour voir les paramètres",
        failedLoad: "Échec du chargement des paramètres",
        settingsSaved: "Paramètres enregistrés avec succès !",
        failedSave: "Échec de l'enregistrement des paramètres",
        loadingSettings: "Chargement des paramètres...",
        title: "Paramètres d'abonnement",
        subtitle: "Contrôlez qui peut vous suivre",
        followRequests: "Demandes d'abonnement",
        followRequestsDesc: "Contrôlez si les gens ont besoin de votre approbation pour vous suivre",
        requireApproval: "Exiger une approbation pour les abonnés",
        approvalOnDesc: "Les personnes doivent envoyer une demande pour vous suivre",
        approvalOffDesc: "Tout le monde peut vous suivre sans approbation",
        whenOn: "Quand c'est ACTIVÉ :",
        onPoint1: "Les utilisateurs doivent envoyer une demande d'abonnement",
        onPoint2: "Vous pouvez approuver ou refuser les demandes",
        onPoint3: "Vous contrôlez entièrement qui vous suit",
        onPoint4: "Parfait pour les comptes privés",
        whenOff: "Quand c'est DÉSACTIVÉ :",
        offPoint1: "Tout le monde peut vous suivre instantanément",
        offPoint2: "Aucune approbation requise",
        offPoint3: "Idéal pour les personnalités publiques et les organisations",
        offPoint4: "Maximise votre portée",
        notifications: "Notifications",
        notificationsDesc: "Gérez comment vous êtes informé des demandes d'abonnement",
        emailNotifications: "Notifications par e-mail",
        emailNotifDesc: "Recevoir des alertes par e-mail pour les nouvelles demandes d'abonnement",
        pushNotifications: "Notifications push",
        pushNotifDesc: "Recevoir des notifications du navigateur pour les demandes d'abonnement",
        inAppNotifications: "Notifications dans l'application",
        inAppNotifDesc: "Voir les notifications dans l'application",
        followers: "Abonnés",
        following: "Abonnements",
        pendingRequests: "Demandes en attente",
        resetDefaults: "Rétablir les valeurs par défaut",
        saving: "Enregistrement...",
        saveSettings: "Enregistrer les paramètres",
      },
      followRequestsPage: {
        failedLoad: "Échec du chargement des demandes d'abonnement",
        serverError: "Erreur du serveur : {{status}}",
        acceptedRequest: "Vous avez accepté la demande de {{name}} !",
        failedAccept: "Échec de l'acceptation de la demande d'abonnement. Veuillez réessayer.",
        rejectedRequest: "Demande de {{name}} refusée",
        failedReject: "Échec du refus de la demande d'abonnement. Veuillez réessayer.",
        needMutualToMessage: "Vous devez vous suivre mutuellement pour envoyer un message à {{name}}",
        failedStartConversation: "Échec du démarrage de la conversation",
        justNow: "À l'instant",
        minAgo: "il y a {{n}} min",
        hourAgo: "il y a {{n}} h",
        dayAgo: "il y a {{n}} j",
        loadingRequests: "Chargement des demandes d'abonnement...",
        title: "Demandes d'abonnement",
        pending: "{{count}} en attente",
        requestCount: "{{count}} demande",
        requestCountPlural: "{{count}} demandes",
        refreshing: "Actualisation...",
        refresh: "Actualiser",
        organization: "Organisation",
        wantsToFollow: "Souhaite vous suivre",
        accept: "Accepter",
        decline: "Refuser",
        sendMessage: "Envoyer un message",
        noRequests: "Aucune demande d'abonnement en attente",
        noRequestsDesc: "Quand quelqu'un souhaite vous suivre, sa demande apparaîtra ici.",
        checkNewRequests: "Vérifier les nouvelles demandes",
      },
      messagesWidget: {
        messages: "Messages",
        newMessage: "Nouveau message",
        fullScreen: "Plein écran",
        close: "Fermer",
        members: "membres",
        online: "En ligne",
        delete: "Supprimer",
        sharedPost: "Publication partagée",
        sharedPostMessage: "📤 A partagé une publication de {{name}}",
        unknown: "Inconnu",
        post: "Publication",
        tapToView: "Appuyez pour voir la publication →",
        sharingPost: "Partage d'une publication",
        from: "De : {{name}}",
        typeMessage: "Tapez un message...",
        direct: "Direct",
        groups: "Groupes",
        noConversations: "Aucune conversation pour le moment",
        startNewChat: "Démarrer une nouvelle discussion",
        noMessages: "Aucun message",
        noGroups: "Aucun groupe pour le moment",
        browseGroups: "Parcourir les groupes",
        someone: "Quelqu'un",
        newMessageTitle: "Nouveau message",
        searchFollowed: "Rechercher des utilisateurs suivis...",
        organization: "Organisation",
        user: "Utilisateur",
        notFollowingAnyone: "Vous ne suivez encore personne",
        followToMessage: "Suivez des personnes pour commencer à leur écrire",
        confirmDeleteMessage: "Supprimer ce message ?",
        emojis: "Émojis",
        recent: "Récents",
        smileys: "Smileys",
        hearts: "Cœurs",
        hands: "Mains",
        animals: "Animaux",
        food: "Nourriture",
        travel: "Voyage",
        symbols: "Symboles",
        weather: "Météo",
      },
      searchModal: {
        placeholder: "Rechercher utilisateurs, organisations, publications, communautés...",
        postThumbnail: "Miniature de publication",
        all: "Tout",
        organizations: "Organisations",
        players: "Participants",
        posts: "Publications",
        communities: "Communautés",
        searching: "Recherche...",
        users: "Utilisateurs",
        noResultsFor: 'Aucun résultat pour "{{query}}"',
        tryDifferentKeywords: "Essayez d'autres mots-clés",
        seeAllResultsFor: 'Voir tous les résultats pour "{{query}}"',
        recentSearches: "Recherches récentes",
        clearAll: "Tout effacer",
        searchPlatform: "Rechercher sur Greenwich",
        findPeopleEtc: "Trouvez des personnes, organisations, publications et communautés",
        organization: "Organisation",
        administrator: "Administrateur",
        communityMember: "Membre de la communauté",
        verifiedOrganization: "Organisation vérifiée",
        followers: "abonnés",
        postsCount: "publications",
        following: "Abonnements",
        follow: "Suivre",
        hAgo: "il y a {{n}} h",
        dAgo: "il y a {{n}} j",
        user: "Utilisateur",
        noContent: "Aucun contenu",
        likes: "j'aime",
        comments: "commentaires",
        community: "Communauté",
        members: "membres",
        privateCommunity: "Communauté privée",
        searchFailed: "Échec de la recherche. Veuillez réessayer plus tard.",
        serverError: "Erreur du serveur. Veuillez réessayer plus tard.",
        cannotConnect: "Impossible de se connecter au serveur. Vérifiez votre connexion et réessayez.",
        networkError: "Erreur réseau. Veuillez réessayer plus tard.",
      },
      onboarding: {
        skip: "Passer",
        skipTour: "Passer la visite",
        back: "Retour",
        next: "Suivant",
        start: "Commencer",
        getStarted: "Commencer",
        steps: {
          welcome:       { title: "Bienvenue sur Greenwich !", subtitle: "Votre nouvelle maison pour vous connecter", content: "Nous sommes ravis de vous voir ici ! Bonjour, je suis Erika AI, et je vais vous guider pendant que vous explorez et découvrez tout ce que notre plateforme a à offrir.", expression: "Ravie de vous rencontrer ! " },
          navigation:    { title: "Menu de navigation", subtitle: "Votre boussole sur Greenwich", content: "Voici votre menu de navigation ! D'ici vous pouvez accéder à l'Accueil, au Profil, aux Messages et aux Notifications.", expression: "Naviguez avec Greenwich !" },
          "create-post": { title: "Créer une publication", subtitle: "Partagez votre voix", content: "Écrivez vos pensées, téléversez des photos, partagez des vidéos, racontez votre histoire au monde. Votre voix compte, faites-la entendre !", expression: "Créez quelque chose ! " },
          "feed-posts":  { title: "Votre fil", subtitle: "Toute l'action au même endroit", content: "Ici vous verrez les publications des personnes et organisations que vous suivez. Aimez, commentez, enregistrez et partagez !", expression: "Un fil de contenu incroyable !" },
          greencoins:    { title: "Marché Greencoin", subtitle: "Dépensez ce que vous gagnez", content: "Gagnez des Greencoins en étant actif, puis dépensez-les ici contre de vraies récompenses et avantages sur le marché.", expression: "C'est l'heure du shopping ! " },
          buddy:         { title: "Greenwich Buddy", subtitle: "Trouvez un mentor, ou devenez-en un", content: "Buddy vous met en relation avec un mentor qui est déjà passé par là où vous voulez aller, ou vous permet de devenir mentor et de guider quelqu'un d'autre.", expression: "Faisons connaissance ! " },
          search:        { title: "Recherche", subtitle: "Découvrez tout", content: "Trouvez de nouveaux amis, organisations, publications et sujets qui vous tiennent à cœur.", expression: "On cherche ? " },
          programs:      { title: "Programmes et projets", subtitle: "Des opportunités vous attendent", content: "Découvrez les projets et programmes en cours. Suivez les progrès, voyez les mises à jour et participez à des initiatives qui créent un véritable impact.", expression: "Construire l'avenir ! " },
          messages:      { title: "Messages", subtitle: "Là où la magie opère", content: "Envoyez des messages directs, créez des conversations de groupe, partagez des photos et voyez quand les messages sont lus.", expression: "Discutez avec des amis ! " },
          notifications: { title: "Notifications", subtitle: "Restez informé", content: "Voyez les j'aime, les nouveaux commentaires, les demandes d'abonnement et les messages. Ne manquez jamais une mise à jour importante !", expression: "Vous avez des notifications !" },
          organization:  { title: "Organisations", subtitle: "Fiable. Reconnue. Impactante.", content: "Votre organisation est officiellement vérifiée. Partagez des mises à jour, publiez des rapports, engagez vos membres et mettez en valeur votre impact réel.", expression: "Professionnel ! " },
          settings:      { title: "Paramètres", subtitle: "Personnalisez tout", content: "Gérez la confidentialité, le thème, les préférences de notification et les informations du compte.", expression: "Sous contrôle ! " },
          communities:   { title: "Communautés", subtitle: "Construisez votre communauté", content: "Rejoignez des groupes d'intérêts communs, participez à des discussions, collaborez sur des projets et créez des amitiés durables.", expression: "Accueillant ! " },
          final:         { title: "Vous êtes prêt !", subtitle: "Bienvenue sur Greenwich !", content: "Vous connaissez maintenant toutes les fonctionnalités principales de Greenwich. Soyez bienveillant, partagez du contenu formidable, connectez-vous avec des personnes extraordinaires et amusez-vous !", expression: "Bienvenue ! " },
        },
      },
      accountProfile: {
        successSaved: "✅ Profil enregistré avec succès ! Redirection...",
        debugImages: "Images de débogage",
        editCover: "Modifier la couverture",
        verifiedOrg: "Organisation vérifiée",
        placeholderFullName: "Votre nom complet",
        placeholderHeadline: "Titre professionnel",
        placeholderLocation: "📍 Lieu",
        placeholderEmail: "E-mail",
        placeholderPhone: "Téléphone",
        aboutMe: "À propos de moi",
        aboutPlaceholder: "Partagez votre histoire, vos passions et ce qui vous motive...",
        quickActions: "Actions rapides",
        myPosts: "Mes publications",
        likedPosts: "Publications aimées",
        savedPosts: "Publications enregistrées",
        areasOfInterest: "Domaines d'intérêt",
        edit: "Modifier",
        save: "Enregistrer",
        selectInterestsGuide: "Sélectionnez vos domaines d'intérêt :",
        noInterestsYet: "Aucun intérêt sélectionné pour le moment",
        profileInformation: "Informations du profil",
        profileInfoNote: "Vos informations de profil seront mises à jour après l'enregistrement.",
        tipsTitle: "Conseils pour de meilleurs résultats :",
        tip1: "Utilisez des images de haute qualité (JPEG ou PNG)",
        tip2: "L'image de profil doit être carrée (ratio 1:1)",
        tip3: "L'image de couverture doit être large (ratio 16:9)",
        tip4: "Les modifications sont automatiquement enregistrées dans votre tableau de bord",
        cancel: "Annuler",
        saving: "Enregistrement...",
        saveProfile: "Enregistrer le profil",
        alertImageTooLarge: "La taille de l'image doit être inférieure à 5 Mo",
        alertInvalidImageType: "Seules les images JPEG, PNG et GIF sont autorisées",
        alertErrorPrefix: "❌ Erreur : ",
        errorUpdateFailed: "Échec de la mise à jour. Veuillez réessayer.",
        errorUnexpected: "Une erreur inattendue s'est produite. Veuillez réessayer.",
      },
      adminProgramsReview: {
        deleteTitle: "Supprimer le programme ?",
        deleteSub: "Cette action est irréversible.",
        cancel: "Annuler",
        delete: "Supprimer",
        needsEditSendTitle: "À corriger, envoyer un commentaire",
        sendMessageTitle: "Envoyer un message à l'organisation",
        needsEditSendSub: "Le statut passe à « à corriger ». L'organisation recevra votre message.",
        sendMessageSub: "Envoyer un message sans changer le statut du programme.",
        program: "Programme",
        quickTemplates: "Modèles rapides",
        template1Label: "Informations manquantes",
        template1Text: "Il manque certaines informations requises dans votre soumission de programme. Veuillez mettre à jour les champs suivants et soumettre à nouveau :\n\n• [Préciser les champs manquants]\n\nUne fois mis à jour, votre programme sera réexaminé.",
        template2Label: "Ne répond pas aux exigences",
        template2Text: "Malheureusement, votre programme ne répond pas actuellement à nos exigences. Plus précisément :\n\n• [Expliquer le problème]\n\nVeuillez consulter nos directives de soumission et envisager de soumettre à nouveau avec les modifications nécessaires.",
        template3Label: "Mettre à jour et soumettre à nouveau",
        template3Text: "Merci d'avoir soumis votre programme. Nous n'avons pas pu l'approuver tel quel, mais nous vous encourageons à apporter les modifications suivantes et à soumettre à nouveau :\n\n• [Liste des modifications nécessaires]\n\nNous avons hâte d'examiner votre soumission mise à jour.",
        template4Label: "Soumission en double",
        template4Text: "Il semble qu'un programme similaire existe déjà sur notre plateforme. Veuillez vérifier les annonces existantes avant de soumettre à nouveau, ou contactez-nous si vous pensez qu'il s'agit d'une erreur.",
        messagePlaceholder: "Écrivez votre message ici…",
        feedbackHint: "L'organisation verra ceci et pourra modifier et soumettre à nouveau.",
        needsEditAndSend: "À corriger et envoyer",
        sendMessage: "Envoyer le message",
        pageTitle: "Révision des programmes",
        pageSubtitle: "Soumissions des organisations. Les approuvées apparaissent dans /programs",
        pendingChip: "{{count}} en attente",
        refresh: "Actualiser",
        tabPending: "En attente",
        tabApproved: "Approuvés",
        tabNeedsEdit: "À corriger",
        tabRejected: "Rejetés",
        tabAll: "Tous",
        loadingPrograms: "Chargement des programmes…",
        noProgramsAll: "Aucun programme",
        noProgramsFiltered: "Aucun programme {{status}}",
        statusWordPending: "en attente",
        statusWordApproved: "approuvé",
        statusWordNeedsEdit: "à corriger",
        statusWordRejected: "rejeté",
        nothingToShow: "Rien à afficher ici pour le moment.",
        saving: "Enregistrement…",
        titlePlaceholder: "Titre",
        categoryPlaceholder: "Catégorie",
        descriptionPlaceholder: "Description",
        uploadImage: "Téléverser une image",
        remove: "Retirer",
        pasteImageUrl: "Ou collez l'URL de l'image…",
        save: "Enregistrer",
        statusPending: "En attente",
        statusApproved: "Approuvé",
        statusNeedsEdit: "À corriger",
        statusRejected: "Rejeté",
        defaultOrgName: "Organisation",
        feedbackSent: "Commentaire envoyé",
        sendMessageTooltip: "Envoyer un message",
        editTooltip: "Modifier",
        deleteTooltip: "Supprimer",
        lastFeedback: "Dernier commentaire",
        approve: "Approuver",
        needsEdit: "À corriger",
        reject: "Rejeter",
        waitingForEdits: "En attente des corrections de l'organisation",
        visibleInPrograms: "Visible dans /programs",
        revoke: "Révoquer",
        reApprove: "Réapprouver",
        sendFeedback: "Envoyer un commentaire",
        deadline: "Date limite",
        location: "Lieu",
        education: "Éducation",
        organization: "Organisation",
        description: "Description",
        openProgram: "Ouvrir le programme",
        view: "Voir",
        toastApproved: "Programme approuvé",
        toastNeedsEdit: "Marqué comme à corriger",
        toastRejected: "Programme rejeté",
        toastDone: "Terminé",
        toastFeedbackSent: "Commentaire envoyé à l'organisation",
        toastDeleted: "Programme supprimé",
        toastUpdated: "Programme mis à jour",
        toastImageTooLarge: "L'image doit faire moins de 5 Mo",
      },
      orgSettings: {
        pageTitle: "Paramètres de l'organisation",
        pageSubtitle: "Gérez les données d'enregistrement et les informations de votre organisation",
        tabProfile: "Profil de l'organisation",
        tabContact: "Contact et réseaux",
        tabTeam: "Équipe et sécurité",
        tabVerification: "Vérification",
        edit: "Modifier",
        save: "Enregistrer",
        saving: "Enregistrement...",
        notSet: "Non défini",
        step1Title: "Étape 1 : Profil de l'organisation",
        orgNames: "Noms de l'organisation",
        langArmenian: "Arménien",
        langEnglish: "Anglais",
        langRussian: "Russe",
        orgNamePlaceholder: "Nom de l'organisation",
        addName: "Ajouter un nom",
        orgType: "Type d'organisation",
        addCustomTypePlaceholder: "Ajouter un type personnalisé",
        description: "Description",
        mission: "Mission",
        focusAreas: "Domaines d'action",
        establishedYear: "Année de création",
        legalForm: "Forme juridique",
        step2Title: "Étape 2 : Contact et réseaux",
        contactEmail: "E-mail de contact",
        primaryPhone: "Téléphone principal",
        secondaryPhone: "Téléphone secondaire",
        address: "Adresse",
        website: "Site web",
        socialLinks: "Réseaux sociaux",
        socialLinkPlaceholder: "https://...",
        addLink: "Ajouter un lien",
        noSocialLinks: "Aucun réseau social",
        networks: "Réseaux",
        step3Title: "Étape 3 : Équipe et sécurité",
        secureSealText: "Texte du cachet sécurisé",
        authorizedMembers: "Membres autorisés de l'équipe",
        memberNum: "Membre n°{{n}}",
        fullNamePlaceholder: "Nom complet",
        rolePlaceholder: "Rôle",
        emailPlaceholder: "E-mail",
        addMember: "Ajouter un membre",
        noMembers: "Aucun membre ajouté",
        step4Title: "Étape 4 : Vérification et connexion",
        username: "Nom d'utilisateur",
        email: "E-mail",
        representativeName: "Nom du représentant",
        representativeEmail: "E-mail du représentant",
        stateRegistrationId: "Numéro d'enregistrement public",
        vatNumber: "Numéro de TVA",
        alertSavedSuccess: "Paramètres enregistrés avec succès !",
        alertErrorSaving: "Erreur lors de l'enregistrement : ",
        alertErrorSavingSettings: "Erreur lors de l'enregistrement des paramètres : ",
      },
      orgAccountProfile: {
        editCover: "Modifier la couverture",
        followers: "Abonnés",
        following: "Abonnements",
        placeholderOrgName: "Nom de l'organisation",
        placeholderOrgType: "Type d'organisation / Titre",
        placeholderLocation: "📍 Lieu",
        placeholderEmail: "E-mail",
        placeholderPhone: "Téléphone",
        quickActions: "Actions rapides",
        myPosts: "Mes publications",
        likedPosts: "Publications aimées",
        savedPosts: "Publications enregistrées",
        aboutOrg: "À propos de l'organisation",
        aboutPlaceholder: "Partagez l'histoire, la mission et ce qui anime votre organisation...",
        areasOfInterest: "Domaines d'intérêt",
        edit: "Modifier",
        save: "Enregistrer",
        selectInterestsGuide: "Sélectionnez vos domaines d'intérêt :",
        noInterestsYet: "Aucun intérêt sélectionné pour le moment",
        createPost: "Créer une publication",
        postPlaceholder: "Partagez ce que vous avez en tête...",
        addPhoto: "Ajouter une photo",
        post: "Publier",
        orgPosts: "Publications de l'organisation",
        noPostsYet: "Aucune publication pour le moment. Partagez votre première publication ci-dessus !",
        orgActivities: "Activités de l'organisation",
        activityNamePlaceholder: "Nom de l'activité ou du projet",
        partnerOrgPlaceholder: "Organisation partenaire",
        activityDescPlaceholder: "Décrivez les activités et réalisations de votre organisation...",
        addActivity: "Ajouter une activité",
        previewProfile: "Aperçu du profil",
        saveContinue: "Enregistrer et continuer vers le tableau de bord",
        defaultOrgFallback: "Organisation",
        coverAlt: "Couverture",
        profileAlt: "Profil",
        verifiedOrgTitle: "Organisation vérifiée",
        uploadAlt: "Téléverser",
        postPreviewAlt: "Aperçu de la publication",
        postAlt: "Publication",
        alertPleaseLogin: "Veuillez vous reconnecter",
        alertInvalidResponse: "Le serveur a renvoyé une réponse invalide. Consultez la console pour plus de détails.",
        alertErrorCreating: "Erreur lors de la création de la publication : ",
        alertNetworkError: "Erreur réseau : ",
        alertEnterContent: "Veuillez saisir du contenu ou ajouter une image",
        alertPostSuccess: "Publication créée avec succès !",
        interests: {
          environment: "Environnement", education: "Éducation", technology: "Technologie", health: "Santé",
          artsCulture: "Arts et culture", communityDevelopment: "Développement communautaire", humanRights: "Droits humains",
          socialInclusion: "Inclusion sociale", internationalExchanges: "Échanges internationaux", entrepreneurship: "Entrepreneuriat",
        },
      },
      orgProgramSubmit: {
        greencoinToggle: "Récompenser les participants avec des greencoins",
        greencoinPitch: "Les programmes qui récompensent avec des greencoins attirent plus de candidats. Les participants qui terminent ce programme recevront le montant ci-dessous, échangeable dans notre boutique de récompenses. Le coût est déduit du solde de greencoins de votre organisation dès que chaque participant est confirmé.",
        greencoinAmountLabel: "Greencoins par participant",
        greencoinBalance: "Votre solde : {{balance}}",
        greencoinLowBalance: "Ce montant dépasse votre solde actuel. Rechargez-le avant que les participants ne terminent le programme, sinon certains pourraient ne pas être payés.",
        successTitle: "Programme soumis !",
        successBodyPre: "Votre programme est maintenant ",
        successBodyBold: "en attente de révision par un admin",
        successBodyPost: ". Il apparaîtra dans /programs une fois approuvé.",
        viewMySubmissions: "Voir mes soumissions",
        submitAnother: "Soumettre un autre",
        title: "Soumettre un programme",
        subtitle: "Mêmes champs que le formulaire admin, examiné avant publication",
        defaultOrgName: "Organisation",
        uploadCoverImage: "Téléverser une image de couverture",
        coverImageHint: "Recommandé : 1200×630px",
        coverImageAlt: "Couverture",
        programTitle: "Titre du programme",
        programTitlePlaceholder: "ex. Échange de jeunes Erasmus+ 2026",
        description: "Description",
        descriptionPlaceholder: "Ce que le programme offre, à qui il s'adresse…",
        categories: "Catégories",
        categoriesHint: " (sélection multiple, comme pour l'admin)",
        sectors: "Secteurs",
        sectorsHint: " (sélection multiple, comme pour l'admin)",
        programUrl: "URL du programme / candidature",
        source: "Source",
        location: "Lieu",
        locationPlaceholder: "ex. Erevan, Arménie",
        format: "Format",
        formatPlaceholder: "ex. En ligne, Hybride, Sur place",
        educationLevel: "Niveau d'études",
        eduAny: "Tous / Non spécifié",
        eduHighSchool: "Lycée",
        eduStudent: "Étudiant",
        eduUndergrad: "Licence",
        eduGrad: "Master",
        eduDoctoral: "Doctorat",
        eduProfessional: "Professionnel",
        startDate: "Date de début",
        endDate: "Date de fin",
        deadline: "Date limite de candidature",
        fundingType: "Type de financement",
        fundingTypePlaceholder: "ex. Entièrement financé, Partiel…",
        targetGroup: "Public cible",
        targetGroupPlaceholder: "ex. Jeunes 18-30 ans, chercheurs…",
        requirements: "Exigences / éligibilité",
        requirementsPlaceholder: "Âge, nationalité, niveau de langue, etc. (ajouté à la description pour les relecteurs)",
        reviewNotice: "Révision par un admin requise. Les catégories et secteurs correspondent aux filtres publics de la page Programmes une fois approuvé.",
        submitting: "Envoi…",
        submitForReview: "Soumettre pour révision ✓",
        errorTitleDesc: "Le titre et la description sont requis.",
        errorCategory: "Sélectionnez au moins une catégorie (comme pour le formulaire admin).",
        errorSector: "Sélectionnez au moins un secteur (comme pour le formulaire admin).",
        errorSubmitFailed: "Échec de la soumission. Veuillez réessayer.",
        errorNetwork: "Erreur réseau. Veuillez réessayer.",
        sectorLabels: {
          ecology: "Écologie", international: "International", technology: "Technologie", medical: "Médical",
          education: "Éducation", business: "Affaires", arts: "Arts et culture", science: "Science",
          sports: "Sport", agriculture: "Agriculture", local: "Local", media: "Médias",
        },
        categoryLabels: {
          education: "Éducation", scholarship: "Bourse", fellowship: "Fellowship", erasmusplus: "Erasmus Plus",
          training: "Formation", grant: "Subvention", internship: "Stage", conference: "Conférence",
          online: "En ligne", volunteering: "Bénévolat", event: "Événement", award: "Prix",
        },
      },
      organizationGreencoins: {
        back: "Retour",
        title: "Portefeuille de greencoins",
        subtitle: "Achetez des greencoins et dépensez-les pour récompenser les participants qui terminent vos programmes.",
        balanceLabel: "Solde actuel",
        buyTitle: "Acheter des greencoins",
        buyNote: "Le paiement est confirmé manuellement pour l'instant. Déposez une demande ci-dessous et notre équipe vous recontactera pour confirmer le paiement et recharger votre solde rapidement.",
        selfServiceLocked: "L'achat direct de greencoins n'est pas encore ouvert. Contactez notre équipe et nous nous occuperons de vous.",
        buyButton: "Acheter maintenant",
        sending: "Envoi...",
        requestSent: "Demande envoyée. Nous vous contacterons pour confirmer le paiement.",
        requestError: "Impossible d'envoyer la demande. Veuillez réessayer.",
        pendingTitle: "Demandes en attente",
        pendingStatus: "En attente de confirmation",
        historyTitle: "Historique",
        historyEmpty: "Aucune transaction pour le moment.",
        txTopup: "Rechargement du solde",
        txSpend: "Récompense versée à un participant",
        perksTitle: "Ce que les greencoins vous permettent de faire",
        perks: {
          reward: { title: "Récompenser les participants", desc: "Associez une récompense en greencoins à vos programmes pour que les participants qui les terminent soient payés automatiquement." },
          completion: { title: "Meilleur taux d'achèvement", desc: "Les programmes avec une récompense associée voient des taux d'inscription-à-achèvement plus élevés." },
          flexible: { title: "Montants flexibles", desc: "Fixez n'importe quelle récompense par programme et achetez exactement le nombre de greencoins dont vous avez besoin." },
        },
        greencoinsLabel: "greencoins",
        amdPerCoin: "AMD / greencoin",
        payTitle: "Payer par virement bancaire",
        payBank: "Banque",
        payAccount: "Numéro de compte",
        payRecipient: "Bénéficiaire",
        payReferenceHint: "Indiquez le nom de votre organisation comme référence de paiement pour que nous puissions associer votre virement.",
        interestTitle: "Pas encore tout à fait disponible",
        interestBody: "L'achat de greencoins n'est pas encore disponible sur le site. Laissez votre e-mail et nous vous préviendrons dès que ce sera prêt.",
        interestEmailPlaceholder: "vous@organisation.org",
        interestSubmit: "Me prévenir",
        interestError: "Impossible d'envoyer cela. Veuillez réessayer.",
        interestDoneTitle: "Merci !",
        interestDoneBody: "Nous avons noté votre intérêt et vous enverrons un e-mail dès que l'achat de greencoins sera disponible.",
        interestClose: "Fermer",
        payWithCard: "Payer par carte",
        redirectingToBank: "Redirection vers la banque...",
        cardPaymentSuccess: "Paiement réussi, votre solde a été rechargé !",
        cardPaymentFailed: "Le paiement a échoué. Vous pouvez réessayer.",
        cardPaymentError: "Un problème est survenu lors du paiement. Veuillez réessayer.",
      },
      organizationPanel: {
        back: "Retour",
        title: "Panneau de l'organisation",
        subtitle: "L'activité de votre organisation, les projets publiés et les récompenses en greencoins, le tout au même endroit.",
        loading: "Chargement...",
        tabOverview: "Vue d'ensemble",
        tabPrograms: "Projets",
        tabGreencoins: "Greencoins",
        statsTitle: "En un coup d'œil",
        statProfileViews: "Vues du profil",
        statFollowers: "Abonnés",
        statPrograms: "Projets",
        statProgramViews: "Vues des projets",
        statApplyClicks: "Clics sur « Postuler »",
        statApplicants: "Candidats",
        statusApproved: "approuvé",
        statusPending: "en révision",
        programsTitle: "Vos projets",
        publishNew: "Publier un projet",
        noPrograms: "Vous n'avez encore publié aucun projet.",
        viewsLabel: "vues",
        clicksLabel: "clics sur « Postuler »",
        manageAll: "Gérer toutes les soumissions",
        status: {
          approved: "Approuvé",
          pending: "En attente",
          needs_edit: "À corriger",
          rejected: "Rejeté",
        },
        greencoinsTitle: "Récompenses en greencoins",
        buyGreencoins: "Acheter des greencoins",
        balanceLabel: "Solde du portefeuille",
        rewardsNote: "Définissez combien de greencoins un participant gagne pour avoir terminé chaque projet. Vous pouvez ajuster le montant à tout moment, même après la mise en ligne du projet.",
        noApprovedPrograms: "Aucun projet approuvé pour le moment.",
        rewardLabel: "Récompense en greencoins",
        rewardSaveError: "Impossible d'enregistrer la récompense. Veuillez réessayer.",
        lowBalanceWarning: "Le solde de votre portefeuille est inférieur à cette récompense. Rechargez-le pour que les participants soient payés.",
        tabUsers: "Utilisateurs",
        users: {
          title: "Créer un compte utilisateur",
          subtitle: "Créez un identifiant et un mot de passe pour quelqu'un qui ne s'inscrira pas lui-même : un compte classique, non rattaché à votre organisation. Il s'y connecte et peut personnaliser son propre profil public (photo, couverture, bio, couleur d'accent) depuis les Paramètres.",
          namePlaceholder: "Prénom",
          surnamePlaceholder: "Nom de famille (facultatif)",
          emailPlaceholder: "E-mail",
          passwordPlaceholder: "Mot de passe",
          createBtn: "Créer le compte",
          creating: "Création...",
          created: "Compte créé pour {{email}}",
          createError: "Impossible de créer le compte. Veuillez réessayer.",
          listTitle: "Comptes que vous avez créés",
          empty: "Vous n'avez encore créé aucun compte utilisateur.",
        },
      },
      greencoinsPage: {
        back: "Retour",
        title: "Greencoins",
        subtitle: "Gagnez des greencoins sur la plateforme et dépensez-les dans la boutique Greenwich.",
        balanceLabel: "Votre solde",
        goToShop: "Aller à la boutique",
        tabEarned: "Gagnés",
        tabSpent: "Dépensés",
        tabWays: "Comment en gagner",
        earnedEmpty: "Aucun greencoin gagné pour le moment. Commencez en complétant votre profil ou en rejoignant un programme.",
        spentEmpty: "Aucun achat pour le moment.",
        waysIntro: "Façons quotidiennes de gagner des greencoins sur Greenwich :",
        aboutTitle: "Que sont les greencoins ?",
        aboutBody: "Les greencoins ne sont pas de l'argent, c'est le système de reconnaissance interne de Greenwich, gagné en étant actif et engagé sur la plateforme. Vous ne pouvez pas les encaisser aujourd'hui, mais cette option est prévue pour l'avenir.",
        aboutPerks: {
          redeem: { title: "Des récompenses réelles", desc: "Échangez ce que vous gagnez contre de vrais avantages et prix dans la boutique Greenwich." },
          motivation: { title: "Reconnaissance, pas de l'argent", desc: "Un moyen de mesurer et de récompenser une vraie contribution, pas une monnaie." },
          future: { title: "L'encaissement arrive plus tard", desc: "Convertir les greencoins en argent réel n'est pas encore possible, mais c'est sur la feuille de route." },
        },
        stat5x: "Les publications et projets avec une récompense en greencoins associée suscitent environ 5 fois plus d'intérêt de la part des membres.",
        actions: {
          account_verified: "Vérifier votre compte",
          profile_complete: "Compléter votre profil",
          onboarding_complete: "Terminer l'intégration",
          program_apply: "Postuler à un programme",
          program_apply_milestone_10: "Postuler à 10 programmes (unique)",
          program_accepted: "Être accepté dans un programme",
          event_attended: "Terminer/assister à un programme",
          project_joined: "Rejoindre un projet/une communauté",
          review_written: "Écrire un avis",
          daily_login: "Se connecter chaque jour",
          login_streak_7: "7 jours de connexion consécutifs",
          buddy_mentee_completed: "Terminer un mentorat Buddy en tant que mentoré",
          buddy_mentor_completed: "Terminer un mentorat Buddy en tant que mentor",
          buddy_mentor_certificate: "Obtenir un certificat de mentor Buddy",
          referral_signup: "Chaque ami que vous parrainez et qui s'inscrit",
          social_event_participation: "Participer à un événement social/communautaire important",
        },
      },
      orgMySubmissions: {
        title: "Mes soumissions",
        subtitle: "Suivez et gérez vos programmes soumis",
        refresh: "Actualiser",
        greencoinWallet: "Portefeuille de greencoins",
        submitNew: "Nouvelle soumission",
        statTotal: "Total",
        statPending: "En attente",
        statApproved: "Approuvés",
        statNeedsEdit: "À corriger",
        loading: "Chargement de vos soumissions…",
        emptyTitleAll: "Aucune soumission pour le moment",
        emptyTitleFiltered: "Aucun programme {{filter}}",
        emptyBodyAll: "Soumettez votre premier programme pour commencer.",
        emptyBodyFiltered: "Vous n'avez aucun programme {{filter}} pour le moment.",
        submitProgram: "Soumettre un programme",
        filterNames: { pending: "en attente", approved: "approuvé", rejected: "rejeté" },
        statusPending: "En attente de révision",
        statusApproved: "Approuvé",
        statusRejected: "Non approuvé",
        submitted: "Soumis le {{date}}",
        editResubmitHeading: "Modifier et soumettre à nouveau",
        fieldTitle: "Titre du programme *",
        fieldTitlePlaceholder: "Titre",
        fieldWebsite: "Site web / Lien de candidature",
        fieldUrlPlaceholder: "https://…",
        fieldLocation: "Lieu",
        fieldLocationPlaceholder: "Ville, pays ou en ligne",
        fieldDeadline: "Date limite",
        fieldDescription: "Description *",
        fieldDescriptionPlaceholder: "Décrivez votre programme…",
        fieldRequirements: "Exigences",
        fieldRequirementsPlaceholder: "Conditions d'éligibilité…",
        fieldBenefits: "Avantages",
        fieldBenefitsPlaceholder: "Ce que reçoivent les participants…",
        fieldCoverImage: "URL de l'image de couverture",
        cancel: "Annuler",
        resubmitForReview: "Soumettre à nouveau pour révision",
        viewProgram: "Voir le programme",
        messageFromAdmin: "Message de l'administrateur",
        feedbackCta: "Veuillez examiner le commentaire ci-dessus et soumettre à nouveau votre programme avec les modifications requises.",
        pendingNotice: "Votre programme est en cours de révision. Nous vous informerons dès qu'une décision sera prise.",
        approvedNotice: "Votre programme est en ligne et visible sur la page Programmes.",
        viewArrow: "Voir →",
        editAndResubmit: "Modifier et soumettre à nouveau",
        updateAndResubmit: "Mettre à jour et soumettre à nouveau",
        resubmittedToast: "🔄 Soumis à nouveau pour révision !",
        savedLocallyToast: "🔄 Enregistré localement, sera synchronisé une fois en ligne.",
        statusNeedsEdit: "À corriger",
        applications: "Candidatures",
        withdraw: "Retirer",
        confirmWithdraw: "Retirer cette soumission ? Cette action est irréversible.",
        withdrawnToast: "Soumission retirée",
        withdrawFailedToast: "Échec du retrait de la soumission",
      },
      shareMenu: {
        sharePost: "Partager la publication",
        copyLink: "Copier le lien",
        defaultShareText: "Découvrez cette publication",
      },
      userPublicProfile: {
        loginRequired: "Vous devez vous connecter pour voir les profils.",
        loadingProfile: "Chargement du profil...",
        userNotFound: "Utilisateur introuvable",
        goBack: "Retour",
        failedLoadProfile: "Échec du chargement du profil.",
        failedLoadPosts: "Échec du chargement des publications.",
        justNow: "À l'instant",
        minutesAgo: "il y a {{n}} min",
        hoursAgo: "il y a {{n}} h",
        daysAgo: "il y a {{n}} j",
        confirmBlock: "Bloquer {{name}} ? Cette personne ne pourra plus vous suivre ni vous envoyer de message.",
        userMuted: "Utilisateur masqué, ses publications sont masquées de votre fil",
        userUnmuted: "Utilisateur démasqué",
        userBlocked: "Utilisateur bloqué",
        userUnblocked: "Utilisateur débloqué",
        failedToMuteUser: "Échec du masquage de l'utilisateur",
        failedToUnmuteUser: "Échec du démasquage de l'utilisateur",
        failedToBlockUser: "Échec du blocage de l'utilisateur",
        failedToUnblockUser: "Échec du déblocage de l'utilisateur",
        reportSubmitted: "Signalement envoyé. Merci de contribuer à la sécurité de la communauté.",
        failedSubmitReport: "Échec de l'envoi du signalement",
        needMutualFollowMessage: "Vous devez vous suivre mutuellement pour envoyer des messages",
        messageSent: "Message envoyé !",
        failedSendMessage: "Échec de l'envoi du message",
        failedStartConversation: "Échec du démarrage de la conversation",
        profileLinkCopied: "Lien du profil copié !",
        failedShareProfile: "Échec du partage du profil",
        back: "Retour",
        coverAlt: "Couverture",
        verified: "Vérifié",
        verifiedOrg: "Organisation vérifiée",
        organization: "Organisation",
        communityMember: "Membre de la communauté",
        approved: "Approuvé",
        message: "Message",
        copied: "Copié !",
        copyLink: "Copier le lien",
        shareOnFacebook: "Partager sur Facebook",
        moreOptions: "Plus d'options",
        pleaseWait: "Veuillez patienter…",
        unmute: "Démasquer",
        mutePosts: "Masquer les publications",
        unblock: "Débloquer",
        blockUser: "Bloquer l'utilisateur",
        reportUser: "Signaler l'utilisateur",
        postsLabel: "Publications",
        aboutLabel: "À propos",
        reportsTabLabel: "Rapports",
        portfolioLabel: "Portfolio",
        certificatesLabel: "Certificats",
        followersLabel: "Abonnés",
        followingLabel: "Abonnements",
        joined: "Inscrit le {{date}}",
        quickMessagePlaceholder: "Envoyer un message rapide…",
        noPostsYet: "Aucune publication pour le moment",
        postImageAlt: "Image de publication {{n}}",
        postAlt: "Publication",
        nameLabel: "Nom",
        emailLabel: "E-mail",
        phoneLabel: "Téléphone",
        locationLabel: "Lieu",
        interestsLabel: "Centres d'intérêt",
        missionLabel: "Mission",
        reportsTitle: "Rapports et licences",
        noReportsYet: "Aucun rapport téléversé pour le moment.",
        view: "Voir",
        download: "Télécharger",
        noPortfolioYet: "Aucun élément de portfolio pour le moment.",
        noCertificatesYet: "Aucun certificat ajouté pour le moment.",
        viewPdf: "Voir le PDF",
        noFollowersYet: "Aucun abonné pour le moment",
        orgBadge: "Org",
        followsYou: "Vous suit",
        friends: "Amis",
        notFollowingAnyone: "Ne suit encore personne",
        mutual: "Mutuel",
        previewNotAvailable: "Aperçu non disponible pour ce type de fichier.",
        reportModalTitle: "Signaler {{name}}",
        reportModalSubtitle: "Sélectionnez un motif. Ceci est anonyme pour la personne signalée.",
        reportReasons: {
          spam: "Spam",
          inappropriate: "Contenu inapproprié",
          harassment: "Harcèlement",
          hateSpeech: "Discours haineux",
          misinformation: "Désinformation",
          other: "Autre",
        },
        detailsPlaceholder: "Détails supplémentaires (facultatif)",
        cancel: "Annuler",
        submitting: "Envoi…",
        submitReport: "Envoyer le signalement",
        comments: "Commentaires",
        noCommentsYet: "Aucun commentaire pour le moment. Soyez le premier !",
        addCommentPlaceholder: "Ajouter un commentaire…",
        interests: {
          environment: "Environnement", education: "Éducation", technology: "Technologie", health: "Santé",
          artsCulture: "Arts et culture", communityDevelopment: "Développement communautaire", humanRights: "Droits humains",
          socialInclusion: "Inclusion sociale", internationalExchanges: "Échanges internationaux", entrepreneurship: "Entrepreneuriat",
        },
      },
      blockedMuted: {
        pleaseLogin: "Veuillez vous connecter pour voir cette page",
        backToSettings: "Retour aux paramètres",
        blockedTitle: "Comptes bloqués",
        blockedSubtitle: "Les personnes que vous avez bloquées ne peuvent pas vous suivre, vous envoyer de message ou voir votre profil.",
        failedLoadBlocked: "Échec du chargement des comptes bloqués",
        userUnblocked: "Utilisateur débloqué",
        failedUnblock: "Échec du déblocage de l'utilisateur",
        noBlocked: "Aucun compte bloqué",
        blockedEmptyHint: "Les comptes que vous bloquez apparaîtront ici.",
        unblocking: "Déblocage…",
        unblock: "Débloquer",
        mutedTitle: "Comptes masqués",
        mutedSubtitle: "Leurs publications sont masquées de votre fil. Vous vous suivez toujours mutuellement et pouvez toujours vous envoyer des messages normalement. Ils ne sont pas notifiés.",
        failedLoadMuted: "Échec du chargement des comptes masqués",
        userUnmuted: "Utilisateur démasqué",
        failedUnmute: "Échec du démasquage de l'utilisateur",
        noMuted: "Aucun compte masqué",
        mutedEmptyHint: "Les comptes que vous masquez apparaîtront ici.",
        unmuting: "Démasquage…",
        unmute: "Démasquer",
        loading: "Chargement...",
      },
      orgDashboard: {
        organization: "Organisation",
        noLocation: "Aucun lieu défini",
        noEmail: "Aucun e-mail",
        aboutOrg: "À propos de l'organisation",
        noDescription: "Pas encore de description",
        areasOfInterest: "Domaines d'intérêt",
        noInterests: "Aucun intérêt sélectionné pour le moment",
        welcomeTitle: "Bienvenue sur le tableau de bord de votre organisation",
        welcomeMessage: "Content de vous revoir, {{name}} ! Voici le tableau de bord de votre organisation où vous pouvez gérer votre profil et vos activités.",
        quickActions: "Actions rapides",
        panel: "Panneau de l'organisation",
        editProfile: "Modifier le profil",
        viewActivities: "Voir les activités",
        settings: "Paramètres",
        recentActivity: "Activité récente",
        profileCompleted: "Profil de l'organisation complété avec succès",
        interestsUpdated: "Centres d'intérêt mis à jour",
        today: "Aujourd'hui",
      },
      orgVerification: {
        sectionTitle: "Vérification",
        pitch: "Obtenez un badge vérifié et devenez éligible au classement des organisations. Soumettez vos documents légaux pour une révision rapide.",
        benefitBadge: "Un badge vérifié sur votre profil et vos publications",
        benefitRanking: "Éligible au classement des organisations et à une mise en avant",
        startBtn: "Se faire vérifier",
        resubmitBtn: "Soumettre à nouveau pour vérification",
        statusPending: "Demande de vérification soumise",
        statusApproved: "Organisation vérifiée",
        statusRejected: "Demande de vérification rejetée",
        etaHint: "La révision prend généralement jusqu'à une semaine.",
        modalTitle: "Demander une vérification",
        modalSubtitle: "Soumettez vos informations légales et documents pour révision",
        registrantRoleQuestion: "Êtes-vous l'organisation elle-même, ou son représentant ?",
        registrantRoleOrg: "L'organisation",
        registrantRoleRep: "Je suis un représentant",
        name: "Prénom",
        surname: "Nom",
        position: "Fonction / Titre",
        phone: "Téléphone",
        email: "E-mail",
        isInformalQuestion: "Votre organisation est-elle un groupe informel / non enregistré ?",
        formallyRegistered: "Non, officiellement enregistrée",
        informal: "Oui, informelle",
        stateRegNumber: "Numéro d'enregistrement public",
        countryOfReg: "Pays d'enregistrement",
        dateOfReg: "Date d'enregistrement",
        taxId: "N° fiscal / Identifiant légal",
        vatNumber: "Numéro de TVA",
        registeredAddress: "Adresse légale enregistrée",
        documentsTitle: "Documents",
        registrationDoc: "Document d'enregistrement",
        vatCertificate: "Certificat de TVA",
        stateSeal: "Cachet officiel",
        passportScan: "Scan du passeport du représentant",
        uploadShort: "Téléverser",
        alreadyUploaded: "déjà téléversé",
        errorRole: "Veuillez préciser si vous êtes l'organisation ou son représentant",
        errorRep: "Le prénom, le nom et la fonction du représentant sont requis",
        errorLegal: "Tous les champs d'enregistrement légal sont requis, sauf si vous êtes un groupe informel",
        errorSubmit: "Échec de l'envoi de la demande de vérification. Veuillez réessayer.",
        fileTooLarge: "Les fichiers doivent faire moins de 8 Mo.",
        submitting: "Envoi...",
        submit: "Soumettre pour révision",
      },
      supportChat: {
        title: "Support Greenwich",
        welcome: "Bonjour ! Posez-moi vos questions sur le fonctionnement de Greenwich : programmes, candidatures, organisations, Pro, greencoins et plus encore.",
        placeholder: "Tapez votre question...",
        error: "Une erreur s'est produite. Veuillez réessayer.",
        leaveContact: "Parler à un humain, laissez vos coordonnées",
        contactIntro: "Laissez votre nom et un moyen de vous joindre, et un administrateur vous contactera directement.",
        contactNamePlaceholder: "Votre nom",
        contactInfoPlaceholder: "E-mail ou numéro de téléphone",
        contactNotePlaceholder: "De quoi s'agit-il ? (facultatif)",
        contactSubmit: "Envoyer",
        contactSending: "Envoi...",
        contactSent: "Merci ! Un administrateur vous contactera bientôt.",
        backToChat: "← Retour au chat",
      },
      activeSessions: {
        pleaseLogin: "Veuillez vous connecter pour voir cette page",
        backToSettings: "Retour aux paramètres",
        title: "Sessions actives",
        subtitle: "Appareils actuellement connectés à votre compte. Déconnectez tout ce que vous ne reconnaissez pas.",
        failedLoad: "Échec du chargement des sessions",
        deviceLoggedOut: "Appareil déconnecté",
        failedLogout: "Échec de la déconnexion de l'appareil",
        confirmRevokeAll: "Déconnecter tous les autres appareils ?",
        loggedOutAll: "Déconnecté de tous les autres appareils",
        failedLogoutAll: "Échec de la déconnexion des autres appareils",
        loading: "Chargement...",
        noSessions: "Aucune session suivie pour le moment. Ceci s'affiche pour les connexions effectuées après l'ajout de cette fonctionnalité.",
        thisDevice: "Cet appareil",
        loggingOut: "Déconnexion…",
        logout: "Déconnexion",
        logoutOtherDevices: "Déconnecter les autres appareils ({{count}})",
        activeJustNow: "Actif à l'instant",
        activeMinAgo: "Actif il y a {{n}} min",
        activeHourAgo: "Actif il y a {{n}} h",
        activeDayAgo: "Actif il y a {{n}} j",
        unknownBrowser: "Navigateur inconnu",
        unknownDevice: "Appareil inconnu",
        onDevice: "{{browser}} sur {{os}}",
      },
      socialAuth: {
        googleLoadFailed: "Impossible de charger la connexion Google.",
        facebookLoadFailed: "Impossible de charger la connexion Facebook.",
        googleCancelled: "La connexion Google a été annulée.",
        googleFailed: "Échec de la connexion Google.",
        facebookCancelled: "La connexion Facebook a été annulée.",
        facebookFailed: "Échec de la connexion Facebook.",
        signUpWith: "S'inscrire avec",
        continueWith: "Continuer avec",
        connectingGoogle: "Connexion à Google...",
        connectingFacebook: "Connexion à Facebook...",
        configHint: "La connexion via réseau social est actuellement indisponible.",
      },
      playerInterest: {
        loading: "Chargement...",
        maxInterests: "Vous pouvez sélectionner jusqu'à 5 centres d'intérêt",
        selectAtLeastOne: "Veuillez sélectionner au moins un centre d'intérêt",
        failedSave: "Échec de l'enregistrement des centres d'intérêt",
        errorSaving: "Une erreur s'est produite lors de l'enregistrement de vos centres d'intérêt",
        detailsTitle: "Complétez votre profil",
        detailsSubtitle: "Quelques détails rapides pour que les gens puissent vous trouver et vous reconnaître.",
        usernameLabel: "Nom d'utilisateur",
        usernamePlaceholder: "ex. jean_dupont",
        nameLabel: "Prénom",
        surnameLabel: "Nom",
        dobLabel: "Date de naissance",
        invalidUsername: "Le nom d'utilisateur doit comporter 3 à 20 caractères : lettres minuscules, chiffres, tirets bas ou points",
        usernameChecking: "Vérification de la disponibilité...",
        usernameAvailable: "Le nom d'utilisateur est disponible",
        usernameTaken: "Ce nom d'utilisateur est déjà pris",
        nameRequired: "Veuillez saisir votre prénom",
        title: "Qu'est-ce qui vous intéresse ?",
        subtitle: "Choisissez-en jusqu'à 5. C'est exactement ce que notre IA utilise pour trouver des programmes qui en valent la peine.",
        selected: "Sélectionné",
        skipForNow: "Passer pour l'instant",
        saving: "Enregistrement...",
        continueBtn: "Continuer",
        interestEnvironment: "Environnement",
        interestEducation: "Éducation",
        interestTechnology: "Technologie",
        interestHealth: "Santé",
        interestArts: "Arts et culture",
        interestCommunityDev: "Développement communautaire",
        interestHumanRights: "Droits humains",
        interestSocialInclusion: "Inclusion sociale",
        interestIntlExchanges: "Échanges internationaux",
        interestEntrepreneurship: "Entrepreneuriat",
      },
      orgActivities: {
        noToken: "Aucun jeton d'authentification trouvé.",
        confirmDeletePost: "Supprimer cette publication ?",
        deleteError: "Erreur de suppression : {{message}}",
        noPostsYet: "Aucune publication pour le moment",
        organization: "Organisation",
        loadingTab: "Chargement de {{tab}}...",
        error: "Erreur : {{message}}",
        orgCreatedPost: "Votre organisation a créé une publication",
        noActivityYet: "Aucune activité pour le moment",
        title: "Activités de l'organisation",
        subtitle: "Suivez les publications et interactions",
        all: "Tout",
        posts: "Publications",
        liked: "Aimées",
        saved: "Enregistrées",
        profileAlt: "Profil",
        postAlt: "Publication",
        deleteFailed: "Échec de la suppression",
      },
      activities: {
        noToken: "Aucun jeton d'authentification trouvé. Veuillez vous reconnecter.",
        unknownApiError: "Erreur API inconnue",
        confirmDeletePost: "Êtes-vous sûr de vouloir supprimer cette publication ? Elle sera déplacée vers la corbeille pendant 30 jours avant suppression définitive.",
        errorDeletingPost: "Erreur lors de la suppression de la publication : {{message}}",
        justNow: "À l'instant",
        hoursAgo: "il y a {{n}} h",
        daysAgo: "il y a {{n}} j",
        errorLoadingTitle: "Erreur de chargement des données",
        tryAgain: "Réessayer",
        loadingYour: "Chargement de vos {{tab}}...",
        noActivitiesYet: "Aucune activité pour le moment. Commencez par créer votre première publication !",
        noPostsYetCreate: "Aucune publication pour le moment. Créez votre première publication depuis votre profil !",
        noLikedYet: "Aucune publication aimée pour le moment. Commencez à explorer et à aimer des publications !",
        noSavedYet: "Aucune publication enregistrée pour le moment. Enregistrez des publications pour les retrouver plus tard !",
        you: "Vous",
        unknown: "Inconnu",
        deletePost: "Supprimer la publication",
        activityPost: "Vous avez créé une nouvelle publication",
        activityLike: "Vous avez aimé une publication",
        activitySave: "Vous avez enregistré une publication",
        activityComment: "Vous avez commenté une publication",
        newActivity: "Nouvelle activité",
        title: "Vos activités",
        subtitle: "Suivez votre engagement et votre contenu",
        allActivities: "Toutes les activités",
        myPosts: "Mes publications",
        likedPosts: "Publications aimées",
        savedPosts: "Publications enregistrées",
        profileAlt: "Profil",
        postAlt: "Publication",
        deleteAlt: "Supprimer",
        likesAlt: "J'aime",
        commentsAlt: "Commentaires",
        savesAlt: "Enregistrements",
      },
      pages: {
        welcome: {
          skip: "Passer",
          next: "Suivant",
          slide1Title: "Trouvez de vraies opportunités",
          slide1Desc: "Parcourez des bourses, subventions, fellowships, stages et programmes d'échange vérifiés, tous mis en correspondance par IA, tous au même endroit.",
          slide2Title: "Postulez en quelques clics",
          slide2Desc: "Remplissez votre profil une fois, puis postulez directement aux programmes via Greenwich et suivez le statut de chaque candidature en temps réel.",
          slide3Title: "Vous n'êtes pas seul dans cette aventure",
          slide3Desc: "Soyez jumelé à un mentor Greenwich Buddy, rejoignez une communauté de candidats comme vous, et gagnez des greencoins en chemin.",
          consentTitle: "Avant de commencer",
          consentDesc: "Nous utilisons des cookies et des données essentielles pour faire fonctionner Greenwich correctement et améliorer votre expérience. En continuant, vous acceptez notre utilisation des cookies telle que décrite dans notre Politique de confidentialité.",
          consentAgree: "Accepter et commencer à utiliser Greenwich",
          alreadyHaveAccount: "Vous avez déjà un compte ?",
          logIn: "Se connecter",
        },
        seo: {
          home: {
            title: "Greenwich : Bourses, subventions et programmes d'échange pour la jeunesse",
            description: "Greenwich est la plateforme de bourses, subventions, fellowships, stages et programmes d'échange. Obtenez une mise en correspondance IA avec des opportunités vérifiées et trouvez un mentor Greenwich Buddy, gratuit et au même endroit.",
            keywords: "bourses d'études, subventions pour les jeunes, fellowships, stages, Erasmus+, programmes d'échange, étudier à l'étranger, programmes de bénévolat, mise en correspondance IA bourses, mentor Greenwich Buddy, bourses gratuites, étudier en Europe, étudier aux États-Unis, bourses de master, bourses de doctorat, bourses de licence, école d'été, stages rémunérés à l'étranger, stages à distance, programmes d'échange jeunesse, programme de mentorat, opportunités éducatives, moteur de recherche de bourses, programmes d'études à l'étranger financés, échange international pour étudiants, candidature Erasmus",
          },
          whoweare: {
            title: "Qui sommes-nous : Greenwich",
            description: "Découvrez la mission de Greenwich : connecter la jeunesse à des bourses, subventions et programmes d'échange vérifiés, et l'accompagner via la communauté de mentorat Greenwich Buddy.",
            keywords: "Greenwich, à propos de Greenwich, ONG jeunesse, association éducation, mentorat",
          },
          programs: {
            title: "Bourses, subventions et programmes d'échange : Greenwich",
            description: "Parcourez des bourses, subventions, fellowships, stages et programmes d'échange vérifiés ouverts à la jeunesse. Filtrez par pays, date limite et catégorie, ou obtenez une mise en correspondance IA instantanée.",
            keywords: "liste de bourses, subventions ouvertes, liste de programmes d'échange, offres de stages, dates limites fellowship, opportunités d'études à l'étranger, bourses en Europe, bourses aux États-Unis, bourses en Allemagne, bourses en France, bourses au Royaume-Uni, liste de programmes Erasmus+, stages d'été à l'étranger, programmes de bénévolat à l'étranger, subventions pour étudiants universitaires, bourses entièrement financées, dates limites de bourses 2026, semestre d'échange à l'étranger, programmes d'année de césure, fellowships de recherche, programmes de mobilité jeunesse",
          },
          contact: {
            title: "Nous contacter : Greenwich",
            description: "Contactez l'équipe Greenwich : questions sur les bourses, partenariats ou la plateforme.",
            keywords: "contact Greenwich, support Greenwich",
          },
          donate: {
            title: "Soutenir la jeunesse : faire un don à Greenwich",
            description: "Soutenez la mission de Greenwich qui connecte la jeunesse à des bourses, subventions et opportunités d'échange qui changent des vies. Chaque contribution aide davantage de jeunes à trouver leur voie.",
            keywords: "don éducation, soutenir la jeunesse, don Greenwich",
          },
          terms: {
            title: "Conditions d'utilisation : Greenwich",
            description: "Consultez les Conditions d'utilisation régissant l'utilisation de la plateforme Greenwich, y compris les comptes, l'utilisation acceptable, le programme Greenwich Buddy et les dons.",
            keywords: "conditions d'utilisation Greenwich, conditions générales Greenwich",
          },
          privacy: {
            title: "Politique de confidentialité : Greenwich",
            description: "Découvrez comment Greenwich collecte, utilise et protège vos données personnelles, y compris les informations sur les cookies, les services tiers et vos droits en matière de confidentialité.",
            keywords: "politique de confidentialité Greenwich, protection des données",
          },
          registration: {
            title: "Inscription : Greenwich",
            description: "Créez votre compte Greenwich gratuit pour obtenir une mise en correspondance IA avec des bourses, subventions et programmes d'échange, et vous connecter avec un mentor Greenwich Buddy.",
            keywords: "inscription Greenwich, créer un compte bourses",
          },
        },
        footer: {
          contactUs: "Nous contacter",
          whoWeAre: "Qui sommes-nous",
          feed: "Fil",
          community: "Communauté",
          account: "Compte",
          organizations: "Organisations",
          contact: "Nous contacter",
          projects: "Projets",
          donate: "Faire un don",
          terms: "Conditions",
          privacy: "Confidentialité",
          copyright: "© 2026 Greenwich",
          copyrightLong: "© 2026 Greenwich. Tous droits réservés.",
        },
        home: {
          hero1: "Jeunesse",
          hero2: "Connectée",
          tagline: "Votre carte des opportunités mondiales",
          explorePrograms: "Explorer les programmes",
          roleCardPlayer: "Je suis\nun participant",
          roleCardPlayerSub: "Découvrez des programmes et postulez en quelques clics",
          roleCardOrganizer: "Je suis un\norganisateur",
          roleCardOrganizerSub: "Publiez vos programmes et trouvez des participants",
          searchOpportunities: "Rechercher des opportunités",
          searchCtaText: "Chaque année, plus de 10 000 000 de jeunes dans le monde participent à des programmes d'échange, des bourses et des stages à l'étranger, entièrement gratuits.",
          searchCtaHint: "Faites glisser une bulle, ou touchez-la pour voir ce qu'elle propose ↓",
          filterScholarship: "Bourses",
          filterExchange: "Échange",
          filterVolunteering: "Bénévolat",
          filterInternship: "Stages",
          filterGrant: "Subventions",
          filterEducation: "Éducation",
          filterFellowship: "Fellowships",
          filterTraining: "Formation",
          benefitScholarship: "Couvrez une partie ou la totalité de vos frais de scolarité. De nombreuses bourses incluent aussi une allocation mensuelle, le logement et l'assurance santé, pour vous concentrer entièrement sur vos études à l'étranger.",
          benefitExchange: "Passez un semestre ou une année complète dans une université partenaire à l'étranger, obtenez des crédits reconnus chez vous, et créez des amitiés dans des dizaines de pays.",
          benefitVolunteering: "Vivez, travaillez et voyagez gratuitement à l'étranger. La plupart des programmes de bénévolat couvrent déjà l'hébergement, les repas et même une allocation mensuelle.",
          benefitInternship: "Acquérez une véritable expérience professionnelle au sein d'une entreprise ou organisation internationale. De nombreux postes sont rémunérés et ouvrent la porte à de futures offres d'emploi.",
          benefitGrant: "Obtenez un financement pour votre propre idée, recherche ou projet. Les subventions de voyage, de recherche et de projet ne sont presque jamais à rembourser.",
          benefitEducation: "Étudiez à l'étranger à tous les niveaux, d'un semestre d'échange à un programme complet de licence, master ou doctorat dans une université étrangère.",
          benefitFellowship: "Rejoignez un fellowship de recherche ou professionnel à l'étranger, travaillez aux côtés d'experts de votre domaine, et développez un réseau qui dure bien au-delà du programme.",
          benefitTraining: "Développez des compétences pratiques et directement utilisables via des cours courts et des ateliers à l'étranger : compétences professionnelles, techniques ou humaines, en ligne ou en présentiel.",
          hotNow: "Date limite proche",
          noDeadlinesSoon: "Aucun programme avec une date limite aujourd'hui ou demain pour le moment",
          programFallback: "Programme",
          untitledProgram: "Programme sans titre",
          countriesHeading: "Trouvez des opportunités partout dans le monde",
          deadlineBadge: "Date limite",
          daysShort: "j ",
          seeMore: "Voir plus",
          viewArrow: "Voir →",
          topOrgs: "Meilleures organisations du mois",
          topOrgsDesc: "Le classement est basé sur l'impact de nos programmes, le nombre de participants, les retours, la visibilité et d'autres indicateurs clés. Il met en avant les organisations qui contribuent activement à la croissance de la communauté, favorisent un engagement significatif et créent un changement positif durable.",
          topOrgsDescMobile: "Classement basé sur l'impact, les participants et les retours de la communauté.",
          orgLabel: "Organisation",
          unknown: "Inconnu",
          seeTopList: "Voir le classement",
          partners: "Partenaires",
          feedbackTitle: "Avis des membres de Greenwich",
          supportedBy: "Soutenu par",
          thankYou: "Merci !",
          feedbackSent: "Votre avis a été envoyé avec succès.",
          betaVersion: "Version bêta",
          shareFeedback: "Partagez votre avis",
          shareFeedbackSub: "Aidez-nous à améliorer YouthConnect, votre avis compte !",
          ratingOptional: "Note (facultatif)",
          inProgress: "En cours",
          comingSoonLabel: "Bientôt disponible",
          craftingSpecial: "Nous préparons quelque chose de spécial.",
          checkBack: "Revenez très bientôt.",
          heroSubDesktop: "Bourses, subventions, fellowships et programmes d'échange du monde entier, mis en correspondance avec la jeunesse et les organisations, le tout au même endroit.",
          heroSubMobile: "Bourses, subventions et programmes d'échange pour la jeunesse, tous au même endroit.",
          memberFeedbackSoon: "Avis des membres",
          supportedBySoon: "Soutenu par",
          aiKicker: "Mise en correspondance IA",
          aiTitle: "La mise en correspondance IA est là",
          aiDesc: "Nous déterminons quels programmes correspondent réellement à vos intérêts et vous les faisons correspondre automatiquement.",
          aiPoint1: "Classés par pertinence",
          aiPoint2: "Nouvelles suggestions chaque jour",
          aiPoint3: "Configuration en moins d'une minute",
          aiCta: "Essayer maintenant",
          buddyKicker: "Greenwich Buddy",
          buddyTitle: "Envie d'apprendre quelque chose de nouveau ? Ou de l'enseigner ?",
          buddyDesc: "Rejoignez Buddy en tant que mentor ou mentoré et commencez à créer de nouvelles amitiés et connexions.",
          buddyPoint1: "Jumelage par intérêts communs",
          buddyPoint2: "Un mois ciblé",
          buddyPoint3: "Certificat après 6 mentorés",
          buddyCta: "Rejoindre Buddy",
          faqKicker: "Questions fréquentes",
          faqTitle: "Tout ce qu'il faut savoir sur Greenwich",
          faqQ1: "Qu'est-ce que Greenwich ?",
          faqA1: "Greenwich est une plateforme gratuite qui connecte les jeunes (environ 14-35 ans) à des bourses, subventions, fellowships, stages et programmes d'échange d'Arménie et du monde entier, y compris des opportunités comme Erasmus+. Nous rassemblons des opportunités vérifiées au même endroit pour que vous n'ayez pas à chercher sur des dizaines de sites.",
          faqQ2: "Est-il gratuit d'utiliser Greenwich et de postuler à des bourses ou subventions ?",
          faqA2: "Oui. Créer un compte, parcourir les programmes, utiliser la mise en correspondance IA et rejoindre Greenwich Buddy sont entièrement gratuits pour les étudiants. Greenwich ne facture jamais de frais pour postuler à une bourse, subvention ou programme d'échange répertorié sur la plateforme.",
          faqQ3: "Comment fonctionne la mise en correspondance IA ?",
          faqA3: "La mise en correspondance IA examine votre profil, vos intérêts et vos objectifs et recommande automatiquement des bourses, subventions, stages et programmes d'échange qui vous correspondent, au lieu de vous faire parcourir manuellement chaque annonce.",
          faqQ4: "Qu'est-ce que Greenwich Buddy ?",
          faqA4: "Greenwich Buddy est notre programme de mentorat entre pairs. Vous pouvez le rejoindre en tant que mentoré pour bénéficier des conseils de quelqu'un ayant une expérience pertinente, ou devenir vous-même mentor après avoir terminé le programme, créer de nouvelles connexions et obtenir un certificat.",
          faqQ5: "Quel type d'opportunités puis-je trouver : bourses, subventions, stages, programmes d'échange ?",
          faqA5: "Greenwich répertorie des bourses, subventions universitaires, fellowships, stages rémunérés et non rémunérés, programmes de bénévolat et programmes d'échange (y compris Erasmus+) pour étudier, travailler et faire du bénévolat en Arménie comme à l'étranger.",
          faqQ6: "Qui peut utiliser Greenwich ?",
          faqA6: "Greenwich est conçu pour les jeunes âgés d'environ 14 à 35 ans : lycéens, étudiants, jeunes diplômés et jeunes professionnels à la recherche de leur prochaine bourse, subvention, stage ou opportunité d'échange.",
          statsKicker: "Nos réalisations",
          trustLabelUsers: "utilisateurs sur la plateforme",
          trustLabelOpportunities: "opportunités publiées",
          trustLabelSatisfaction: "trouvent un projet qu'ils adorent",
          trustLabelCountries: "pays avec des programmes actifs",
        },
        programs: {
          allPrograms: "Tous les programmes",
          greencoinReward: "+{{amount}} greencoins à l'achèvement",
          greencoinsFilter: "Récompenses en greencoins",
          programsFound: "{{count}} programme(s) trouvé(s)",
          viewDetails: "Voir les détails",
          noPrograms: "Aucun programme trouvé",
          adjustFilters: "Essayez d'ajuster vos filtres.",
          resetFilters: "Réinitialiser les filtres",
          clear: "Effacer",
          anyAge: "Tout âge",
          anyTime: "N'importe quand",
          educationAny: "Tout niveau",
          educationLevelLabel: "Niveau d'études",
          educationLevelShort: "Études",
          educationUndergraduate: "Licence",
          educationGraduate: "Master",
          educationDoctoral: "Doctorat",
          educationStudent: "Étudiant (général)",
          educationProfessional: "Professionnel",
          educationHighSchool: "Lycée",
          filtersLabel: "Filtres",
          ageLabel: "Âge",
          age18_25: "18-25 ans",
          age25_35: "25-35 ans",
          age35plus: "35 ans et plus",
          deadlinePassed: "Date limite dépassée",
          deadlineLabel: "Date limite",
          applyDeadlineLabel: "Date limite de candidature",
          eventDateLabel: "Date de l'événement",
          eventDatePassed: "Événement passé",
          funding: "Financement",
          location: "Lieu",
          pending: "En attente",
          rejected: "Rejeté",
          approve: "Approuver",
          reapprove: "Réapprouver",
          reject: "Rejeter",
          revoke: "Révoquer",
          edit: "Modifier",
          delete: "Supprimer",
          save: "Enregistrer",
          cancel: "Annuler",
          title: "Titre",
          description: "Description",
          saveProgram: "Enregistrer",
          unsaveProgram: "Enregistré",
          savePromptLogin: "Connectez-vous pour enregistrer des programmes",
          recommendedTitle: "Recommandé pour vous",
          popularTitle: "Populaire en ce moment",
          recommendedLoading: "Recherche de programmes pour vous…",
          recommendedEmpty: "Rien à recommander pour le moment. Explorez les programmes pour obtenir des suggestions personnalisées.",
          heroTitle: "Explorer les programmes",
          heroSubtitle: "Bourses, fellowships, stages, prix et plus encore",
          sourceLabel: "Source :",
          sourceByAi: "Par IA",
          sourceByAdmin: "Par l'admin",
          sourceByOrganization: "Par une organisation",
          sourceAllOption: "Source : Toutes",
          allSectorsOption: "Tous les secteurs",
          sector_ecology: "Écologie",
          sector_international: "International",
          sector_technology: "Technologie",
          sector_medical: "Médical",
          sector_education: "Éducation",
          sector_business: "Affaires",
          sector_arts: "Arts et culture",
          sector_science: "Science",
          sector_sports: "Sport",
          sector_agriculture: "Agriculture",
          sector_local: "Local",
          sector_media: "Médias",
          cat_education: "Éducation",
          cat_scholarship: "Bourse",
          cat_fellowship: "Fellowship",
          cat_erasmusplus: "Erasmus Plus",
          cat_training: "Formation",
          cat_grant: "Subvention",
          cat_internship: "Stage",
          cat_conference: "Conférence",
          cat_online: "En ligne",
          cat_volunteering: "Bénévolat",
          cat_event: "Événement",
          cat_award: "Prix",
          sub_all_education: "Toute l'éducation",
          sub_abroad: "Étudier à l'étranger",
          sub_bachelor: "Licence",
          sub_master: "Master",
          sub_phd: "Doctorat",
          sub_online: "En ligne",
          sub_all_scholarship: "Toutes les bourses",
          sub_full: "Complète",
          sub_partial: "Partielle",
          sub_government: "Gouvernementale",
          sub_private: "Privée",
          sub_all_fellowship: "Tous les fellowships",
          sub_research: "Recherche",
          sub_postdoc: "Postdoctorat",
          sub_visiting: "Visiteur",
          sub_all_erasmusplus: "Tout Erasmus+",
          sub_ka1: "KA1 - Mobilité",
          sub_ka2: "KA2 - Coopération",
          sub_ka3: "KA3 - Politique",
          sub_all_training: "Toutes les formations",
          sub_professional: "Professionnelle",
          sub_technical: "Technique",
          sub_soft_skills: "Compétences douces",
          sub_online_training: "En ligne",
          sub_all_grant: "Toutes les subventions",
          sub_research_grant: "Recherche",
          sub_project_grant: "Projet",
          sub_travel_grant: "Voyage",
          sub_all_internship: "Tous les stages",
          sub_summer: "Été",
          sub_paid: "Rémunéré",
          sub_unpaid: "Non rémunéré",
          sub_virtual: "Virtuel",
          sub_all_conference: "Toutes les conférences",
          sub_international_conf: "Internationale",
          sub_funded_conf: "Financée",
          sub_virtual_conf: "Virtuelle",
          sub_all_online: "Tout en ligne",
          sub_online_course: "Cours",
          sub_webinar: "Webinaire",
          sub_mooc: "MOOC",
          sub_all_volunteering: "Tout le bénévolat",
          sub_local_vol: "Local",
          sub_international_vol: "International",
          sub_evs: "SVE / CES",
          sub_all_event: "Tous les événements",
          sub_festival: "Festival",
          sub_competition: "Concours",
          sub_summit: "Sommet",
          sub_all_award: "Tous les prix",
          sub_international_award: "International",
          sub_national_award: "National",
          sub_regional_award: "Régional",
          sub_special_award: "Reconnaissance spéciale",
          deadlineAny: "N'importe quelle date limite",
          deadlineLast24h: "Dernières 24 heures",
          deadlineIn3Days: "Dans 3 jours",
          deadlineIn7Days: "Dans 7 jours",
          deadlineIn30Days: "Dans 30 jours",
          archiveLabel: "Archive",
          archiveShowActive: "Afficher les programmes actifs",
          archiveShowArchive: "Afficher les archives",
          archiveEmpty: "Aucune archive",
          aiMatchingTag: "Mise en correspondance IA",
          aiThinkingButton: "L'IA réfléchit…",
          aiMatchedToday: "Mis en correspondance aujourd'hui ✓",
          aiShowAllPrograms: "Afficher tous les programmes",
          aiNextMatchIn: "Prochaine mise en correspondance IA dans {{time}}",
          aiNewMatchesIn: "Nouvelles correspondances disponibles dans {{time}}",
          aiShowProgramsMatchedTooltip: "Afficher les programmes mis en correspondance pour vous par l'IA",
          aiOverlaySub: "Mise en correspondance de vos intérêts avec chaque programme ouvert…",
          aiCouldNotLoad: "Impossible de charger les recommandations",
          tryAgain: "Réessayer",
          aiNoStrongMatches: "Pas encore de correspondances fortes",
          aiBrowseAndSave: "Parcourez et enregistrez quelques programmes pour que nous puissions apprendre ce que vous aimez.",
          programsMatchedCount: "{{count}} programmes mis en correspondance pour vous",
          aiPhaseReading: "Lecture de vos intérêts…",
          aiPhaseScanning: "Analyse des programmes ouverts…",
          aiPhaseComparing: "Comparaison des catégories et secteurs…",
          aiPhaseScoring: "Évaluation des meilleures correspondances…",
          aiPhaseAlmost: "Presque terminé…",
          nowLabel: "maintenant",
          unlockPreviewText: "Vous voyez {{previewLimit}} programmes sur {{count}}. Créez un compte gratuit pour débloquer le reste, enregistrer vos favoris et recevoir des rappels de dates limites.",
          unlockMoreWaiting: "{{count}} programmes supplémentaires vous attendent",
          unlockFullListText: "Créez un compte gratuit pour débloquer la liste complète, enregistrer les programmes que vous aimez et recevoir des rappels avant les dates limites.",
          unlockFullListCta: "Débloquer la liste complète, c'est gratuit",
          orgBarQuestion: "Vous voulez répertorier votre programme ?",
          mySubmissions: "Mes soumissions",
          submitNew: "Nouvelle soumission",
          categoriesLabel: "Catégories",
          sidebarClose: "Fermer",
          sidebarFilter: "Filtrer",
          deleteConfirmTitle: "Supprimer ce programme ?",
          deleteConfirmBody: "Cette action est irréversible.",
          loadingPrograms: "Chargement des programmes…",
          durationLabel: "Durée",
          datesLabel: "Dates",
          targetGroupLabel: "Public cible",
          formatLabel: "Format",
          organizerLabel: "Organisateur",
          mediaLabel: "Médias",
          additionalDetailsLabel: "Détails supplémentaires",
          requirementsLabel: "Exigences",
          benefitsLabel: "Avantages",
          openMediaLabel: "Ouvrir les médias",
          applyNowLabel: "Postuler maintenant",
          applyLabel: "Postuler",
          copyLinkLabel: "Copier le lien",
          copyLinkTooltip: "Copier le lien partageable",
          yourApplicationLabel: "Votre candidature",
          acceptedStatus: "Accepté",
          notAcceptedStatus: "Non accepté",
          attendedStatus: "Participé",
          appStatusPendingMsg: "Candidature soumise, en attente de réponse.",
          appAcceptedMsg: "Accepté !",
          appNotAcceptedMsg: "Non accepté.",
          appAttendedMsg: "Participation confirmée.",
          appCertificateMayFollow: "Un certificat pourrait suivre.",
          rateOrgTitle: "Évaluer cette organisation",
          optionalCommentPlaceholder: "Commentaire facultatif",
          submitReviewLabel: "Envoyer l'avis",
          submittingLabel: "Envoi...",
          thanksForFeedback: "Merci pour votre avis !",
          starAriaLabel: "{{n}} étoile",
          linkCopiedToast: "🔗 Lien copié !",
          applicationSubmittedToast: "✅ Candidature soumise !",
          submitReviewFailedToast: "Échec de l'envoi de l'avis",
          submitReviewNetworkErrorToast: "Erreur réseau lors de l'envoi de l'avis",
          loadRecommendationsFailedError: "Échec du chargement des recommandations",
        },
        cookie: {
          title: "Cookies et confidentialité",
          accept: "Accepter",
          reject: "Refuser",
          learnMore: "En savoir plus",
          bannerTitle: "Nous respectons votre vie privée",
          bannerDesc: "En continuant à utiliser Greenwich, vous acceptez notre utilisation des cookies. Nous ne collectons que les données essentielles nécessaires pour améliorer votre expérience et garantir le bon fonctionnement de la plateforme.",
          decline: "Refuser",
          acceptContinueFull: "Accepter et continuer",
          requiredTitle: "Cookies requis",
          requiredBody: "Pour continuer à utiliser Greenwich, vous devez accepter l'utilisation des cookies essentiels. Ils sont nécessaires au bon fonctionnement de la plateforme et à une expérience fluide.",
          acceptCookiesContinue: "Accepter les cookies et continuer",
        },
        community: {
          title: "Communauté",
          loading: "Chargement des communautés...",
          retry: "Réessayer",
          createGroup: "Créer un groupe",
          createShort: "Créer",
          myCommunities: "Mes communautés",
          myGroupsShort: "Mes groupes",
          searchPlaceholder: "Rechercher des communautés...",
          filterAll: "Toutes",
          filterOpen: "Ouvertes",
          filterClosed: "Fermées",
          noGroupsSearch: 'Aucun groupe trouvé pour "{{term}}".',
          noGroupsYet: "Aucun groupe pour le moment. Soyez le premier à en créer un !",
          createFirstGroup: "Créer le premier groupe",
          fetchError: "Échec de la récupération des groupes",
          loadError: "Échec du chargement des communautés. Veuillez réessayer.",
          joinSuccess: "Vous avez rejoint le groupe avec succès !",
          joinRequestSent: "Demande d'adhésion envoyée. Le propriétaire du groupe l'examinera.",
          joinFailed: "Échec de l'adhésion au groupe",
          joinError: "Erreur lors de l'adhésion au groupe. Veuillez réessayer.",
          membersCount: "{{count}} membres",
          public: "Public",
          private: "Privé",
          admin: "Admin",
          closed: "Fermé",
          manageGroup: "Gérer le groupe",
          viewGroup: "Voir le groupe",
          joining: "Adhésion en cours...",
          registrationClosed: "Inscriptions fermées",
          join: "Rejoindre",
          noDescriptionAvailable: "Aucune description disponible",
        },
        organizations: {
          topTitle: "Meilleures organisations",
          topSubtitle: "Organisations les plus populaires ce mois-ci",
          secondPlace: "Deuxième place",
          secondDesc: "Excellente organisation aux belles réalisations",
          firstPlace: "Première place",
          firstDesc: "Organisation leader aux performances exceptionnelles",
          thirdPlace: "Troisième place",
          thirdDesc: "Organisation remarquable qui change les choses",
          allVerified: "Toutes les organisations vérifiées",
          loading: "Chargement des organisations...",
          tryAgain: "Réessayer",
          noneTitle: "Aucune organisation trouvée",
          noneDesc: "Il n'y a actuellement aucune organisation à afficher.",
          refresh: "Actualiser",
          loadError: "Échec du chargement des organisations. Veuillez réessayer.",
          noDescription: "Aucune description disponible",
          unknownOrg: "Organisation inconnue",
        },
        adminPanel: {
          signOutTitle: "Se déconnecter ?",
          signOutBody: "Voulez-vous vraiment vous déconnecter du panneau d'administration ?",
          cancel: "Annuler",
          yesLogOut: "Oui, se déconnecter",
          viewArrow: "Voir →",
          dashboardTitle: "Tableau de bord admin",
          welcomeBack: "Content de vous revoir,",
          navOrganizerApprovals: "Approbations d'organisateurs",
          navPrograms: "Programmes",
          navAnalytics: "Analytique",
          logoutBtn: "Déconnexion",
          statTotalOrganizers: "Total des organisateurs",
          statPendingOrganizers: "Organisateurs en attente",
          statVerifiedOrganizers: "Organisateurs vérifiés",
          statRejectedUsers: "Utilisateurs rejetés",
          statTotalUsers: "Total des utilisateurs",
          statRecentRegistrations: "Inscriptions récentes",
          statBetaFeedbacks: "Avis bêta",
          statTotalPosts: "Total des publications",
          statTotalPrograms: "Total des programmes",
          statPendingPrograms: "Programmes en attente",
          statTotalCommunities: "Total des communautés",
          statPendingReports: "Signalements en attente",
          reviewLink: "Examiner →",
          recentRegistrations: "Inscriptions récentes",
          noRecentRegistrations: "Aucune inscription récente",
          colLogo: "Logo",
          colName: "Nom",
          colEmail: "E-mail",
          colOrganization: "Organisation",
          colType: "Type",
          colStatus: "Statut",
          colDate: "Date",
          colActions: "Actions",
        },
        buddy: {
          title: "Buddy",
          subtitle: "Un système personnalisé de mise en relation avec un mentor : connectez-vous avec quelqu'un d'expérimenté dans ce qui vous tient à cœur, ou devenez cette personne pour quelqu'un qui débute.",
          backHome: "Retour à l'accueil",
          loading: "Chargement...",
          roleMentorTitle: "Devenir mentor",
          roleMentorDesc: "Partagez votre expérience avec quelqu'un qui débute dans les projets jeunesse, le bénévolat, Erasmus+, le CES et opportunités similaires.",
          roleMenteeTitle: "Devenir mentoré",
          roleMenteeDesc: "Soyez mis en relation avec un mentor expérimenté dans les domaines qui vous intéressent.",
          mentorInfoTitle: "Le rôle du mentor 🌟",
          mentorInfoBody: "Un mentor est un participant expérimenté qui aide les nouveaux venus à comprendre le monde des projets jeunesse, du bénévolat, d'Erasmus+, du CES et d'autres opportunités.\n\nResponsabilités :\n• Rester en contact avec votre mentoré pendant tout le mois\n• Guider avec des conseils et une expérience réelle\n• Être respectueux, responsable et bienveillant\n• Ne promettez pas ce que vous ne pouvez pas tenir\n\nUn mentor peut avoir jusqu'à 3 mentorés actifs à la fois. Après 6 mentorats réussis, vous obtenez le certificat de mentor Greenwich.",
          menteeInfoTitle: "Le rôle du mentoré 🚀",
          menteeInfoBody: "Un mentoré est quelqu'un qui débute son parcours dans les projets jeunesse, le bénévolat ou les programmes internationaux.\n\nVous pouvez choisir un mentor expérimenté dans les domaines qui vous intéressent.\nVous ne pouvez avoir qu'un seul mentor actif à la fois.\nUn mentorat dure 1 mois.",
          agreeContinue: "J'accepte, continuer",
          cancel: "Annuler",
          back: "Retour",
          step: "Étape {{current}} sur {{total}}",
          formCategoriesMentor: "Choisissez jusqu'à 3 domaines où vous avez de l'expérience",
          formCategoriesMentee: "Choisissez jusqu'à 3 domaines qui vous intéressent",
          categoriesHint: "{{count}}/3 sélectionnés",
          formExperience: "Évaluez votre expérience dans ce domaine de 1 à 10",
          formExperienceMentee: "Quelle expérience avez-vous déjà dans ce domaine ? Cela nous aide à vous associer au bon niveau de mentor.",
          formExperiencePlaceholder: "1 = aucune expérience, 10 = expert",
          experiencePrompt: "Choisissez une note en étoiles",
          experienceLevels: { novice: "Novice", amateur: "Amateur", pro: "Pro", guru: "Expert" },
          menteeExperienceLabel: "{{level}} dans ce domaine",
          formProjectsCount: "À combien de projets avez-vous participé, dans les domaines choisis ?",
          formProjectsCountPlaceholder: "ex. 5",
          formHours: "Combien d'heures par semaine pouvez-vous consacrer au mentorat ?",
          formBio: "Une courte biographie que vos mentorés verront (200 caractères max)",
          formBioMenteeLabel: "Que souhaitez-vous accomplir avec un mentor ? (200 caractères max)",
          formBioPlaceholder: "Parlez un peu de vous...",
          formContact: "Comment un mentoré/mentor mis en relation peut-il vous joindre ?",
          contactHint: "Partagé uniquement une fois la demande acceptée. Tout ici est facultatif",
          contactHintMentor: "Partagé uniquement une fois la demande acceptée. Choisissez au moins 2 moyens d'être joint",
          contactInvalidHint: "L'un de ces éléments semble incorrect. Vérifiez le format du téléphone, de l'e-mail ou de Telegram",
          contactMinHint: "Veuillez remplir au moins 2 moyens de contact",
          phonePlaceholder: "Numéro de téléphone",
          emailPlaceholder: "E-mail",
          telegramPlaceholder: "Nom d'utilisateur Telegram",
          instagramPlaceholder: "Instagram",
          facebookPlaceholder: "Facebook",
          formGender: "Votre genre",
          genders: { male: "Homme", female: "Femme", other: "Autre" },
          formPreferredMenteeGender: "Quel genre souhaitez-vous pour votre mentoré ?",
          formPreferredMentorGender: "Quel genre souhaitez-vous pour votre mentor ?",
          genderPrefs: { any: "Aucune préférence", male: "Homme", female: "Femme", same: "Même que moi" },
          previewLabel: "Aperçu de votre profil",
          previewHint: "C'est exactement ce que les mentorés verront en parcourant les mentors",
          noRatingsYet: "Aucune évaluation pour le moment",
          contactLabels: { phone: "Téléphone", email: "E-mail", telegram: "Telegram", instagram: "Instagram", facebook: "Facebook" },
          continueBtn: "Continuer",
          submitMentor: "Soumettre la candidature de mentor",
          submitMentee: "Enregistrer et voir les mentors correspondants",
          errPickCategory: "Choisissez au moins 1 catégorie",
          errExperience: "Saisissez un nombre de 1 à 10",
          errBioLength: "La bio doit faire moins de 100 mots",
          errGeneric: "Une erreur s'est produite. Veuillez réessayer.",
          mentorPendingTitle: "Candidature en cours d'examen",
          mentorPendingBody: "Votre candidature de mentor a été envoyée aux administrateurs de Greenwich. Nous vous informerons dès qu'elle sera approuvée.",
          mentorRejectedTitle: "Candidature non approuvée",
          mentorRejectedBody: "Votre candidature de mentor n'a pas été approuvée cette fois.",
          mentorApprovedBadge: "Mentor approuvé",
          availabilityOn: "Disponible pour de nouveaux mentorés",
          availabilityOff: "Non disponible pour le moment",
          toggleAvailability: "Basculer la disponibilité",
          activeMenteesTitle: "Vos mentorés actifs",
          noActiveMentees: "Aucun mentoré actif pour le moment.",
          pendingRequestsTitle: "Nouvelles demandes de mentorés",
          noPendingRequests: "Aucune demande en attente.",
          accept: "Accepter",
          decline: "Refuser",
          completedLabel: "Mentorats terminés",
          mentorsChatBtn: "Chat des mentors",
          certificateEarned: "🎓 Vous avez obtenu le certificat de mentor Greenwich Buddy !",
          asMentorTab: "En tant que mentor",
          asMenteeTab: "En tant que mentoré",
          matchingMentorsTitle: "Mentors qui vous correspondent",
          allMentorsTitle: "Mentors disponibles",
          noMatchingMentors: "Aucun mentor correspondant n'est libre pour le moment. Réessayez plus tard.",
          overlapLabel: "{{count}} domaine(s) en commun",
          experienceLabel: "Expérience",
          projectsLabel: "Projets",
          activeLabel: "Mentorés actifs",
          chooseMentor: "Choisir ce mentor",
          requestSentTitle: "Demande envoyée ✅",
          requestSentBody: "Nous avons informé le mentor. Vous serez notifié dès qu'il répondra.",
          withdrawRequest: "Retirer la demande",
          youHaveMentorTitle: "Votre mentor",
          youHaveMenteeOf: "Mentoré",
          daysLeft: "{{count}} jours restants",
          endsOn: "Se termine le {{date}}",
          messageBtn: "Message",
          viewProfile: "Voir le profil",
          endMentorship: "Mettre fin au mentorat",
          endMentorshipConfirmTitle: "Mettre fin à ce mentorat ?",
          endMentorshipConfirmBody: "Cette action est irréversible. Une évaluation privée vous sera demandée à tous les deux par la suite.",
          endMentorshipConfirmYes: "Oui, y mettre fin",
          reviewTitle: "Évaluez votre mentorat",
          reviewBody: "Ceci reste privé et n'est jamais montré à l'autre personne.",
          reviewCommentPlaceholder: "Un court commentaire (facultatif)",
          submitReview: "Envoyer l'évaluation",
          reviewThanks: "Merci pour votre avis ✅",
          skipReview: "Passer",
          pendingReviewTitle: "En attente de votre évaluation",
          pendingReviewBody: "Ces mentorats sont terminés. Laissez une évaluation privée. L'autre personne ne la verra jamais.",
          leaveReview: "Laisser une évaluation",
          reportBtn: "Signaler",
          reportTitle: "Signaler {{name}}",
          reportBody: "Dites-nous ce qui s'est passé dans ce mentorat Buddy. Notre équipe l'examinera. {{name}} ne verra pas ce message.",
          reportDetailsPlaceholder: "Que s'est-il passé ? (facultatif, nous aide à examiner plus vite)",
          reportSubmittedTitle: "Signalement envoyé",
          reportSubmittedBody: "Merci, notre équipe va l'examiner. Si vous craignez pour votre sécurité, contactez-nous aussi directement.",
          close: "Fermer",
          cancel: "Annuler",
          submitting: "Envoi…",
          submitReport: "Envoyer le signalement",
          categories: {
            volunteering: "Bénévolat", intlPractice: "Pratique internationale", erasmusPlus: "Erasmus+",
            erasmusMundus: "Erasmus Mundus", esc: "CES", leadership: "Leadership", networking: "Réseautage",
            webinar: "Webinaire", workshop: "Atelier", business: "Affaires", startup: "Startup",
            hiking: "Randonnée", training: "Formation", eco: "Écologie", communitySupport: "Soutien communautaire",
            organizational: "Compétences organisationnelles", marketing: "Marketing", communication: "Communication",
            regionalDev: "Développement régional", art: "Art", painting: "Peinture", dance: "Danse",
            singing: "Chant", other: "Autre",
          },
        },
        levels: {
          title: "Niveaux et XP",
          subtitle: "Chaque compte progresse à travers des niveaux au fur et à mesure de votre participation à la plateforme. Cette page explique le principe général, pas des chiffres exacts.",
          nextLevel: "En route vers le niveau {{level}}",
          maxLevelReached: "Vous avez atteint le niveau maximum 🏆",
          howTitle: "Comment gagner de l'XP",
          howSub: "À peu près tout ce que vous faites sur la plateforme qui aide les autres ou vous fait progresser compte pour votre niveau.",
          categories: {
            apply: { title: "Postuler et être accepté", desc: "Postuler à des programmes via la plateforme, et être accepté dans l'un d'eux." },
            attend: { title: "Participer et être présent", desc: "Participer réellement aux programmes et événements auxquels vous vous êtes inscrit." },
            community: { title: "Communautés", desc: "Démarrer une communauté, ou en rejoindre une créée par quelqu'un d'autre." },
            voice: { title: "Faites entendre votre voix", desc: "Publier des mises à jour et obtenir un véritable engagement des autres." },
            mentorship: { title: "Mentorat", desc: "Être mentor ou mentoré Buddy, et aller jusqu'au bout." },
            trust: { title: "Confiance et profil", desc: "Vérifier votre compte, compléter votre profil, ajouter votre CV." },
            reviews: { title: "Avis", desc: "Laisser un avis honnête après la fin d'un programme." },
            streak: { title: "Régularité", desc: "Revenir régulièrement : être actif jour après jour compte." },
            tasks: { title: "Défis", desc: "Terminer les défis proposés de temps en temps par l'équipe." },
            referrals: { title: "Parrainages", desc: "Amener des amis sur la plateforme." },
          },
          certTitle: "Certificats et XP",
          certSub: "Les programmes qui offrent des greencoins vous rapportent aussi de l'XP et un certificat une fois que vous y participez et les terminez réellement.",
          certSteps: {
            participate: { title: "Assister à l'événement", desc: "Inscrivez-vous et soyez réellement présent. Les organisateurs marquent la présence une fois le programme terminé." },
            certificate: { title: "Gagnez de l'XP + un certificat", desc: "Les programmes terminés ajoutent de l'XP à votre niveau, et les programmes éligibles délivrent un certificat sur votre compte." },
            bio: { title: "Affichez-le sur votre profil", desc: "Vos certificats figurent sur votre profil, classés selon leur importance et la date d'obtention." },
          },
          tiersTitle: "Paliers",
          tiersSub: "Au fur et à mesure que votre niveau augmente, votre badge évolue à travers cinq paliers.",
          tierNames: { bronze: "Bronze", silver: "Argent", gold: "Or", diamond: "Diamant", legend: "Légende" },
          tierDescs: {
            bronze: "Tout le monde commence ici.",
            silver: "Membres réguliers et actifs.",
            gold: "Utilisateurs sérieusement engagés.",
            diamond: "Contributeurs de longue date.",
            legend: "Les plus dévoués de la plateforme.",
          },
          youAreHere: "Vous êtes ici",
          greencoins: "greencoins",
          tasksLink: "Tâches",
          back: "Retour",
        },
        tasks: {
          title: "Tâches",
          subtitle: "Des actions rapides pour gagner de l'XP et des greencoins en plus. Certaines se renouvellent chaque jour ou chaque mois.",
          loading: "Chargement des tâches...",
          empty: "Aucune tâche pour le moment — revenez plus tard.",
          frequencyOnce: "Ponctuelle",
          frequencyDaily: "Quotidienne",
          frequencyMonthly: "Mensuelle",
          xpAmount: "{{amount}} XP",
          completeBtn: "Valider",
          doneBtn: "Fait",
          savingEllipsis: "Enregistrement...",
          completed: "+{{xp}} XP !",
          completedWithCoins: "+{{xp}} XP, +{{coins}} greencoins !",
          completeFailed: "Impossible de valider cette tâche. Réessayez.",
          back: "Retour",
        },
        pro: {
          title: "Greenwich Pro",
          subtitle: "Un abonnement payant pour les membres qui veulent plus de contrôle sur leur profil et sur la façon dont ils trouvent leur prochaine opportunité.",
          plans: { "1m": "1 mois", "3m": "3 mois", "6m": "6 mois" },
          bestValue: "Meilleur rapport qualité-prix",
          perMonth: "{{price}} AMD / mois",
          totalBilled: "{{total}} AMD au total pour {{months}} mois",
          perksTitle: "Ce que Pro vous apporte",
          perks: {
            design: { title: "Design de profil personnalisé", desc: "Personnalisez votre profil avec votre propre style." },
            frame: { title: "Cadre d'avatar personnalisé", desc: "Démarquez-vous avec un cadre exclusif autour de votre photo." },
            views: { title: "Voyez qui a visité votre profil", desc: "Utilisateurs individuels et organisations, avec les dates, pendant toute la durée de votre abonnement." },
            matches: { title: "Les projets les plus pertinents, livrés directement", desc: "Recevez vos meilleures correspondances de projets par e-mail, bot Telegram ou directement dans la plateforme. Vous choisissez le canal." },
            shop: { title: "Récompenses exclusives en greencoins", desc: "Dépensez vos greencoins sur des articles exclusifs, pas seulement les habituels." },
            early: { title: "Accès anticipé", desc: "Voyez les nouvelles opportunités 6 heures avant tout le monde." },
          },
          statusActive: "Votre Pro est actif jusqu'au {{date}}",
          statusNone: "Vous n'avez pas encore Pro",
          paymentComingSoon: "Le paiement en ligne est en cours de mise en place. L'achat de Pro n'est pas encore disponible sur le site.",
          choosePlan: "Choisissez un abonnement, puis payez par virement bancaire",
          payTitle: "Payer par virement bancaire",
          payBank: "Banque",
          payAccount: "Numéro de compte",
          payRecipient: "Bénéficiaire",
          payReference: "Référence de paiement",
          payReferenceHint: "Indiquez-la exactement pour que nous puissions associer votre virement à votre compte.",
          submitPayment: "Payer maintenant",
          signInToPay: "Connectez-vous pour acheter",
          submitting: "Envoi...",
          submitSuccess: "Merci ! Nous confirmerons votre virement et activerons Pro sous 24 heures.",
          pendingNote: "Votre demande {{plan}} est en attente. Nous confirmons votre virement et activerons Pro sous peu.",
          interestTitle: "Un instant",
          interestBody: "Nous finalisons le paiement en ligne pour Pro. Appuyez ci-dessous et nous enverrons un e-mail à votre compte dès que ce sera prêt.",
          interestSubmit: "Me prévenir",
          interestDoneTitle: "Merci !",
          interestDoneBody: "Nous avons noté votre intérêt et vous enverrons un e-mail dès que l'achat de Pro sera disponible.",
          interestClose: "Fermer",
          payWithCard: "Payer par carte",
          redirectingToBank: "Redirection vers la banque...",
          cardPaymentSuccess: "Paiement réussi, Pro est maintenant actif !",
          cardPaymentFailed: "Le paiement a échoué. Vous pouvez réessayer.",
          cardPaymentError: "Un problème est survenu lors du paiement. Veuillez réessayer.",
          extendPrompt: "Vous avez déjà Pro.",
          extendLink: "Vous voulez un autre plan ? Acheter à nouveau",
          historyTitle: "Historique des achats",
          historyEmpty: "Aucun achat pour le moment.",
          historyReceipt: "Reçu",
          receiptTitle: "Reçu de paiement",
          receiptOrder: "Commande",
          receiptDate: "Date",
          receiptPlan: "Plan",
          receiptAmount: "Montant",
          receiptCard: "Carte",
          receiptApproval: "Code d'approbation",
          receiptClose: "Fermer",
          receiptPrint: "Imprimer / Enregistrer en PDF",
          back: "Retour",
        },
        paymentConfirmation: {
          titleSuccess: "Paiement réussi",
          titleFailed: "Échec du paiement",
          titlePending: "Vérification du paiement...",
          subtitleSuccess: "Votre achat est confirmé et actif sur votre compte.",
          subtitleFailed: "La banque n'a pas pu finaliser ce paiement. Aucun montant n'a été prélevé.",
          subtitlePending: "Un instant, cela prend quelques secondes.",
          viewReceipt: "Voir les détails du reçu",
          hideReceipt: "Masquer les détails",
          downloadReceipt: "Télécharger le reçu",
          continuePro: "Aller à Pro",
          backToFeed: "Retour au fil",
          tryAgain: "Réessayer",
          refundNote: "Vous avez changé d'avis ? Vous pouvez demander un remboursement sous 7 jours dans",
          refundNoteLink: "Paramètres → Pro → Facturation",
          notFound: "Nous n'avons pas trouvé ce paiement.",
        },
        shop: {
          title: "Boutique Greencoin",
          subtitle: "Dépensez les greencoins gagnés sur la plateforme contre de vraies récompenses.",
          greencoins: "greencoins",
          loading: "Chargement...",
          empty: "Rien ici pour le moment, revenez bientôt.",
          everydayTitle: "Récompenses du quotidien",
          exclusiveTitle: "Récompenses exclusives",
          exclusiveSub: "Réservées aux membres Pro.",
          exclusive: "Pro",
          proOnly: "Pro uniquement",
          redeem: "Échanger",
          confirmRedeem: 'Échanger "{{name}}" contre {{cost}} greencoins ?',
          redeemSuccess: '"{{name}}" échangé ! Notre équipe assurera le suivi de la livraison.',
          redeemError: "Impossible d'échanger cet article. Veuillez réessayer.",
          cancel: "Annuler",
          redeeming: "Échange en cours...",
          redeemSuccessTitle: "Échangé !",
          qrHint: "Présentez ce code QR lors du retrait.",
          codeHint: "Présentez ou saisissez ce code lors du retrait.",
          done: "Terminé",
          myPurchases: "Mes achats",
          myPurchasesSub: "Tout ce que vous avez échangé, avec vos codes de retrait.",
          noPurchases: "Vous n'avez encore rien échangé.",
          showCode: "Afficher le code",
          hideCode: "Masquer le code",
          back: "Retour",
        },
        donate: {
          heroTitle: "Soutenez la jeunesse",
          heroSub: "Rejoignez notre communauté de donateurs et aidez à créer des opportunités pour la prochaine génération de leaders.",
          missionTitle: "Notre mission",
          missionSub: "Donner à la jeunesse les moyens d'agir grâce à l'éducation",
          quote: "« En soutenant notre mission, vous investissez dans l'avenir de la jeunesse. »",
          quoteBody: "Votre contribution nous aide à créer des programmes éducatifs, à offrir du mentorat et à ouvrir de nouvelles opportunités de croissance. Chaque don nous rapproche un peu plus de la réalisation de cette vision.",
          statYouth: "Jeunes touchés",
          statSuccess: "Réussite des programmes",
          statPrograms: "Programmes créés",
          chooseTier: "Choisissez votre niveau de soutien",
          chooseTierSub: "Sélectionnez un niveau de soutien mensuel ou saisissez un montant personnalisé",
          popular: "Populaire",
          perMonth: "par mois",
          customAmount: "Ou saisissez un montant personnalisé",
          minUsd: "Minimum ${{amount}} ({{amd}} AMD)",
          thankYou: "Merci ! 🎉",
          thankBody: "Votre soutien mensuel de ${{amount}} est maintenant actif. Confirmation envoyée à {{email}}.",
          whatNext: "Ce qui se passe ensuite :",
          next1: "E-mail de bienvenue sous 24 heures",
          next2: "Reçu mensuel par e-mail",
          next3: "Les avantages donateur commencent immédiatement",
          makeAnother: "Faire un autre don",
          supportLevel: "Niveau de soutien :",
          custom: "Personnalisé",
          quickAmount: "Montant rapide :",
          monthly: "Mensuel :",
          recurringNote: "Don mensuel récurrent",
          cancelAnytime: "Annulez ou modifiez à tout moment",
          yourInfo: "Vos informations",
          fullName: "Nom complet",
          emailReq: "Adresse e-mail *",
          paymentMethod: "Moyen de paiement",
          bmcTitle: "Buy Me a Coffee",
          bmcSub: "Soutien simple, ponctuel ou mensuel",
          processing: "Traitement...",
          continueBmc: "Continuer vers Buy Me a Coffee",
          redirectTitle: "Ouverture de la page de paiement sécurisée...",
          redirectBody: "Nous avons ouvert Buy Me a Coffee dans un nouvel onglet pour finaliser votre don de ${{amount}}. Veuillez terminer le paiement là-bas. Cette page n'a aucun moyen de savoir quand c'est fait.",
          reopenPayment: "Rouvrir la page de paiement",
          backToForm: "Retour au formulaire",
          secureNote: "Paiement sécurisé et chiffré",
          termsAgree: "En continuant, vous acceptez nos",
          terms: "Conditions",
          and: "et notre",
          privacyPolicy: "Politique de confidentialité",
          whyMonthly: "Pourquoi soutenir mensuellement ?",
          whyItems: [
            ["Impact durable", "Permet une planification de programmes à long terme"],
            ["Financement prévisible", "Nous aide à servir plus de jeunes de façon constante"],
            ["Flexible", "Modifiez ou annulez votre soutien à tout moment"],
            ["Avantages fiscaux", "Reçus mensuels pour une déclaration fiscale simplifiée"],
          ],
          alertMin: "Veuillez saisir au moins ${{min}}",
          alertEmail: "Veuillez saisir votre adresse e-mail.",
          alertPayment: "Veuillez sélectionner un moyen de paiement.",
          alertCardLogin: "Veuillez vous connecter pour faire un don par carte.",
          alertCardError: "Un problème est survenu lors du paiement. Veuillez réessayer.",
          bmcToast: "☕ Buy Me a Coffee sélectionné",
          cardTitle: "Payer par carte",
          cardSub: "Don ponctuel instantané en AMD",
          continueCard: "Faire un don par carte",
          redirectingToBank: "Redirection vers la banque...",
          cardPaymentSuccess: "Merci, votre don a été effectué !",
          cardPaymentFailed: "Le paiement a échoué. Vous pouvez réessayer.",
          cardPaymentError: "Un problème est survenu lors du paiement. Veuillez réessayer.",
          tier1n: "Soutien", tier1d: "Soutien de base à notre mission", tier1p0: "E-mail de remerciement", tier1p1: "Newsletter mensuelle",
          tier2n: "Ami", tier2d: "Aider à financer du matériel pédagogique", tier2p0: "Tous les avantages précédents", tier2p1: "Certificat numérique", tier2p2: "Nom dans la liste des donateurs",
          tier3n: "Champion", tier3d: "Parrainer un programme jeunesse", tier3p0: "Tous les avantages précédents", tier3p1: "Mises à jour exclusives", tier3p2: "Badge numérique",
          tier4n: "Leader", tier4d: "Avoir un impact significatif", tier4p0: "Tous les avantages précédents", tier4p1: "Remerciement vidéo", tier4p2: "Reconnaissance sur le site",
        },
        contact: {
          badge: "Nous sommes là pour aider",
          title: "Contactez-nous",
          subtitle: "Connectez-vous avec notre équipe pour en savoir plus sur les opportunités, les partenariats, ou comment vous impliquer.",
          email: "E-mail",
          phone: "Téléphone",
          followJourney: "Suivez notre parcours",
          quickAskTitle: "Besoin d'une réponse rapide ?",
          quickAskSubtitle: "Posez votre question à notre assistant IA au lieu d'attendre une réponse au formulaire ci-dessous.",
          faqTitle: "Questions fréquentes",
          tabGeneral: "Général",
          tabPrograms: "Programmes",
          tabPartnerships: "Partenariats",
          sendMessage: "Envoyez-nous un message",
          replyWithin: "Nous vous répondrons sous 24 heures",
          sentTitle: "Message envoyé ! 🎉",
          sentBody: "Merci d'avoir contacté Greenwich. Notre équipe vous répondra sous peu.",
          sendError: "Une erreur s'est produite lors de l'envoi de votre message. Veuillez réessayer dans un instant.",
          yourName: "Votre nom",
          emailPlaceholder: "Adresse e-mail",
          messagePlaceholder: "Votre message...",
          sending: "Envoi...",
          sendBtn: "Envoyer le message",
          responseTime: "Délai de réponse : sous 24 heures",
          ctaTitle: "Prêt à commencer votre aventure ?",
          ctaSub: "Rejoignez des milliers de jeunes qui ont trouvé leur voie grâce à Greenwich.",
          browseOpps: "Parcourir les opportunités",
          learnMore: "En savoir plus sur nous",
          faqG1q: "Qu'est-ce que Greenwich ?", faqG1a: "Greenwich est une plateforme numérique qui connecte la jeunesse à des opportunités mondiales en éducation, programmes d'échange et développement de carrière.",
          faqG2q: "Qui peut utiliser Greenwich ?", faqG2a: "Les jeunes de 14 à 35 ans, étudiants, professionnels, et toute personne en recherche d'opportunités internationales.",
          faqP1q: "Quels types de programmes proposez-vous ?", faqP1a: "Nous proposons des programmes d'échange, des bourses, des stages, des opportunités de bénévolat et des échanges culturels.",
          faqP2q: "Comment postuler aux programmes ?", faqP2a: "Créez un compte, parcourez les opportunités et soumettez vos candidatures via notre système.",
          faqPr1q: "Mon organisation peut-elle s'associer à Greenwich ?", faqPr1a: "Oui ! Nous accueillons des partenariats avec des établissements d'enseignement, des ONG et des entreprises.",
          faqPr2q: "Quels sont les avantages d'un partenariat ?", faqPr2a: "Les partenaires accèdent à notre vivier de talents, co-organisent des événements et gagnent en visibilité dans notre réseau.",
        },
        whoWeAre: {
          heroLabel: "Fondé en 2025 · Arménie",
          heroTitle1: "Connecter la jeunesse",
          heroTitle2: "au monde",
          heroBody: "Greenwich connecte les jeunes (14-35 ans) à des opportunités mondiales et locales : des bourses et échanges au bénévolat et aux programmes culturels.",
          seeMore: "Voir plus →",
          sectionLabel: "Qui sommes-nous",
          overviewTitle1: "Une plateforme conçue",
          overviewTitle2: "pour les jeunes",
          overviewP1: "Greenwich.am est une plateforme numérique qui connecte les jeunes à des opportunités éducatives, sociales et professionnelles dans le monde entier. Fondée en Arménie début 2025, elle a débuté comme une chaîne Telegram et a rapidement évolué en une plateforme web innovante qui réunit jeunes et organisations dans un écosystème de confiance.",
          overviewP2: "Greenwich aide les utilisateurs à découvrir des projets vérifiés, à construire un portfolio numérique et à accéder à des opportunités mondiales au même endroit.",
          statAge: "Tranche d'âge cible",
          statYear: "Année de création",
          statOpp: "Opportunités répertoriées",
          whyLabel: "Pourquoi Greenwich ?",
          whyTitle1: "Toutes les opportunités,",
          whyTitle2: "un seul endroit de confiance",
          whyBody: "Trouver des opportunités peut être difficile : elles sont dispersées sur des sites web, les réseaux sociaux et le bouche-à-oreille. Beaucoup de jeunes les manquent simplement parce que l'information n'est pas accessible au même endroit. Greenwich rassemble tout cela.",
          regionAmerica: "Amérique", regionAsia: "Asie", regionEurope: "Europe",
          quote: "« Nous nous efforçons de construire un écosystème numérique de confiance qui connecte la jeunesse et les organisations, et rend la participation visible et mesurable. »",
          visionLabel: "Vision",
          visionTitle1: "Notre",
          visionTitle2: "vision",
          visionTitle3: "pour",
          visionTitle4: "la jeunesse mondiale",
          visionBody: "Notre vision est de créer une plateforme mondiale unifiée où chaque jeune a un accès égal aux opportunités, quel que soit son lieu de résidence ou son origine. Nous nous efforçons de construire un écosystème numérique de confiance qui connecte la jeunesse et les organisations, rend la participation visible et mesurable, et transforme l'engagement en impact réel et en croissance à long terme.",
          missionLabel: "Mission",
          missionTitle1: "Donner à la jeunesse les moyens d'agir",
          missionTitle2: "grâce à la technologie",
          missionBody1: "Notre mission est de rendre les opportunités mondiales accessibles, structurées et transparentes pour les jeunes partout dans le monde. Nous visons à connecter des personnes motivées avec des organisations, à soutenir une participation significative et à offrir un espace numérique de confiance où les réussites sont reconnues et la croissance encouragée.",
          missionBody2: "Grâce à la technologie et à la communauté, nous donnons à la jeunesse les moyens de découvrir son potentiel et de transformer les opportunités en impact réel.",
          sdgLabel: "Durabilité",
          sdgTitle1: "Promouvoir l'",
          sdgTitle2: "Agenda des ODD",
          sdgBody: "Greenwich.am s'engage à promouvoir les Objectifs de développement durable des Nations unies en donnant aux jeunes les moyens de participer activement à des initiatives sociales, éducatives et communautaires.",
          sdgChip1: "Éducation de qualité", sdgChip2: "Travail décent", sdgChip3: "Inégalités réduites", sdgChip4: "Action climatique", sdgChip5: "Institutions solides",
          ctaTitle1: "Prêt à découvrir",
          ctaTitle2: "votre opportunité ?",
          ctaSub: "Rejoignez des milliers de jeunes qui grandissent déjà avec Greenwich.",
          getStarted: "Commencer →",
        },
        notifications: {
          title: "Notifications",
          newBadge: "{{count}} nouvelles",
          markAllRead: "Tout marquer comme lu",
          total: "Total",
          unread: "Non lues",
          likes: "J'aime",
          follows: "Abonnements",
          filter: "Filtrer :",
          all: "Toutes",
          unreadTab: "Non lues",
          readTab: "Lues",
          allTypes: "Tous les types",
          comments: "Commentaires",
          noneTitle: "Aucune notification trouvée",
          noneUnread: "Vous n'avez aucune notification non lue.",
          noneDefault: "Quand vous recevrez des notifications, elles apparaîtront ici.",
          showAll: "Afficher toutes les notifications",
          today: "Aujourd'hui",
          yesterday: "Hier",
          markRead: "Marquer comme lu",
          deleteTitle: "Supprimer la notification",
          deleting: "Suppression...",
          footer: "Affichage de {{shown}} sur {{total}} notifications",
          someone: "Quelqu'un",
          msgLike: "{{name}} a aimé votre publication",
          msgComment: "{{name}} a commenté votre publication",
          msgFollow: "{{name}} a commencé à vous suivre",
          msgFollowReq: "{{name}} souhaite vous suivre",
          msgMessage: "{{name}} vous a envoyé un message",
          msgVerify: "Votre organisation a été vérifiée !",
          msgMention: "{{name}} vous a mentionné dans une publication",
          msgNew: "Nouvelle notification",
          justNow: "À l'instant",
          timeAgo: "il y a {{n}} min",
          hourAgo: "il y a {{n}} h",
          dayAgo: "il y a {{n}} j",
        },
        search: {
          likes: "J'aime",
          comments: "Commentaires",
          tabAll: "Tout",
          tabUsers: "Utilisateurs",
          tabOrganizations: "Organisations",
          tabProjects: "Projets",
          tabHashtags: "Hashtags",
          tabCommunities: "Communautés",
          tabPosts: "Publications",
          heroTitle: "Rechercher sur Greenwich",
          heroSubtitle: "Découvrez des personnes, organisations, communautés et contenus sur la plateforme",
          searchPlaceholder: "Rechercher des utilisateurs, organisations, communautés, publications...",
          filtersBtn: "Filtres",
          sortBy: "Trier par :",
          sortRelevance: "Pertinence",
          sortNewest: "Plus récent",
          sortPopular: "Plus populaire",
          sortName: "Nom A-Z",
          dateRange: "Période :",
          dateAll: "Depuis toujours",
          dateToday: "Aujourd'hui",
          dateWeek: "Cette semaine",
          dateMonth: "Ce mois-ci",
          locationLabel: "Lieu :",
          locationPlaceholder: "Saisir un lieu",
          verifiedOnly: "Vérifiés uniquement",
          clearFilters: "Effacer les filtres",
          searchingFor: 'Recherche de "{{term}}"...',
          emptyTitle: "Rechercher sur Greenwich",
          emptyDescription: "Trouvez des personnes, organisations, publications et communautés sur la plateforme",
          browseCategory: "Parcourir {{category}}",
          trendingHeading: "Recherches tendances",
          trendingTerms: [
            "Éducation", "Erasmus", "Travail", "International", "programmesjeunesse",
            "jobsdété", "recherchebourse", "annéedecésure", "Communauté", "Organisation",
            "Événement", "Étudier à l'étranger", "Bourses complètes", "Fellowship", "Subventions",
          ],
          resultsHeading: "Résultats",
          pageOf: "Page {{current}} sur {{total}}",
          noResultsFor: 'Aucun résultat trouvé pour "{{term}}"',
          noResultsHint: "Essayez d'ajuster vos termes de recherche ou vos filtres",
          previous: "Précédent",
          next: "Suivant",
          pillUser: "Utilisateur",
          pillOrg: "Org",
          pillProgram: "Projet",
          pillOrganizationFull: "Organisation",
          pillCommunity: "Communauté",
          pillPost: "Publication",
          metaFollowers: "abonnés",
          metaPosts: "publications",
          metaMembers: "membres",
          btnFollowing: "Abonné(e)",
          btnRequested: "Demandé",
          btnFollow: "Suivre",
          viewCommunity: "Voir la communauté",
          viewPost: "Voir la publication",
          viewOrg: "Voir l'org",
          viewProgram: "Voir le projet",
          untitledProgram: "Projet sans titre",
          viewProfile: "Voir le profil",
          viewShort: "Voir",
          statFollowers: "Abonnés",
          statPosts: "Publications",
          statMembers: "Membres",
          unknown: "Inconnu",
          unknownUser: "Utilisateur inconnu",
          today: "Aujourd'hui",
          yesterday: "Hier",
        },
        dashboard: {
          pleaseLoginSave: "Veuillez vous connecter pour enregistrer les modifications",
          saveFailed: "Échec de l'enregistrement des modifications",
          saveError: "Erreur lors de l'enregistrement des modifications.",
          imageTooBig: "La taille de l'image doit être inférieure à 5 Mo",
          imageTypes: "Seules les images JPEG, PNG et GIF sont autorisées",
          coverFailed: "Échec de la mise à jour de la photo de couverture",
          coverError: "Erreur lors de la mise à jour de la photo de couverture",
          avatarFailed: "Échec de la mise à jour de la photo de profil",
          avatarError: "Erreur lors de la mise à jour de la photo de profil",
          loginUpload: "Veuillez vous connecter pour téléverser des fichiers",
          uploadFailed: "Échec du téléversement des fichiers",
          uploadError: "Erreur lors du téléversement du fichier",
          deleteFileFailed: "Échec de la suppression du fichier",
          deleteFileError: "Erreur lors de la suppression du fichier",
          navAbout: "À propos",
          navPosts: "Publications",
          navReports: "Rapports",
          navPortfolio: "Portfolio",
          navCertificates: "Certificats",
          navApplications: "Mes candidatures",
          editProfileBtn: "Modifier le profil",
          tabAbout: "À propos",
          tabPosts: "Publications",
          tabReports: "Rapports et licences",
          tabPortfolio: "Portfolio",
          tabCertificates: "Certificats",
          tabApplications: "Mes candidatures",
          firstName: "Prénom *",
          firstNamePh: "Prénom",
          lastName: "Nom",
          titlePosition: "Titre / Fonction",
          titlePh: "Chef de produit senior",
          emailLabel: "E-mail *",
          emailPh: "exemple@email.com",
          invalidEmail: "Veuillez saisir une adresse e-mail valide",
          phoneLabel: "Téléphone",
          phonePh: "+1234567890",
          locationLabel: "Lieu",
          locationPh: "Saisir un lieu",
          websiteLabel: "Site web",
          websitePh: "https://exemple.com",
          bioLabel: "Bio",
          bioPh: "Parlez-nous de vous...",
          interestsLabel: "Centres d'intérêt",
          addInterestPh: "Ajouter un intérêt (Entrée)",
          addBtn: "Ajouter",
          maxInterests: "{{count}}/5 sélectionnés — utilisé pour vous recommander des programmes",
          saveChanges: "Enregistrer les modifications",
          saving: "Enregistrement...",
          cancel: "Annuler",
          noBio: "Pas encore de bio.",
          nameLabel: "Nom",
          emailInfoLabel: "E-mail",
          phoneInfoLabel: "Téléphone",
          locationInfoLabel: "Lieu",
          websiteInfoLabel: "Site web",
          interestsHeader: "Centres d'intérêt",
          whatsOnMind: "À quoi pensez-vous ?",
          photosBtn: "Photos",
          postBtn: "Publier",
          loadingPosts: "Chargement des publications...",
          noPostsYet: "Aucune publication pour le moment",
          noCommentsYet: "Aucun commentaire pour le moment",
          writeReplyPh: "Écrire une réponse...",
          writeCommentPh: "Écrire un commentaire...",
          postFeedbackEmpty: "Veuillez ajouter du contenu ou une image.",
          postFeedbackLoginRequired: "Veuillez vous connecter pour publier.",
          postCreateFailed: "Échec de la création de la publication",
          postCreateError: "Erreur lors de la création de la publication.",
          postCreated: "Publication créée avec succès.",
          linkCopied: "Lien copié",
          maxImages: "Vous pouvez téléverser 10 images maximum",
          imageTooLarge: "Image {{name}} trop volumineuse",
          notAnImage: "{{name}} n'est pas une image",
          uploadedDocuments: "Documents téléversés",
          portfolioItems: "Éléments du portfolio",
          uploadFileBtn: "Téléverser un fichier",
          addItemBtn: "Ajouter un élément",
          previewBtn: "Aperçu",
          downloadBtn: "Télécharger",
          openBtn: "Ouvrir",
          deleteBtn: "Supprimer",
          confirmDeleteFile: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
          myCertificates: "Mes certificats",
          addCertificateBtn: "Ajouter un certificat",
          certTitlePh: "Titre du certificat *",
          certIssuerPh: "Organisation émettrice",
          certDatePh: "Date d'émission (ex. 2026-01-15)",
          certLocationPh: "Lieu (ville, pays)",
          certRolePh: "Votre rôle / activité",
          certDescPh: "Description (facultatif)",
          cvHeader: "CV",
          cvUploadBtn: "Importer le CV",
          cvReplaceBtn: "Remplacer le CV",
          cvUploadedNote: "Visible par les organisateurs lors de votre candidature.",
          cvEmptyNote: "Ajoutez votre CV en PDF pour que les organisateurs le voient lors de votre candidature.",
          saveCertificate: "Enregistrer le certificat",
          savingEllipsis: "Enregistrement…",
          noCertificatesYet: "Aucun certificat ajouté pour le moment.",
          issuedByOrganizerFor: "Émis par {{org}} pour {{program}}",
          issuedByOrganizer: "Émis par {{org}}",
          theOrganizer: "l'organisateur",
          viewPdf: "Voir le PDF",
          confirmDeleteCertificate: "Supprimer ce certificat ?",
          certTitleRequired: "Le titre est requis.",
          certFileRequired: "Veuillez joindre le certificat au format PDF.",
          certFilePdfOnly: "Les certificats doivent être téléversés au format PDF.",
          certAddFailed: "Échec de l'ajout du certificat.",
          certDeleteFailed: "Échec de la suppression du certificat.",
          programsAppliedTo: "Programmes auxquels j'ai postulé",
          loadingApplications: "Chargement des candidatures…",
          noApplicationsYet: "Vous n'avez encore postulé à aucun programme.",
          browsePrograms: "Parcourir les programmes",
          appliedOn: "Candidature envoyée le {{date}}",
          statusPending: "⏳ En attente de réponse",
          statusAccepted: "✅ Accepté",
          statusRejected: "❌ Non accepté",
          statusAttended: "🎓 Participation confirmée",
          certIssuedSeeTab: "Certificat émis, voir votre onglet Certificats",
          certPending: "Certificat en attente",
          viewSubmission: "Voir ma soumission",
          programFallback: "Programme",
          statsPosts: "Publications",
          statsFollowers: "Abonnés",
          statsFollowing: "Abonnements",
          totalPostsLabel: "Total des publications :",
          openPosts: "Publications ouvertes",
          noUsersYet: "Aucun utilisateur à afficher pour le moment.",
          unsavedTitle: "Modifications non enregistrées",
          unsavedMessage: "Vous avez des modifications non enregistrées. Voulez-vous les enregistrer ?",
          dontSave: "Ne pas enregistrer",
          changeCoverPhoto: "Changer la photo de couverture",
          coverLabel: "Couverture",
          changeProfilePhoto: "Changer la photo de profil",
          reportAction: "Signaler",
          saveBtn: "Enregistrer",
        },
        messages: {
          justNow: "À l'instant",
          errNoContent: "Veuillez saisir un message ou sélectionner une image",
          errNoConversation: "Aucune conversation active",
          confirmDeleteMessage: "Supprimer ce message ?",
          errDeleteMessage: "Échec de la suppression du message",
          errNoGroup: "Aucun groupe actif",
          confirmDeleteConversation: "Supprimer cette conversation ?",
          conversationDeleted: "Conversation supprimée",
          errDeleteConversation: "Échec de la suppression de la conversation",
          confirmLeaveGroup: "Quitter ce groupe ?",
          leftGroupSuccess: "Groupe quitté avec succès",
          errLeaveGroup: "Échec de la sortie du groupe",
          joinedGroupSuccess: "Vous avez rejoint le groupe avec succès !",
          errJoinGroup: "Échec de l'adhésion au groupe",
          errFileTooLarge: "La taille du fichier doit être inférieure à 10 Mo",
          errSelectImage: "Veuillez sélectionner un fichier image",
          errSendMessage: "Échec de l'envoi du message",
          errCreateConversation: "Échec de la création de la conversation",
          errStartConversation: "Échec du démarrage de la conversation",
          emojiRecent: "Récents",
          emojiSmileys: "Smileys",
          emojiHearts: "Cœurs",
          emojiHands: "Mains",
          emojiAnimals: "Animaux",
          emojiFood: "Nourriture",
          emojiTravel: "Voyage",
          emojiSymbols: "Symboles",
          emojiWeather: "Météo",
          signInTitle: "Connectez-vous pour continuer",
          signInSubtitle: "Voir et envoyer des messages",
          logIn: "Se connecter",
          title: "Messages",
          newTooltip: "Nouveau",
          tabDirect: "Direct",
          tabGroups: "Groupes",
          searchPlaceholder: "Rechercher...",
          loading: "Chargement...",
          noConversations: "Aucune conversation pour le moment",
          startChat: "Démarrer une discussion",
          unknown: "Inconnu",
          sharedAPost: "📤 A partagé une publication",
          noMessagesYet: "Aucun message pour le moment",
          noGroups: "Aucun groupe pour le moment",
          browseGroups: "Parcourir les groupes",
          tagPrivate: "Privé",
          tagAdmin: "Admin",
          membersCount: "{{count}} membres",
          someoneTyping: "{{name}} écrit...",
          online: "En ligne",
          offline: "Hors ligne",
          typing: "En train d'écrire...",
          viewProfileTooltip: "Voir le profil",
          infoTooltip: "Info",
          leaveGroupTooltip: "Quitter le groupe",
          loadingMessages: "Chargement des messages...",
          beFirstToSayHello: "Soyez le premier à dire bonjour !",
          joinGroupToChat: "Rejoindre le groupe pour discuter",
          sharedPost: "Publication partagée",
          tapToView: "Appuyez pour voir →",
          deleteMessageTooltip: "Supprimer le message",
          joinToSend: "Rejoignez ce groupe pour envoyer des messages",
          join: "Rejoindre",
          attachTooltip: "Joindre",
          emojisTooltip: "Émojis",
          messagePlaceholder: "Message à {{name}}...",
          yourMessages: "Vos messages",
          yourGroups: "Vos groupes",
          selectConversation: "Sélectionnez une conversation ou démarrez-en une nouvelle",
          selectGroup: "Sélectionnez un groupe pour commencer à discuter",
          newConversation: "Nouvelle conversation",
          newMessageTitle: "Nouveau message",
          noUsersAvailable: "Aucun utilisateur disponible",
          mutualFollowersOnly: "Vous ne pouvez envoyer des messages qu'à vos abonnements mutuels",
          conversationInfoTitle: "Infos de la conversation",
          deleteConversation: "Supprimer la conversation",
          groupInfoTitle: "Infos du groupe",
          membersCountDot: "{{count}} membres ·",
          public: "Public",
          leaveGroup: "Quitter le groupe",
          joinGroup: "Rejoindre le groupe",
        },
        feed: {
          seeMore: "Voir plus",
          seeLess: "Voir moins",
          noPostsYet: "Aucune publication disponible pour le moment. Soyez le premier à publier !",
          loadFailed: "Échec du chargement du fil. Veuillez réessayer plus tard.",
          justNow: "À l'instant",
          minAgo: "il y a {{n}} min",
          hourAgo: "il y a {{n}} h",
          dayAgo: "il y a {{n}} j",
          loginToLike: "Veuillez vous connecter pour aimer des publications",
          followRequestSent: "Demande d'abonnement envoyée !",
          failedFollowReq: "Échec de l'envoi de la demande d'abonnement",
          replyPosted: "Réponse publiée !",
          commentAdded: "Commentaire ajouté !",
          failedComment: "Échec de l'ajout du commentaire.",
          failedLike: "Échec de l'ajout du j'aime.",
          failedSave: "Échec de l'enregistrement de la publication.",
        },
      },
      settings: {
        title: "Paramètres",
        subtitle: "Gérez les préférences et le contenu de votre compte",
        sidebar: {
          account: "Compte",
          accountSettings: "Paramètres du compte",
          savedLiked: "Enregistrements et j'aime",
          preferences: "Préférences",
          privacySecurity: "Confidentialité et sécurité",
          notifications: "Notifications",
          pro: "Pro",
          archive: "Archive",
          yourActivity: "Votre activité",
          howOthersInteract: "Comment les autres interagissent avec vous",
          interactionsLabel: "Messages, commentaires et restrictions",
          accessibility: "Accessibilité",
          dataPermissions: "Archivage, téléchargement et permissions",
          support: "Support",
        },
        interactions: {
          title: "Comment les autres peuvent interagir avec vous",
          subtitle: "Contrôlez qui peut vous envoyer un message, qui peut commenter vos publications, et qui est restreint.",
          messagesHeading: "Messages",
          messagesSubtitle: "Qui peut démarrer une nouvelle conversation avec vous.",
          everyone: "Tout le monde",
          followersBack: "Les personnes qui vous suivent en retour",
          noOne: "Personne",
          commentsHeading: "Commentaires",
          commentsSubtitle: "Qui peut commenter vos publications.",
          yourFollowers: "Vos abonnés",
          turnOffComments: "Désactiver les commentaires",
          restrictedHeading: "Comptes restreints",
          restrictedSubtitle: "Les personnes restreintes ne peuvent pas commenter vos publications. Elles peuvent toujours voir votre profil public et vous suivre. C'est plus léger qu'un blocage.",
          searchPlaceholder: "Rechercher par nom ou nom d'utilisateur…",
          searching: "Recherche…",
          noUsersFound: "Aucun utilisateur trouvé.",
          restrictBtn: "Restreindre",
          noneRestricted: "Vous n'avez restreint personne.",
          unrestrictBtn: "Ne plus restreindre",
        },
        archive: {
          title: "Archive",
          subtitle: "Les publications que vous avez archivées sont masquées de votre profil. Vous seul pouvez voir cette liste.",
          emptyTitle: "Rien d'archivé",
          emptyBody: "Archivez une publication depuis son menu d'options et elle apparaîtra ici.",
          unarchiveBtn: "Désarchiver",
        },
        activity: {
          title: "Votre activité",
          subtitle: "Un aperçu rapide de ce que vous avez fait récemment.",
          filterLiked: "Aimées",
          filterSaved: "Enregistrées",
          filterCommented: "Commentées",
          filterSearches: "Recherches",
          empty: "Rien ici pour le moment.",
        },
        accessibility: {
          title: "Accessibilité",
          subtitle: "Ajustez le comportement du site pour qu'il vous convienne.",
          reduceMotion: "Réduire les animations",
          reduceMotionDesc: "Désactive les animations et transitions sur tout le site.",
        },
        dataExport: {
          title: "Archivage et téléchargement",
          subtitle: "Téléchargez une copie de vos données.",
          downloadHeading: "Téléchargez vos données",
          downloadDesc: "Obtenez un fichier JSON avec votre profil, vos publications et vos candidatures.",
          preparing: "Préparation…",
          downloadBtn: "Télécharger",
          scopeHint: "Choisissez tout, ou seulement une partie de vos données.",
          scopeAll: "Tout",
          scopeProfile: "Profil uniquement",
          scopePrograms: "Candidatures aux programmes",
          scopeBuddy: "Mentorat Buddy",
          scopeMessages: "Messages",
          permissionsTitle: "🔐 Permissions du site",
          permissionsSubtitle: "Ce que votre navigateur autorise Greenwich à faire, et comment le modifier.",
          permissionsPara1: "Greenwich ne demande qu'une seule permission à votre navigateur : les notifications, pour vous alerter des j'aime, commentaires, abonnements et messages même quand l'onglet n'est pas ouvert. Il ne demande ni votre caméra, ni votre micro, ni votre position.",
          permissionsPara2: "Vous pouvez la vérifier ou la révoquer à tout moment dans les paramètres du site de votre navigateur. Cliquez sur l'icône de cadenas à côté de la barre d'adresse sur greenwich.am.",
        },
        toasts: {
          failedToSave: "Échec de l'enregistrement.",
          userRestricted: "Utilisateur restreint.",
          failedToRestrict: "Échec de la restriction de l'utilisateur.",
          userUnrestricted: "Restriction de l'utilisateur levée.",
          failedToUnrestrict: "Échec de la levée de restriction de l'utilisateur.",
          postUnarchived: "Publication désarchivée, elle est de retour sur votre profil.",
          failedToUnarchive: "Échec du désarchivage de la publication.",
          failedToExport: "Échec de l'exportation de vos données.",
        },
        account: {
          title: "Informations du compte",
          subtitle: "Gérez vos informations personnelles et préférences",
          firstName: "Prénom",
          lastName: "Nom",
          email: "E-mail",
          phone: "Téléphone",
          location: "Lieu",
          bio: "Bio",
          bioPlaceholder: "Parlez-nous de vous...",
          profileColor: "Couleur d'accent du profil",
          profileColorHint: "Affichée sur votre profil public. Choisissez la vôtre ou gardez celle par défaut.",
          saveChanges: "Enregistrer les modifications",
          profileUpdated: "Profil mis à jour avec succès !",
          profileUpdateError: "Erreur lors de la mise à jour du profil",
          accountDeleted: "Compte supprimé avec succès.",
          changePasswordTitle: "Changer le mot de passe",
          changePasswordSubtitle: "Mettez à jour le mot de passe que vous utilisez pour vous connecter.",
          currentPassword: "Mot de passe actuel",
          newPassword: "Nouveau mot de passe",
          confirmNewPassword: "Confirmer le nouveau mot de passe",
          newPasswordPlaceholder: "Au moins 8 caractères",
          confirmNewPasswordPlaceholder: "Ressaisissez le nouveau mot de passe",
          updatePassword: "Mettre à jour le mot de passe",
          passwordFieldsRequired: "Veuillez remplir tous les champs de mot de passe.",
          passwordTooShort: "Le nouveau mot de passe doit comporter au moins 8 caractères.",
          passwordMismatch: "Le nouveau mot de passe et sa confirmation ne correspondent pas.",
          passwordUpdated: "Mot de passe mis à jour avec succès.",
          passwordUpdateFailed: "Échec de la mise à jour du mot de passe.",
          activeSessionsTitle: "Sessions actives",
          activeSessionsSubtitle: "Voyez où vous êtes connecté et déconnectez les autres appareils.",
          manage: "Gérer →",
        },
        savedLiked: {
          title: "Publications enregistrées et aimées",
          subtitle: "Publications que vous avez enregistrées ou aimées",
          emptyTitle: "Aucune publication enregistrée ou aimée",
          emptySubtitle: "Les publications que vous enregistrez ou aimez apparaîtront ici pour un accès rapide.",
          savedCount: "Enregistrées",
          likedCount: "Aimées",
          badgeSaved: "Enregistré",
          badgeLiked: "Aimé",
          loadingPosts: "Chargement des publications...",
          unknownAuthor: "Inconnu",
        },
        privacy: {
          title: "Confidentialité et sécurité",
          subtitle: "Contrôlez vos paramètres de confidentialité et de sécurité",
          accountPrivacy: "Confidentialité du compte",
          accountPrivacySubtitle: "Contrôlez qui peut voir votre profil et vos publications",
          visibility: {
            public: "Public",
            private: "Privé",
            friends: "Amis uniquement",
          },
          language: "Langue",
          languageSubtitle: "Choisissez votre langue préférée",
          contentLanguage: "Langue du contenu",
          contentLanguageSubtitle: "Dans quelle langue sont affichés les programmes et opportunités, indépendamment de la langue de l'interface",
          market: "Pays",
          marketSubtitle: "Basculez entre les versions Arménie et France de Greenwich",
          twoFactor: "Authentification à deux facteurs",
          twoFactorSubtitle: "Ajoutez une couche de sécurité supplémentaire à votre compte",
          privateAccount: "Compte privé et demandes d'abonnement",
          privateAccountSubtitle: "Exiger une approbation avant que les gens puissent vous suivre",
          notificationsRow: "Notifications",
          notificationsRowSubtitle: "Choisissez les alertes que vous recevez par e-mail, push et dans l'application, et définissez des heures de silence",
          security: "Sécurité",
          securitySubtitle: "Authentification à deux facteurs, changement d'e-mail, comptes connectés",
          blockedAccounts: "Comptes bloqués",
          blockedAccountsSubtitle: "Les personnes que vous avez bloquées ne peuvent pas voir votre profil ni vous contacter",
          mutedAccounts: "Comptes masqués",
          mutedAccountsSubtitle: "Leurs publications sont masquées de votre fil, silencieusement",
          manage: "Gérer →",
          dangerZone: "Zone de danger",
        },
        deleteModal: {
          heading: "Pourquoi voulez-vous supprimer votre compte ?",
          selectReason: "Sélectionner un motif",
          reasonPrivacy: "Préoccupations de confidentialité",
          reasonNotUseful: "Pas utile",
          reasonTooManyEmails: "Trop de notifications",
          reasonOther: "Autre",
          writeReason: "Écrivez votre motif...",
          pleaseSelectReason: "Veuillez sélectionner un motif",
          areYouSure: "Êtes-vous sûr ?",
          cannotBeUndone: "Cette action est irréversible. Toutes vos données seront définitivement supprimées.",
          yesDelete: "Oui, supprimer",
          error: "Erreur lors de la suppression du compte. Veuillez réessayer.",
        },
        notifications: {
          title: "Notifications",
          subtitle: "Gérez comment et quand vous recevez des notifications",
          pushTitle: "Notifications push",
          pushSubtitle: "Recevoir des notifications du navigateur",
        },
        languages: {
          en: "Anglais",
          hy: "Arménien",
          ru: "Russe",
          de: "Allemand",
          es: "Espagnol",
          fr: "Français",
        },
        pro: {
          title: "Greenwich Pro",
          subtitle: "Gérez vos avantages Pro : design personnalisé, cadre d'avatar et historique des vues de profil.",
          statusActive: "Votre Pro est actif jusqu'au {{date}}",
          statusNone: "Vous n'avez pas encore Pro.",
          learnMore: "En savoir plus sur Pro",
          frameTitle: "Cadre d'avatar",
          frameNone: "Aucun", frameGold: "Or", frameEmerald: "Émeraude", frameRoyal: "Royal",
          designTitle: "Design du profil",
          designNone: "Aucun", designSunset: "Coucher de soleil", designOcean: "Océan", designForest: "Forêt", designMidnight: "Minuit",
          save: "Enregistrer", saving: "Enregistrement...",
          customizationSaved: "Personnalisation enregistrée !",
          customizationError: "Échec de l'enregistrement de la personnalisation.",
          channelTitle: "Diffusion des correspondances de projets",
          channelSubtitle: "Choisissez où vous souhaitez recevoir vos meilleures suggestions de projets.",
          channelPlatform: "Dans la plateforme", channelEmail: "E-mail", channelTelegram: "Bot Telegram",
          comingSoon: "bientôt disponible",
          linkTelegram: "lier votre compte",
          sendTest: "Envoyer mes correspondances maintenant",
          testSent: "Envoyé ! Vérifiez le canal choisi.",
          timingTitle: "Timing et contenu",
          timingSubtitle: "Contrôlez quand les suggestions arrivent, si vous recevez des rappels, et le niveau de détail de chacune.",
          deliveryHour: "Heure de livraison",
          remindersLabel: "Continuer à envoyer même quand les suggestions n'ont pas changé (mode rappel)",
          detailLevel: "Détail du message",
          detail_brief: "Bref", detail_detailed: "Détaillé",
          sourceTitle: "Comment les suggestions sont choisies",
          sourceAi: "Mise en correspondance IA (recommandé)", sourceCategories: "Je choisis mes catégories",
          sourceAiHint: "Recommandé pour la précision. Les suggestions sont classées selon votre activité sur la plateforme.",
          category_education: "Éducation", category_scholarship: "Bourse", category_fellowship: "Fellowship",
          category_erasmusplus: "Erasmus+", category_training: "Formation", category_grant: "Subvention",
          category_internship: "Stage", category_conference: "Conférence", category_online: "En ligne",
          category_volunteering: "Bénévolat", category_event: "Événement", category_award: "Prix",
          viewsTitle: "Qui a visité votre profil",
          viewsSubtitle: "Visible uniquement tant que votre abonnement Pro reste actif.",
          viewsLocked: "Obtenez Pro pour voir qui a visité votre profil.",
          viewsCountToday: "{{count}} personnes ont visité votre profil aujourd'hui.",
          viewsEmpty: "Aucune visite de profil pour le moment durant cette période Pro.",
          loading: "Chargement...",
          billingTitle: "Facturation et remboursements",
          billingSubtitle: "Vos achats précédents, avec la possibilité de demander un remboursement sous 7 jours.",
          billingEmpty: "Aucun achat pour le moment.",
          requestRefund: "Demander un remboursement",
          refundWindowExpired: "Le délai de remboursement est dépassé",
          refundStatusRequested: "Remboursement demandé, en cours d'examen",
          refundStatusApproved: "Remboursement approuvé",
          refundStatusRejected: "Demande de remboursement refusée",
          refundStatusRefunded: "Remboursé",
          refundModalTitle: "Demander un remboursement",
          refundModalSubtitle: "Dites-nous ce qui s'est passé. Cela nous aide à nous améliorer et est nécessaire pour traiter votre remboursement.",
          refundReasonLabel: "Motif",
          selectReason: "Sélectionnez un motif",
          reason_not_what_expected: "Ce n'était pas ce à quoi je m'attendais",
          reason_found_cheaper_elsewhere: "Trouvé moins cher ailleurs",
          reason_technical_issues: "Rencontré des problèmes techniques",
          reason_accidental_purchase: "Achat accidentel",
          reason_no_longer_needed: "N'en ai plus besoin",
          reason_bought_wrong_plan: "Acheté le mauvais plan",
          reason_unsatisfied_with_features: "Pas satisfait(e) des fonctionnalités",
          reason_other: "Autre",
          ratingLabel: "Comment évalueriez-vous votre expérience ?",
          commentLabel: "Autre chose à ajouter ? (facultatif)",
          commentPlaceholder: "Dites-nous en plus...",
          talkToSupport: "Vous préférez d'abord parler à quelqu'un ?",
          talkToSupportLink: "Discuter avec le support",
          submitRefund: "Envoyer la demande de remboursement",
          submittingRefund: "Envoi en cours...",
          refundSubmitted: "Demande de remboursement envoyée. Nous l'examinerons bientôt.",
          refundError: "Impossible d'envoyer la demande. Veuillez réessayer.",
        },
        confirmLogout: "Voulez-vous vraiment vous déconnecter ?",
      },
      feed: {
        sidebarExplore: "Explorer",
        photos: "Photos",
        postBtn: "Publier",
        whatsOnMind: "À quoi pensez-vous ?",
        recommendedForYou: "Recommandé pour vous",
        programsForYou: "Programmes pour vous",
        programsForYouFallback: "Programme",
        programsForYouPopularHint: "Populaire en ce moment. Enregistrez ou postulez à des programmes pour les personnaliser.",
        seeAll: "Voir tout",
        followPeopleHint: "Suivez des personnes pour les voir ici",
        loading: "Chargement...",
        close: "Fermer",
        noFollowersYet: "Aucun abonné pour le moment",
        noFollowingYet: "Ne suit personne pour le moment",
        unknown: "Inconnu",
        viewAllFollowing: "Voir les {{count}} abonnements",
        noRecommendationsYet: "Aucune recommandation pour le moment",
        recommendationsHint: "Suivez des personnes ou explorez pour obtenir des recommandations",
        alreadyFollowing: "Déjà abonné",
        reasonViolent: "Contenu violent",
        reasonDescSpam: "C'est du spam",
        reasonDescInappropriate: "Contient du contenu 18+ ou explicite",
        reasonDescViolent: "Contient du contenu violent, choquant ou dérangeant",
        reasonDescHarassment: "Harcèlement ou intimidation",
        reasonDescHateSpeech: "Promeut la haine ou la violence",
        reasonDescMisinformation: "Informations fausses ou trompeuses",
        reasonDescOther: "Autre motif",
        reportComment: "Signaler le commentaire",
        reportSelectReasonHint: "Veuillez sélectionner un motif pour signaler ce {{type}}. Cette action est anonyme.",
        additionalDetails: "Détails supplémentaires (facultatif)",
        reportDetailsPlaceholder: "Fournissez plus de détails sur votre signalement...",
        submitReport: "Envoyer le signalement",
        editPost: "Modifier la publication",
        archivePost: "Archiver la publication",
        archiving: "Archivage…",
        commentWillBeDeleted: "Ce commentaire sera définitivement supprimé. Cette action est irréversible.",
        sendAndShare: "Envoyer et partager",
        imagePost: "Publication image",
        sendToMutualFollows: "Envoyer aux abonnements mutuels",
        loadingMutualFollows: "Chargement des abonnements mutuels...",
        showLess: "Afficher moins",
        showAllUsers: "Afficher les {{count}} utilisateurs",
        shareOnSocialMedia: "Partager sur les réseaux sociaux",
        failedToCopyLink: "Échec de la copie du lien",
        failedToLikeComment: "Échec de l'ajout du j'aime au commentaire.",
        commentDeletedToast: "Commentaire supprimé !",
        failedToDeleteComment: "Échec de la suppression du commentaire",
        postArchivedToast: "Publication archivée. Vous la trouverez dans Paramètres → Archive.",
        reportSubmittedToast: "Signalement envoyé avec succès",
        failedToSubmitReport: "Échec de l'envoi du signalement",
        maxImagesError: "Vous pouvez téléverser 10 images maximum",
        postContentEmptyError: "Le contenu de la publication ne peut pas être vide",
        pleaseLogInToEdit: "Veuillez vous connecter pour modifier des publications",
        postUpdatedToast: "Publication mise à jour avec succès !",
        cannotSendPostError: "Impossible d'envoyer la publication : informations manquantes",
        postNotFoundError: "Publication introuvable",
        pleaseAddContentError: "Veuillez ajouter du contenu ou une image",
        pleaseLogInToPost: "Veuillez vous connecter pour publier",
        postCreatedToast: "Publication créée avec succès !",
        cannotConnectError: "Impossible de se connecter au serveur. Vérifiez votre connexion internet",
        cannotCopyProfileLinkError: "Impossible de copier le lien du profil : utilisateur non chargé",
        postDeletedByAdmin: "Publication supprimée par un administrateur.",
        failedToDeletePost: "Échec de la suppression de la publication",
        failedToArchivePost: "Échec de l'archivage de la publication",
        failedToUpdatePost: "Échec de la mise à jour de la publication.",
        failedToCreatePost: "Échec de la création de la publication.",
        replaceImages: "Remplacer les images",
        addImages: "Ajouter des images",
      },
    },
  },
};
